/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: any; output: any; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) and, if it has a timezone, [RFC
   * 3339](https://datatracker.ietf.org/doc/html/rfc3339) standards. Input values
   * that do not conform to both ISO 8601 and RFC 3339 may be coerced, which may lead
   * to unexpected results.
   */
  Datetime: { input: string; output: string; }
  /** The `GeoJSON` scalar type represents GeoJSON values as specified by[RFC 7946](https://tools.ietf.org/html/rfc7946). */
  GeoJSON: { input: any; output: any; }
  /** Represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, MetadataField>; output: Record<string, MetadataField>; }
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: any; output: any; }
};

/** All input for the `acceptInvitation` mutation. */
export type AcceptInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `acceptInvitation` mutation. */
export type AcceptInvitationPayload = {
  __typename?: 'AcceptInvitationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge?: Maybe<MembersEdge>;
  /** Reads a single `Organization` that is related to this `Member`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Member`. */
  user?: Maybe<User>;
};


/** The output of our `acceptInvitation` mutation. */
export type AcceptInvitationPayloadMemberEdgeArgs = {
  orderBy?: Array<MembersOrderBy>;
};

/** All input for the `acknowledgeAllUserNotifications` mutation. */
export type AcknowledgeAllUserNotificationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `acknowledgeAllUserNotifications` mutation. */
export type AcknowledgeAllUserNotificationsPayload = {
  __typename?: 'AcknowledgeAllUserNotificationsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  userNotifications?: Maybe<Array<UserNotification>>;
};

/** All input for the `acknowledgeUserNotifications` mutation. */
export type AcknowledgeUserNotificationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notificationIds: Array<InputMaybe<Scalars['String']['input']>>;
};

/** The output of our `acknowledgeUserNotifications` mutation. */
export type AcknowledgeUserNotificationsPayload = {
  __typename?: 'AcknowledgeUserNotificationsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  userNotifications?: Maybe<Array<UserNotification>>;
};

export type AddEmailAddressInput = {
  emailAddress: Scalars['String']['input'];
};

export type AddEmailAddressPayload = {
  __typename?: 'AddEmailAddressPayload';
  pendingEmailAddress: PendingEmailAddress;
  query?: Maybe<Query>;
  /** @deprecated Use AddEmailAddressPayload.pendingEmailAddress */
  userEmailAddress: UserEmailAddress;
};

/** All input for the `addGroupMembers` mutation. */
export type AddGroupMembersInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  memberIds: Array<InputMaybe<Scalars['String']['input']>>;
};

/** The output of our `addGroupMembers` mutation. */
export type AddGroupMembersPayload = {
  __typename?: 'AddGroupMembersPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Organization` that is related to this `Group`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `addGroupMembers` mutation. */
export type AddGroupMembersPayloadGroupEdgeArgs = {
  orderBy?: Array<GroupsOrderBy>;
};

/** All input for the `addGuardmeAttachments` mutation. */
export type AddGuardmeAttachmentsInput = {
  attachmentIds: Array<InputMaybe<Scalars['String']['input']>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  guardmeId: Scalars['String']['input'];
};

/** The output of our `addGuardmeAttachments` mutation. */
export type AddGuardmeAttachmentsPayload = {
  __typename?: 'AddGuardmeAttachmentsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Guardme` that is related to this `GuardmeAttachment`. */
  guardme?: Maybe<Guardme>;
  guardmeAttachment?: Maybe<GuardmeAttachment>;
  /** An edge for our `GuardmeAttachment`. May be used by Relay 1. */
  guardmeAttachmentEdge?: Maybe<GuardmeAttachmentsEdge>;
  /** Reads a single `Member` that is related to this `GuardmeAttachment`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `GuardmeAttachment`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `addGuardmeAttachments` mutation. */
export type AddGuardmeAttachmentsPayloadGuardmeAttachmentEdgeArgs = {
  orderBy?: Array<GuardmeAttachmentsOrderBy>;
};

/** All input for the `addIncidentAttachments` mutation. */
export type AddIncidentAttachmentsInput = {
  attachmentIds: Array<InputMaybe<Scalars['String']['input']>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  incidentId: Scalars['String']['input'];
};

/** The output of our `addIncidentAttachments` mutation. */
export type AddIncidentAttachmentsPayload = {
  __typename?: 'AddIncidentAttachmentsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Incident` that is related to this `IncidentUpdate`. */
  incident?: Maybe<Incident>;
  incidentUpdate?: Maybe<IncidentUpdate>;
  /** An edge for our `IncidentUpdate`. May be used by Relay 1. */
  incidentUpdateEdge?: Maybe<IncidentUpdatesEdge>;
  /** Reads a single `Organization` that is related to this `IncidentUpdate`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Member` that is related to this `IncidentUpdate`. */
  performedByMember?: Maybe<Member>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `addIncidentAttachments` mutation. */
export type AddIncidentAttachmentsPayloadIncidentUpdateEdgeArgs = {
  orderBy?: Array<IncidentUpdatesOrderBy>;
};

/** All input for the `addMemberToGroup` mutation. */
export type AddMemberToGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

/** The output of our `addMemberToGroup` mutation. */
export type AddMemberToGroupPayload = {
  __typename?: 'AddMemberToGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  mapGroupsMember?: Maybe<MapGroupsMember>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type AddPhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
};

export type AddPhoneNumberPayload = {
  __typename?: 'AddPhoneNumberPayload';
  pendingPhoneNumber: PendingPhoneNumber;
  query?: Maybe<Query>;
  /** @deprecated Use AddPhoneNumberPayload.pendingPhoneNumber */
  userPhoneNumber: UserPhoneNumber;
};

/** All input for the `addUserToOrganization` mutation. */
export type AddUserToOrganizationInput = {
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  asAuditor?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** The output of our `addUserToOrganization` mutation. */
export type AddUserToOrganizationPayload = {
  __typename?: 'AddUserToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge?: Maybe<MembersEdge>;
  /** Reads a single `Organization` that is related to this `Member`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Member`. */
  user?: Maybe<User>;
};


/** The output of our `addUserToOrganization` mutation. */
export type AddUserToOrganizationPayloadMemberEdgeArgs = {
  orderBy?: Array<MembersOrderBy>;
};

/** All input for the `adminCreateIncidentType` mutation. */
export type AdminCreateIncidentTypeInput = {
  allowlist: Array<InputMaybe<Scalars['String']['input']>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dataSchema: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  iconPng: Scalars['String']['input'];
  iconSvg: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  uiSchema: Scalars['JSON']['input'];
  useAllowlist: Scalars['Boolean']['input'];
};

/** The output of our `adminCreateIncidentType` mutation. */
export type AdminCreateIncidentTypePayload = {
  __typename?: 'AdminCreateIncidentTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  incidentType?: Maybe<IncidentType>;
  /** An edge for our `IncidentType`. May be used by Relay 1. */
  incidentTypeEdge?: Maybe<IncidentTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `adminCreateIncidentType` mutation. */
export type AdminCreateIncidentTypePayloadIncidentTypeEdgeArgs = {
  orderBy?: Array<IncidentTypesOrderBy>;
};

export type AdminCreateOrganizationInput = {
  name: Scalars['String']['input'];
  ownerEmailAddress: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type AdminCreateOrganizationPayload = {
  __typename?: 'AdminCreateOrganizationPayload';
  organization?: Maybe<Organization>;
};

export type AdminDeleteOrganizationInput = {
  delayed: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};

export type AdminDeleteOrganizationPayload = {
  __typename?: 'AdminDeleteOrganizationPayload';
  organization?: Maybe<Organization>;
  query?: Maybe<Query>;
};

export type AdminDeleteUserInput = {
  userId: Scalars['String']['input'];
};

export type AdminDeleteUserPayload = {
  __typename?: 'AdminDeleteUserPayload';
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export type AdminDestroyOrganizationInput = {
  organizationId: Scalars['String']['input'];
};

export type AdminDestroyOrganizationPayload = {
  __typename?: 'AdminDestroyOrganizationPayload';
  organization?: Maybe<Organization>;
  query?: Maybe<Query>;
};

export type AdminDisableUserInput = {
  userId: Scalars['String']['input'];
};

export type AdminDisableUserPayload = {
  __typename?: 'AdminDisableUserPayload';
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export type AdminEnableUserInput = {
  userId: Scalars['String']['input'];
};

export type AdminEnableUserPayload = {
  __typename?: 'AdminEnableUserPayload';
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export type AdminRemoveEmailAddressInput = {
  userId: Scalars['String']['input'];
};

export type AdminRemoveEmailAddressPayload = {
  __typename?: 'AdminRemoveEmailAddressPayload';
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export type AdminRemovePhoneNumberInput = {
  userId: Scalars['String']['input'];
};

export type AdminRemovePhoneNumberPayload = {
  __typename?: 'AdminRemovePhoneNumberPayload';
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

/** All input for the `adminUpdateIncidentType` mutation. */
export type AdminUpdateIncidentTypeInput = {
  allowlist: Array<InputMaybe<Scalars['String']['input']>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dataSchema: Scalars['JSON']['input'];
  description: Scalars['String']['input'];
  iconPng: Scalars['String']['input'];
  iconSvg: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  uiSchema: Scalars['JSON']['input'];
  useAllowlist: Scalars['Boolean']['input'];
};

/** The output of our `adminUpdateIncidentType` mutation. */
export type AdminUpdateIncidentTypePayload = {
  __typename?: 'AdminUpdateIncidentTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  incidentType?: Maybe<IncidentType>;
  /** An edge for our `IncidentType`. May be used by Relay 1. */
  incidentTypeEdge?: Maybe<IncidentTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `adminUpdateIncidentType` mutation. */
export type AdminUpdateIncidentTypePayloadIncidentTypeEdgeArgs = {
  orderBy?: Array<IncidentTypesOrderBy>;
};

/** All input for the `adminUpdateOrganizationMetrics` mutation. */
export type AdminUpdateOrganizationMetricsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `adminUpdateOrganizationMetrics` mutation. */
export type AdminUpdateOrganizationMetricsPayload = {
  __typename?: 'AdminUpdateOrganizationMetricsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `OrganizationMetric`. */
  organization?: Maybe<Organization>;
  organizationMetric?: Maybe<OrganizationMetric>;
  /** An edge for our `OrganizationMetric`. May be used by Relay 1. */
  organizationMetricEdge?: Maybe<OrganizationMetricsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `adminUpdateOrganizationMetrics` mutation. */
export type AdminUpdateOrganizationMetricsPayloadOrganizationMetricEdgeArgs = {
  orderBy?: Array<OrganizationMetricsOrderBy>;
};

export type AdminUpdateOrganizationOwnerInput = {
  memberId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type AdminUpdateOrganizationOwnerPayload = {
  __typename?: 'AdminUpdateOrganizationOwnerPayload';
  organization?: Maybe<Organization>;
  query?: Maybe<Query>;
};

export type AdminUpdateOrganizationPlanInput = {
  organizationId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
};

export type AdminUpdateOrganizationPlanPayload = {
  __typename?: 'AdminUpdateOrganizationPlanPayload';
  organization?: Maybe<Organization>;
  query?: Maybe<Query>;
};

export type AdminUpdateOrganizationStateInput = {
  organizationId: Scalars['String']['input'];
  state: OrganizationState;
};

export type AdminUpdateOrganizationStatePayload = {
  __typename?: 'AdminUpdateOrganizationStatePayload';
  organization?: Maybe<Organization>;
  query?: Maybe<Query>;
};

export type AdminUpdateUserRoleInput = {
  role: ApplicationRole;
  userId: Scalars['String']['input'];
};

export type AdminUpdateUserRolePayload = {
  __typename?: 'AdminUpdateUserRolePayload';
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export enum ApplicationRole {
  GlobalAdmin = 'GLOBAL_ADMIN',
  User = 'USER'
}

export type ApplicationStatistic = {
  __typename?: 'ApplicationStatistic';
  backgroundTaskCount: Scalars['Int']['output'];
  checkInCount: Scalars['Int']['output'];
  guardmeCount: Scalars['Int']['output'];
  id: Scalars['Datetime']['output'];
  memberCount: Scalars['Int']['output'];
  organizationCount: Scalars['Int']['output'];
  planCount: Scalars['Int']['output'];
  rapidsosWorkflowCount: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
};

/** All input for the `approveMembershipRequest` mutation. */
export type ApproveMembershipRequestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  groupIds: Array<InputMaybe<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  privateMetadata: Scalars['JSON']['input'];
  publicMetadata: Scalars['JSON']['input'];
  role: MemberRole;
};

/** The output of our `approveMembershipRequest` mutation. */
export type ApproveMembershipRequestPayload = {
  __typename?: 'ApproveMembershipRequestPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge?: Maybe<MembersEdge>;
  /** Reads a single `Organization` that is related to this `Member`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Member`. */
  user?: Maybe<User>;
};


/** The output of our `approveMembershipRequest` mutation. */
export type ApproveMembershipRequestPayloadMemberEdgeArgs = {
  orderBy?: Array<MembersOrderBy>;
};

/** All input for the `assignBivyStickToMember` mutation. */
export type AssignBivyStickToMemberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

/** The output of our `assignBivyStickToMember` mutation. */
export type AssignBivyStickToMemberPayload = {
  __typename?: 'AssignBivyStickToMemberPayload';
  bivyStick?: Maybe<BivyStick>;
  /** An edge for our `BivyStick`. May be used by Relay 1. */
  bivyStickEdge?: Maybe<BivySticksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `BivyStick`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `BivyStick`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `assignBivyStickToMember` mutation. */
export type AssignBivyStickToMemberPayloadBivyStickEdgeArgs = {
  orderBy?: Array<BivySticksOrderBy>;
};

export type Attachment = Node & {
  __typename?: 'Attachment';
  createdAt: Scalars['Datetime']['output'];
  filename: Scalars['String']['output'];
  filesize: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Attachment`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `Attachment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AttachmentCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Attachment` object types. All fields are combined with a logical ‘and.’ */
export type AttachmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AttachmentFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AttachmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AttachmentFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `Attachment` values. */
export type AttachmentsConnection = {
  __typename?: 'AttachmentsConnection';
  /** A list of edges which contains the `Attachment` and cursor to aid in pagination. */
  edges: Array<AttachmentsEdge>;
  /** A list of `Attachment` objects. */
  nodes: Array<Attachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Attachment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Attachment` edge in the connection. */
export type AttachmentsEdge = {
  __typename?: 'AttachmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Attachment` at the end of the edge. */
  node: Attachment;
};

/** Methods to use when ordering `Attachment`. */
export enum AttachmentsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export enum AvatarType {
  Custom = 'CUSTOM',
  Gravatar = 'GRAVATAR',
  Initials = 'INITIALS'
}

export type BivyStick = Node & {
  __typename?: 'BivyStick';
  batteryLevel?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  imei: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isLocationEnabled: Scalars['Boolean']['output'];
  isMessagesEnabled: Scalars['Boolean']['output'];
  isRegistered: Scalars['Boolean']['output'];
  /** Reads a single `Member` that is related to this `BivyStick`. */
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `BivyStick`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `BivyStick` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BivyStickCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `imei` field. */
  imei?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `BivyStick` object types. All fields are combined with a logical ‘and.’ */
export type BivyStickFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BivyStickFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `imei` field. */
  imei?: InputMaybe<StringFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** A related `member` exists. */
  memberExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BivyStickFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BivyStickFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `BivyStick` values. */
export type BivySticksConnection = {
  __typename?: 'BivySticksConnection';
  /** A list of edges which contains the `BivyStick` and cursor to aid in pagination. */
  edges: Array<BivySticksEdge>;
  /** A list of `BivyStick` objects. */
  nodes: Array<BivyStick>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BivyStick` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BivyStick` edge in the connection. */
export type BivySticksEdge = {
  __typename?: 'BivySticksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BivyStick` at the end of the edge. */
  node: BivyStick;
};

/** Methods to use when ordering `BivyStick`. */
export enum BivySticksOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ImeiAsc = 'IMEI_ASC',
  ImeiDesc = 'IMEI_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** All input for the `cancelMembershipRequest` mutation. */
export type CancelMembershipRequestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `cancelMembershipRequest` mutation. */
export type CancelMembershipRequestPayload = {
  __typename?: 'CancelMembershipRequestPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MembershipCode` that is related to this `MembershipRequest`. */
  membershipCode?: Maybe<MembershipCode>;
  membershipRequest?: Maybe<MembershipRequest>;
  /** An edge for our `MembershipRequest`. May be used by Relay 1. */
  membershipRequestEdge?: Maybe<MembershipRequestsEdge>;
  /** Reads a single `Organization` that is related to this `MembershipRequest`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `MembershipRequest`. */
  user?: Maybe<User>;
};


/** The output of our `cancelMembershipRequest` mutation. */
export type CancelMembershipRequestPayloadMembershipRequestEdgeArgs = {
  orderBy?: Array<MembershipRequestsOrderBy>;
};

export type CheckIn = Node & {
  __typename?: 'CheckIn';
  accuracy: Scalars['Float']['output'];
  altitude: Scalars['Float']['output'];
  altitudeAccuracy: Scalars['Float']['output'];
  buildingFloor: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `CheckInRequest`. */
  checkInRequests: CheckInRequestsConnection;
  coordinates: GeometryPoint;
  createdAt: Scalars['Datetime']['output'];
  geocode?: Maybe<CheckInGeocode>;
  heading: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `CheckIn`. */
  member?: Maybe<Member>;
  memberId: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `CheckIn`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Place`. */
  places: PlacesConnection;
  shortId: Scalars['String']['output'];
  speed: Scalars['Float']['output'];
};


export type CheckInCheckInRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInRequestCondition>;
  filter?: InputMaybe<CheckInRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInRequestsOrderBy>>;
};


export type CheckInPlacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PlaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `CheckIn` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CheckInCondition = {
  /** Filters Check In's by creation. */
  createdAt?: InputMaybe<CheckInsCreatedAtConditionInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Filter Check In's by short ID. */
  shortId?: InputMaybe<Scalars['String']['input']>;
  /** Filter Check In's by user ID. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CheckIn` object types. All fields are combined with a logical ‘and.’ */
export type CheckInFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CheckInFilter>>;
  /** Filter by the object’s `checkInRequests` relation. */
  checkInRequests?: InputMaybe<CheckInToManyCheckInRequestFilter>;
  /** Some related `checkInRequests` exist. */
  checkInRequestsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CheckInFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CheckInFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

export type CheckInGeocode = {
  __typename?: 'CheckInGeocode';
  address: Scalars['String']['output'];
  id: Scalars['String']['output'];
  plusCode: Scalars['String']['output'];
  shortPlusCode: Scalars['String']['output'];
};

export type CheckInReport = Node & {
  __typename?: 'CheckInReport';
  /** Reads and enables pagination through a set of `CheckInRequest`. */
  checkInRequests: CheckInRequestsConnection;
  createdAt: Scalars['Datetime']['output'];
  cutoffAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `CheckInReport`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** Reads a single `Place` that is related to this `CheckInReport`. */
  place?: Maybe<Place>;
  placeId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `CheckInReport`. */
  requestorMember?: Maybe<Member>;
  requestorMemberId: Scalars['String']['output'];
  shortId: Scalars['String']['output'];
};


export type CheckInReportCheckInRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInRequestCondition>;
  filter?: InputMaybe<CheckInRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInRequestsOrderBy>>;
};

/**
 * A condition to be used against `CheckInReport` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CheckInReportCondition = {
  /** Filters Check In Report's by creation. */
  createdAt?: InputMaybe<CheckInReportsCreatedAtConditionInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `placeId` field. */
  placeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `requestorMemberId` field. */
  requestorMemberId?: InputMaybe<Scalars['String']['input']>;
  /** Filters Check In Report's by short ID. */
  shortId?: InputMaybe<Scalars['String']['input']>;
  /** Filters Check In Report's by user ID. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CheckInReport` object types. All fields are combined with a logical ‘and.’ */
export type CheckInReportFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CheckInReportFilter>>;
  /** Filter by the object’s `checkInRequests` relation. */
  checkInRequests?: InputMaybe<CheckInReportToManyCheckInRequestFilter>;
  /** Some related `checkInRequests` exist. */
  checkInRequestsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CheckInReportFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CheckInReportFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `place` relation. */
  place?: InputMaybe<PlaceFilter>;
  /** A related `place` exists. */
  placeExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `placeId` field. */
  placeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `requestorMember` relation. */
  requestorMember?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `requestorMemberId` field. */
  requestorMemberId?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `CheckInRequest` object types. All fields are combined with a logical ‘and.’ */
export type CheckInReportToManyCheckInRequestFilter = {
  /** Every related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckInRequestFilter>;
  /** No related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckInRequestFilter>;
  /** Some related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckInRequestFilter>;
};

export type CheckInReportUpdatesInput = {
  checkInReportId: Scalars['String']['input'];
};

export type CheckInReportUpdatesPayload = {
  __typename?: 'CheckInReportUpdatesPayload';
  checkInReport?: Maybe<CheckInReport>;
  event?: Maybe<GraphqlCheckInReportUpdateEvent>;
  relatedIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** A connection to a list of `CheckInReport` values. */
export type CheckInReportsConnection = {
  __typename?: 'CheckInReportsConnection';
  /** A list of edges which contains the `CheckInReport` and cursor to aid in pagination. */
  edges: Array<CheckInReportsEdge>;
  /** A list of `CheckInReport` objects. */
  nodes: Array<CheckInReport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CheckInReport` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type CheckInReportsCreatedAtConditionInput = {
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A `CheckInReport` edge in the connection. */
export type CheckInReportsEdge = {
  __typename?: 'CheckInReportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CheckInReport` at the end of the edge. */
  node: CheckInReport;
};

/** Methods to use when ordering `CheckInReport`. */
export enum CheckInReportsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PlaceIdAsc = 'PLACE_ID_ASC',
  PlaceIdDesc = 'PLACE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RequestorMemberIdAsc = 'REQUESTOR_MEMBER_ID_ASC',
  RequestorMemberIdDesc = 'REQUESTOR_MEMBER_ID_DESC'
}

export type CheckInRequest = Node & {
  __typename?: 'CheckInRequest';
  /** Reads a single `CheckIn` that is related to this `CheckInRequest`. */
  checkIn?: Maybe<CheckIn>;
  checkInId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CheckInReport` that is related to this `CheckInRequest`. */
  checkInReport?: Maybe<CheckInReport>;
  checkInReportId: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  cutoffAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Group` that is related to this `CheckInRequest`. */
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `CheckInRequest`. */
  member?: Maybe<Member>;
  memberId: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `CheckInRequest`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** Reads a single `Place` that is related to this `CheckInRequest`. */
  place?: Maybe<Place>;
  placeId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `CheckInRequest` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CheckInRequestCondition = {
  /** Checks for equality with the object’s `checkInId` field. */
  checkInId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `checkInReportId` field. */
  checkInReportId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `placeId` field. */
  placeId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CheckInRequest` object types. All fields are combined with a logical ‘and.’ */
export type CheckInRequestFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CheckInRequestFilter>>;
  /** Filter by the object’s `checkIn` relation. */
  checkIn?: InputMaybe<CheckInFilter>;
  /** A related `checkIn` exists. */
  checkInExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `checkInId` field. */
  checkInId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `checkInReport` relation. */
  checkInReport?: InputMaybe<CheckInReportFilter>;
  /** Filter by the object’s `checkInReportId` field. */
  checkInReportId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `group` relation. */
  group?: InputMaybe<GroupFilter>;
  /** A related `group` exists. */
  groupExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CheckInRequestFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CheckInRequestFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `place` relation. */
  place?: InputMaybe<PlaceFilter>;
  /** A related `place` exists. */
  placeExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `placeId` field. */
  placeId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `CheckInRequest` values. */
export type CheckInRequestsConnection = {
  __typename?: 'CheckInRequestsConnection';
  /** A list of edges which contains the `CheckInRequest` and cursor to aid in pagination. */
  edges: Array<CheckInRequestsEdge>;
  /** A list of `CheckInRequest` objects. */
  nodes: Array<CheckInRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CheckInRequest` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CheckInRequest` edge in the connection. */
export type CheckInRequestsEdge = {
  __typename?: 'CheckInRequestsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CheckInRequest` at the end of the edge. */
  node: CheckInRequest;
};

/** Methods to use when ordering `CheckInRequest`. */
export enum CheckInRequestsOrderBy {
  CheckInIdAsc = 'CHECK_IN_ID_ASC',
  CheckInIdDesc = 'CHECK_IN_ID_DESC',
  CheckInReportIdAsc = 'CHECK_IN_REPORT_ID_ASC',
  CheckInReportIdDesc = 'CHECK_IN_REPORT_ID_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PlaceIdAsc = 'PLACE_ID_ASC',
  PlaceIdDesc = 'PLACE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against many `CheckInRequest` object types. All fields are combined with a logical ‘and.’ */
export type CheckInToManyCheckInRequestFilter = {
  /** Every related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckInRequestFilter>;
  /** No related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckInRequestFilter>;
  /** Some related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckInRequestFilter>;
};

export type CheckInUpdatesInput = {
  organizationId: Scalars['String']['input'];
};

export type CheckInUpdatesPayload = {
  __typename?: 'CheckInUpdatesPayload';
  checkIn?: Maybe<CheckIn>;
  event?: Maybe<GraphqlCheckInEvent>;
  relatedIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** A connection to a list of `CheckIn` values. */
export type CheckInsConnection = {
  __typename?: 'CheckInsConnection';
  /** A list of edges which contains the `CheckIn` and cursor to aid in pagination. */
  edges: Array<CheckInsEdge>;
  /** A list of `CheckIn` objects. */
  nodes: Array<CheckIn>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CheckIn` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type CheckInsCreatedAtConditionInput = {
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A `CheckIn` edge in the connection. */
export type CheckInsEdge = {
  __typename?: 'CheckInsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CheckIn` at the end of the edge. */
  node: CheckIn;
};

/** Methods to use when ordering `CheckIn`. */
export enum CheckInsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `closeOrganization` mutation. */
export type CloseOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `closeOrganization` mutation. */
export type CloseOrganizationPayload = {
  __typename?: 'CloseOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `closeOrganization` mutation. */
export type CloseOrganizationPayloadOrganizationEdgeArgs = {
  orderBy?: Array<OrganizationsOrderBy>;
};

/** All input for the `completeMembershipRequest` mutation. */
export type CompleteMembershipRequestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  publicMetadata: Scalars['JSON']['input'];
};

/** The output of our `completeMembershipRequest` mutation. */
export type CompleteMembershipRequestPayload = {
  __typename?: 'CompleteMembershipRequestPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MembershipCode` that is related to this `MembershipRequest`. */
  membershipCode?: Maybe<MembershipCode>;
  membershipRequest?: Maybe<MembershipRequest>;
  /** An edge for our `MembershipRequest`. May be used by Relay 1. */
  membershipRequestEdge?: Maybe<MembershipRequestsEdge>;
  /** Reads a single `Organization` that is related to this `MembershipRequest`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `MembershipRequest`. */
  user?: Maybe<User>;
};


/** The output of our `completeMembershipRequest` mutation. */
export type CompleteMembershipRequestPayloadMembershipRequestEdgeArgs = {
  orderBy?: Array<MembershipRequestsOrderBy>;
};

/** All input for the `concludeGuardme` mutation. */
export type ConcludeGuardmeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['String']['input'];
};

/** The output of our `concludeGuardme` mutation. */
export type ConcludeGuardmePayload = {
  __typename?: 'ConcludeGuardmePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  guardme?: Maybe<Guardme>;
  /** An edge for our `Guardme`. May be used by Relay 1. */
  guardmeEdge?: Maybe<GuardmesEdge>;
  /** Reads a single `Member` that is related to this `Guardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Guardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `concludeGuardme` mutation. */
export type ConcludeGuardmePayloadGuardmeEdgeArgs = {
  orderBy?: Array<GuardmesOrderBy>;
};

/** An input for mutations affecting `Coordinate` */
export type CoordinateInput = {
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  altitude?: InputMaybe<Scalars['Float']['input']>;
  altitudeAccuracy?: InputMaybe<Scalars['Float']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

/** All input for the `createBivyStick` mutation. */
export type CreateBivyStickInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  imei: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `createBivyStick` mutation. */
export type CreateBivyStickPayload = {
  __typename?: 'CreateBivyStickPayload';
  bivyStick?: Maybe<BivyStick>;
  /** An edge for our `BivyStick`. May be used by Relay 1. */
  bivyStickEdge?: Maybe<BivySticksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `BivyStick`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `BivyStick`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createBivyStick` mutation. */
export type CreateBivyStickPayloadBivyStickEdgeArgs = {
  orderBy?: Array<BivySticksOrderBy>;
};

/** All input for the `createCheckInReport` mutation. */
export type CreateCheckInReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cutoffAt?: InputMaybe<Scalars['Datetime']['input']>;
  groupIds: Array<InputMaybe<Scalars['String']['input']>>;
  memberIds: Array<InputMaybe<Scalars['String']['input']>>;
  organizationId: Scalars['String']['input'];
  placeId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `createCheckInReport` mutation. */
export type CreateCheckInReportPayload = {
  __typename?: 'CreateCheckInReportPayload';
  checkInReport?: Maybe<CheckInReport>;
  /** An edge for our `CheckInReport`. May be used by Relay 1. */
  checkInReportEdge?: Maybe<CheckInReportsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `CheckInReport`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Place` that is related to this `CheckInReport`. */
  place?: Maybe<Place>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Member` that is related to this `CheckInReport`. */
  requestorMember?: Maybe<Member>;
};


/** The output of our `createCheckInReport` mutation. */
export type CreateCheckInReportPayloadCheckInReportEdgeArgs = {
  orderBy?: Array<CheckInReportsOrderBy>;
};

/** All input for the `createEmergencyContact` mutation. */
export type CreateEmergencyContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
};

/** The output of our `createEmergencyContact` mutation. */
export type CreateEmergencyContactPayload = {
  __typename?: 'CreateEmergencyContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emergencyContact?: Maybe<EmergencyContact>;
  /** An edge for our `EmergencyContact`. May be used by Relay 1. */
  emergencyContactEdge?: Maybe<EmergencyContactsEdge>;
  /** Reads a single `Member` that is related to this `EmergencyContact`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `EmergencyContact`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmergencyContact`. */
  user?: Maybe<User>;
};


/** The output of our `createEmergencyContact` mutation. */
export type CreateEmergencyContactPayloadEmergencyContactEdgeArgs = {
  orderBy?: Array<EmergencyContactsOrderBy>;
};

/** All input for the `createGroup` mutation. */
export type CreateGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `createGroup` mutation. */
export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Organization` that is related to this `Group`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createGroup` mutation. */
export type CreateGroupPayloadGroupEdgeArgs = {
  orderBy?: Array<GroupsOrderBy>;
};

/** All input for the `createIncident` mutation. */
export type CreateIncidentInput = {
  additionalData: Scalars['JSON']['input'];
  attachmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactMemberId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  incidentCoordinates: CoordinateInput;
  incidentTypeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  parentIncidentId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<IncidentPriorityType>;
  subject: Scalars['String']['input'];
  submitterCoordinates: CoordinateInput;
};

/** All input for the `createIncidentNote` mutation. */
export type CreateIncidentNoteInput = {
  attachmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  incidentId: Scalars['String']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `createIncidentNote` mutation. */
export type CreateIncidentNotePayload = {
  __typename?: 'CreateIncidentNotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `Incident`. */
  contactMember?: Maybe<Member>;
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `IncidentType` that is related to this `Incident`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `Organization` that is related to this `Incident`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Group` that is related to this `Incident`. */
  ownedByGroup?: Maybe<Group>;
  /** Reads a single `Member` that is related to this `Incident`. */
  ownedByMember?: Maybe<Member>;
  /** Reads a single `Incident` that is related to this `Incident`. */
  parent?: Maybe<Incident>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Member` that is related to this `Incident`. */
  submittedByMember?: Maybe<Member>;
};


/** The output of our `createIncidentNote` mutation. */
export type CreateIncidentNotePayloadIncidentEdgeArgs = {
  orderBy?: Array<IncidentsOrderBy>;
};

/** The output of our `createIncident` mutation. */
export type CreateIncidentPayload = {
  __typename?: 'CreateIncidentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `Incident`. */
  contactMember?: Maybe<Member>;
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `IncidentType` that is related to this `Incident`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `Organization` that is related to this `Incident`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Group` that is related to this `Incident`. */
  ownedByGroup?: Maybe<Group>;
  /** Reads a single `Member` that is related to this `Incident`. */
  ownedByMember?: Maybe<Member>;
  /** Reads a single `Incident` that is related to this `Incident`. */
  parent?: Maybe<Incident>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Member` that is related to this `Incident`. */
  submittedByMember?: Maybe<Member>;
};


/** The output of our `createIncident` mutation. */
export type CreateIncidentPayloadIncidentEdgeArgs = {
  orderBy?: Array<IncidentsOrderBy>;
};

/** All input for the `createInvitation` mutation. */
export type CreateInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupIds: Array<InputMaybe<Scalars['String']['input']>>;
  key: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
  organizationId: Scalars['String']['input'];
  organizationRole: MemberRole;
};

/** The output of our `createInvitation` mutation. */
export type CreateInvitationPayload = {
  __typename?: 'CreateInvitationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invitation?: Maybe<Invitation>;
  /** An edge for our `Invitation`. May be used by Relay 1. */
  invitationEdge?: Maybe<InvitationsEdge>;
  /** Reads a single `Organization` that is related to this `Invitation`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createInvitation` mutation. */
export type CreateInvitationPayloadInvitationEdgeArgs = {
  orderBy?: Array<InvitationsOrderBy>;
};

/** All input for the `createMembershipCode` mutation. */
export type CreateMembershipCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  groupIds: Array<InputMaybe<Scalars['String']['input']>>;
  organizationId: Scalars['String']['input'];
  organizationRole: MemberRole;
  requiresApproval: Scalars['Boolean']['input'];
};

/** The output of our `createMembershipCode` mutation. */
export type CreateMembershipCodePayload = {
  __typename?: 'CreateMembershipCodePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  membershipCode?: Maybe<MembershipCode>;
  /** An edge for our `MembershipCode`. May be used by Relay 1. */
  membershipCodeEdge?: Maybe<MembershipCodesEdge>;
  /** Reads a single `Organization` that is related to this `MembershipCode`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createMembershipCode` mutation. */
export type CreateMembershipCodePayloadMembershipCodeEdgeArgs = {
  orderBy?: Array<MembershipCodesOrderBy>;
};

/** All input for the `createOneshotScheduledGuardme` mutation. */
export type CreateOneshotScheduledGuardmeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  durationMinutes: Scalars['Int']['input'];
  isEnabled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
  schedule: Scalars['Datetime']['input'];
  timezone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** The output of our `createOneshotScheduledGuardme` mutation. */
export type CreateOneshotScheduledGuardmePayload = {
  __typename?: 'CreateOneshotScheduledGuardmePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `ScheduledGuardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `ScheduledGuardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  scheduledGuardme?: Maybe<ScheduledGuardme>;
  /** An edge for our `ScheduledGuardme`. May be used by Relay 1. */
  scheduledGuardmeEdge?: Maybe<ScheduledGuardmesEdge>;
};


/** The output of our `createOneshotScheduledGuardme` mutation. */
export type CreateOneshotScheduledGuardmePayloadScheduledGuardmeEdgeArgs = {
  orderBy?: Array<ScheduledGuardmesOrderBy>;
};

export type CreateOrganizationSubscriptionIntentInput = {
  annual: Scalars['Boolean']['input'];
  metadata: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  subscriptionCount: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
};

export type CreateOrganizationSubscriptionIntentPayload = {
  __typename?: 'CreateOrganizationSubscriptionIntentPayload';
  clientSecret: Scalars['String']['output'];
  invoice: StripeInvoice;
  organizationId: Scalars['String']['output'];
  query?: Maybe<Query>;
  subscriptionId: Scalars['String']['output'];
};

/** All input for the `createPlace` mutation. */
export type CreatePlaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  geojson: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  radius: Scalars['Int']['input'];
};

/** The output of our `createPlace` mutation. */
export type CreatePlacePayload = {
  __typename?: 'CreatePlacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Place`. */
  organization?: Maybe<Organization>;
  place?: Maybe<Place>;
  /** An edge for our `Place`. May be used by Relay 1. */
  placeEdge?: Maybe<PlacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPlace` mutation. */
export type CreatePlacePayloadPlaceEdgeArgs = {
  orderBy?: Array<PlacesOrderBy>;
};

/** All input for the `createPtcAsset` mutation. */
export type CreatePtcAssetInput = {
  chainingStationValue: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crc: Scalars['String']['input'];
  distanceFromReferencePoint: Scalars['String']['input'];
  drawingReference: Scalars['String']['input'];
  line: Scalars['String']['input'];
  lineShort: Scalars['String']['input'];
  location: Scalars['String']['input'];
  mpValueOfFirstTransponder: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  ramsId: Scalars['String']['input'];
  referencePoint: Scalars['String']['input'];
  referencePointStationChaining: Scalars['String']['input'];
  softwareReleaseTimestamp: Scalars['String']['input'];
  softwareVersion: Scalars['String']['input'];
  telegramHex: Scalars['String']['input'];
  trackNumber: Scalars['String']['input'];
  transponderNumber: Scalars['String']['input'];
  transponderSet: Scalars['String']['input'];
};

/** All input for the `createPtcAssetInstallationReport` mutation. */
export type CreatePtcAssetInstallationReportInput = {
  actualDistanceFromReferencePoint: Scalars['Float']['input'];
  actualDistanceFromReferencePointComment: Scalars['String']['input'];
  chainingStationValueComment: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crcComment: Scalars['String']['input'];
  distanceFromReferencePointComment: Scalars['String']['input'];
  drawingReferenceComment: Scalars['String']['input'];
  gpsCoordindates: Scalars['GeoJSON']['input'];
  gpsCoordindatesComment: Scalars['String']['input'];
  installedAt: Scalars['Datetime']['input'];
  installedAtComment: Scalars['String']['input'];
  installedByMemberComment: Scalars['String']['input'];
  installedByMemberId: Scalars['String']['input'];
  lineComment: Scalars['String']['input'];
  locationComment: Scalars['String']['input'];
  mpValueOfFirstTransponderComment: Scalars['String']['input'];
  programPlugLabelIdVerifiedByMemberComment: Scalars['String']['input'];
  programPlugLabelIdVerifiedByMemberId: Scalars['String']['input'];
  ptcAssetId: Scalars['UUID']['input'];
  ramsIdComment: Scalars['String']['input'];
  referencePointComment: Scalars['String']['input'];
  referencePointStationChainingComment: Scalars['String']['input'];
  softwareReleaseTimestampComment: Scalars['String']['input'];
  softwareVersionComment: Scalars['String']['input'];
  telegramHexComment: Scalars['String']['input'];
  trackNumberComment: Scalars['String']['input'];
  transponderNumberComment: Scalars['String']['input'];
  transponderSerialNumber: Scalars['String']['input'];
  transponderSerialNumberComment: Scalars['String']['input'];
  transponderSetComment: Scalars['String']['input'];
  transponderTelegramReadByMemberComment: Scalars['String']['input'];
  transponderTelegramReadByMemberId: Scalars['String']['input'];
  verifiedAt: Scalars['Datetime']['input'];
  verifiedAtComment: Scalars['String']['input'];
  verifiedByMemberComment: Scalars['String']['input'];
  verifiedByMemberId: Scalars['String']['input'];
};

/** The output of our `createPtcAssetInstallationReport` mutation. */
export type CreatePtcAssetInstallationReportPayload = {
  __typename?: 'CreatePtcAssetInstallationReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `PtcAsset`. */
  organization?: Maybe<Organization>;
  ptcAsset?: Maybe<PtcAsset>;
  /** An edge for our `PtcAsset`. May be used by Relay 1. */
  ptcAssetEdge?: Maybe<PtcAssetsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPtcAssetInstallationReport` mutation. */
export type CreatePtcAssetInstallationReportPayloadPtcAssetEdgeArgs = {
  orderBy?: Array<PtcAssetsOrderBy>;
};

/** The output of our `createPtcAsset` mutation. */
export type CreatePtcAssetPayload = {
  __typename?: 'CreatePtcAssetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `PtcAsset`. */
  organization?: Maybe<Organization>;
  ptcAsset?: Maybe<PtcAsset>;
  /** An edge for our `PtcAsset`. May be used by Relay 1. */
  ptcAssetEdge?: Maybe<PtcAssetsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPtcAsset` mutation. */
export type CreatePtcAssetPayloadPtcAssetEdgeArgs = {
  orderBy?: Array<PtcAssetsOrderBy>;
};

/** All input for the `createPtcAssetVerificationReport` mutation. */
export type CreatePtcAssetVerificationReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ptcAssetId: Scalars['UUID']['input'];
  question01Comment: Scalars['String']['input'];
  question01Response: Scalars['Boolean']['input'];
  question02Comment: Scalars['String']['input'];
  question02Response: Scalars['Boolean']['input'];
  question03Comment: Scalars['String']['input'];
  question03Response: Scalars['Boolean']['input'];
  question04Comment: Scalars['String']['input'];
  question04Response: Scalars['Boolean']['input'];
  question05Comment: Scalars['String']['input'];
  question05Response: Scalars['Boolean']['input'];
  question06Comment: Scalars['String']['input'];
  question06Response: Scalars['Boolean']['input'];
  question07Comment: Scalars['String']['input'];
  question07Response: Scalars['Boolean']['input'];
  question08Comment: Scalars['String']['input'];
  question08Response: Scalars['Boolean']['input'];
  question09Comment: Scalars['String']['input'];
  question09Response: Scalars['Boolean']['input'];
  question10Comment: Scalars['String']['input'];
  question10Response: Scalars['Boolean']['input'];
  question11Comment: Scalars['String']['input'];
  question11Response: Scalars['Boolean']['input'];
  question12Comment: Scalars['String']['input'];
  question12Response: Scalars['Boolean']['input'];
  question13Comment: Scalars['String']['input'];
  question13Response: Scalars['Boolean']['input'];
};

/** The output of our `createPtcAssetVerificationReport` mutation. */
export type CreatePtcAssetVerificationReportPayload = {
  __typename?: 'CreatePtcAssetVerificationReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `PtcAsset`. */
  organization?: Maybe<Organization>;
  ptcAsset?: Maybe<PtcAsset>;
  /** An edge for our `PtcAsset`. May be used by Relay 1. */
  ptcAssetEdge?: Maybe<PtcAssetsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPtcAssetVerificationReport` mutation. */
export type CreatePtcAssetVerificationReportPayloadPtcAssetEdgeArgs = {
  orderBy?: Array<PtcAssetsOrderBy>;
};

/** All input for the `createRecurringScheduledGuardme` mutation. */
export type CreateRecurringScheduledGuardmeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  durationMinutes: Scalars['Int']['input'];
  isEnabled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
  schedule: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** The output of our `createRecurringScheduledGuardme` mutation. */
export type CreateRecurringScheduledGuardmePayload = {
  __typename?: 'CreateRecurringScheduledGuardmePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `ScheduledGuardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `ScheduledGuardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  scheduledGuardme?: Maybe<ScheduledGuardme>;
  /** An edge for our `ScheduledGuardme`. May be used by Relay 1. */
  scheduledGuardmeEdge?: Maybe<ScheduledGuardmesEdge>;
};


/** The output of our `createRecurringScheduledGuardme` mutation. */
export type CreateRecurringScheduledGuardmePayloadScheduledGuardmeEdgeArgs = {
  orderBy?: Array<ScheduledGuardmesOrderBy>;
};

/** An input for mutations affecting `CurrentLocationInputRecord` */
export type CurrentLocationInputRecordInput = {
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  altitude?: InputMaybe<Scalars['Float']['input']>;
  altitudeAccuracy?: InputMaybe<Scalars['Float']['input']>;
  buildingFloor?: InputMaybe<Scalars['Int']['input']>;
  heading?: InputMaybe<Scalars['Float']['input']>;
  isMock?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  recordedAt?: InputMaybe<Scalars['Datetime']['input']>;
  speed?: InputMaybe<Scalars['Float']['input']>;
};

/** All input for the `currentUserCloseAccount` mutation. */
export type CurrentUserCloseAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `currentUserCloseAccount` mutation. */
export type CurrentUserCloseAccountPayload = {
  __typename?: 'CurrentUserCloseAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `currentUserCloseAccount` mutation. */
export type CurrentUserCloseAccountPayloadUserEdgeArgs = {
  orderBy?: Array<UsersOrderBy>;
};

/** All input for the `currentUserDeleteEmailAddress` mutation. */
export type CurrentUserDeleteEmailAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `currentUserDeleteEmailAddress` mutation. */
export type CurrentUserDeleteEmailAddressPayload = {
  __typename?: 'CurrentUserDeleteEmailAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `currentUserDeleteEmailAddress` mutation. */
export type CurrentUserDeleteEmailAddressPayloadUserEdgeArgs = {
  orderBy?: Array<UsersOrderBy>;
};

/** All input for the `currentUserDeletePendingEmailAddress` mutation. */
export type CurrentUserDeletePendingEmailAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `currentUserDeletePendingEmailAddress` mutation. */
export type CurrentUserDeletePendingEmailAddressPayload = {
  __typename?: 'CurrentUserDeletePendingEmailAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  pendingEmailAddress?: Maybe<PendingEmailAddress>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `currentUserDeletePendingPhoneNumber` mutation. */
export type CurrentUserDeletePendingPhoneNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `currentUserDeletePendingPhoneNumber` mutation. */
export type CurrentUserDeletePendingPhoneNumberPayload = {
  __typename?: 'CurrentUserDeletePendingPhoneNumberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  pendingPhoneNumber?: Maybe<PendingPhoneNumber>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `currentUserDeletePhoneNumber` mutation. */
export type CurrentUserDeletePhoneNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `currentUserDeletePhoneNumber` mutation. */
export type CurrentUserDeletePhoneNumberPayload = {
  __typename?: 'CurrentUserDeletePhoneNumberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `currentUserDeletePhoneNumber` mutation. */
export type CurrentUserDeletePhoneNumberPayloadUserEdgeArgs = {
  orderBy?: Array<UsersOrderBy>;
};

export type CurrentUserNotificationUpdatesPayload = {
  __typename?: 'CurrentUserNotificationUpdatesPayload';
  event?: Maybe<Scalars['String']['output']>;
  relatedIds?: Maybe<Array<Scalars['String']['output']>>;
  userNotification?: Maybe<UserNotification>;
};

/** All input for the `currentUserUpdateAvatarUrl` mutation. */
export type CurrentUserUpdateAvatarUrlInput = {
  avatarUrl: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `currentUserUpdateAvatarUrl` mutation. */
export type CurrentUserUpdateAvatarUrlPayload = {
  __typename?: 'CurrentUserUpdateAvatarUrlPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `currentUserUpdateAvatarUrl` mutation. */
export type CurrentUserUpdateAvatarUrlPayloadUserEdgeArgs = {
  orderBy?: Array<UsersOrderBy>;
};

export type CurrentUserUpdateDetailsInput = {
  avatarType: UpdateAvatarType;
  customAvatarKey?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type CurrentUserUpdateDetailsPayload = {
  __typename?: 'CurrentUserUpdateDetailsPayload';
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

/** All input for the `currentUserUpdateEmailAddress` mutation. */
export type CurrentUserUpdateEmailAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
};

/** The output of our `currentUserUpdateEmailAddress` mutation. */
export type CurrentUserUpdateEmailAddressPayload = {
  __typename?: 'CurrentUserUpdateEmailAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  pendingEmailAddress?: Maybe<PendingEmailAddress>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `currentUserUpdateFullName` mutation. */
export type CurrentUserUpdateFullNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
};

/** The output of our `currentUserUpdateFullName` mutation. */
export type CurrentUserUpdateFullNamePayload = {
  __typename?: 'CurrentUserUpdateFullNamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `currentUserUpdateFullName` mutation. */
export type CurrentUserUpdateFullNamePayloadUserEdgeArgs = {
  orderBy?: Array<UsersOrderBy>;
};

/** All input for the `currentUserUpdateMetadata` mutation. */
export type CurrentUserUpdateMetadataInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  metadata: Scalars['JSON']['input'];
};

/** The output of our `currentUserUpdateMetadata` mutation. */
export type CurrentUserUpdateMetadataPayload = {
  __typename?: 'CurrentUserUpdateMetadataPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `currentUserUpdateMetadata` mutation. */
export type CurrentUserUpdateMetadataPayloadUserEdgeArgs = {
  orderBy?: Array<UsersOrderBy>;
};

/** All input for the `currentUserUpdatePhoneNumber` mutation. */
export type CurrentUserUpdatePhoneNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

/** The output of our `currentUserUpdatePhoneNumber` mutation. */
export type CurrentUserUpdatePhoneNumberPayload = {
  __typename?: 'CurrentUserUpdatePhoneNumberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  pendingPhoneNumber?: Maybe<PendingPhoneNumber>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type CurrentUserUpdatesPayload = {
  __typename?: 'CurrentUserUpdatesPayload';
  event?: Maybe<Scalars['String']['output']>;
  relatedIds?: Maybe<Array<Scalars['String']['output']>>;
  user?: Maybe<User>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

export type DebugMobilePushInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  /** Subtitle only valid for iOS notifications */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DebugMobilePushPayload = {
  __typename?: 'DebugMobilePushPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  query?: Maybe<Query>;
};

export type DebugSentryErrorPayload = {
  __typename?: 'DebugSentryErrorPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorId: Scalars['String']['output'];
};

/** All input for the `deleteAllUserNotifications` mutation. */
export type DeleteAllUserNotificationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filter: UserNotificationReadFilter;
};

/** The output of our `deleteAllUserNotifications` mutation. */
export type DeleteAllUserNotificationsPayload = {
  __typename?: 'DeleteAllUserNotificationsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  userNotifications?: Maybe<Array<UserNotification>>;
};

/** All input for the `deleteBivyStick` mutation. */
export type DeleteBivyStickInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `deleteBivyStick` mutation. */
export type DeleteBivyStickPayload = {
  __typename?: 'DeleteBivyStickPayload';
  bivyStick?: Maybe<BivyStick>;
  /** An edge for our `BivyStick`. May be used by Relay 1. */
  bivyStickEdge?: Maybe<BivySticksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `BivyStick`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `BivyStick`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deleteBivyStick` mutation. */
export type DeleteBivyStickPayloadBivyStickEdgeArgs = {
  orderBy?: Array<BivySticksOrderBy>;
};

/** All input for the `deleteCheckInReport` mutation. */
export type DeleteCheckInReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `deleteCheckInReport` mutation. */
export type DeleteCheckInReportPayload = {
  __typename?: 'DeleteCheckInReportPayload';
  checkInReport?: Maybe<CheckInReport>;
  /** An edge for our `CheckInReport`. May be used by Relay 1. */
  checkInReportEdge?: Maybe<CheckInReportsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `CheckInReport`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Place` that is related to this `CheckInReport`. */
  place?: Maybe<Place>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Member` that is related to this `CheckInReport`. */
  requestorMember?: Maybe<Member>;
};


/** The output of our `deleteCheckInReport` mutation. */
export type DeleteCheckInReportPayloadCheckInReportEdgeArgs = {
  orderBy?: Array<CheckInReportsOrderBy>;
};

/** All input for the `deleteEmergencyContact` mutation. */
export type DeleteEmergencyContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `deleteEmergencyContact` mutation. */
export type DeleteEmergencyContactPayload = {
  __typename?: 'DeleteEmergencyContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emergencyContact?: Maybe<EmergencyContact>;
  /** An edge for our `EmergencyContact`. May be used by Relay 1. */
  emergencyContactEdge?: Maybe<EmergencyContactsEdge>;
  /** Reads a single `Member` that is related to this `EmergencyContact`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `EmergencyContact`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmergencyContact`. */
  user?: Maybe<User>;
};


/** The output of our `deleteEmergencyContact` mutation. */
export type DeleteEmergencyContactPayloadEmergencyContactEdgeArgs = {
  orderBy?: Array<EmergencyContactsOrderBy>;
};

/** All input for the `deleteGroup` mutation. */
export type DeleteGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `deleteGroup` mutation. */
export type DeleteGroupPayload = {
  __typename?: 'DeleteGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Organization` that is related to this `Group`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deleteGroup` mutation. */
export type DeleteGroupPayloadGroupEdgeArgs = {
  orderBy?: Array<GroupsOrderBy>;
};

/** All input for the `deleteGuardmeAttachment` mutation. */
export type DeleteGuardmeAttachmentInput = {
  attachmentId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `deleteGuardmeAttachment` mutation. */
export type DeleteGuardmeAttachmentPayload = {
  __typename?: 'DeleteGuardmeAttachmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Guardme` that is related to this `GuardmeAttachment`. */
  guardme?: Maybe<Guardme>;
  guardmeAttachment?: Maybe<GuardmeAttachment>;
  /** An edge for our `GuardmeAttachment`. May be used by Relay 1. */
  guardmeAttachmentEdge?: Maybe<GuardmeAttachmentsEdge>;
  /** Reads a single `Member` that is related to this `GuardmeAttachment`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `GuardmeAttachment`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deleteGuardmeAttachment` mutation. */
export type DeleteGuardmeAttachmentPayloadGuardmeAttachmentEdgeArgs = {
  orderBy?: Array<GuardmeAttachmentsOrderBy>;
};

/** All input for the `deleteIncidentType` mutation. */
export type DeleteIncidentTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `deleteIncidentType` mutation. */
export type DeleteIncidentTypePayload = {
  __typename?: 'DeleteIncidentTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  incidentType?: Maybe<IncidentType>;
  /** An edge for our `IncidentType`. May be used by Relay 1. */
  incidentTypeEdge?: Maybe<IncidentTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deleteIncidentType` mutation. */
export type DeleteIncidentTypePayloadIncidentTypeEdgeArgs = {
  orderBy?: Array<IncidentTypesOrderBy>;
};

/** All input for the `deleteInvitation` mutation. */
export type DeleteInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `deleteInvitation` mutation. */
export type DeleteInvitationPayload = {
  __typename?: 'DeleteInvitationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invitation?: Maybe<Invitation>;
  /** An edge for our `Invitation`. May be used by Relay 1. */
  invitationEdge?: Maybe<InvitationsEdge>;
  /** Reads a single `Organization` that is related to this `Invitation`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deleteInvitation` mutation. */
export type DeleteInvitationPayloadInvitationEdgeArgs = {
  orderBy?: Array<InvitationsOrderBy>;
};

/** All input for the `deleteMember` mutation. */
export type DeleteMemberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** All input for the `deleteMemberMetadataField` mutation. */
export type DeleteMemberMetadataFieldInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fieldName: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `deleteMemberMetadataField` mutation. */
export type DeleteMemberMetadataFieldPayload = {
  __typename?: 'DeleteMemberMetadataFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  json?: Maybe<Scalars['JSON']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `deleteMember` mutation. */
export type DeleteMemberPayload = {
  __typename?: 'DeleteMemberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge?: Maybe<MembersEdge>;
  /** Reads a single `Organization` that is related to this `Member`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Member`. */
  user?: Maybe<User>;
};


/** The output of our `deleteMember` mutation. */
export type DeleteMemberPayloadMemberEdgeArgs = {
  orderBy?: Array<MembersOrderBy>;
};

/** All input for the `deleteMembershipCode` mutation. */
export type DeleteMembershipCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `deleteMembershipCode` mutation. */
export type DeleteMembershipCodePayload = {
  __typename?: 'DeleteMembershipCodePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  membershipCode?: Maybe<MembershipCode>;
  /** An edge for our `MembershipCode`. May be used by Relay 1. */
  membershipCodeEdge?: Maybe<MembershipCodesEdge>;
  /** Reads a single `Organization` that is related to this `MembershipCode`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deleteMembershipCode` mutation. */
export type DeleteMembershipCodePayloadMembershipCodeEdgeArgs = {
  orderBy?: Array<MembershipCodesOrderBy>;
};

/** All input for the `deleteOrganization` mutation. */
export type DeleteOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  soft: Scalars['Boolean']['input'];
};

/** The output of our `deleteOrganization` mutation. */
export type DeleteOrganizationPayload = {
  __typename?: 'DeleteOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deleteOrganization` mutation. */
export type DeleteOrganizationPayloadOrganizationEdgeArgs = {
  orderBy?: Array<OrganizationsOrderBy>;
};

export type DeleteOrganizationSubscriptionIntentInput = {
  subscriptionId: Scalars['String']['input'];
};

export type DeleteOrganizationSubscriptionIntentPayload = {
  __typename?: 'DeleteOrganizationSubscriptionIntentPayload';
  query?: Maybe<Query>;
  status: Scalars['Boolean']['output'];
};

/** All input for the `deletePlace` mutation. */
export type DeletePlaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `deletePlace` mutation. */
export type DeletePlacePayload = {
  __typename?: 'DeletePlacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Place`. */
  organization?: Maybe<Organization>;
  place?: Maybe<Place>;
  /** An edge for our `Place`. May be used by Relay 1. */
  placeEdge?: Maybe<PlacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deletePlace` mutation. */
export type DeletePlacePayloadPlaceEdgeArgs = {
  orderBy?: Array<PlacesOrderBy>;
};

/** All input for the `deletePlan` mutation. */
export type DeletePlanInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
};

/** The output of our `deletePlan` mutation. */
export type DeletePlanPayload = {
  __typename?: 'DeletePlanPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  /** An edge for our `Plan`. May be used by Relay 1. */
  planEdge?: Maybe<PlansEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `deletePlan` mutation. */
export type DeletePlanPayloadPlanEdgeArgs = {
  orderBy?: Array<PlansOrderBy>;
};

/** All input for the `deleteScheduledGuardme` mutation. */
export type DeleteScheduledGuardmeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our `deleteScheduledGuardme` mutation. */
export type DeleteScheduledGuardmePayload = {
  __typename?: 'DeleteScheduledGuardmePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `ScheduledGuardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `ScheduledGuardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  scheduledGuardme?: Maybe<ScheduledGuardme>;
  /** An edge for our `ScheduledGuardme`. May be used by Relay 1. */
  scheduledGuardmeEdge?: Maybe<ScheduledGuardmesEdge>;
};


/** The output of our `deleteScheduledGuardme` mutation. */
export type DeleteScheduledGuardmePayloadScheduledGuardmeEdgeArgs = {
  orderBy?: Array<ScheduledGuardmesOrderBy>;
};

/** All input for the `deleteUserNotifications` mutation. */
export type DeleteUserNotificationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notificationIds: Array<InputMaybe<Scalars['String']['input']>>;
};

/** The output of our `deleteUserNotifications` mutation. */
export type DeleteUserNotificationsPayload = {
  __typename?: 'DeleteUserNotificationsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  userNotifications?: Maybe<Array<UserNotification>>;
};

/** All input for the `denyInvitation` mutation. */
export type DenyInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `denyInvitation` mutation. */
export type DenyInvitationPayload = {
  __typename?: 'DenyInvitationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invitation?: Maybe<Invitation>;
  /** An edge for our `Invitation`. May be used by Relay 1. */
  invitationEdge?: Maybe<InvitationsEdge>;
  /** Reads a single `Organization` that is related to this `Invitation`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `denyInvitation` mutation. */
export type DenyInvitationPayloadInvitationEdgeArgs = {
  orderBy?: Array<InvitationsOrderBy>;
};

/** All input for the `denyMembershipRequest` mutation. */
export type DenyMembershipRequestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `denyMembershipRequest` mutation. */
export type DenyMembershipRequestPayload = {
  __typename?: 'DenyMembershipRequestPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MembershipCode` that is related to this `MembershipRequest`. */
  membershipCode?: Maybe<MembershipCode>;
  membershipRequest?: Maybe<MembershipRequest>;
  /** An edge for our `MembershipRequest`. May be used by Relay 1. */
  membershipRequestEdge?: Maybe<MembershipRequestsEdge>;
  /** Reads a single `Organization` that is related to this `MembershipRequest`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `MembershipRequest`. */
  user?: Maybe<User>;
};


/** The output of our `denyMembershipRequest` mutation. */
export type DenyMembershipRequestPayloadMembershipRequestEdgeArgs = {
  orderBy?: Array<MembershipRequestsOrderBy>;
};

/** All input for the `deregisterMobileDevice` mutation. */
export type DeregisterMobileDeviceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `deregisterMobileDevice` mutation. */
export type DeregisterMobileDevicePayload = {
  __typename?: 'DeregisterMobileDevicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  mobileDevice?: Maybe<MobileDevice>;
  /** An edge for our `MobileDevice`. May be used by Relay 1. */
  mobileDeviceEdge?: Maybe<MobileDevicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `MobileDevice`. */
  user?: Maybe<User>;
};


/** The output of our `deregisterMobileDevice` mutation. */
export type DeregisterMobileDevicePayloadMobileDeviceEdgeArgs = {
  orderBy?: Array<MobileDevicesOrderBy>;
};

/** All input for the `disableIncidentForOrganization` mutation. */
export type DisableIncidentForOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  incidentTypeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `disableIncidentForOrganization` mutation. */
export type DisableIncidentForOrganizationPayload = {
  __typename?: 'DisableIncidentForOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `EnabledIncidentType`. */
  defaultAssignedGroup?: Maybe<Group>;
  enabledIncidentType?: Maybe<EnabledIncidentType>;
  /** An edge for our `EnabledIncidentType`. May be used by Relay 1. */
  enabledIncidentTypeEdge?: Maybe<EnabledIncidentTypesEdge>;
  /** Reads a single `IncidentType` that is related to this `EnabledIncidentType`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `Organization` that is related to this `EnabledIncidentType`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `disableIncidentForOrganization` mutation. */
export type DisableIncidentForOrganizationPayloadEnabledIncidentTypeEdgeArgs = {
  orderBy?: Array<EnabledIncidentTypesOrderBy>;
};

/** All input for the `disableMember` mutation. */
export type DisableMemberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `disableMember` mutation. */
export type DisableMemberPayload = {
  __typename?: 'DisableMemberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge?: Maybe<MembersEdge>;
  /** Reads a single `Organization` that is related to this `Member`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Member`. */
  user?: Maybe<User>;
};


/** The output of our `disableMember` mutation. */
export type DisableMemberPayloadMemberEdgeArgs = {
  orderBy?: Array<MembersOrderBy>;
};

/** All input for the `disableUser` mutation. */
export type DisableUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** The output of our `disableUser` mutation. */
export type DisableUserPayload = {
  __typename?: 'DisableUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `disableUser` mutation. */
export type DisableUserPayloadUserEdgeArgs = {
  orderBy?: Array<UsersOrderBy>;
};

export type EmailAddresses = {
  __typename?: 'EmailAddresses';
  nodes: Array<UserEmailAddress>;
};

/**   An emergency contact. */
export type EmergencyContact = Node & {
  __typename?: 'EmergencyContact';
  createdAt: Scalars['Datetime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `EmergencyContact`. */
  member?: Maybe<Member>;
  memberId: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `EmergencyContact`. */
  organization?: Maybe<Organization>;
  phoneNumber: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `EmergencyContact`. */
  user?: Maybe<User>;
};

/**
 * A condition to be used against `EmergencyContact` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EmergencyContactCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `EmergencyContact` object types. All fields are combined with a logical ‘and.’ */
export type EmergencyContactFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmergencyContactFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmergencyContactFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmergencyContactFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
};

/** An input for mutations affecting `EmergencyContactPatchRecord` */
export type EmergencyContactPatchRecordInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `EmergencyContact` values. */
export type EmergencyContactsConnection = {
  __typename?: 'EmergencyContactsConnection';
  /** A list of edges which contains the `EmergencyContact` and cursor to aid in pagination. */
  edges: Array<EmergencyContactsEdge>;
  /** A list of `EmergencyContact` objects. */
  nodes: Array<EmergencyContact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmergencyContact` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EmergencyContact` edge in the connection. */
export type EmergencyContactsEdge = {
  __typename?: 'EmergencyContactsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EmergencyContact` at the end of the edge. */
  node: EmergencyContact;
};

/** Methods to use when ordering `EmergencyContact`. */
export enum EmergencyContactsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `enableIncidentForOrganization` mutation. */
export type EnableIncidentForOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultAssignedGroupId: Scalars['String']['input'];
  incidentTypeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `enableIncidentForOrganization` mutation. */
export type EnableIncidentForOrganizationPayload = {
  __typename?: 'EnableIncidentForOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `EnabledIncidentType`. */
  defaultAssignedGroup?: Maybe<Group>;
  enabledIncidentType?: Maybe<EnabledIncidentType>;
  /** An edge for our `EnabledIncidentType`. May be used by Relay 1. */
  enabledIncidentTypeEdge?: Maybe<EnabledIncidentTypesEdge>;
  /** Reads a single `IncidentType` that is related to this `EnabledIncidentType`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `Organization` that is related to this `EnabledIncidentType`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `enableIncidentForOrganization` mutation. */
export type EnableIncidentForOrganizationPayloadEnabledIncidentTypeEdgeArgs = {
  orderBy?: Array<EnabledIncidentTypesOrderBy>;
};

/** All input for the `enableMember` mutation. */
export type EnableMemberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `enableMember` mutation. */
export type EnableMemberPayload = {
  __typename?: 'EnableMemberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge?: Maybe<MembersEdge>;
  /** Reads a single `Organization` that is related to this `Member`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Member`. */
  user?: Maybe<User>;
};


/** The output of our `enableMember` mutation. */
export type EnableMemberPayloadMemberEdgeArgs = {
  orderBy?: Array<MembersOrderBy>;
};

/** All input for the `enableUser` mutation. */
export type EnableUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** The output of our `enableUser` mutation. */
export type EnableUserPayload = {
  __typename?: 'EnableUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `enableUser` mutation. */
export type EnableUserPayloadUserEdgeArgs = {
  orderBy?: Array<UsersOrderBy>;
};

export type EnabledIncidentType = Node & {
  __typename?: 'EnabledIncidentType';
  /** Reads a single `Group` that is related to this `EnabledIncidentType`. */
  defaultAssignedGroup?: Maybe<Group>;
  defaultAssignedGroupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Reads a single `IncidentType` that is related to this `EnabledIncidentType`. */
  incidentType?: Maybe<IncidentType>;
  incidentTypeId: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `EnabledIncidentType`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
};

/**
 * A condition to be used against `EnabledIncidentType` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type EnabledIncidentTypeCondition = {
  /** Checks for equality with the object’s `defaultAssignedGroupId` field. */
  defaultAssignedGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `incidentTypeId` field. */
  incidentTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `EnabledIncidentType` object types. All fields are combined with a logical ‘and.’ */
export type EnabledIncidentTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EnabledIncidentTypeFilter>>;
  /** Filter by the object’s `defaultAssignedGroup` relation. */
  defaultAssignedGroup?: InputMaybe<GroupFilter>;
  /** A related `defaultAssignedGroup` exists. */
  defaultAssignedGroupExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `defaultAssignedGroupId` field. */
  defaultAssignedGroupId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `incidentType` relation. */
  incidentType?: InputMaybe<IncidentTypeFilter>;
  /** Filter by the object’s `incidentTypeId` field. */
  incidentTypeId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EnabledIncidentTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EnabledIncidentTypeFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `EnabledIncidentType` values. */
export type EnabledIncidentTypesConnection = {
  __typename?: 'EnabledIncidentTypesConnection';
  /** A list of edges which contains the `EnabledIncidentType` and cursor to aid in pagination. */
  edges: Array<EnabledIncidentTypesEdge>;
  /** A list of `EnabledIncidentType` objects. */
  nodes: Array<EnabledIncidentType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EnabledIncidentType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EnabledIncidentType` edge in the connection. */
export type EnabledIncidentTypesEdge = {
  __typename?: 'EnabledIncidentTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EnabledIncidentType` at the end of the edge. */
  node: EnabledIncidentType;
};

/** Methods to use when ordering `EnabledIncidentType`. */
export enum EnabledIncidentTypesOrderBy {
  DefaultAssignedGroupIdAsc = 'DEFAULT_ASSIGNED_GROUP_ID_ASC',
  DefaultAssignedGroupIdDesc = 'DEFAULT_ASSIGNED_GROUP_ID_DESC',
  IncidentTypeIdAsc = 'INCIDENT_TYPE_ID_ASC',
  IncidentTypeIdDesc = 'INCIDENT_TYPE_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `endGuardmeByMemberId` mutation. */
export type EndGuardmeByMemberIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['String']['input'];
};

/** The output of our `endGuardmeByMemberId` mutation. */
export type EndGuardmeByMemberIdPayload = {
  __typename?: 'EndGuardmeByMemberIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  guardme?: Maybe<Guardme>;
  /** An edge for our `Guardme`. May be used by Relay 1. */
  guardmeEdge?: Maybe<GuardmesEdge>;
  /** Reads a single `Member` that is related to this `Guardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Guardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `endGuardmeByMemberId` mutation. */
export type EndGuardmeByMemberIdPayloadGuardmeEdgeArgs = {
  orderBy?: Array<GuardmesOrderBy>;
};

/** All input for the `endGuardme` mutation. */
export type EndGuardmeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  guardmeId: Scalars['String']['input'];
};

/** All input for the `endGuardmeLivestream` mutation. */
export type EndGuardmeLivestreamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  livestreamId: Scalars['String']['input'];
};

/** The output of our `endGuardmeLivestream` mutation. */
export type EndGuardmeLivestreamPayload = {
  __typename?: 'EndGuardmeLivestreamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Guardme` that is related to this `Livestream`. */
  guardme?: Maybe<Guardme>;
  /** Reads a single `Incident` that is related to this `Livestream`. */
  incident?: Maybe<Incident>;
  livestream?: Maybe<Livestream>;
  /** An edge for our `Livestream`. May be used by Relay 1. */
  livestreamEdge?: Maybe<LivestreamsEdge>;
  /** Reads a single `Member` that is related to this `Livestream`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Livestream`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `endGuardmeLivestream` mutation. */
export type EndGuardmeLivestreamPayloadLivestreamEdgeArgs = {
  orderBy?: Array<LivestreamsOrderBy>;
};

/** The output of our `endGuardme` mutation. */
export type EndGuardmePayload = {
  __typename?: 'EndGuardmePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  guardme?: Maybe<Guardme>;
  /** An edge for our `Guardme`. May be used by Relay 1. */
  guardmeEdge?: Maybe<GuardmesEdge>;
  /** Reads a single `Member` that is related to this `Guardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Guardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `endGuardme` mutation. */
export type EndGuardmePayloadGuardmeEdgeArgs = {
  orderBy?: Array<GuardmesOrderBy>;
};

/** All input for the `endIncidentLivestream` mutation. */
export type EndIncidentLivestreamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  livestreamId: Scalars['String']['input'];
};

/** The output of our `endIncidentLivestream` mutation. */
export type EndIncidentLivestreamPayload = {
  __typename?: 'EndIncidentLivestreamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Guardme` that is related to this `Livestream`. */
  guardme?: Maybe<Guardme>;
  /** Reads a single `Incident` that is related to this `Livestream`. */
  incident?: Maybe<Incident>;
  livestream?: Maybe<Livestream>;
  /** An edge for our `Livestream`. May be used by Relay 1. */
  livestreamEdge?: Maybe<LivestreamsEdge>;
  /** Reads a single `Member` that is related to this `Livestream`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Livestream`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `endIncidentLivestream` mutation. */
export type EndIncidentLivestreamPayloadLivestreamEdgeArgs = {
  orderBy?: Array<LivestreamsOrderBy>;
};

export type GenerateIncidentPdfInput = {
  incidentId: Scalars['String']['input'];
};

export type GenerateIncidentPdfPayload = {
  __typename?: 'GenerateIncidentPdfPayload';
  downloadUrl: Scalars['String']['output'];
  incidentId: Scalars['String']['output'];
  query?: Maybe<Query>;
};

/** All geography XY types implement this interface */
export type GeographyGeometry = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int']['output'];
};

/** All geography types implement this interface */
export type GeographyInterface = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int']['output'];
};

export type GeographyLineString = GeographyGeometry & GeographyInterface & {
  __typename?: 'GeographyLineString';
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  points?: Maybe<Array<Maybe<GeographyPoint>>>;
  srid: Scalars['Int']['output'];
};

export type GeographyPoint = GeographyGeometry & GeographyInterface & {
  __typename?: 'GeographyPoint';
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  srid: Scalars['Int']['output'];
};

export type GeographyPolygon = GeographyGeometry & GeographyInterface & {
  __typename?: 'GeographyPolygon';
  exterior?: Maybe<GeographyLineString>;
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  interiors?: Maybe<Array<Maybe<GeographyLineString>>>;
  srid: Scalars['Int']['output'];
};

/** All geometry XY types implement this interface */
export type GeometryGeometry = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int']['output'];
};

/** All geometry types implement this interface */
export type GeometryInterface = {
  /** Converts the object to GeoJSON */
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  /** Spatial reference identifier (SRID) */
  srid: Scalars['Int']['output'];
};

export type GeometryLineString = GeometryGeometry & GeometryInterface & {
  __typename?: 'GeometryLineString';
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  points?: Maybe<Array<Maybe<GeometryPoint>>>;
  srid: Scalars['Int']['output'];
};

export type GeometryPoint = GeometryGeometry & GeometryInterface & {
  __typename?: 'GeometryPoint';
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  srid: Scalars['Int']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type GeometryPolygon = GeometryGeometry & GeometryInterface & {
  __typename?: 'GeometryPolygon';
  exterior?: Maybe<GeometryLineString>;
  geojson?: Maybe<Scalars['GeoJSON']['output']>;
  interiors?: Maybe<Array<Maybe<GeometryLineString>>>;
  srid: Scalars['Int']['output'];
};

export enum GraphqlCheckInEvent {
  New = 'NEW',
  Updated = 'UPDATED'
}

export enum GraphqlCheckInReportUpdateEvent {
  NewCheckIn = 'NEW_CHECK_IN',
  Updated = 'UPDATED'
}

export enum GraphqlGuardmeEvent {
  AttachmentAdded = 'ATTACHMENT_ADDED',
  AttachmentRemoved = 'ATTACHMENT_REMOVED',
  Concluded = 'CONCLUDED',
  Expired = 'EXPIRED',
  Extended = 'EXTENDED',
  LivestreamActive = 'LIVESTREAM_ACTIVE',
  LivestreamEnded = 'LIVESTREAM_ENDED',
  LivestreamStarted = 'LIVESTREAM_STARTED',
  LocationUpdated = 'LOCATION_UPDATED',
  Panic = 'PANIC',
  Started = 'STARTED',
  StartedPanic = 'STARTED_PANIC',
  Updated = 'UPDATED'
}

export enum GraphqlGuardmeLocationEvent {
  Updated = 'UPDATED'
}

export enum GraphqlIncidentUpdateEvent {
  ContactUpdated = 'CONTACT_UPDATED',
  CoordinatesUpdated = 'COORDINATES_UPDATED',
  DetailsUpdated = 'DETAILS_UPDATED',
  GroupUpdated = 'GROUP_UPDATED',
  IsAcknowledged = 'IS_ACKNOWLEDGED',
  LivestreamActive = 'LIVESTREAM_ACTIVE',
  LivestreamEnded = 'LIVESTREAM_ENDED',
  LivestreamStarted = 'LIVESTREAM_STARTED',
  OwnerUpdated = 'OWNER_UPDATED',
  PriorityUpdated = 'PRIORITY_UPDATED',
  PrivateNoteAdded = 'PRIVATE_NOTE_ADDED',
  PublicNoteAdded = 'PUBLIC_NOTE_ADDED',
  StatusUpdated = 'STATUS_UPDATED',
  TypeUpdated = 'TYPE_UPDATED',
  Updated = 'UPDATED'
}

export enum GraphqlIncidentsUpdatesEvent {
  Created = 'CREATED'
}

export enum GraphqlOrganizationUpdateEvent {
  Updated = 'UPDATED'
}

/** An organization group. */
export type Group = Node & {
  __typename?: 'Group';
  /** Reads and enables pagination through a set of `CheckInRequest`. */
  checkInRequests: CheckInRequestsConnection;
  createdAt: Scalars['Datetime']['output'];
  description: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `EnabledIncidentType`. */
  enabledIncidentTypesByDefaultAssignedGroupId: EnabledIncidentTypesConnection;
  id: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Incident`. */
  incidentsByOwnedByGroupId: IncidentsConnection;
  /** Reads and enables pagination through a set of `Member`. */
  members: MembersConnection;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Group`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `OrganizationSetting`. */
  organizationSettingsByCheckInSupervisorGroupId: OrganizationSettingsConnection;
  /** Reads and enables pagination through a set of `OrganizationSetting`. */
  organizationSettingsByGuardmeSupervisorGroupId: OrganizationSettingsConnection;
  /** Reads and enables pagination through a set of `OrganizationSetting`. */
  organizationSettingsByIncidentSupervisorGroupId: OrganizationSettingsConnection;
  /** Reads and enables pagination through a set of `OrganizationSetting`. */
  organizationSettingsByPtcReadOnlyGroupId: OrganizationSettingsConnection;
  /** Reads and enables pagination through a set of `OrganizationSetting`. */
  organizationSettingsByPtcReadWriteGroupId: OrganizationSettingsConnection;
  updatedAt: Scalars['Datetime']['output'];
};


/** An organization group. */
export type GroupCheckInRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInRequestCondition>;
  filter?: InputMaybe<CheckInRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInRequestsOrderBy>>;
};


/** An organization group. */
export type GroupEnabledIncidentTypesByDefaultAssignedGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnabledIncidentTypeCondition>;
  filter?: InputMaybe<EnabledIncidentTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnabledIncidentTypesOrderBy>>;
};


/** An organization group. */
export type GroupIncidentsByOwnedByGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentCondition>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};


/** An organization group. */
export type GroupMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization group. */
export type GroupOrganizationSettingsByCheckInSupervisorGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization group. */
export type GroupOrganizationSettingsByGuardmeSupervisorGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization group. */
export type GroupOrganizationSettingsByIncidentSupervisorGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization group. */
export type GroupOrganizationSettingsByPtcReadOnlyGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization group. */
export type GroupOrganizationSettingsByPtcReadWriteGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A condition to be used against `Group` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GroupCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Group` object types. All fields are combined with a logical ‘and.’ */
export type GroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `checkInRequests` relation. */
  checkInRequests?: InputMaybe<GroupToManyCheckInRequestFilter>;
  /** Some related `checkInRequests` exist. */
  checkInRequestsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `enabledIncidentTypesByDefaultAssignedGroupId` relation. */
  enabledIncidentTypesByDefaultAssignedGroupId?: InputMaybe<GroupToManyEnabledIncidentTypeFilter>;
  /** Some related `enabledIncidentTypesByDefaultAssignedGroupId` exist. */
  enabledIncidentTypesByDefaultAssignedGroupIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `incidentsByOwnedByGroupId` relation. */
  incidentsByOwnedByGroupId?: InputMaybe<GroupToManyIncidentFilter>;
  /** Some related `incidentsByOwnedByGroupId` exist. */
  incidentsByOwnedByGroupIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `CheckInRequest` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyCheckInRequestFilter = {
  /** Every related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckInRequestFilter>;
  /** No related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckInRequestFilter>;
  /** Some related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckInRequestFilter>;
};

/** A filter to be used against many `EnabledIncidentType` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyEnabledIncidentTypeFilter = {
  /** Every related `EnabledIncidentType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EnabledIncidentTypeFilter>;
  /** No related `EnabledIncidentType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EnabledIncidentTypeFilter>;
  /** Some related `EnabledIncidentType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EnabledIncidentTypeFilter>;
};

/** A filter to be used against many `Incident` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyIncidentFilter = {
  /** Every related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IncidentFilter>;
  /** No related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IncidentFilter>;
  /** Some related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IncidentFilter>;
};

/** A connection to a list of `Group` values. */
export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  /** A list of edges which contains the `Group` and cursor to aid in pagination. */
  edges: Array<GroupsEdge>;
  /** A list of `Group` objects. */
  nodes: Array<Group>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Group` edge in the connection. */
export type GroupsEdge = {
  __typename?: 'GroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Group` at the end of the edge. */
  node: Group;
};

/** Methods to use when ordering `Group`. */
export enum GroupsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type GuardMesCreatedAtConditionInput = {
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
};

export type GuardMesStatusConditionInput = {
  concluded?: InputMaybe<Scalars['Boolean']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  inPanic?: InputMaybe<Scalars['Boolean']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuardMesUpdatedAtConditionInput = {
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
};

export type Guardme = Node & {
  __typename?: 'Guardme';
  /** @deprecated Use Guardme.guardmeAuditLogs */
  activityLogs?: Maybe<GuardmeAuditLogsConnection>;
  /** @deprecated Use Guardme.guardmeAttachments */
  attachments?: Maybe<GuardmeAttachmentsConnection>;
  /** The battery level of the mobile device that is reporting this GuardMe. */
  batteryLevel?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  endsAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `GuardmeAttachment`. */
  guardmeAttachments: GuardmeAttachmentsConnection;
  /** Reads and enables pagination through a set of `GuardmeAuditLog`. */
  guardmeAuditLogs: GuardmeAuditLogsConnection;
  /** Reads and enables pagination through a set of `GuardmeLivestream`. */
  guardmeLivestreams: GuardmeLivestreamsConnection;
  /** Reads and enables pagination through a set of `GuardmeLocation`. */
  guardmeLocations: GuardmeLocationsConnection;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  isSafe: Scalars['Boolean']['output'];
  isUnderDuress: Scalars['Boolean']['output'];
  lastLocation?: Maybe<GuardmeLocation>;
  /** Reads and enables pagination through a set of `Livestream`. */
  livestreams: LivestreamsConnection;
  /** @deprecated Use Guardme.guardmeLocations */
  locationHistory?: Maybe<GuardmeLocationsConnection>;
  locationOverride?: Maybe<Scalars['String']['output']>;
  locationTimelineAsEncodedPolyline?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `Guardme`. */
  member?: Maybe<Member>;
  memberId: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  notes: Scalars['String']['output'];
  /** Reads a single `Organization` that is related to this `Guardme`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Place`. */
  places: PlacesConnection;
  shortId: Scalars['String']['output'];
  status: GuardmeStatus;
  totalAttachments?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};


export type GuardmeActivityLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeAuditLogCondition>;
  filter?: InputMaybe<GuardmeAuditLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeAuditLogsOrderBy>>;
};


export type GuardmeAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeAttachmentCondition>;
  filter?: InputMaybe<GuardmeAttachmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeAttachmentsOrderBy>>;
};


export type GuardmeGuardmeAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeAttachmentCondition>;
  filter?: InputMaybe<GuardmeAttachmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeAttachmentsOrderBy>>;
};


export type GuardmeGuardmeAuditLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeAuditLogCondition>;
  filter?: InputMaybe<GuardmeAuditLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeAuditLogsOrderBy>>;
};


export type GuardmeGuardmeLivestreamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeLivestreamCondition>;
  filter?: InputMaybe<GuardmeLivestreamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeLivestreamsOrderBy>>;
};


export type GuardmeGuardmeLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeLocationCondition>;
  filter?: InputMaybe<GuardmeLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeLocationsOrderBy>>;
};


export type GuardmeLivestreamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LivestreamCondition>;
  filter?: InputMaybe<LivestreamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LivestreamsOrderBy>>;
};


export type GuardmeLocationHistoryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeLocationCondition>;
  filter?: InputMaybe<GuardmeLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeLocationsOrderBy>>;
};


export type GuardmePlacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PlaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GuardmeAttachment = Node & {
  __typename?: 'GuardmeAttachment';
  /** Reads and enables pagination through a set of `Attachment`. */
  attachments: AttachmentsConnection;
  bucket?: Maybe<Scalars['String']['output']>;
  comment: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  filesize?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Guardme` that is related to this `GuardmeAttachment`. */
  guardme?: Maybe<Guardme>;
  guardmeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `GuardmeAttachment`. */
  member?: Maybe<Member>;
  memberId: Scalars['String']['output'];
  mimetype?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `GuardmeAttachment`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** @deprecated Use GuardmeAttachment.Attachments */
  url?: Maybe<Scalars['String']['output']>;
};


export type GuardmeAttachmentAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<AttachmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `GuardmeAttachment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GuardmeAttachmentCondition = {
  /** Checks for equality with the object’s `guardmeId` field. */
  guardmeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `GuardmeAttachment` object types. All fields are combined with a logical ‘and.’ */
export type GuardmeAttachmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GuardmeAttachmentFilter>>;
  /** Filter by the object’s `guardme` relation. */
  guardme?: InputMaybe<GuardmeFilter>;
  /** Filter by the object’s `guardmeId` field. */
  guardmeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GuardmeAttachmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GuardmeAttachmentFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `GuardmeAttachment` values. */
export type GuardmeAttachmentsConnection = {
  __typename?: 'GuardmeAttachmentsConnection';
  /** A list of edges which contains the `GuardmeAttachment` and cursor to aid in pagination. */
  edges: Array<GuardmeAttachmentsEdge>;
  /** A list of `GuardmeAttachment` objects. */
  nodes: Array<GuardmeAttachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GuardmeAttachment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GuardmeAttachment` edge in the connection. */
export type GuardmeAttachmentsEdge = {
  __typename?: 'GuardmeAttachmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GuardmeAttachment` at the end of the edge. */
  node: GuardmeAttachment;
};

/** Methods to use when ordering `GuardmeAttachment`. */
export enum GuardmeAttachmentsOrderBy {
  GuardmeIdAsc = 'GUARDME_ID_ASC',
  GuardmeIdDesc = 'GUARDME_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type GuardmeAuditLog = Node & {
  __typename?: 'GuardmeAuditLog';
  createdAt: Scalars['Datetime']['output'];
  details: Scalars['JSON']['output'];
  /** @deprecated Use Guardme.type */
  event: Scalars['String']['output'];
  /** Reads a single `Guardme` that is related to this `GuardmeAuditLog`. */
  guardme?: Maybe<Guardme>;
  guardmeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `GuardmeAuditLog`. */
  member?: Maybe<Member>;
  memberId: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `GuardmeAuditLog`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `GuardmeAuditLog`. */
  performedBy?: Maybe<Member>;
  performedById?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/**
 * A condition to be used against `GuardmeAuditLog` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GuardmeAuditLogCondition = {
  /** Checks for equality with the object’s `guardmeId` field. */
  guardmeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `performedById` field. */
  performedById?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `GuardmeAuditLog` object types. All fields are combined with a logical ‘and.’ */
export type GuardmeAuditLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GuardmeAuditLogFilter>>;
  /** Filter by the object’s `guardme` relation. */
  guardme?: InputMaybe<GuardmeFilter>;
  /** Filter by the object’s `guardmeId` field. */
  guardmeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GuardmeAuditLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GuardmeAuditLogFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `performedBy` relation. */
  performedBy?: InputMaybe<MemberFilter>;
  /** A related `performedBy` exists. */
  performedByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `performedById` field. */
  performedById?: InputMaybe<StringFilter>;
};

/** A connection to a list of `GuardmeAuditLog` values. */
export type GuardmeAuditLogsConnection = {
  __typename?: 'GuardmeAuditLogsConnection';
  /** A list of edges which contains the `GuardmeAuditLog` and cursor to aid in pagination. */
  edges: Array<GuardmeAuditLogsEdge>;
  /** A list of `GuardmeAuditLog` objects. */
  nodes: Array<GuardmeAuditLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GuardmeAuditLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GuardmeAuditLog` edge in the connection. */
export type GuardmeAuditLogsEdge = {
  __typename?: 'GuardmeAuditLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GuardmeAuditLog` at the end of the edge. */
  node: GuardmeAuditLog;
};

/** Methods to use when ordering `GuardmeAuditLog`. */
export enum GuardmeAuditLogsOrderBy {
  GuardmeIdAsc = 'GUARDME_ID_ASC',
  GuardmeIdDesc = 'GUARDME_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PerformedByIdAsc = 'PERFORMED_BY_ID_ASC',
  PerformedByIdDesc = 'PERFORMED_BY_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A condition to be used against `Guardme` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GuardmeCondition = {
  /** Filters GuardMe's by creation. */
  createdAt?: InputMaybe<GuardMesCreatedAtConditionInput>;
  /** Filters GuardMe's by excluding the provided member ids from results. */
  excludeMemberIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Filter GuardMe's by search terms. Includes shortId. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filters GuardMe's by short ID. */
  shortId?: InputMaybe<Scalars['String']['input']>;
  /** Filters GuardMe's by status. */
  status?: InputMaybe<GuardMesStatusConditionInput>;
  /** Checks for equality with the object’s `uniqueActive` field. */
  uniqueActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters GuardMe's by update. */
  updatedAt?: InputMaybe<GuardMesUpdatedAtConditionInput>;
};

export type GuardmeCountType = {
  __typename?: 'GuardmeCountType';
  active: Scalars['Int']['output'];
  expired: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  panic: Scalars['Int']['output'];
  underDuress: Scalars['Int']['output'];
};

/** A filter to be used against `Guardme` object types. All fields are combined with a logical ‘and.’ */
export type GuardmeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GuardmeFilter>>;
  /** Filter by the object’s `guardmeAttachments` relation. */
  guardmeAttachments?: InputMaybe<GuardmeToManyGuardmeAttachmentFilter>;
  /** Some related `guardmeAttachments` exist. */
  guardmeAttachmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmeAuditLogs` relation. */
  guardmeAuditLogs?: InputMaybe<GuardmeToManyGuardmeAuditLogFilter>;
  /** Some related `guardmeAuditLogs` exist. */
  guardmeAuditLogsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmeLivestreams` relation. */
  guardmeLivestreams?: InputMaybe<GuardmeToManyGuardmeLivestreamFilter>;
  /** Some related `guardmeLivestreams` exist. */
  guardmeLivestreamsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmeLocations` relation. */
  guardmeLocations?: InputMaybe<GuardmeToManyGuardmeLocationFilter>;
  /** Some related `guardmeLocations` exist. */
  guardmeLocationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isExpired` field. */
  isExpired?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `livestreams` relation. */
  livestreams?: InputMaybe<GuardmeToManyLivestreamFilter>;
  /** Some related `livestreams` exist. */
  livestreamsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `locationTimelineAsEncodedPolyline` field. */
  locationTimelineAsEncodedPolyline?: InputMaybe<StringFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GuardmeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GuardmeFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `totalAttachments` field. */
  totalAttachments?: InputMaybe<IntFilter>;
  /** Filter by the object’s `uniqueActive` field. */
  uniqueActive?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `Guardme` */
export type GuardmeInput = {
  /** The battery level of the mobile device that is reporting this GuardMe. */
  batteryLevel?: InputMaybe<Scalars['Int']['input']>;
  endsAt?: InputMaybe<Scalars['Datetime']['input']>;
  isSafe?: InputMaybe<Scalars['Boolean']['input']>;
  isUnderDuress?: InputMaybe<Scalars['Boolean']['input']>;
  locationOverride?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  status?: InputMaybe<GuardmeStatus>;
};

export type GuardmeLivestream = Node & {
  __typename?: 'GuardmeLivestream';
  createdAt: Scalars['Datetime']['output'];
  endedAt?: Maybe<Scalars['Datetime']['output']>;
  expiresAt: Scalars['Datetime']['output'];
  /** Reads a single `Guardme` that is related to this `GuardmeLivestream`. */
  guardme?: Maybe<Guardme>;
  guardmeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isSaving: Scalars['Boolean']['output'];
  /** Reads a single `Member` that is related to this `GuardmeLivestream`. */
  member?: Maybe<Member>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `GuardmeLivestream`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  startedAt: Scalars['Datetime']['output'];
  streamingUrl: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `GuardmeLivestream` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GuardmeLivestreamCondition = {
  /** Checks for equality with the object’s `guardmeId` field. */
  guardmeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `GuardmeLivestream` object types. All fields are combined with a logical ‘and.’ */
export type GuardmeLivestreamFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GuardmeLivestreamFilter>>;
  /** Filter by the object’s `guardme` relation. */
  guardme?: InputMaybe<GuardmeFilter>;
  /** Filter by the object’s `guardmeId` field. */
  guardmeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GuardmeLivestreamFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GuardmeLivestreamFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `GuardmeLivestream` values. */
export type GuardmeLivestreamsConnection = {
  __typename?: 'GuardmeLivestreamsConnection';
  /** A list of edges which contains the `GuardmeLivestream` and cursor to aid in pagination. */
  edges: Array<GuardmeLivestreamsEdge>;
  /** A list of `GuardmeLivestream` objects. */
  nodes: Array<GuardmeLivestream>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GuardmeLivestream` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GuardmeLivestream` edge in the connection. */
export type GuardmeLivestreamsEdge = {
  __typename?: 'GuardmeLivestreamsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GuardmeLivestream` at the end of the edge. */
  node: GuardmeLivestream;
};

/** Methods to use when ordering `GuardmeLivestream`. */
export enum GuardmeLivestreamsOrderBy {
  GuardmeIdAsc = 'GUARDME_ID_ASC',
  GuardmeIdDesc = 'GUARDME_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type GuardmeLocation = Node & {
  __typename?: 'GuardmeLocation';
  accuracy: Scalars['Float']['output'];
  altitude: Scalars['Float']['output'];
  altitudeAccuracy: Scalars['Float']['output'];
  buildingFloor: Scalars['Int']['output'];
  coordinates: GeometryPoint;
  createdAt: Scalars['Datetime']['output'];
  geocode?: Maybe<GuardmeLocationGeocode>;
  /** Reads a single `Guardme` that is related to this `GuardmeLocation`. */
  guardme?: Maybe<Guardme>;
  guardmeId: Scalars['String']['output'];
  heading: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isMock: Scalars['Boolean']['output'];
  /** Reads a single `Member` that is related to this `GuardmeLocation`. */
  member?: Maybe<Member>;
  memberId?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `GuardmeLocation`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** @deprecated Use Guardme.createdAt */
  recordedAt: Scalars['Datetime']['output'];
  speed: Scalars['Float']['output'];
};

/**
 * A condition to be used against `GuardmeLocation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GuardmeLocationCondition = {
  /** Checks for equality with the object’s `guardmeId` field. */
  guardmeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `GuardmeLocation` object types. All fields are combined with a logical ‘and.’ */
export type GuardmeLocationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GuardmeLocationFilter>>;
  /** Filter by the object’s `guardme` relation. */
  guardme?: InputMaybe<GuardmeFilter>;
  /** Filter by the object’s `guardmeId` field. */
  guardmeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** A related `member` exists. */
  memberExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GuardmeLocationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GuardmeLocationFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

export type GuardmeLocationGeocode = {
  __typename?: 'GuardmeLocationGeocode';
  address: Scalars['String']['output'];
  id: Scalars['String']['output'];
  plusCode: Scalars['String']['output'];
  shortPlusCode: Scalars['String']['output'];
};

export type GuardmeLocationUpdatesInput = {
  guardmeId: Scalars['String']['input'];
};

export type GuardmeLocationUpdatesPayload = {
  __typename?: 'GuardmeLocationUpdatesPayload';
  event?: Maybe<GraphqlGuardmeLocationEvent>;
  guardmeLocation?: Maybe<GuardmeLocation>;
  relatedIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** A connection to a list of `GuardmeLocation` values. */
export type GuardmeLocationsConnection = {
  __typename?: 'GuardmeLocationsConnection';
  /** A list of edges which contains the `GuardmeLocation` and cursor to aid in pagination. */
  edges: Array<GuardmeLocationsEdge>;
  /** A list of `GuardmeLocation` objects. */
  nodes: Array<GuardmeLocation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GuardmeLocation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GuardmeLocation` edge in the connection. */
export type GuardmeLocationsEdge = {
  __typename?: 'GuardmeLocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GuardmeLocation` at the end of the edge. */
  node: GuardmeLocation;
};

/** Methods to use when ordering `GuardmeLocation`. */
export enum GuardmeLocationsOrderBy {
  GuardmeIdAsc = 'GUARDME_ID_ASC',
  GuardmeIdDesc = 'GUARDME_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `guardmePanic` mutation. */
export type GuardmePanicInput = {
  batteryLevel: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentLocation: LocationInput;
  memberId: Scalars['String']['input'];
};

/** The output of our `guardmePanic` mutation. */
export type GuardmePanicPayload = {
  __typename?: 'GuardmePanicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  guardme?: Maybe<Guardme>;
  /** An edge for our `Guardme`. May be used by Relay 1. */
  guardmeEdge?: Maybe<GuardmesEdge>;
  /** Reads a single `Member` that is related to this `Guardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Guardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `guardmePanic` mutation. */
export type GuardmePanicPayloadGuardmeEdgeArgs = {
  orderBy?: Array<GuardmesOrderBy>;
};

/** An input for mutations affecting `GuardmePatchRecord` */
export type GuardmePatchRecordInput = {
  endsAt?: InputMaybe<Scalars['Datetime']['input']>;
  isSafe?: InputMaybe<Scalars['Boolean']['input']>;
  isUnderDuress?: InputMaybe<Scalars['Boolean']['input']>;
  locationOverride?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export enum GuardmeStatus {
  Concluded = 'CONCLUDED',
  Expired = 'EXPIRED',
  InPanic = 'IN_PANIC',
  InProgress = 'IN_PROGRESS'
}

/** A filter to be used against many `GuardmeAttachment` object types. All fields are combined with a logical ‘and.’ */
export type GuardmeToManyGuardmeAttachmentFilter = {
  /** Every related `GuardmeAttachment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeAttachmentFilter>;
  /** No related `GuardmeAttachment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeAttachmentFilter>;
  /** Some related `GuardmeAttachment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeAttachmentFilter>;
};

/** A filter to be used against many `GuardmeAuditLog` object types. All fields are combined with a logical ‘and.’ */
export type GuardmeToManyGuardmeAuditLogFilter = {
  /** Every related `GuardmeAuditLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeAuditLogFilter>;
  /** No related `GuardmeAuditLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeAuditLogFilter>;
  /** Some related `GuardmeAuditLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeAuditLogFilter>;
};

/** A filter to be used against many `GuardmeLivestream` object types. All fields are combined with a logical ‘and.’ */
export type GuardmeToManyGuardmeLivestreamFilter = {
  /** Every related `GuardmeLivestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeLivestreamFilter>;
  /** No related `GuardmeLivestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeLivestreamFilter>;
  /** Some related `GuardmeLivestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeLivestreamFilter>;
};

/** A filter to be used against many `GuardmeLocation` object types. All fields are combined with a logical ‘and.’ */
export type GuardmeToManyGuardmeLocationFilter = {
  /** Every related `GuardmeLocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeLocationFilter>;
  /** No related `GuardmeLocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeLocationFilter>;
  /** Some related `GuardmeLocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeLocationFilter>;
};

/** A filter to be used against many `Livestream` object types. All fields are combined with a logical ‘and.’ */
export type GuardmeToManyLivestreamFilter = {
  /** Every related `Livestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LivestreamFilter>;
  /** No related `Livestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LivestreamFilter>;
  /** Some related `Livestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LivestreamFilter>;
};

export type GuardmeUpdatesInput = {
  organizationId: Scalars['String']['input'];
};

export type GuardmeUpdatesPayload = {
  __typename?: 'GuardmeUpdatesPayload';
  event?: Maybe<GraphqlGuardmeEvent>;
  guardme?: Maybe<Guardme>;
  relatedIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** A connection to a list of `Guardme` values. */
export type GuardmesConnection = {
  __typename?: 'GuardmesConnection';
  /** A list of edges which contains the `Guardme` and cursor to aid in pagination. */
  edges: Array<GuardmesEdge>;
  /** A list of `Guardme` objects. */
  nodes: Array<Guardme>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Guardme` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Guardme` edge in the connection. */
export type GuardmesEdge = {
  __typename?: 'GuardmesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Guardme` at the end of the edge. */
  node: Guardme;
};

/** Methods to use when ordering `Guardme`. */
export enum GuardmesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UniqueActiveAsc = 'UNIQUE_ACTIVE_ASC',
  UniqueActiveDesc = 'UNIQUE_ACTIVE_DESC'
}

export type Incident = Node & {
  __typename?: 'Incident';
  additionalData: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `Attachment`. */
  attachments: AttachmentsConnection;
  /** Reads and enables pagination through a set of `Incident`. */
  childIncidents: IncidentsConnection;
  /** Reads a single `Member` that is related to this `Incident`. */
  contactMember?: Maybe<Member>;
  contactMemberId: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  description: Scalars['String']['output'];
  firstResponseAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  /**
   * Reads and enables pagination through a set of `Attachment`.
   * @deprecated Use Incident.attachments
   */
  incidentAttachments: AttachmentsConnection;
  incidentCoordinates: GeometryPoint;
  incidentCoordinatesAccuracy: Scalars['Float']['output'];
  incidentCoordinatesAltitude: Scalars['Float']['output'];
  incidentCoordinatesAltitudeAccuracy: Scalars['Float']['output'];
  incidentCoordinatesGeocode?: Maybe<IncidentCoordinatesGeocode>;
  /** Reads a single `IncidentType` that is related to this `Incident`. */
  incidentType?: Maybe<IncidentType>;
  incidentTypeId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `IncidentUpdate`. */
  incidentUpdates: IncidentUpdatesConnection;
  isAcknowledged: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `Livestream`. */
  livestreams: LivestreamsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Incident`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** Reads a single `Group` that is related to this `Incident`. */
  ownedByGroup?: Maybe<Group>;
  ownedByGroupId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `Incident`. */
  ownedByMember?: Maybe<Member>;
  ownedByMemberId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Incident` that is related to this `Incident`. */
  parent?: Maybe<Incident>;
  parentId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Place`. */
  places: PlacesConnection;
  priority: IncidentPriorityType;
  resolutionAt?: Maybe<Scalars['Datetime']['output']>;
  shortId: Scalars['String']['output'];
  status: IncidentStatusType;
  subject: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `Incident`. */
  submittedByMember?: Maybe<Member>;
  submittedByMemberCoordinates: GeometryPoint;
  submittedByMemberCoordinatesAccuracy: Scalars['Float']['output'];
  submittedByMemberCoordinatesAltitude: Scalars['Float']['output'];
  submittedByMemberCoordinatesAltitudeAccuracy: Scalars['Float']['output'];
  submittedByMemberCoordinatesGeocode?: Maybe<IncidentCoordinatesGeocode>;
  submittedByMemberId: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};


export type IncidentAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<AttachmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type IncidentChildIncidentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentCondition>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};


export type IncidentIncidentAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<AttachmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type IncidentIncidentUpdatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentUpdateCondition>;
  filter?: InputMaybe<IncidentUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentUpdatesOrderBy>>;
};


export type IncidentLivestreamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LivestreamCondition>;
  filter?: InputMaybe<LivestreamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LivestreamsOrderBy>>;
};


export type IncidentPlacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<PlaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `Incident` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type IncidentCondition = {
  /** Filter Incidents showing only incidents assigned to the current user or groups the current user is in. */
  assignedToMeOrMyGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `contactMemberId` field. */
  contactMemberId?: InputMaybe<Scalars['String']['input']>;
  /** Filter Incidents by creation. */
  createdAt?: InputMaybe<IncidentsCreatedAtConditionInput>;
  /** Filter Incidents by excluding the provided member ids from results. */
  excludeMemberIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `incidentTypeId` field. */
  incidentTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ownedByGroupId` field. */
  ownedByGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ownedByMemberId` field. */
  ownedByMemberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['String']['input']>;
  /** Filter Incidents by priority. */
  priority?: InputMaybe<IncidentsPriorityConditionInput>;
  /** Filter Incidents for provided terms. Includes shortId, subject, description, incidentType. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter Incidents by short ID. */
  shortId?: InputMaybe<Scalars['String']['input']>;
  /** Filter Incidents by status. */
  status?: InputMaybe<IncidentsStatusConditionInput>;
  /** Checks for equality with the object’s `submittedByMemberId` field. */
  submittedByMemberId?: InputMaybe<Scalars['String']['input']>;
  /** Filter Incidents to records matching one of these incident type ids. */
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter Incidents by update. */
  updatedAt?: InputMaybe<IncidentsUpdatedAtConditionInput>;
};

export type IncidentCoordinatesGeocode = {
  __typename?: 'IncidentCoordinatesGeocode';
  address: Scalars['String']['output'];
  id: Scalars['String']['output'];
  plusCode: Scalars['String']['output'];
  shortPlusCode: Scalars['String']['output'];
};

/** A filter to be used against `Incident` object types. All fields are combined with a logical ‘and.’ */
export type IncidentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IncidentFilter>>;
  /** Filter by the object’s `childIncidents` relation. */
  childIncidents?: InputMaybe<IncidentToManyIncidentFilter>;
  /** Some related `childIncidents` exist. */
  childIncidentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `contactMember` relation. */
  contactMember?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `contactMemberId` field. */
  contactMemberId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `incidentType` relation. */
  incidentType?: InputMaybe<IncidentTypeFilter>;
  /** Filter by the object’s `incidentTypeId` field. */
  incidentTypeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `incidentUpdates` relation. */
  incidentUpdates?: InputMaybe<IncidentToManyIncidentUpdateFilter>;
  /** Some related `incidentUpdates` exist. */
  incidentUpdatesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `livestreams` relation. */
  livestreams?: InputMaybe<IncidentToManyLivestreamFilter>;
  /** Some related `livestreams` exist. */
  livestreamsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<IncidentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IncidentFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ownedByGroup` relation. */
  ownedByGroup?: InputMaybe<GroupFilter>;
  /** A related `ownedByGroup` exists. */
  ownedByGroupExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ownedByGroupId` field. */
  ownedByGroupId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ownedByMember` relation. */
  ownedByMember?: InputMaybe<MemberFilter>;
  /** A related `ownedByMember` exists. */
  ownedByMemberExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ownedByMemberId` field. */
  ownedByMemberId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `parent` relation. */
  parent?: InputMaybe<IncidentFilter>;
  /** A related `parent` exists. */
  parentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `submittedByMember` relation. */
  submittedByMember?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `submittedByMemberId` field. */
  submittedByMemberId?: InputMaybe<StringFilter>;
};

export enum IncidentPriorityType {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

export enum IncidentStatusType {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN'
}

/** A filter to be used against many `Incident` object types. All fields are combined with a logical ‘and.’ */
export type IncidentToManyIncidentFilter = {
  /** Every related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IncidentFilter>;
  /** No related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IncidentFilter>;
  /** Some related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IncidentFilter>;
};

/** A filter to be used against many `IncidentUpdate` object types. All fields are combined with a logical ‘and.’ */
export type IncidentToManyIncidentUpdateFilter = {
  /** Every related `IncidentUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IncidentUpdateFilter>;
  /** No related `IncidentUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IncidentUpdateFilter>;
  /** Some related `IncidentUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IncidentUpdateFilter>;
};

/** A filter to be used against many `Livestream` object types. All fields are combined with a logical ‘and.’ */
export type IncidentToManyLivestreamFilter = {
  /** Every related `Livestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LivestreamFilter>;
  /** No related `Livestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LivestreamFilter>;
  /** Some related `Livestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LivestreamFilter>;
};

export type IncidentType = Node & {
  __typename?: 'IncidentType';
  allowDroneEndpoint: Scalars['Boolean']['output'];
  allowlist: Array<Maybe<Scalars['String']['output']>>;
  category: Scalars['String']['output'];
  color: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  dataSchema: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `EnabledIncidentType`. */
  enabledIncidentTypes: EnabledIncidentTypesConnection;
  icon: Scalars['String']['output'];
  /** base64 encoded png image */
  iconPng: Scalars['String']['output'];
  /** base64 encoded svg image */
  iconSvg: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Incident`. */
  incidents: IncidentsConnection;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  shortId?: Maybe<Scalars['String']['output']>;
  uiSchema: Scalars['JSON']['output'];
  updatedAt: Scalars['Datetime']['output'];
  useAllowlist: Scalars['Boolean']['output'];
};


export type IncidentTypeEnabledIncidentTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnabledIncidentTypeCondition>;
  filter?: InputMaybe<EnabledIncidentTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnabledIncidentTypesOrderBy>>;
};


export type IncidentTypeIncidentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentCondition>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};

/**
 * A condition to be used against `IncidentType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type IncidentTypeCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type IncidentTypeCountType = {
  __typename?: 'IncidentTypeCountType';
  count?: Maybe<Scalars['Int']['output']>;
  incidentTypeId?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against `IncidentType` object types. All fields are combined with a logical ‘and.’ */
export type IncidentTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IncidentTypeFilter>>;
  /** Filter by the object’s `enabledIncidentTypes` relation. */
  enabledIncidentTypes?: InputMaybe<IncidentTypeToManyEnabledIncidentTypeFilter>;
  /** Some related `enabledIncidentTypes` exist. */
  enabledIncidentTypesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `incidents` relation. */
  incidents?: InputMaybe<IncidentTypeToManyIncidentFilter>;
  /** Some related `incidents` exist. */
  incidentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<IncidentTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IncidentTypeFilter>>;
};

/** A filter to be used against many `EnabledIncidentType` object types. All fields are combined with a logical ‘and.’ */
export type IncidentTypeToManyEnabledIncidentTypeFilter = {
  /** Every related `EnabledIncidentType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EnabledIncidentTypeFilter>;
  /** No related `EnabledIncidentType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EnabledIncidentTypeFilter>;
  /** Some related `EnabledIncidentType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EnabledIncidentTypeFilter>;
};

/** A filter to be used against many `Incident` object types. All fields are combined with a logical ‘and.’ */
export type IncidentTypeToManyIncidentFilter = {
  /** Every related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IncidentFilter>;
  /** No related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IncidentFilter>;
  /** Some related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IncidentFilter>;
};

/** A connection to a list of `IncidentType` values. */
export type IncidentTypesConnection = {
  __typename?: 'IncidentTypesConnection';
  /** A list of edges which contains the `IncidentType` and cursor to aid in pagination. */
  edges: Array<IncidentTypesEdge>;
  /** A list of `IncidentType` objects. */
  nodes: Array<IncidentType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IncidentType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IncidentType` edge in the connection. */
export type IncidentTypesEdge = {
  __typename?: 'IncidentTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IncidentType` at the end of the edge. */
  node: IncidentType;
};

/** Methods to use when ordering `IncidentType`. */
export enum IncidentTypesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type IncidentUpdate = Node & {
  __typename?: 'IncidentUpdate';
  /** Reads and enables pagination through a set of `Attachment`. */
  attachments: AttachmentsConnection;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  /** Reads a single `Incident` that is related to this `IncidentUpdate`. */
  incident?: Maybe<Incident>;
  /** @deprecated Use IncidentUpdate.attachments */
  incidentAttachment?: Maybe<Attachment>;
  incidentId: Scalars['String']['output'];
  isSystemMessage: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `IncidentUpdate`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `IncidentUpdate`. */
  performedByMember?: Maybe<Member>;
  performedByMemberId?: Maybe<Scalars['String']['output']>;
  previousValue?: Maybe<Scalars['JSON']['output']>;
  type: IncidentUpdateTypeType;
  updatedValue?: Maybe<Scalars['JSON']['output']>;
};


export type IncidentUpdateAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<AttachmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `IncidentUpdate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type IncidentUpdateCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `incidentId` field. */
  incidentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `performedByMemberId` field. */
  performedByMemberId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `IncidentUpdate` object types. All fields are combined with a logical ‘and.’ */
export type IncidentUpdateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IncidentUpdateFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `incident` relation. */
  incident?: InputMaybe<IncidentFilter>;
  /** Filter by the object’s `incidentId` field. */
  incidentId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IncidentUpdateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IncidentUpdateFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `performedByMember` relation. */
  performedByMember?: InputMaybe<MemberFilter>;
  /** A related `performedByMember` exists. */
  performedByMemberExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `performedByMemberId` field. */
  performedByMemberId?: InputMaybe<StringFilter>;
};

export enum IncidentUpdateTypeType {
  AttachmentAdded = 'ATTACHMENT_ADDED',
  AttachmentDeleted = 'ATTACHMENT_DELETED',
  ContactChange = 'CONTACT_CHANGE',
  DetailsChange = 'DETAILS_CHANGE',
  GroupChange = 'GROUP_CHANGE',
  LivestreamActive = 'LIVESTREAM_ACTIVE',
  LivestreamEnded = 'LIVESTREAM_ENDED',
  LivestreamStarted = 'LIVESTREAM_STARTED',
  OwnerChange = 'OWNER_CHANGE',
  PriorityChange = 'PRIORITY_CHANGE',
  PrivateNote = 'PRIVATE_NOTE',
  PublicNote = 'PUBLIC_NOTE',
  StatusChange = 'STATUS_CHANGE',
  TypeChange = 'TYPE_CHANGE'
}

/** A connection to a list of `IncidentUpdate` values. */
export type IncidentUpdatesConnection = {
  __typename?: 'IncidentUpdatesConnection';
  /** A list of edges which contains the `IncidentUpdate` and cursor to aid in pagination. */
  edges: Array<IncidentUpdatesEdge>;
  /** A list of `IncidentUpdate` objects. */
  nodes: Array<IncidentUpdate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IncidentUpdate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IncidentUpdate` edge in the connection. */
export type IncidentUpdatesEdge = {
  __typename?: 'IncidentUpdatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IncidentUpdate` at the end of the edge. */
  node: IncidentUpdate;
};

export type IncidentUpdatesInput = {
  incidentId: Scalars['String']['input'];
};

/** Methods to use when ordering `IncidentUpdate`. */
export enum IncidentUpdatesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IncidentIdAsc = 'INCIDENT_ID_ASC',
  IncidentIdDesc = 'INCIDENT_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PerformedByMemberIdAsc = 'PERFORMED_BY_MEMBER_ID_ASC',
  PerformedByMemberIdDesc = 'PERFORMED_BY_MEMBER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type IncidentUpdatesPayload = {
  __typename?: 'IncidentUpdatesPayload';
  event?: Maybe<GraphqlIncidentUpdateEvent>;
  incident?: Maybe<Incident>;
  relatedIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** A connection to a list of `Incident` values. */
export type IncidentsConnection = {
  __typename?: 'IncidentsConnection';
  /** A list of edges which contains the `Incident` and cursor to aid in pagination. */
  edges: Array<IncidentsEdge>;
  /** A list of `Incident` objects. */
  nodes: Array<Incident>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Incident` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type IncidentsCreatedAtConditionInput = {
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A `Incident` edge in the connection. */
export type IncidentsEdge = {
  __typename?: 'IncidentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Incident` at the end of the edge. */
  node: Incident;
};

/** Methods to use when ordering `Incident`. */
export enum IncidentsOrderBy {
  ContactMemberIdAsc = 'CONTACT_MEMBER_ID_ASC',
  ContactMemberIdDesc = 'CONTACT_MEMBER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IncidentTypeIdAsc = 'INCIDENT_TYPE_ID_ASC',
  IncidentTypeIdDesc = 'INCIDENT_TYPE_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  OwnedByGroupIdAsc = 'OWNED_BY_GROUP_ID_ASC',
  OwnedByGroupIdDesc = 'OWNED_BY_GROUP_ID_DESC',
  OwnedByMemberIdAsc = 'OWNED_BY_MEMBER_ID_ASC',
  OwnedByMemberIdDesc = 'OWNED_BY_MEMBER_ID_DESC',
  ParentIdAsc = 'PARENT_ID_ASC',
  ParentIdDesc = 'PARENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SubmittedByMemberIdAsc = 'SUBMITTED_BY_MEMBER_ID_ASC',
  SubmittedByMemberIdDesc = 'SUBMITTED_BY_MEMBER_ID_DESC'
}

export type IncidentsPriorityConditionInput = {
  high?: InputMaybe<Scalars['Boolean']['input']>;
  low?: InputMaybe<Scalars['Boolean']['input']>;
  medium?: InputMaybe<Scalars['Boolean']['input']>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IncidentsStatusConditionInput = {
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IncidentsUpdatedAtConditionInput = {
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
};

export type IncidentsUpdatesInput = {
  organizationId: Scalars['String']['input'];
};

export type IncidentsUpdatesPayload = {
  __typename?: 'IncidentsUpdatesPayload';
  event?: Maybe<GraphqlIncidentsUpdatesEvent>;
  incident?: Maybe<Incident>;
  relatedIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Invitation = Node & {
  __typename?: 'Invitation';
  groupIds: Array<Maybe<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  /** @deprecated Use Invitation.key */
  matchedEmailAddress?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use Invitation.key */
  matchedPhoneNumber?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Invitation`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationRole: MemberRole;
};

/**
 * A condition to be used against `Invitation` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type InvitationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Invitation` object types. All fields are combined with a logical ‘and.’ */
export type InvitationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InvitationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InvitationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InvitationFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `organizationName` field. */
  organizationName?: InputMaybe<StringFilter>;
};

/** A connection to a list of `Invitation` values. */
export type InvitationsConnection = {
  __typename?: 'InvitationsConnection';
  /** A list of edges which contains the `Invitation` and cursor to aid in pagination. */
  edges: Array<InvitationsEdge>;
  /** A list of `Invitation` objects. */
  nodes: Array<Invitation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Invitation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Invitation` edge in the connection. */
export type InvitationsEdge = {
  __typename?: 'InvitationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Invitation` at the end of the edge. */
  node: Invitation;
};

/** Methods to use when ordering `Invitation`. */
export enum InvitationsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type IotSettingsPayload = {
  __typename?: 'IotSettingsPayload';
  /** The Credential-Provider endpoint for iot devices. */
  credentialProviderEndpoint: Scalars['String']['output'];
  /** The Data-ATS endpoint for iot devices. */
  dataAtsEndpoint: Scalars['String']['output'];
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type Livestream = Node & {
  __typename?: 'Livestream';
  createdAt: Scalars['Datetime']['output'];
  droneEndpoint?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Guardme` that is related to this `Livestream`. */
  guardme?: Maybe<Guardme>;
  guardmeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Reads a single `Incident` that is related to this `Livestream`. */
  incident?: Maybe<Incident>;
  incidentId?: Maybe<Scalars['String']['output']>;
  isEnded: Scalars['Boolean']['output'];
  kinesisEndpoint?: Maybe<LivestreamKinesisEndpoint>;
  /** Reads a single `Member` that is related to this `Livestream`. */
  member?: Maybe<Member>;
  memberId: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Livestream`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  status: LivestreamStatus;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  webrtcEndpoint?: Maybe<LivestreamWebrtcEndpoint>;
};

/**
 * A condition to be used against `Livestream` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LivestreamCondition = {
  /** Checks for equality with the object’s `guardmeId` field. */
  guardmeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `incidentId` field. */
  incidentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type LivestreamDeviceStreamingUrlPayload = {
  __typename?: 'LivestreamDeviceStreamingUrlPayload';
  url: Scalars['String']['output'];
};

export type LivestreamDevices = {
  __typename?: 'LivestreamDevices';
  id: Scalars['String']['output'];
  isIotConfigured: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

/** A filter to be used against `Livestream` object types. All fields are combined with a logical ‘and.’ */
export type LivestreamFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LivestreamFilter>>;
  /** Filter by the object’s `guardme` relation. */
  guardme?: InputMaybe<GuardmeFilter>;
  /** A related `guardme` exists. */
  guardmeExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmeId` field. */
  guardmeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `incident` relation. */
  incident?: InputMaybe<IncidentFilter>;
  /** A related `incident` exists. */
  incidentExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `incidentId` field. */
  incidentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LivestreamFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LivestreamFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

export type LivestreamKinesisEndpoint = {
  __typename?: 'LivestreamKinesisEndpoint';
  accessKeyId: Scalars['String']['output'];
  expiration: Scalars['Datetime']['output'];
  secretAccessKey: Scalars['String']['output'];
  sessionToken: Scalars['String']['output'];
  streamName: Scalars['String']['output'];
};

export enum LivestreamStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  Idle = 'IDLE'
}

export type LivestreamWebrtcEndpoint = {
  __typename?: 'LivestreamWebrtcEndpoint';
  accessKeyId: Scalars['String']['output'];
  channelArn: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  expiration: Scalars['Datetime']['output'];
  httpsEndpoint: Scalars['String']['output'];
  secretAccessKey: Scalars['String']['output'];
  sessionToken: Scalars['String']['output'];
  webrtcEndpoint: Scalars['String']['output'];
  wssEndpoint: Scalars['String']['output'];
};

/** A connection to a list of `Livestream` values. */
export type LivestreamsConnection = {
  __typename?: 'LivestreamsConnection';
  /** A list of edges which contains the `Livestream` and cursor to aid in pagination. */
  edges: Array<LivestreamsEdge>;
  /** A list of `Livestream` objects. */
  nodes: Array<Livestream>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Livestream` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Livestream` edge in the connection. */
export type LivestreamsEdge = {
  __typename?: 'LivestreamsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Livestream` at the end of the edge. */
  node: Livestream;
};

/** Methods to use when ordering `Livestream`. */
export enum LivestreamsOrderBy {
  GuardmeIdAsc = 'GUARDME_ID_ASC',
  GuardmeIdDesc = 'GUARDME_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IncidentIdAsc = 'INCIDENT_ID_ASC',
  IncidentIdDesc = 'INCIDENT_ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** An input for mutations affecting `Location` */
export type LocationInput = {
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  altitude?: InputMaybe<Scalars['Float']['input']>;
  altitudeAccuracy?: InputMaybe<Scalars['Float']['input']>;
  buildingFloor?: InputMaybe<Scalars['Int']['input']>;
  heading?: InputMaybe<Scalars['Float']['input']>;
  isMock?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  recordedAt?: InputMaybe<Scalars['Datetime']['input']>;
  speed?: InputMaybe<Scalars['Float']['input']>;
};

export enum LogoType {
  Custom = 'CUSTOM',
  Initials = 'INITIALS'
}

export type MapGroupsMember = {
  __typename?: 'MapGroupsMember';
  createdAt: Scalars['Datetime']['output'];
  groupId: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

/**   A member of an organization */
export type Member = Node & {
  __typename?: 'Member';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `BivyStick`. */
  bivySticks: BivySticksConnection;
  /** @deprecated Use Member.id */
  chatId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `CheckInReport`. */
  checkInReportsByRequestorMemberId: CheckInReportsConnection;
  /** Reads and enables pagination through a set of `CheckInRequest`. */
  checkInRequests: CheckInRequestsConnection;
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkIns: CheckInsConnection;
  createdAt: Scalars['Datetime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use Member.emailAddress */
  emailAddresses: Array<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `EmergencyContact`. */
  emergencyContacts: EmergencyContactsConnection;
  fullName: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Group`. */
  groups: GroupsConnection;
  /** Reads and enables pagination through a set of `GuardmeAttachment`. */
  guardmeAttachments: GuardmeAttachmentsConnection;
  /** Reads and enables pagination through a set of `GuardmeAuditLog`. */
  guardmeAuditLogs: GuardmeAuditLogsConnection;
  /** Reads and enables pagination through a set of `GuardmeAuditLog`. */
  guardmeAuditLogsByPerformedById: GuardmeAuditLogsConnection;
  /** Reads and enables pagination through a set of `GuardmeLivestream`. */
  guardmeLivestreams: GuardmeLivestreamsConnection;
  /** Reads and enables pagination through a set of `GuardmeLocation`. */
  guardmeLocations: GuardmeLocationsConnection;
  /** Reads and enables pagination through a set of `Guardme`. */
  guardmes: GuardmesConnection;
  id: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `IncidentUpdate`. */
  incidentUpdatesByPerformedByMemberId: IncidentUpdatesConnection;
  /** Reads and enables pagination through a set of `Incident`. */
  incidentsByContactMemberId: IncidentsConnection;
  /** Reads and enables pagination through a set of `Incident`. */
  incidentsByOwnedByMemberId: IncidentsConnection;
  /** Reads and enables pagination through a set of `Incident`. */
  incidentsBySubmittedByMemberId: IncidentsConnection;
  /** @deprecated Use Organization.billingDetails.billingEmailAddress */
  isBillingContact: Scalars['Boolean']['output'];
  isCheckInSupervisor?: Maybe<Scalars['Boolean']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  isGuardmeSupervisor?: Maybe<Scalars['Boolean']['output']>;
  isIncidentSupervisor?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use Member.organization_role */
  isOwner: Scalars['Boolean']['output'];
  lastActiveAt?: Maybe<Scalars['Datetime']['output']>;
  /** @deprecated No longer supported. */
  livestreamDevices: MemberLivestreamDevices;
  /** Reads and enables pagination through a set of `Livestream`. */
  livestreams: LivestreamsConnection;
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Member`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  organizationRole: MemberRole;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOwnerMemberId: OrganizationsConnection;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use Member.phoneNumber */
  phoneNumbers: Array<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `PtcInstallationReport`. */
  ptcInstallationReportsByCreatedByMemberId: PtcInstallationReportsConnection;
  /** Reads and enables pagination through a set of `PtcInstallationReport`. */
  ptcInstallationReportsByInstalledByMemberId: PtcInstallationReportsConnection;
  /** Reads and enables pagination through a set of `PtcInstallationReport`. */
  ptcInstallationReportsByProgramPlugLabelIdVerifiedByMemberId: PtcInstallationReportsConnection;
  /** Reads and enables pagination through a set of `PtcInstallationReport`. */
  ptcInstallationReportsByTransponderTelegramReadByMemberId: PtcInstallationReportsConnection;
  /** Reads and enables pagination through a set of `PtcInstallationReport`. */
  ptcInstallationReportsByVerifiedByMemberId: PtcInstallationReportsConnection;
  /** Reads and enables pagination through a set of `PtcVerificationReport`. */
  ptcVerificationReportsByCreatedByMemberId: PtcVerificationReportsConnection;
  /** @deprecated Use Member.organization_role. */
  role: MemberRoleObject;
  /** Reads and enables pagination through a set of `ScheduledGuardme`. */
  scheduledGuardmes: ScheduledGuardmesConnection;
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Member`. */
  user?: Maybe<User>;
};


/**   A member of an organization */
export type MemberBivySticksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BivyStickCondition>;
  filter?: InputMaybe<BivyStickFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BivySticksOrderBy>>;
};


/**   A member of an organization */
export type MemberCheckInReportsByRequestorMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInReportCondition>;
  filter?: InputMaybe<CheckInReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInReportsOrderBy>>;
};


/**   A member of an organization */
export type MemberCheckInRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInRequestCondition>;
  filter?: InputMaybe<CheckInRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInRequestsOrderBy>>;
};


/**   A member of an organization */
export type MemberCheckInsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInCondition>;
  filter?: InputMaybe<CheckInFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


/**   A member of an organization */
export type MemberEmergencyContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmergencyContactCondition>;
  filter?: InputMaybe<EmergencyContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmergencyContactsOrderBy>>;
};


/**   A member of an organization */
export type MemberGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**   A member of an organization */
export type MemberGuardmeAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeAttachmentCondition>;
  filter?: InputMaybe<GuardmeAttachmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeAttachmentsOrderBy>>;
};


/**   A member of an organization */
export type MemberGuardmeAuditLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeAuditLogCondition>;
  filter?: InputMaybe<GuardmeAuditLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeAuditLogsOrderBy>>;
};


/**   A member of an organization */
export type MemberGuardmeAuditLogsByPerformedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeAuditLogCondition>;
  filter?: InputMaybe<GuardmeAuditLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeAuditLogsOrderBy>>;
};


/**   A member of an organization */
export type MemberGuardmeLivestreamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeLivestreamCondition>;
  filter?: InputMaybe<GuardmeLivestreamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeLivestreamsOrderBy>>;
};


/**   A member of an organization */
export type MemberGuardmeLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeLocationCondition>;
  filter?: InputMaybe<GuardmeLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeLocationsOrderBy>>;
};


/**   A member of an organization */
export type MemberGuardmesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeCondition>;
  filter?: InputMaybe<GuardmeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmesOrderBy>>;
};


/**   A member of an organization */
export type MemberIncidentUpdatesByPerformedByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentUpdateCondition>;
  filter?: InputMaybe<IncidentUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentUpdatesOrderBy>>;
};


/**   A member of an organization */
export type MemberIncidentsByContactMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentCondition>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};


/**   A member of an organization */
export type MemberIncidentsByOwnedByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentCondition>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};


/**   A member of an organization */
export type MemberIncidentsBySubmittedByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentCondition>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};


/**   A member of an organization */
export type MemberLivestreamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LivestreamCondition>;
  filter?: InputMaybe<LivestreamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LivestreamsOrderBy>>;
};


/**   A member of an organization */
export type MemberOrganizationsByOwnerMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  filter?: InputMaybe<OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


/**   A member of an organization */
export type MemberPtcInstallationReportsByCreatedByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcInstallationReportCondition>;
  filter?: InputMaybe<PtcInstallationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcInstallationReportsOrderBy>>;
};


/**   A member of an organization */
export type MemberPtcInstallationReportsByInstalledByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcInstallationReportCondition>;
  filter?: InputMaybe<PtcInstallationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcInstallationReportsOrderBy>>;
};


/**   A member of an organization */
export type MemberPtcInstallationReportsByProgramPlugLabelIdVerifiedByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcInstallationReportCondition>;
  filter?: InputMaybe<PtcInstallationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcInstallationReportsOrderBy>>;
};


/**   A member of an organization */
export type MemberPtcInstallationReportsByTransponderTelegramReadByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcInstallationReportCondition>;
  filter?: InputMaybe<PtcInstallationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcInstallationReportsOrderBy>>;
};


/**   A member of an organization */
export type MemberPtcInstallationReportsByVerifiedByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcInstallationReportCondition>;
  filter?: InputMaybe<PtcInstallationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcInstallationReportsOrderBy>>;
};


/**   A member of an organization */
export type MemberPtcVerificationReportsByCreatedByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcVerificationReportCondition>;
  filter?: InputMaybe<PtcVerificationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcVerificationReportsOrderBy>>;
};


/**   A member of an organization */
export type MemberScheduledGuardmesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledGuardmeCondition>;
  filter?: InputMaybe<ScheduledGuardmeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledGuardmesOrderBy>>;
};

/** All input for the `memberCheckIn` mutation. */
export type MemberCheckInInput = {
  accuracy: Scalars['Float']['input'];
  altitude: Scalars['Float']['input'];
  altitudeAccuracy: Scalars['Float']['input'];
  buildingFloor: Scalars['Int']['input'];
  checkInRequestId?: InputMaybe<Scalars['String']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  heading: Scalars['Float']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  organizationId: Scalars['String']['input'];
  speed: Scalars['Float']['input'];
};

/** The output of our `memberCheckIn` mutation. */
export type MemberCheckInPayload = {
  __typename?: 'MemberCheckInPayload';
  checkIn?: Maybe<CheckIn>;
  /** An edge for our `CheckIn`. May be used by Relay 1. */
  checkInEdge?: Maybe<CheckInsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `CheckIn`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `CheckIn`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `memberCheckIn` mutation. */
export type MemberCheckInPayloadCheckInEdgeArgs = {
  orderBy?: Array<CheckInsOrderBy>;
};

/** A condition to be used against `Member` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MemberCondition = {
  /** Filter Members by creation. */
  createdAt?: InputMaybe<MembersCreatedAtConditionInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Filters Members based on activity. */
  lastActiveAt?: InputMaybe<MembersLastActiveAtConditionInput>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Member` object types. All fields are combined with a logical ‘and.’ */
export type MemberFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MemberFilter>>;
  /** Filter by the object’s `avatarUrl` field. */
  avatarUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `bivySticks` relation. */
  bivySticks?: InputMaybe<MemberToManyBivyStickFilter>;
  /** Some related `bivySticks` exist. */
  bivySticksExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `checkInReportsByRequestorMemberId` relation. */
  checkInReportsByRequestorMemberId?: InputMaybe<MemberToManyCheckInReportFilter>;
  /** Some related `checkInReportsByRequestorMemberId` exist. */
  checkInReportsByRequestorMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `checkInRequests` relation. */
  checkInRequests?: InputMaybe<MemberToManyCheckInRequestFilter>;
  /** Some related `checkInRequests` exist. */
  checkInRequestsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `checkIns` relation. */
  checkIns?: InputMaybe<MemberToManyCheckInFilter>;
  /** Some related `checkIns` exist. */
  checkInsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `emailAddress` field. */
  emailAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emergencyContacts` relation. */
  emergencyContacts?: InputMaybe<MemberToManyEmergencyContactFilter>;
  /** Some related `emergencyContacts` exist. */
  emergencyContactsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `guardmeAttachments` relation. */
  guardmeAttachments?: InputMaybe<MemberToManyGuardmeAttachmentFilter>;
  /** Some related `guardmeAttachments` exist. */
  guardmeAttachmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmeAuditLogs` relation. */
  guardmeAuditLogs?: InputMaybe<MemberToManyGuardmeAuditLogFilter>;
  /** Filter by the object’s `guardmeAuditLogsByPerformedById` relation. */
  guardmeAuditLogsByPerformedById?: InputMaybe<MemberToManyGuardmeAuditLogFilter>;
  /** Some related `guardmeAuditLogsByPerformedById` exist. */
  guardmeAuditLogsByPerformedByIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Some related `guardmeAuditLogs` exist. */
  guardmeAuditLogsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmeLivestreams` relation. */
  guardmeLivestreams?: InputMaybe<MemberToManyGuardmeLivestreamFilter>;
  /** Some related `guardmeLivestreams` exist. */
  guardmeLivestreamsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmeLocations` relation. */
  guardmeLocations?: InputMaybe<MemberToManyGuardmeLocationFilter>;
  /** Some related `guardmeLocations` exist. */
  guardmeLocationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmes` relation. */
  guardmes?: InputMaybe<MemberToManyGuardmeFilter>;
  /** Some related `guardmes` exist. */
  guardmesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `incidentUpdatesByPerformedByMemberId` relation. */
  incidentUpdatesByPerformedByMemberId?: InputMaybe<MemberToManyIncidentUpdateFilter>;
  /** Some related `incidentUpdatesByPerformedByMemberId` exist. */
  incidentUpdatesByPerformedByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `incidentsByContactMemberId` relation. */
  incidentsByContactMemberId?: InputMaybe<MemberToManyIncidentFilter>;
  /** Some related `incidentsByContactMemberId` exist. */
  incidentsByContactMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `incidentsByOwnedByMemberId` relation. */
  incidentsByOwnedByMemberId?: InputMaybe<MemberToManyIncidentFilter>;
  /** Some related `incidentsByOwnedByMemberId` exist. */
  incidentsByOwnedByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `incidentsBySubmittedByMemberId` relation. */
  incidentsBySubmittedByMemberId?: InputMaybe<MemberToManyIncidentFilter>;
  /** Some related `incidentsBySubmittedByMemberId` exist. */
  incidentsBySubmittedByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `isCheckInSupervisor` field. */
  isCheckInSupervisor?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isGuardmeSupervisor` field. */
  isGuardmeSupervisor?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isIncidentSupervisor` field. */
  isIncidentSupervisor?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `livestreams` relation. */
  livestreams?: InputMaybe<MemberToManyLivestreamFilter>;
  /** Some related `livestreams` exist. */
  livestreamsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MemberFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MemberFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `organizationsByOwnerMemberId` relation. */
  organizationsByOwnerMemberId?: InputMaybe<MemberToManyOrganizationFilter>;
  /** Some related `organizationsByOwnerMemberId` exist. */
  organizationsByOwnerMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ptcInstallationReportsByCreatedByMemberId` relation. */
  ptcInstallationReportsByCreatedByMemberId?: InputMaybe<MemberToManyPtcInstallationReportFilter>;
  /** Some related `ptcInstallationReportsByCreatedByMemberId` exist. */
  ptcInstallationReportsByCreatedByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ptcInstallationReportsByInstalledByMemberId` relation. */
  ptcInstallationReportsByInstalledByMemberId?: InputMaybe<MemberToManyPtcInstallationReportFilter>;
  /** Some related `ptcInstallationReportsByInstalledByMemberId` exist. */
  ptcInstallationReportsByInstalledByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ptcInstallationReportsByProgramPlugLabelIdVerifiedByMemberId` relation. */
  ptcInstallationReportsByProgramPlugLabelIdVerifiedByMemberId?: InputMaybe<MemberToManyPtcInstallationReportFilter>;
  /** Some related `ptcInstallationReportsByProgramPlugLabelIdVerifiedByMemberId` exist. */
  ptcInstallationReportsByProgramPlugLabelIdVerifiedByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ptcInstallationReportsByTransponderTelegramReadByMemberId` relation. */
  ptcInstallationReportsByTransponderTelegramReadByMemberId?: InputMaybe<MemberToManyPtcInstallationReportFilter>;
  /** Some related `ptcInstallationReportsByTransponderTelegramReadByMemberId` exist. */
  ptcInstallationReportsByTransponderTelegramReadByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ptcInstallationReportsByVerifiedByMemberId` relation. */
  ptcInstallationReportsByVerifiedByMemberId?: InputMaybe<MemberToManyPtcInstallationReportFilter>;
  /** Some related `ptcInstallationReportsByVerifiedByMemberId` exist. */
  ptcInstallationReportsByVerifiedByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ptcVerificationReportsByCreatedByMemberId` relation. */
  ptcVerificationReportsByCreatedByMemberId?: InputMaybe<MemberToManyPtcVerificationReportFilter>;
  /** Some related `ptcVerificationReportsByCreatedByMemberId` exist. */
  ptcVerificationReportsByCreatedByMemberIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `scheduledGuardmes` relation. */
  scheduledGuardmes?: InputMaybe<MemberToManyScheduledGuardmeFilter>;
  /** Some related `scheduledGuardmes` exist. */
  scheduledGuardmesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `timezone` field. */
  timezone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MemberLivestreamDevices = {
  __typename?: 'MemberLivestreamDevices';
  nodes: Array<LivestreamDevices>;
};

export enum MemberRole {
  Administrator = 'ADMINISTRATOR',
  ExternalMonitoringAgent = 'EXTERNAL_MONITORING_AGENT',
  Member = 'MEMBER',
  Owner = 'OWNER',
  Supervisor = 'SUPERVISOR',
  Visualc3 = 'VISUALC3'
}

export type MemberRoleObject = {
  __typename?: 'MemberRoleObject';
  name: Scalars['String']['output'];
  scopes: Array<Scalars['String']['output']>;
};

export type MemberStatistic = {
  __typename?: 'MemberStatistic';
  checkInCount: Scalars['BigInt']['output'];
  guardmeCount: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  incidentCount: Scalars['BigInt']['output'];
  intervalType: StatisticIntervalType;
  memberId: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  timestamp: Scalars['Datetime']['output'];
  timezone: Scalars['String']['output'];
};

/** A filter to be used against `MemberStatistic` object types. All fields are combined with a logical ‘and.’ */
export type MemberStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MemberStatisticFilter>>;
  /** Filter by the object’s `intervalType` field. */
  intervalType?: InputMaybe<StatisticIntervalTypeFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MemberStatisticFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MemberStatisticFilter>>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `timezone` field. */
  timezone?: InputMaybe<StringFilter>;
};

/** A connection to a list of `MemberStatistic` values. */
export type MemberStatisticsConnection = {
  __typename?: 'MemberStatisticsConnection';
  /** A list of edges which contains the `MemberStatistic` and cursor to aid in pagination. */
  edges: Array<MemberStatisticsEdge>;
  /** A list of `MemberStatistic` objects. */
  nodes: Array<MemberStatistic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MemberStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MemberStatistic` edge in the connection. */
export type MemberStatisticsEdge = {
  __typename?: 'MemberStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MemberStatistic` at the end of the edge. */
  node: MemberStatistic;
};

/** A filter to be used against many `BivyStick` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyBivyStickFilter = {
  /** Every related `BivyStick` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BivyStickFilter>;
  /** No related `BivyStick` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BivyStickFilter>;
  /** Some related `BivyStick` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BivyStickFilter>;
};

/** A filter to be used against many `CheckIn` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyCheckInFilter = {
  /** Every related `CheckIn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckInFilter>;
  /** No related `CheckIn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckInFilter>;
  /** Some related `CheckIn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckInFilter>;
};

/** A filter to be used against many `CheckInReport` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyCheckInReportFilter = {
  /** Every related `CheckInReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckInReportFilter>;
  /** No related `CheckInReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckInReportFilter>;
  /** Some related `CheckInReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckInReportFilter>;
};

/** A filter to be used against many `CheckInRequest` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyCheckInRequestFilter = {
  /** Every related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckInRequestFilter>;
  /** No related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckInRequestFilter>;
  /** Some related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckInRequestFilter>;
};

/** A filter to be used against many `EmergencyContact` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyEmergencyContactFilter = {
  /** Every related `EmergencyContact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmergencyContactFilter>;
  /** No related `EmergencyContact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmergencyContactFilter>;
  /** Some related `EmergencyContact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmergencyContactFilter>;
};

/** A filter to be used against many `GuardmeAttachment` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyGuardmeAttachmentFilter = {
  /** Every related `GuardmeAttachment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeAttachmentFilter>;
  /** No related `GuardmeAttachment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeAttachmentFilter>;
  /** Some related `GuardmeAttachment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeAttachmentFilter>;
};

/** A filter to be used against many `GuardmeAuditLog` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyGuardmeAuditLogFilter = {
  /** Every related `GuardmeAuditLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeAuditLogFilter>;
  /** No related `GuardmeAuditLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeAuditLogFilter>;
  /** Some related `GuardmeAuditLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeAuditLogFilter>;
};

/** A filter to be used against many `Guardme` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyGuardmeFilter = {
  /** Every related `Guardme` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeFilter>;
  /** No related `Guardme` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeFilter>;
  /** Some related `Guardme` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeFilter>;
};

/** A filter to be used against many `GuardmeLivestream` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyGuardmeLivestreamFilter = {
  /** Every related `GuardmeLivestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeLivestreamFilter>;
  /** No related `GuardmeLivestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeLivestreamFilter>;
  /** Some related `GuardmeLivestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeLivestreamFilter>;
};

/** A filter to be used against many `GuardmeLocation` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyGuardmeLocationFilter = {
  /** Every related `GuardmeLocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeLocationFilter>;
  /** No related `GuardmeLocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeLocationFilter>;
  /** Some related `GuardmeLocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeLocationFilter>;
};

/** A filter to be used against many `Incident` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyIncidentFilter = {
  /** Every related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IncidentFilter>;
  /** No related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IncidentFilter>;
  /** Some related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IncidentFilter>;
};

/** A filter to be used against many `IncidentUpdate` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyIncidentUpdateFilter = {
  /** Every related `IncidentUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IncidentUpdateFilter>;
  /** No related `IncidentUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IncidentUpdateFilter>;
  /** Some related `IncidentUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IncidentUpdateFilter>;
};

/** A filter to be used against many `Livestream` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyLivestreamFilter = {
  /** Every related `Livestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LivestreamFilter>;
  /** No related `Livestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LivestreamFilter>;
  /** Some related `Livestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LivestreamFilter>;
};

/** A filter to be used against many `Organization` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyOrganizationFilter = {
  /** Every related `Organization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OrganizationFilter>;
  /** No related `Organization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OrganizationFilter>;
  /** Some related `Organization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OrganizationFilter>;
};

/** A filter to be used against many `PtcInstallationReport` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyPtcInstallationReportFilter = {
  /** Every related `PtcInstallationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PtcInstallationReportFilter>;
  /** No related `PtcInstallationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PtcInstallationReportFilter>;
  /** Some related `PtcInstallationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PtcInstallationReportFilter>;
};

/** A filter to be used against many `PtcVerificationReport` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyPtcVerificationReportFilter = {
  /** Every related `PtcVerificationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PtcVerificationReportFilter>;
  /** No related `PtcVerificationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PtcVerificationReportFilter>;
  /** Some related `PtcVerificationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PtcVerificationReportFilter>;
};

/** A filter to be used against many `ScheduledGuardme` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyScheduledGuardmeFilter = {
  /** Every related `ScheduledGuardme` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledGuardmeFilter>;
  /** No related `ScheduledGuardme` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledGuardmeFilter>;
  /** Some related `ScheduledGuardme` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledGuardmeFilter>;
};

/** A connection to a list of `Member` values. */
export type MembersConnection = {
  __typename?: 'MembersConnection';
  /** A list of edges which contains the `Member` and cursor to aid in pagination. */
  edges: Array<MembersEdge>;
  /** A list of `Member` objects. */
  nodes: Array<Member>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Member` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type MembersCreatedAtConditionInput = {
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A `Member` edge in the connection. */
export type MembersEdge = {
  __typename?: 'MembersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Member` at the end of the edge. */
  node: Member;
};

export type MembersLastActiveAtConditionInput = {
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Methods to use when ordering `Member`. */
export enum MembersOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type MembershipCode = Node & {
  __typename?: 'MembershipCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  groupIds: Array<Maybe<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `MembershipRequest`. */
  membershipRequests: MembershipRequestsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `MembershipCode`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  organizationRole: MemberRole;
  requiresApproval: Scalars['Boolean']['output'];
  role?: Maybe<MemberRole>;
  updatedAt: Scalars['Datetime']['output'];
};


export type MembershipCodeMembershipRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipRequestCondition>;
  filter?: InputMaybe<MembershipRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipRequestsOrderBy>>;
};

/**
 * A condition to be used against `MembershipCode` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MembershipCodeCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MembershipCode` object types. All fields are combined with a logical ‘and.’ */
export type MembershipCodeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MembershipCodeFilter>>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `membershipRequests` relation. */
  membershipRequests?: InputMaybe<MembershipCodeToManyMembershipRequestFilter>;
  /** Some related `membershipRequests` exist. */
  membershipRequestsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<MembershipCodeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MembershipCodeFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `MembershipRequest` object types. All fields are combined with a logical ‘and.’ */
export type MembershipCodeToManyMembershipRequestFilter = {
  /** Every related `MembershipRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembershipRequestFilter>;
  /** No related `MembershipRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembershipRequestFilter>;
  /** Some related `MembershipRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembershipRequestFilter>;
};

/** A connection to a list of `MembershipCode` values. */
export type MembershipCodesConnection = {
  __typename?: 'MembershipCodesConnection';
  /** A list of edges which contains the `MembershipCode` and cursor to aid in pagination. */
  edges: Array<MembershipCodesEdge>;
  /** A list of `MembershipCode` objects. */
  nodes: Array<MembershipCode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MembershipCode` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MembershipCode` edge in the connection. */
export type MembershipCodesEdge = {
  __typename?: 'MembershipCodesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MembershipCode` at the end of the edge. */
  node: MembershipCode;
};

/** Methods to use when ordering `MembershipCode`. */
export enum MembershipCodesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type MembershipRequest = Node & {
  __typename?: 'MembershipRequest';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MembershipRequest.emailAddress */
  emailAddresses: Array<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Reads a single `MembershipCode` that is related to this `MembershipRequest`. */
  membershipCode?: Maybe<MembershipCode>;
  membershipCodeId?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `MembershipRequest`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use MembershipRequest.phoneNumber */
  phoneNumbers: Array<Scalars['String']['output']>;
  publicMetadata: Scalars['JSON']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `MembershipRequest`. */
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

/**
 * A condition to be used against `MembershipRequest` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MembershipRequestCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `membershipCodeId` field. */
  membershipCodeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the `membershipRequestDiscover` mutation. */
export type MembershipRequestDiscoverInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
};

/** The output of our `membershipRequestDiscover` mutation. */
export type MembershipRequestDiscoverPayload = {
  __typename?: 'MembershipRequestDiscoverPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  membershipRequestDiscoverResult?: Maybe<MembershipRequestDiscoverResult>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type MembershipRequestDiscoverResult = {
  __typename?: 'MembershipRequestDiscoverResult';
  code?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationLogoUrl?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  publicMetadataFields?: Maybe<Scalars['JSON']['output']>;
};

/** A filter to be used against `MembershipRequest` object types. All fields are combined with a logical ‘and.’ */
export type MembershipRequestFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MembershipRequestFilter>>;
  /** Filter by the object’s `avatarUrl` field. */
  avatarUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailAddress` field. */
  emailAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `membershipCode` relation. */
  membershipCode?: InputMaybe<MembershipCodeFilter>;
  /** A related `membershipCode` exists. */
  membershipCodeExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `membershipCodeId` field. */
  membershipCodeId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MembershipRequestFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MembershipRequestFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `organizationName` field. */
  organizationName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
};

/** All input for the `membershipRequestSubmit` mutation. */
export type MembershipRequestSubmitInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  publicMetadata: Scalars['JSON']['input'];
};

/** The output of our `membershipRequestSubmit` mutation. */
export type MembershipRequestSubmitPayload = {
  __typename?: 'MembershipRequestSubmitPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `MembershipCode` that is related to this `MembershipRequest`. */
  membershipCode?: Maybe<MembershipCode>;
  membershipRequest?: Maybe<MembershipRequest>;
  /** An edge for our `MembershipRequest`. May be used by Relay 1. */
  membershipRequestEdge?: Maybe<MembershipRequestsEdge>;
  /** Reads a single `Organization` that is related to this `MembershipRequest`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `MembershipRequest`. */
  user?: Maybe<User>;
};


/** The output of our `membershipRequestSubmit` mutation. */
export type MembershipRequestSubmitPayloadMembershipRequestEdgeArgs = {
  orderBy?: Array<MembershipRequestsOrderBy>;
};

/** A connection to a list of `MembershipRequest` values. */
export type MembershipRequestsConnection = {
  __typename?: 'MembershipRequestsConnection';
  /** A list of edges which contains the `MembershipRequest` and cursor to aid in pagination. */
  edges: Array<MembershipRequestsEdge>;
  /** A list of `MembershipRequest` objects. */
  nodes: Array<MembershipRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MembershipRequest` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MembershipRequest` edge in the connection. */
export type MembershipRequestsEdge = {
  __typename?: 'MembershipRequestsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MembershipRequest` at the end of the edge. */
  node: MembershipRequest;
};

/** Methods to use when ordering `MembershipRequest`. */
export enum MembershipRequestsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MembershipCodeIdAsc = 'MEMBERSHIP_CODE_ID_ASC',
  MembershipCodeIdDesc = 'MEMBERSHIP_CODE_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type MobileDevice = Node & {
  __typename?: 'MobileDevice';
  applicationVersion: Scalars['String']['output'];
  /** @deprecated Use MobileDevice.applicationVersion. */
  copperVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  deviceModel: Scalars['String']['output'];
  deviceOsVersion: Scalars['String']['output'];
  deviceToken: Scalars['String']['output'];
  deviceType: MobileDeviceType;
  id: Scalars['String']['output'];
  isSandbox: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** APNS or GCM status of push notification capable device */
  operationalStatus?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `MobileDevice`. */
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

/**
 * A condition to be used against `MobileDevice` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MobileDeviceCondition = {
  /** Checks for equality with the object’s `deviceToken` field. */
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MobileDevice` object types. All fields are combined with a logical ‘and.’ */
export type MobileDeviceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MobileDeviceFilter>>;
  /** Filter by the object’s `deviceToken` field. */
  deviceToken?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MobileDeviceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MobileDeviceFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
};

export enum MobileDeviceType {
  Android = 'ANDROID',
  Ios = 'IOS'
}

/** A connection to a list of `MobileDevice` values. */
export type MobileDevicesConnection = {
  __typename?: 'MobileDevicesConnection';
  /** A list of edges which contains the `MobileDevice` and cursor to aid in pagination. */
  edges: Array<MobileDevicesEdge>;
  /** A list of `MobileDevice` objects. */
  nodes: Array<MobileDevice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MobileDevice` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MobileDevice` edge in the connection. */
export type MobileDevicesEdge = {
  __typename?: 'MobileDevicesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MobileDevice` at the end of the edge. */
  node: MobileDevice;
};

/** Methods to use when ordering `MobileDevice`. */
export enum MobileDevicesOrderBy {
  DeviceTokenAsc = 'DEVICE_TOKEN_ASC',
  DeviceTokenDesc = 'DEVICE_TOKEN_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation?: Maybe<AcceptInvitationPayload>;
  acknowledgeAllUserNotifications?: Maybe<AcknowledgeAllUserNotificationsPayload>;
  acknowledgeUserNotifications?: Maybe<AcknowledgeUserNotificationsPayload>;
  /** @deprecated Use updateCurrentUserEmailAddress */
  addEmailAddress?: Maybe<AddEmailAddressPayload>;
  addGroupMembers?: Maybe<AddGroupMembersPayload>;
  addGuardmeAttachments?: Maybe<AddGuardmeAttachmentsPayload>;
  addIncidentAttachments?: Maybe<AddIncidentAttachmentsPayload>;
  addMemberToGroup?: Maybe<AddMemberToGroupPayload>;
  /** @deprecated Use updateCurrentUserPhoneNumber */
  addPhoneNumber?: Maybe<AddPhoneNumberPayload>;
  addUserToOrganization?: Maybe<AddUserToOrganizationPayload>;
  adminCreateIncidentType?: Maybe<AdminCreateIncidentTypePayload>;
  adminCreateOrganization?: Maybe<AdminCreateOrganizationPayload>;
  adminDeleteOrganization?: Maybe<AdminDeleteOrganizationPayload>;
  adminDeleteUser?: Maybe<AdminDeleteUserPayload>;
  adminDestroyOrganization?: Maybe<AdminDestroyOrganizationPayload>;
  adminDisableUser?: Maybe<AdminDisableUserPayload>;
  adminEnableUser?: Maybe<AdminEnableUserPayload>;
  adminRemoveEmailAddress?: Maybe<AdminRemoveEmailAddressPayload>;
  adminRemovePhoneNumber?: Maybe<AdminRemovePhoneNumberPayload>;
  adminUpdateIncidentType?: Maybe<AdminUpdateIncidentTypePayload>;
  adminUpdateOrganizationMetrics?: Maybe<AdminUpdateOrganizationMetricsPayload>;
  adminUpdateOrganizationOwner?: Maybe<AdminUpdateOrganizationOwnerPayload>;
  adminUpdateOrganizationPlan?: Maybe<AdminUpdateOrganizationPlanPayload>;
  adminUpdateOrganizationState?: Maybe<AdminUpdateOrganizationStatePayload>;
  adminUpdateUserRole?: Maybe<AdminUpdateUserRolePayload>;
  approveMembershipRequest?: Maybe<ApproveMembershipRequestPayload>;
  assignBivyStickToMember?: Maybe<AssignBivyStickToMemberPayload>;
  cancelMembershipRequest?: Maybe<CancelMembershipRequestPayload>;
  closeOrganization?: Maybe<CloseOrganizationPayload>;
  completeMembershipRequest?: Maybe<CompleteMembershipRequestPayload>;
  concludeGuardme?: Maybe<ConcludeGuardmePayload>;
  createBivyStick?: Maybe<CreateBivyStickPayload>;
  createCheckInReport?: Maybe<CreateCheckInReportPayload>;
  createEmergencyContact?: Maybe<CreateEmergencyContactPayload>;
  createGroup?: Maybe<CreateGroupPayload>;
  createIncident?: Maybe<CreateIncidentPayload>;
  createIncidentNote?: Maybe<CreateIncidentNotePayload>;
  createInvitation?: Maybe<CreateInvitationPayload>;
  createMembershipCode?: Maybe<CreateMembershipCodePayload>;
  createOneshotScheduledGuardme?: Maybe<CreateOneshotScheduledGuardmePayload>;
  /** Use this mutation to generate a stripe subscription endpoint. */
  createOrganizationSubscriptionIntent?: Maybe<CreateOrganizationSubscriptionIntentPayload>;
  createPlace?: Maybe<CreatePlacePayload>;
  createPtcAsset?: Maybe<CreatePtcAssetPayload>;
  createPtcAssetInstallationReport?: Maybe<CreatePtcAssetInstallationReportPayload>;
  createPtcAssetVerificationReport?: Maybe<CreatePtcAssetVerificationReportPayload>;
  createRecurringScheduledGuardme?: Maybe<CreateRecurringScheduledGuardmePayload>;
  currentUserCloseAccount?: Maybe<CurrentUserCloseAccountPayload>;
  currentUserDeleteEmailAddress?: Maybe<CurrentUserDeleteEmailAddressPayload>;
  currentUserDeletePendingEmailAddress?: Maybe<CurrentUserDeletePendingEmailAddressPayload>;
  currentUserDeletePendingPhoneNumber?: Maybe<CurrentUserDeletePendingPhoneNumberPayload>;
  currentUserDeletePhoneNumber?: Maybe<CurrentUserDeletePhoneNumberPayload>;
  currentUserUpdateAvatarUrl?: Maybe<CurrentUserUpdateAvatarUrlPayload>;
  currentUserUpdateDetails?: Maybe<CurrentUserUpdateDetailsPayload>;
  currentUserUpdateEmailAddress?: Maybe<CurrentUserUpdateEmailAddressPayload>;
  currentUserUpdateFullName?: Maybe<CurrentUserUpdateFullNamePayload>;
  currentUserUpdateMetadata?: Maybe<CurrentUserUpdateMetadataPayload>;
  currentUserUpdatePhoneNumber?: Maybe<CurrentUserUpdatePhoneNumberPayload>;
  /** Use this mutation to generate a push notification to the current user. */
  debugMobilePush?: Maybe<DebugMobilePushPayload>;
  debugSentryError?: Maybe<DebugSentryErrorPayload>;
  deleteAllUserNotifications?: Maybe<DeleteAllUserNotificationsPayload>;
  deleteBivyStick?: Maybe<DeleteBivyStickPayload>;
  deleteCheckInReport?: Maybe<DeleteCheckInReportPayload>;
  deleteEmergencyContact?: Maybe<DeleteEmergencyContactPayload>;
  deleteGroup?: Maybe<DeleteGroupPayload>;
  deleteGuardmeAttachment?: Maybe<DeleteGuardmeAttachmentPayload>;
  deleteIncidentType?: Maybe<DeleteIncidentTypePayload>;
  deleteInvitation?: Maybe<DeleteInvitationPayload>;
  deleteMember?: Maybe<DeleteMemberPayload>;
  deleteMemberMetadataField?: Maybe<DeleteMemberMetadataFieldPayload>;
  deleteMembershipCode?: Maybe<DeleteMembershipCodePayload>;
  deleteOrganization?: Maybe<DeleteOrganizationPayload>;
  /** Use this mutation to delete a stripe subscription payment intent. */
  deleteOrganizationSubscriptionIntent?: Maybe<DeleteOrganizationSubscriptionIntentPayload>;
  deletePlace?: Maybe<DeletePlacePayload>;
  deletePlan?: Maybe<DeletePlanPayload>;
  deleteScheduledGuardme?: Maybe<DeleteScheduledGuardmePayload>;
  deleteUserNotifications?: Maybe<DeleteUserNotificationsPayload>;
  denyInvitation?: Maybe<DenyInvitationPayload>;
  denyMembershipRequest?: Maybe<DenyMembershipRequestPayload>;
  deregisterMobileDevice?: Maybe<DeregisterMobileDevicePayload>;
  disableIncidentForOrganization?: Maybe<DisableIncidentForOrganizationPayload>;
  disableMember?: Maybe<DisableMemberPayload>;
  disableUser?: Maybe<DisableUserPayload>;
  enableIncidentForOrganization?: Maybe<EnableIncidentForOrganizationPayload>;
  enableMember?: Maybe<EnableMemberPayload>;
  enableUser?: Maybe<EnableUserPayload>;
  endGuardme?: Maybe<EndGuardmePayload>;
  endGuardmeByMemberId?: Maybe<EndGuardmeByMemberIdPayload>;
  endGuardmeLivestream?: Maybe<EndGuardmeLivestreamPayload>;
  endIncidentLivestream?: Maybe<EndIncidentLivestreamPayload>;
  /** Use this mutation to create an incident report in pdf form. */
  generateIncidentPdf?: Maybe<GenerateIncidentPdfPayload>;
  guardmePanic?: Maybe<GuardmePanicPayload>;
  memberCheckIn?: Maybe<MemberCheckInPayload>;
  membershipRequestDiscover?: Maybe<MembershipRequestDiscoverPayload>;
  membershipRequestSubmit?: Maybe<MembershipRequestSubmitPayload>;
  registerLiveActivityTokens?: Maybe<RegisterLiveActivityTokensPayload>;
  registerMobileDevice?: Maybe<RegisterMobileDevicePayload>;
  /** @deprecated Removed */
  removeEmailAddress?: Maybe<RemoveEmailAddressPayload>;
  removeMemberFromGroup?: Maybe<RemoveMemberFromGroupPayload>;
  /** @deprecated Removed */
  removePhoneNumber?: Maybe<RemovePhoneNumberPayload>;
  /** @deprecated Use updateCurrentUserEmailAddress */
  reverifyEmailAddress?: Maybe<ReverifyEmailAddressPayload>;
  /** @deprecated Use updateCurrentUserPhoneNumber */
  reverifyPhoneNumber?: Maybe<ReverifyPhoneNumberPayload>;
  setCurrentUserDefaultOrganizationId?: Maybe<SetCurrentUserDefaultOrganizationIdPayload>;
  startGuardme?: Maybe<StartGuardmePayload>;
  startGuardmeLivestream?: Maybe<StartGuardmeLivestreamPayload>;
  startIncidentLivestream?: Maybe<StartIncidentLivestreamPayload>;
  startMembershipRequest?: Maybe<StartMembershipRequestPayload>;
  startTimedGuardme?: Maybe<StartTimedGuardmePayload>;
  transferOrganizationOwnership?: Maybe<TransferOrganizationOwnershipPayload>;
  updateAllowMembershipRequests?: Maybe<UpdateAllowMembershipRequestsPayload>;
  updateCurrentLocation?: Maybe<UpdateCurrentLocationPayload>;
  updateEmergencyContact?: Maybe<UpdateEmergencyContactPayload>;
  updateEnabledIncidentTypeAssignedGroup?: Maybe<UpdateEnabledIncidentTypeAssignedGroupPayload>;
  updateGroup?: Maybe<UpdateGroupPayload>;
  updateGroupMembers?: Maybe<UpdateGroupMembersPayload>;
  updateGuardme?: Maybe<UpdateGuardmePayload>;
  /**   This mutation allows the client to update the battery level of the mobile device related to this GuardMe. */
  updateGuardmeBatteryLevel?: Maybe<UpdateGuardmeBatteryLevelPayload>;
  updateGuardmeNotes?: Maybe<UpdateGuardmeNotesPayload>;
  updateGuardmePanicAsAdmin?: Maybe<UpdateGuardmePanicAsAdminPayload>;
  updateIncidentContact?: Maybe<UpdateIncidentContactPayload>;
  updateIncidentDetails?: Maybe<UpdateIncidentDetailsPayload>;
  updateIncidentGroup?: Maybe<UpdateIncidentGroupPayload>;
  updateIncidentOwner?: Maybe<UpdateIncidentOwnerPayload>;
  updateIncidentPriority?: Maybe<UpdateIncidentPriorityPayload>;
  updateIncidentStatus?: Maybe<UpdateIncidentStatusPayload>;
  updateIncidentType?: Maybe<UpdateIncidentTypePayload>;
  updateIncidentTypeAllowlist?: Maybe<UpdateIncidentTypeAllowlistPayload>;
  updateInvitation?: Maybe<UpdateInvitationPayload>;
  updateMemberDisplayName?: Maybe<UpdateMemberDisplayNamePayload>;
  updateMemberGroups?: Maybe<UpdateMemberGroupsPayload>;
  updateMemberMetadata?: Maybe<UpdateMemberMetadataPayload>;
  updateMemberRole?: Maybe<UpdateMemberRolePayload>;
  updateOrganizationCheckInSettings?: Maybe<UpdateOrganizationCheckInSettingsPayload>;
  updateOrganizationCheckInSupervisorGroup?: Maybe<UpdateOrganizationCheckInSupervisorGroupPayload>;
  updateOrganizationDetails?: Maybe<UpdateOrganizationDetailsPayload>;
  updateOrganizationGuardmeNotificationSettings?: Maybe<UpdateOrganizationGuardmeNotificationSettingsPayload>;
  updateOrganizationGuardmeSettings?: Maybe<UpdateOrganizationGuardmeSettingsPayload>;
  updateOrganizationGuardmeSupervisorGroup?: Maybe<UpdateOrganizationGuardmeSupervisorGroupPayload>;
  updateOrganizationIncidentSettings?: Maybe<UpdateOrganizationIncidentSettingsPayload>;
  updateOrganizationIncidentSupervisorGroup?: Maybe<UpdateOrganizationIncidentSupervisorGroupPayload>;
  updateOrganizationLogoUrl?: Maybe<UpdateOrganizationLogoUrlPayload>;
  updateOrganizationMapSettings?: Maybe<UpdateOrganizationMapSettingsPayload>;
  updateOrganizationMemberMetadataFields?: Maybe<UpdateOrganizationMemberMetadataFieldsPayload>;
  updateOrganizationName?: Maybe<UpdateOrganizationNamePayload>;
  updateOrganizationRapidsosSettings?: Maybe<UpdateOrganizationRapidsosSettingsPayload>;
  updateOrganizationSettingsAdministratorNotifiedOnCheckIn?: Maybe<UpdateOrganizationSettingsAdministratorNotifiedOnCheckInPayload>;
  updateOrganizationSettingsAdministratorNotifiedOnGuardme?: Maybe<UpdateOrganizationSettingsAdministratorNotifiedOnGuardmePayload>;
  updateOrganizationSettingsAdministratorNotifiedOnIncident?: Maybe<UpdateOrganizationSettingsAdministratorNotifiedOnIncidentPayload>;
  updateOrganizationSettingsOwnerNotifiedOnCheckIn?: Maybe<UpdateOrganizationSettingsOwnerNotifiedOnCheckInPayload>;
  updateOrganizationSettingsOwnerNotifiedOnGuardme?: Maybe<UpdateOrganizationSettingsOwnerNotifiedOnGuardmePayload>;
  updateOrganizationSettingsOwnerNotifiedOnIncident?: Maybe<UpdateOrganizationSettingsOwnerNotifiedOnIncidentPayload>;
  updateOrganizationTimezone?: Maybe<UpdateOrganizationTimezonePayload>;
  updatePlace?: Maybe<UpdatePlacePayload>;
  updatePlan?: Maybe<UpdatePlanPayload>;
  updatePtcAccess?: Maybe<UpdatePtcAccessPayload>;
  updatePtcNotifications?: Maybe<UpdatePtcNotificationsPayload>;
  updateScheduledGuardme?: Maybe<UpdateScheduledGuardmePayload>;
  updateTimedGuardmeEndsAt?: Maybe<UpdateTimedGuardmeEndsAtPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  /** Use this mutation to get the url to upload an attachment for a guardme. */
  uploadAttachment?: Maybe<UploadAttachmentPayload>;
  /** Use this mutation to get the url to upload a custom avatar for your profile. */
  uploadAvatar?: Maybe<UploadAvatarPayload>;
  /**
   * Use this mutation to get the url to upload an attachment for a guardme.
   * @deprecated Use uploadAttachment
   */
  uploadGuardmeAttachment?: Maybe<UploadGuardmeAttachmentPayload>;
  /**
   * Use this mutation to get the url to upload an attachment for a incident.
   * @deprecated Use uploadAttachment
   */
  uploadIncidentAttachment?: Maybe<UploadIncidentAttachmentPayload>;
  /** Use this mutation to get the url to upload a custom logo for your organization. */
  uploadOrganizationLogo?: Maybe<UploadOrganizationLogoPayload>;
  userMemberIds?: Maybe<UserMemberIdsPayload>;
  verifyEmailAddress?: Maybe<VerifyEmailAddressPayload>;
  verifyPhoneNumber?: Maybe<VerifyPhoneNumberPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcknowledgeAllUserNotificationsArgs = {
  input: AcknowledgeAllUserNotificationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcknowledgeUserNotificationsArgs = {
  input: AcknowledgeUserNotificationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddEmailAddressArgs = {
  input?: InputMaybe<AddEmailAddressInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddGroupMembersArgs = {
  input: AddGroupMembersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddGuardmeAttachmentsArgs = {
  input: AddGuardmeAttachmentsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddIncidentAttachmentsArgs = {
  input: AddIncidentAttachmentsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddMemberToGroupArgs = {
  input: AddMemberToGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddPhoneNumberArgs = {
  input?: InputMaybe<AddPhoneNumberInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddUserToOrganizationArgs = {
  input: AddUserToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminCreateIncidentTypeArgs = {
  input: AdminCreateIncidentTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminCreateOrganizationArgs = {
  input?: InputMaybe<AdminCreateOrganizationInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminDeleteOrganizationArgs = {
  input?: InputMaybe<AdminDeleteOrganizationInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminDeleteUserArgs = {
  input?: InputMaybe<AdminDeleteUserInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminDestroyOrganizationArgs = {
  input?: InputMaybe<AdminDestroyOrganizationInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminDisableUserArgs = {
  input?: InputMaybe<AdminDisableUserInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminEnableUserArgs = {
  input?: InputMaybe<AdminEnableUserInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminRemoveEmailAddressArgs = {
  input?: InputMaybe<AdminRemoveEmailAddressInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminRemovePhoneNumberArgs = {
  input?: InputMaybe<AdminRemovePhoneNumberInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminUpdateIncidentTypeArgs = {
  input: AdminUpdateIncidentTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminUpdateOrganizationMetricsArgs = {
  input: AdminUpdateOrganizationMetricsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminUpdateOrganizationOwnerArgs = {
  input?: InputMaybe<AdminUpdateOrganizationOwnerInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminUpdateOrganizationPlanArgs = {
  input?: InputMaybe<AdminUpdateOrganizationPlanInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminUpdateOrganizationStateArgs = {
  input?: InputMaybe<AdminUpdateOrganizationStateInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminUpdateUserRoleArgs = {
  input?: InputMaybe<AdminUpdateUserRoleInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApproveMembershipRequestArgs = {
  input: ApproveMembershipRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAssignBivyStickToMemberArgs = {
  input: AssignBivyStickToMemberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelMembershipRequestArgs = {
  input: CancelMembershipRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCloseOrganizationArgs = {
  input: CloseOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCompleteMembershipRequestArgs = {
  input: CompleteMembershipRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationConcludeGuardmeArgs = {
  input: ConcludeGuardmeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBivyStickArgs = {
  input: CreateBivyStickInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCheckInReportArgs = {
  input: CreateCheckInReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmergencyContactArgs = {
  input: CreateEmergencyContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIncidentArgs = {
  input: CreateIncidentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIncidentNoteArgs = {
  input: CreateIncidentNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMembershipCodeArgs = {
  input: CreateMembershipCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOneshotScheduledGuardmeArgs = {
  input: CreateOneshotScheduledGuardmeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrganizationSubscriptionIntentArgs = {
  input?: InputMaybe<CreateOrganizationSubscriptionIntentInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePlaceArgs = {
  input: CreatePlaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePtcAssetArgs = {
  input: CreatePtcAssetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePtcAssetInstallationReportArgs = {
  input: CreatePtcAssetInstallationReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePtcAssetVerificationReportArgs = {
  input: CreatePtcAssetVerificationReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRecurringScheduledGuardmeArgs = {
  input: CreateRecurringScheduledGuardmeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserCloseAccountArgs = {
  input: CurrentUserCloseAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserDeleteEmailAddressArgs = {
  input: CurrentUserDeleteEmailAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserDeletePendingEmailAddressArgs = {
  input: CurrentUserDeletePendingEmailAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserDeletePendingPhoneNumberArgs = {
  input: CurrentUserDeletePendingPhoneNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserDeletePhoneNumberArgs = {
  input: CurrentUserDeletePhoneNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserUpdateAvatarUrlArgs = {
  input: CurrentUserUpdateAvatarUrlInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserUpdateDetailsArgs = {
  input?: InputMaybe<CurrentUserUpdateDetailsInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserUpdateEmailAddressArgs = {
  input: CurrentUserUpdateEmailAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserUpdateFullNameArgs = {
  input: CurrentUserUpdateFullNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserUpdateMetadataArgs = {
  input: CurrentUserUpdateMetadataInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserUpdatePhoneNumberArgs = {
  input: CurrentUserUpdatePhoneNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDebugMobilePushArgs = {
  input: DebugMobilePushInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllUserNotificationsArgs = {
  input: DeleteAllUserNotificationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBivyStickArgs = {
  input: DeleteBivyStickInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCheckInReportArgs = {
  input: DeleteCheckInReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmergencyContactArgs = {
  input: DeleteEmergencyContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGuardmeAttachmentArgs = {
  input: DeleteGuardmeAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIncidentTypeArgs = {
  input: DeleteIncidentTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInvitationArgs = {
  input: DeleteInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMemberArgs = {
  input: DeleteMemberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMemberMetadataFieldArgs = {
  input: DeleteMemberMetadataFieldInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipCodeArgs = {
  input: DeleteMembershipCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrganizationSubscriptionIntentArgs = {
  input?: InputMaybe<DeleteOrganizationSubscriptionIntentInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlaceArgs = {
  input: DeletePlaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePlanArgs = {
  input: DeletePlanInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScheduledGuardmeArgs = {
  input: DeleteScheduledGuardmeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserNotificationsArgs = {
  input: DeleteUserNotificationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDenyInvitationArgs = {
  input: DenyInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDenyMembershipRequestArgs = {
  input: DenyMembershipRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeregisterMobileDeviceArgs = {
  input: DeregisterMobileDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDisableIncidentForOrganizationArgs = {
  input: DisableIncidentForOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDisableMemberArgs = {
  input: DisableMemberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDisableUserArgs = {
  input: DisableUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEnableIncidentForOrganizationArgs = {
  input: EnableIncidentForOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEnableMemberArgs = {
  input: EnableMemberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEnableUserArgs = {
  input: EnableUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEndGuardmeArgs = {
  input: EndGuardmeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEndGuardmeByMemberIdArgs = {
  input: EndGuardmeByMemberIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEndGuardmeLivestreamArgs = {
  input: EndGuardmeLivestreamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEndIncidentLivestreamArgs = {
  input: EndIncidentLivestreamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateIncidentPdfArgs = {
  input: GenerateIncidentPdfInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGuardmePanicArgs = {
  input: GuardmePanicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMemberCheckInArgs = {
  input: MemberCheckInInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMembershipRequestDiscoverArgs = {
  input: MembershipRequestDiscoverInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMembershipRequestSubmitArgs = {
  input: MembershipRequestSubmitInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterLiveActivityTokensArgs = {
  input: RegisterLiveActivityTokensInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterMobileDeviceArgs = {
  input: RegisterMobileDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveEmailAddressArgs = {
  input?: InputMaybe<RemoveEmailAddressInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveMemberFromGroupArgs = {
  input: RemoveMemberFromGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemovePhoneNumberArgs = {
  input?: InputMaybe<RemovePhoneNumberInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationReverifyEmailAddressArgs = {
  input?: InputMaybe<ReverifyEmailAddressInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationReverifyPhoneNumberArgs = {
  input?: InputMaybe<ReverifyPhoneNumberInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetCurrentUserDefaultOrganizationIdArgs = {
  input: SetCurrentUserDefaultOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartGuardmeArgs = {
  input: StartGuardmeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartGuardmeLivestreamArgs = {
  input: StartGuardmeLivestreamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartIncidentLivestreamArgs = {
  input: StartIncidentLivestreamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartMembershipRequestArgs = {
  input: StartMembershipRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartTimedGuardmeArgs = {
  input: StartTimedGuardmeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTransferOrganizationOwnershipArgs = {
  input: TransferOrganizationOwnershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAllowMembershipRequestsArgs = {
  input: UpdateAllowMembershipRequestsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCurrentLocationArgs = {
  input: UpdateCurrentLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmergencyContactArgs = {
  input: UpdateEmergencyContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEnabledIncidentTypeAssignedGroupArgs = {
  input: UpdateEnabledIncidentTypeAssignedGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupMembersArgs = {
  input: UpdateGroupMembersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGuardmeArgs = {
  input: UpdateGuardmeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGuardmeBatteryLevelArgs = {
  input: UpdateGuardmeBatteryLevelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGuardmeNotesArgs = {
  input: UpdateGuardmeNotesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGuardmePanicAsAdminArgs = {
  input: UpdateGuardmePanicAsAdminInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIncidentContactArgs = {
  input: UpdateIncidentContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIncidentDetailsArgs = {
  input: UpdateIncidentDetailsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIncidentGroupArgs = {
  input: UpdateIncidentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIncidentOwnerArgs = {
  input: UpdateIncidentOwnerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIncidentPriorityArgs = {
  input: UpdateIncidentPriorityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIncidentStatusArgs = {
  input: UpdateIncidentStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIncidentTypeArgs = {
  input: UpdateIncidentTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIncidentTypeAllowlistArgs = {
  input: UpdateIncidentTypeAllowlistInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInvitationArgs = {
  input: UpdateInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMemberDisplayNameArgs = {
  input: UpdateMemberDisplayNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMemberGroupsArgs = {
  input: UpdateMemberGroupsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMemberMetadataArgs = {
  input: UpdateMemberMetadataInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMemberRoleArgs = {
  input: UpdateMemberRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationCheckInSettingsArgs = {
  input: UpdateOrganizationCheckInSettingsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationCheckInSupervisorGroupArgs = {
  input: UpdateOrganizationCheckInSupervisorGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationDetailsArgs = {
  input: UpdateOrganizationDetailsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationGuardmeNotificationSettingsArgs = {
  input: UpdateOrganizationGuardmeNotificationSettingsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationGuardmeSettingsArgs = {
  input: UpdateOrganizationGuardmeSettingsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationGuardmeSupervisorGroupArgs = {
  input: UpdateOrganizationGuardmeSupervisorGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationIncidentSettingsArgs = {
  input: UpdateOrganizationIncidentSettingsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationIncidentSupervisorGroupArgs = {
  input: UpdateOrganizationIncidentSupervisorGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationLogoUrlArgs = {
  input: UpdateOrganizationLogoUrlInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationMapSettingsArgs = {
  input: UpdateOrganizationMapSettingsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationMemberMetadataFieldsArgs = {
  input: UpdateOrganizationMemberMetadataFieldsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationNameArgs = {
  input: UpdateOrganizationNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationRapidsosSettingsArgs = {
  input: UpdateOrganizationRapidsosSettingsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationSettingsAdministratorNotifiedOnCheckInArgs = {
  input: UpdateOrganizationSettingsAdministratorNotifiedOnCheckInInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationSettingsAdministratorNotifiedOnGuardmeArgs = {
  input: UpdateOrganizationSettingsAdministratorNotifiedOnGuardmeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationSettingsAdministratorNotifiedOnIncidentArgs = {
  input: UpdateOrganizationSettingsAdministratorNotifiedOnIncidentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationSettingsOwnerNotifiedOnCheckInArgs = {
  input: UpdateOrganizationSettingsOwnerNotifiedOnCheckInInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationSettingsOwnerNotifiedOnGuardmeArgs = {
  input: UpdateOrganizationSettingsOwnerNotifiedOnGuardmeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationSettingsOwnerNotifiedOnIncidentArgs = {
  input: UpdateOrganizationSettingsOwnerNotifiedOnIncidentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationTimezoneArgs = {
  input: UpdateOrganizationTimezoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlaceArgs = {
  input: UpdatePlaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePlanArgs = {
  input: UpdatePlanInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePtcAccessArgs = {
  input: UpdatePtcAccessInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePtcNotificationsArgs = {
  input: UpdatePtcNotificationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScheduledGuardmeArgs = {
  input: UpdateScheduledGuardmeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTimedGuardmeEndsAtArgs = {
  input: UpdateTimedGuardmeEndsAtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUploadAttachmentArgs = {
  input: UploadAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUploadAvatarArgs = {
  input: UploadAvatarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUploadGuardmeAttachmentArgs = {
  input: UploadGuardmeAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUploadIncidentAttachmentArgs = {
  input: UploadIncidentAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUploadOrganizationLogoArgs = {
  input: UploadOrganizationLogoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUserMemberIdsArgs = {
  input: UserMemberIdsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVerifyEmailAddressArgs = {
  input: VerifyEmailAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVerifyPhoneNumberArgs = {
  input: VerifyPhoneNumberInput;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**   An organization. */
export type Organization = Node & {
  __typename?: 'Organization';
  /** Reads and enables pagination through a set of `Attachment`. */
  attachments: AttachmentsConnection;
  /** @deprecated Dropped */
  billingContact?: Maybe<Member>;
  /** Reads and enables pagination through a set of `BivyStick`. */
  bivySticks: BivySticksConnection;
  /** Reads and enables pagination through a set of `CheckInReport`. */
  checkInReports: CheckInReportsConnection;
  /** Reads and enables pagination through a set of `CheckInRequest`. */
  checkInRequests: CheckInRequestsConnection;
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkIns: CheckInsConnection;
  createdAt: Scalars['Datetime']['output'];
  defaultMapCenter: GeographyPoint;
  defaultMapZoom: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `EmergencyContact`. */
  emergencyContacts: EmergencyContactsConnection;
  /** Reads and enables pagination through a set of `EnabledIncidentType`. */
  enabledIncidentTypes: EnabledIncidentTypesConnection;
  /** Reads and enables pagination through a set of `Group`. */
  groups: GroupsConnection;
  /** Reads and enables pagination through a set of `GuardmeAttachment`. */
  guardmeAttachments: GuardmeAttachmentsConnection;
  /** Reads and enables pagination through a set of `GuardmeAuditLog`. */
  guardmeAuditLogs: GuardmeAuditLogsConnection;
  guardmeCount: GuardmeCountType;
  /** Reads and enables pagination through a set of `GuardmeLivestream`. */
  guardmeLivestreams: GuardmeLivestreamsConnection;
  /** Reads and enables pagination through a set of `GuardmeLocation`. */
  guardmeLocations: GuardmeLocationsConnection;
  guardmeNotificationSettings: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `Guardme`. */
  guardmes: GuardmesConnection;
  id: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `IncidentUpdate`. */
  incidentUpdates: IncidentUpdatesConnection;
  /** Reads and enables pagination through a set of `Incident`. */
  incidents: IncidentsConnection;
  /** Reads and enables pagination through a set of `Invitation`. */
  invitations: InvitationsConnection;
  /** @deprecated Use Organization.state */
  isEnabled: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `Livestream`. */
  livestreams: LivestreamsConnection;
  logoType: LogoType;
  logoUrl: Scalars['String']['output'];
  memberCount?: Maybe<Scalars['Int']['output']>;
  memberMetadataFields: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `Member`. */
  members: MembersConnection;
  /** Reads and enables pagination through a set of `MembershipCode`. */
  membershipCodes: MembershipCodesConnection;
  /** Reads and enables pagination through a set of `MembershipRequest`. */
  membershipRequests: MembershipRequestsConnection;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `OrganizationMetric` that is related to this `Organization`. */
  organizationMetric?: Maybe<OrganizationMetric>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  ownerMemberId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Place`. */
  places: PlacesConnection;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  planId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `PtcAsset`. */
  ptcAssets: PtcAssetsConnection;
  /** Reads and enables pagination through a set of `PtcInstallationReport`. */
  ptcInstallationReports: PtcInstallationReportsConnection;
  /** Reads and enables pagination through a set of `PtcVerificationReport`. */
  ptcVerificationReports: PtcVerificationReportsConnection;
  /** Reads and enables pagination through a set of `ScheduledGuardme`. */
  scheduledGuardmes: ScheduledGuardmesConnection;
  settingIsRapidsosOperatorFlowEnabled: Scalars['Boolean']['output'];
  settingIsRapidsosPanicButtonFlowEnabled: Scalars['Boolean']['output'];
  settingRapidsosSocPhoneNumber: Scalars['String']['output'];
  /** Reads a single `OrganizationSetting` that is related to this `Organization`. */
  settings?: Maybe<OrganizationSetting>;
  slug?: Maybe<Scalars['String']['output']>;
  state: OrganizationState;
  stripe?: Maybe<Scalars['JSON']['output']>;
  stripeCustomerId: Scalars['String']['output'];
  subscription?: Maybe<StripeSubscription>;
  subscriptionCount: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
  totalActiveMembers?: Maybe<Scalars['Int']['output']>;
  totalDisabledMembers?: Maybe<Scalars['Int']['output']>;
  totalGroups?: Maybe<Scalars['Int']['output']>;
  totalMembershipRequests?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `UserNotification`. */
  userNotifications: UserNotificationsConnection;
};


/**   An organization. */
export type OrganizationAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AttachmentCondition>;
  filter?: InputMaybe<AttachmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AttachmentsOrderBy>>;
};


/**   An organization. */
export type OrganizationBivySticksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BivyStickCondition>;
  filter?: InputMaybe<BivyStickFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BivySticksOrderBy>>;
};


/**   An organization. */
export type OrganizationCheckInReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInReportCondition>;
  filter?: InputMaybe<CheckInReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInReportsOrderBy>>;
};


/**   An organization. */
export type OrganizationCheckInRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInRequestCondition>;
  filter?: InputMaybe<CheckInRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInRequestsOrderBy>>;
};


/**   An organization. */
export type OrganizationCheckInsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInCondition>;
  filter?: InputMaybe<CheckInFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


/**   An organization. */
export type OrganizationEmergencyContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmergencyContactCondition>;
  filter?: InputMaybe<EmergencyContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmergencyContactsOrderBy>>;
};


/**   An organization. */
export type OrganizationEnabledIncidentTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnabledIncidentTypeCondition>;
  filter?: InputMaybe<EnabledIncidentTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnabledIncidentTypesOrderBy>>;
};


/**   An organization. */
export type OrganizationGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


/**   An organization. */
export type OrganizationGuardmeAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeAttachmentCondition>;
  filter?: InputMaybe<GuardmeAttachmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeAttachmentsOrderBy>>;
};


/**   An organization. */
export type OrganizationGuardmeAuditLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeAuditLogCondition>;
  filter?: InputMaybe<GuardmeAuditLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeAuditLogsOrderBy>>;
};


/**   An organization. */
export type OrganizationGuardmeLivestreamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeLivestreamCondition>;
  filter?: InputMaybe<GuardmeLivestreamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeLivestreamsOrderBy>>;
};


/**   An organization. */
export type OrganizationGuardmeLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeLocationCondition>;
  filter?: InputMaybe<GuardmeLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeLocationsOrderBy>>;
};


/**   An organization. */
export type OrganizationGuardmesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeCondition>;
  filter?: InputMaybe<GuardmeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmesOrderBy>>;
};


/**   An organization. */
export type OrganizationIncidentUpdatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentUpdateCondition>;
  filter?: InputMaybe<IncidentUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentUpdatesOrderBy>>;
};


/**   An organization. */
export type OrganizationIncidentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentCondition>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};


/**   An organization. */
export type OrganizationInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvitationCondition>;
  filter?: InputMaybe<InvitationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvitationsOrderBy>>;
};


/**   An organization. */
export type OrganizationLivestreamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LivestreamCondition>;
  filter?: InputMaybe<LivestreamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LivestreamsOrderBy>>;
};


/**   An organization. */
export type OrganizationMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCondition>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersOrderBy>>;
};


/**   An organization. */
export type OrganizationMembershipCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipCodeCondition>;
  filter?: InputMaybe<MembershipCodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipCodesOrderBy>>;
};


/**   An organization. */
export type OrganizationMembershipRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipRequestCondition>;
  filter?: InputMaybe<MembershipRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipRequestsOrderBy>>;
};


/**   An organization. */
export type OrganizationPlacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PlaceCondition>;
  filter?: InputMaybe<PlaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PlacesOrderBy>>;
};


/**   An organization. */
export type OrganizationPtcAssetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcAssetCondition>;
  filter?: InputMaybe<PtcAssetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcAssetsOrderBy>>;
};


/**   An organization. */
export type OrganizationPtcInstallationReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcInstallationReportCondition>;
  filter?: InputMaybe<PtcInstallationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcInstallationReportsOrderBy>>;
};


/**   An organization. */
export type OrganizationPtcVerificationReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcVerificationReportCondition>;
  filter?: InputMaybe<PtcVerificationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcVerificationReportsOrderBy>>;
};


/**   An organization. */
export type OrganizationScheduledGuardmesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledGuardmeCondition>;
  filter?: InputMaybe<ScheduledGuardmeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledGuardmesOrderBy>>;
};


/**   An organization. */
export type OrganizationSubscriptionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**   An organization. */
export type OrganizationUserNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserNotificationCondition>;
  filter?: InputMaybe<UserNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
};

/**
 * A condition to be used against `Organization` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrganizationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Filter Organizations with names like the provided value. */
  nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ownerMemberId` field. */
  ownerMemberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `planId` field. */
  planId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Organization` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrganizationFilter>>;
  /** Filter by the object’s `attachments` relation. */
  attachments?: InputMaybe<OrganizationToManyAttachmentFilter>;
  /** Some related `attachments` exist. */
  attachmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `bivySticks` relation. */
  bivySticks?: InputMaybe<OrganizationToManyBivyStickFilter>;
  /** Some related `bivySticks` exist. */
  bivySticksExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `checkInReports` relation. */
  checkInReports?: InputMaybe<OrganizationToManyCheckInReportFilter>;
  /** Some related `checkInReports` exist. */
  checkInReportsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `checkInRequests` relation. */
  checkInRequests?: InputMaybe<OrganizationToManyCheckInRequestFilter>;
  /** Some related `checkInRequests` exist. */
  checkInRequestsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `checkIns` relation. */
  checkIns?: InputMaybe<OrganizationToManyCheckInFilter>;
  /** Some related `checkIns` exist. */
  checkInsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `emergencyContacts` relation. */
  emergencyContacts?: InputMaybe<OrganizationToManyEmergencyContactFilter>;
  /** Some related `emergencyContacts` exist. */
  emergencyContactsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `enabledIncidentTypes` relation. */
  enabledIncidentTypes?: InputMaybe<OrganizationToManyEnabledIncidentTypeFilter>;
  /** Some related `enabledIncidentTypes` exist. */
  enabledIncidentTypesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `groups` relation. */
  groups?: InputMaybe<OrganizationToManyGroupFilter>;
  /** Some related `groups` exist. */
  groupsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmeAttachments` relation. */
  guardmeAttachments?: InputMaybe<OrganizationToManyGuardmeAttachmentFilter>;
  /** Some related `guardmeAttachments` exist. */
  guardmeAttachmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmeAuditLogs` relation. */
  guardmeAuditLogs?: InputMaybe<OrganizationToManyGuardmeAuditLogFilter>;
  /** Some related `guardmeAuditLogs` exist. */
  guardmeAuditLogsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmeLivestreams` relation. */
  guardmeLivestreams?: InputMaybe<OrganizationToManyGuardmeLivestreamFilter>;
  /** Some related `guardmeLivestreams` exist. */
  guardmeLivestreamsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmeLocations` relation. */
  guardmeLocations?: InputMaybe<OrganizationToManyGuardmeLocationFilter>;
  /** Some related `guardmeLocations` exist. */
  guardmeLocationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `guardmes` relation. */
  guardmes?: InputMaybe<OrganizationToManyGuardmeFilter>;
  /** Some related `guardmes` exist. */
  guardmesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `incidentUpdates` relation. */
  incidentUpdates?: InputMaybe<OrganizationToManyIncidentUpdateFilter>;
  /** Some related `incidentUpdates` exist. */
  incidentUpdatesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `incidents` relation. */
  incidents?: InputMaybe<OrganizationToManyIncidentFilter>;
  /** Some related `incidents` exist. */
  incidentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `invitations` relation. */
  invitations?: InputMaybe<OrganizationToManyInvitationFilter>;
  /** Some related `invitations` exist. */
  invitationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `livestreams` relation. */
  livestreams?: InputMaybe<OrganizationToManyLivestreamFilter>;
  /** Some related `livestreams` exist. */
  livestreamsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberCount` field. */
  memberCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `members` relation. */
  members?: InputMaybe<OrganizationToManyMemberFilter>;
  /** Some related `members` exist. */
  membersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `membershipCodes` relation. */
  membershipCodes?: InputMaybe<OrganizationToManyMembershipCodeFilter>;
  /** Some related `membershipCodes` exist. */
  membershipCodesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `membershipRequests` relation. */
  membershipRequests?: InputMaybe<OrganizationToManyMembershipRequestFilter>;
  /** Some related `membershipRequests` exist. */
  membershipRequestsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<OrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrganizationFilter>>;
  /** Filter by the object’s `organizationMetric` relation. */
  organizationMetric?: InputMaybe<OrganizationMetricFilter>;
  /** A related `organizationMetric` exists. */
  organizationMetricExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ownerMember` relation. */
  ownerMember?: InputMaybe<MemberFilter>;
  /** A related `ownerMember` exists. */
  ownerMemberExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ownerMemberId` field. */
  ownerMemberId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `places` relation. */
  places?: InputMaybe<OrganizationToManyPlaceFilter>;
  /** Some related `places` exist. */
  placesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `plan` relation. */
  plan?: InputMaybe<PlanFilter>;
  /** A related `plan` exists. */
  planExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `planId` field. */
  planId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ptcAssets` relation. */
  ptcAssets?: InputMaybe<OrganizationToManyPtcAssetFilter>;
  /** Some related `ptcAssets` exist. */
  ptcAssetsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ptcInstallationReports` relation. */
  ptcInstallationReports?: InputMaybe<OrganizationToManyPtcInstallationReportFilter>;
  /** Some related `ptcInstallationReports` exist. */
  ptcInstallationReportsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ptcVerificationReports` relation. */
  ptcVerificationReports?: InputMaybe<OrganizationToManyPtcVerificationReportFilter>;
  /** Some related `ptcVerificationReports` exist. */
  ptcVerificationReportsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `scheduledGuardmes` relation. */
  scheduledGuardmes?: InputMaybe<OrganizationToManyScheduledGuardmeFilter>;
  /** Some related `scheduledGuardmes` exist. */
  scheduledGuardmesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `totalActiveMembers` field. */
  totalActiveMembers?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalDisabledMembers` field. */
  totalDisabledMembers?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalGroups` field. */
  totalGroups?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalMembershipRequests` field. */
  totalMembershipRequests?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userNotifications` relation. */
  userNotifications?: InputMaybe<OrganizationToManyUserNotificationFilter>;
  /** Some related `userNotifications` exist. */
  userNotificationsExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationMetric = Node & {
  __typename?: 'OrganizationMetric';
  checkInReportsTotal: Scalars['Int']['output'];
  checkInsGraph?: Maybe<Array<Maybe<TimeSeries>>>;
  checkInsTotal: Scalars['Int']['output'];
  guardmesActive: Scalars['Int']['output'];
  guardmesExpired: Scalars['Int']['output'];
  guardmesGraph?: Maybe<Array<Maybe<TimeSeries>>>;
  guardmesInPanic: Scalars['Int']['output'];
  guardmesTotal: Scalars['Int']['output'];
  incidentsActive: Scalars['Int']['output'];
  incidentsActiveHigh: Scalars['Int']['output'];
  incidentsActiveLow: Scalars['Int']['output'];
  incidentsActiveMedium: Scalars['Int']['output'];
  incidentsActiveUrgent: Scalars['Int']['output'];
  incidentsGraph?: Maybe<Array<Maybe<TimeSeries>>>;
  incidentsInProgress: Scalars['Int']['output'];
  incidentsOpen: Scalars['Int']['output'];
  incidentsTotal: Scalars['Int']['output'];
  incidentsTypeCount: Array<Maybe<IncidentTypeCountType>>;
  invitations: Scalars['Int']['output'];
  members: Scalars['Int']['output'];
  membershipRequests: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `OrganizationMetric`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
};


export type OrganizationMetricCheckInsGraphArgs = {
  days: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
};


export type OrganizationMetricGuardmesGraphArgs = {
  days: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
};


export type OrganizationMetricIncidentsGraphArgs = {
  days: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
};

/**
 * A condition to be used against `OrganizationMetric` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrganizationMetricCondition = {
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `OrganizationMetric` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationMetricFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrganizationMetricFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<OrganizationMetricFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrganizationMetricFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `OrganizationMetric` values. */
export type OrganizationMetricsConnection = {
  __typename?: 'OrganizationMetricsConnection';
  /** A list of edges which contains the `OrganizationMetric` and cursor to aid in pagination. */
  edges: Array<OrganizationMetricsEdge>;
  /** A list of `OrganizationMetric` objects. */
  nodes: Array<OrganizationMetric>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrganizationMetric` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrganizationMetric` edge in the connection. */
export type OrganizationMetricsEdge = {
  __typename?: 'OrganizationMetricsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrganizationMetric` at the end of the edge. */
  node: OrganizationMetric;
};

/** Methods to use when ordering `OrganizationMetric`. */
export enum OrganizationMetricsOrderBy {
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type OrganizationSetting = Node & {
  __typename?: 'OrganizationSetting';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  checkInSupervisorGroupId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** @deprecated Dropped */
  customGuardmeIcon?: Maybe<Scalars['String']['output']>;
  /** @deprecated Dropped */
  customGuardmeName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Dropped */
  guardmeCustomIcon?: Maybe<Scalars['String']['output']>;
  /** @deprecated Dropped */
  guardmeCustomName?: Maybe<Scalars['String']['output']>;
  guardmeIsConcludedNotificationEnabled: Scalars['Boolean']['output'];
  guardmeIsExpiredNotificationEnabled: Scalars['Boolean']['output'];
  guardmeIsMetadataIncludedInNotification: Scalars['Boolean']['output'];
  guardmeIsPanicNotificationEnabled: Scalars['Boolean']['output'];
  guardmeIsStartedNotificationEnabled: Scalars['Boolean']['output'];
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  guardmeSupervisorGroupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  incidentSupervisorGroupId?: Maybe<Scalars['String']['output']>;
  isAdministratorNotifiedOnCheckIn: Scalars['Boolean']['output'];
  isAdministratorNotifiedOnGuardme: Scalars['Boolean']['output'];
  isAdministratorNotifiedOnIncident: Scalars['Boolean']['output'];
  /** @deprecated Dropped */
  isCall911Enabled: Scalars['Boolean']['output'];
  isOwnerNotifiedOnCheckIn: Scalars['Boolean']['output'];
  isOwnerNotifiedOnGuardme: Scalars['Boolean']['output'];
  isOwnerNotifiedOnIncident: Scalars['Boolean']['output'];
  isSupervisorNotifiedOnCheckIn: Scalars['Boolean']['output'];
  isSupervisorNotifiedOnGuardme: Scalars['Boolean']['output'];
  isSupervisorNotifiedOnIncident: Scalars['Boolean']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  ptcIsEnabled: Scalars['Boolean']['output'];
  ptcNotifyAdministratorOnChange: Scalars['Boolean']['output'];
  ptcNotifyReadOnlyGroupOnChange: Scalars['Boolean']['output'];
  ptcNotifyReadWriteGroupOnChange: Scalars['Boolean']['output'];
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  ptcReadOnlyGroupId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  ptcReadWriteGroupId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

/** A connection to a list of `OrganizationSetting` values. */
export type OrganizationSettingsConnection = {
  __typename?: 'OrganizationSettingsConnection';
  /** A list of edges which contains the `OrganizationSetting` and cursor to aid in pagination. */
  edges: Array<OrganizationSettingsEdge>;
  /** A list of `OrganizationSetting` objects. */
  nodes: Array<OrganizationSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrganizationSetting` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrganizationSetting` edge in the connection. */
export type OrganizationSettingsEdge = {
  __typename?: 'OrganizationSettingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrganizationSetting` at the end of the edge. */
  node: OrganizationSetting;
};

export enum OrganizationState {
  Active = 'ACTIVE',
  AwaitingDeletion = 'AWAITING_DELETION',
  AwaitingPayment = 'AWAITING_PAYMENT',
  AwaitingSubscription = 'AWAITING_SUBSCRIPTION',
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Initializing = 'INITIALIZING'
}

export type OrganizationStatistic = {
  __typename?: 'OrganizationStatistic';
  checkInCount: Scalars['BigInt']['output'];
  guardmeCount: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  incidentCount: Scalars['BigInt']['output'];
  intervalType: StatisticIntervalType;
  organizationId: Scalars['String']['output'];
  timestamp: Scalars['Datetime']['output'];
  timezone: Scalars['String']['output'];
};

/** A filter to be used against `OrganizationStatistic` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationStatisticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrganizationStatisticFilter>>;
  /** Filter by the object’s `intervalType` field. */
  intervalType?: InputMaybe<StatisticIntervalTypeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrganizationStatisticFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrganizationStatisticFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `timezone` field. */
  timezone?: InputMaybe<StringFilter>;
};

/** A connection to a list of `OrganizationStatistic` values. */
export type OrganizationStatisticsConnection = {
  __typename?: 'OrganizationStatisticsConnection';
  /** A list of edges which contains the `OrganizationStatistic` and cursor to aid in pagination. */
  edges: Array<OrganizationStatisticsEdge>;
  /** A list of `OrganizationStatistic` objects. */
  nodes: Array<OrganizationStatistic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrganizationStatistic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrganizationStatistic` edge in the connection. */
export type OrganizationStatisticsEdge = {
  __typename?: 'OrganizationStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrganizationStatistic` at the end of the edge. */
  node: OrganizationStatistic;
};

/** A filter to be used against many `Attachment` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyAttachmentFilter = {
  /** Every related `Attachment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AttachmentFilter>;
  /** No related `Attachment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AttachmentFilter>;
  /** Some related `Attachment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AttachmentFilter>;
};

/** A filter to be used against many `BivyStick` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyBivyStickFilter = {
  /** Every related `BivyStick` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BivyStickFilter>;
  /** No related `BivyStick` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BivyStickFilter>;
  /** Some related `BivyStick` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BivyStickFilter>;
};

/** A filter to be used against many `CheckIn` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyCheckInFilter = {
  /** Every related `CheckIn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckInFilter>;
  /** No related `CheckIn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckInFilter>;
  /** Some related `CheckIn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckInFilter>;
};

/** A filter to be used against many `CheckInReport` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyCheckInReportFilter = {
  /** Every related `CheckInReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckInReportFilter>;
  /** No related `CheckInReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckInReportFilter>;
  /** Some related `CheckInReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckInReportFilter>;
};

/** A filter to be used against many `CheckInRequest` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyCheckInRequestFilter = {
  /** Every related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckInRequestFilter>;
  /** No related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckInRequestFilter>;
  /** Some related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckInRequestFilter>;
};

/** A filter to be used against many `EmergencyContact` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyEmergencyContactFilter = {
  /** Every related `EmergencyContact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmergencyContactFilter>;
  /** No related `EmergencyContact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmergencyContactFilter>;
  /** Some related `EmergencyContact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmergencyContactFilter>;
};

/** A filter to be used against many `EnabledIncidentType` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyEnabledIncidentTypeFilter = {
  /** Every related `EnabledIncidentType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EnabledIncidentTypeFilter>;
  /** No related `EnabledIncidentType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EnabledIncidentTypeFilter>;
  /** Some related `EnabledIncidentType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EnabledIncidentTypeFilter>;
};

/** A filter to be used against many `Group` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyGroupFilter = {
  /** Every related `Group` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GroupFilter>;
  /** No related `Group` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GroupFilter>;
  /** Some related `Group` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GroupFilter>;
};

/** A filter to be used against many `GuardmeAttachment` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyGuardmeAttachmentFilter = {
  /** Every related `GuardmeAttachment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeAttachmentFilter>;
  /** No related `GuardmeAttachment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeAttachmentFilter>;
  /** Some related `GuardmeAttachment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeAttachmentFilter>;
};

/** A filter to be used against many `GuardmeAuditLog` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyGuardmeAuditLogFilter = {
  /** Every related `GuardmeAuditLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeAuditLogFilter>;
  /** No related `GuardmeAuditLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeAuditLogFilter>;
  /** Some related `GuardmeAuditLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeAuditLogFilter>;
};

/** A filter to be used against many `Guardme` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyGuardmeFilter = {
  /** Every related `Guardme` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeFilter>;
  /** No related `Guardme` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeFilter>;
  /** Some related `Guardme` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeFilter>;
};

/** A filter to be used against many `GuardmeLivestream` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyGuardmeLivestreamFilter = {
  /** Every related `GuardmeLivestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeLivestreamFilter>;
  /** No related `GuardmeLivestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeLivestreamFilter>;
  /** Some related `GuardmeLivestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeLivestreamFilter>;
};

/** A filter to be used against many `GuardmeLocation` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyGuardmeLocationFilter = {
  /** Every related `GuardmeLocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GuardmeLocationFilter>;
  /** No related `GuardmeLocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GuardmeLocationFilter>;
  /** Some related `GuardmeLocation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GuardmeLocationFilter>;
};

/** A filter to be used against many `Incident` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyIncidentFilter = {
  /** Every related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IncidentFilter>;
  /** No related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IncidentFilter>;
  /** Some related `Incident` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IncidentFilter>;
};

/** A filter to be used against many `IncidentUpdate` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyIncidentUpdateFilter = {
  /** Every related `IncidentUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IncidentUpdateFilter>;
  /** No related `IncidentUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IncidentUpdateFilter>;
  /** Some related `IncidentUpdate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IncidentUpdateFilter>;
};

/** A filter to be used against many `Invitation` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyInvitationFilter = {
  /** Every related `Invitation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<InvitationFilter>;
  /** No related `Invitation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<InvitationFilter>;
  /** Some related `Invitation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<InvitationFilter>;
};

/** A filter to be used against many `Livestream` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyLivestreamFilter = {
  /** Every related `Livestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LivestreamFilter>;
  /** No related `Livestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LivestreamFilter>;
  /** Some related `Livestream` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LivestreamFilter>;
};

/** A filter to be used against many `Member` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyMemberFilter = {
  /** Every related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberFilter>;
  /** No related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberFilter>;
  /** Some related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberFilter>;
};

/** A filter to be used against many `MembershipCode` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyMembershipCodeFilter = {
  /** Every related `MembershipCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembershipCodeFilter>;
  /** No related `MembershipCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembershipCodeFilter>;
  /** Some related `MembershipCode` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembershipCodeFilter>;
};

/** A filter to be used against many `MembershipRequest` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyMembershipRequestFilter = {
  /** Every related `MembershipRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembershipRequestFilter>;
  /** No related `MembershipRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembershipRequestFilter>;
  /** Some related `MembershipRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembershipRequestFilter>;
};

/** A filter to be used against many `Place` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyPlaceFilter = {
  /** Every related `Place` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PlaceFilter>;
  /** No related `Place` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PlaceFilter>;
  /** Some related `Place` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PlaceFilter>;
};

/** A filter to be used against many `PtcAsset` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyPtcAssetFilter = {
  /** Every related `PtcAsset` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PtcAssetFilter>;
  /** No related `PtcAsset` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PtcAssetFilter>;
  /** Some related `PtcAsset` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PtcAssetFilter>;
};

/** A filter to be used against many `PtcInstallationReport` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyPtcInstallationReportFilter = {
  /** Every related `PtcInstallationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PtcInstallationReportFilter>;
  /** No related `PtcInstallationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PtcInstallationReportFilter>;
  /** Some related `PtcInstallationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PtcInstallationReportFilter>;
};

/** A filter to be used against many `PtcVerificationReport` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyPtcVerificationReportFilter = {
  /** Every related `PtcVerificationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PtcVerificationReportFilter>;
  /** No related `PtcVerificationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PtcVerificationReportFilter>;
  /** Some related `PtcVerificationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PtcVerificationReportFilter>;
};

/** A filter to be used against many `ScheduledGuardme` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyScheduledGuardmeFilter = {
  /** Every related `ScheduledGuardme` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledGuardmeFilter>;
  /** No related `ScheduledGuardme` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledGuardmeFilter>;
  /** Some related `ScheduledGuardme` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledGuardmeFilter>;
};

/** A filter to be used against many `UserNotification` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationToManyUserNotificationFilter = {
  /** Every related `UserNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserNotificationFilter>;
  /** No related `UserNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserNotificationFilter>;
  /** Some related `UserNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserNotificationFilter>;
};

export type OrganizationUpdatesInput = {
  id: Scalars['String']['input'];
};

export type OrganizationUpdatesPayload = {
  __typename?: 'OrganizationUpdatesPayload';
  event?: Maybe<GraphqlOrganizationUpdateEvent>;
  organization?: Maybe<Organization>;
  relatedIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** A connection to a list of `Organization` values. */
export type OrganizationsConnection = {
  __typename?: 'OrganizationsConnection';
  /** A list of edges which contains the `Organization` and cursor to aid in pagination. */
  edges: Array<OrganizationsEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Organization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Organization` edge in the connection. */
export type OrganizationsEdge = {
  __typename?: 'OrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Organization` at the end of the edge. */
  node: Organization;
};

/** Methods to use when ordering `Organization`. */
export enum OrganizationsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OwnerMemberIdAsc = 'OWNER_MEMBER_ID_ASC',
  OwnerMemberIdDesc = 'OWNER_MEMBER_ID_DESC',
  PlanIdAsc = 'PLAN_ID_ASC',
  PlanIdDesc = 'PLAN_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type PendingEmailAddress = {
  __typename?: 'PendingEmailAddress';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type PendingPhoneNumber = {
  __typename?: 'PendingPhoneNumber';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumbers = {
  __typename?: 'PhoneNumbers';
  nodes: Array<UserPhoneNumber>;
};

export type Place = Node & {
  __typename?: 'Place';
  center: GeographyPoint;
  /** Reads and enables pagination through a set of `CheckInReport`. */
  checkInReports: CheckInReportsConnection;
  /** Reads and enables pagination through a set of `CheckInRequest`. */
  checkInRequests: CheckInRequestsConnection;
  createdAt: Scalars['Datetime']['output'];
  description: Scalars['String']['output'];
  encodedPolyline?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Place`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  radius: Scalars['Int']['output'];
  spatialData: GeographyInterface;
  updatedAt: Scalars['Datetime']['output'];
};


export type PlaceCheckInReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInReportCondition>;
  filter?: InputMaybe<CheckInReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInReportsOrderBy>>;
};


export type PlaceCheckInRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInRequestCondition>;
  filter?: InputMaybe<CheckInRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInRequestsOrderBy>>;
};

/** A condition to be used against `Place` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PlaceCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Filter Places by name for provided terms. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Place` object types. All fields are combined with a logical ‘and.’ */
export type PlaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlaceFilter>>;
  /** Filter by the object’s `checkInReports` relation. */
  checkInReports?: InputMaybe<PlaceToManyCheckInReportFilter>;
  /** Some related `checkInReports` exist. */
  checkInReportsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `checkInRequests` relation. */
  checkInRequests?: InputMaybe<PlaceToManyCheckInRequestFilter>;
  /** Some related `checkInRequests` exist. */
  checkInRequestsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `encodedPolyline` field. */
  encodedPolyline?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlaceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlaceFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `CheckInReport` object types. All fields are combined with a logical ‘and.’ */
export type PlaceToManyCheckInReportFilter = {
  /** Every related `CheckInReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckInReportFilter>;
  /** No related `CheckInReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckInReportFilter>;
  /** Some related `CheckInReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckInReportFilter>;
};

/** A filter to be used against many `CheckInRequest` object types. All fields are combined with a logical ‘and.’ */
export type PlaceToManyCheckInRequestFilter = {
  /** Every related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CheckInRequestFilter>;
  /** No related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CheckInRequestFilter>;
  /** Some related `CheckInRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CheckInRequestFilter>;
};

/** A connection to a list of `Place` values. */
export type PlacesConnection = {
  __typename?: 'PlacesConnection';
  /** A list of edges which contains the `Place` and cursor to aid in pagination. */
  edges: Array<PlacesEdge>;
  /** A list of `Place` objects. */
  nodes: Array<Place>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Place` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Place` edge in the connection. */
export type PlacesEdge = {
  __typename?: 'PlacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Place` at the end of the edge. */
  node: Place;
};

/** Methods to use when ordering `Place`. */
export enum PlacesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Plan = Node & {
  __typename?: 'Plan';
  createdAt: Scalars['Datetime']['output'];
  description: Scalars['String']['output'];
  featureList: Array<Maybe<Scalars['String']['output']>>;
  featureRapidsos: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isExternalBilling: Scalars['Boolean']['output'];
  marketingType?: Maybe<PlanMarketingType>;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Organization`. */
  organizations: OrganizationsConnection;
  stripeMonthPrice?: Maybe<StripePrice>;
  stripeMonthPriceId: Scalars['String']['output'];
  stripeProduct?: Maybe<StripeProduct>;
  stripeProductId: Scalars['String']['output'];
  stripeYearPrice?: Maybe<StripePrice>;
  stripeYearPriceId: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};


export type PlanOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  filter?: InputMaybe<OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};

/** A condition to be used against `Plan` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PlanCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `marketingType` field. */
  marketingType?: InputMaybe<PlanMarketingType>;
};

/** A filter to be used against `Plan` object types. All fields are combined with a logical ‘and.’ */
export type PlanFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PlanFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `marketingType` field. */
  marketingType?: InputMaybe<PlanMarketingTypeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PlanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PlanFilter>>;
  /** Filter by the object’s `organizations` relation. */
  organizations?: InputMaybe<PlanToManyOrganizationFilter>;
  /** Some related `organizations` exist. */
  organizationsExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PlanMarketingType {
  Basic = 'BASIC',
  Family = 'FAMILY',
  Premium = 'PREMIUM'
}

/** A filter to be used against PlanMarketingType fields. All fields are combined with a logical ‘and.’ */
export type PlanMarketingTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PlanMarketingType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PlanMarketingType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PlanMarketingType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PlanMarketingType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PlanMarketingType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PlanMarketingType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PlanMarketingType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PlanMarketingType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PlanMarketingType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PlanMarketingType>>;
};

/** A filter to be used against many `Organization` object types. All fields are combined with a logical ‘and.’ */
export type PlanToManyOrganizationFilter = {
  /** Every related `Organization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OrganizationFilter>;
  /** No related `Organization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OrganizationFilter>;
  /** Some related `Organization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OrganizationFilter>;
};

/** A connection to a list of `Plan` values. */
export type PlansConnection = {
  __typename?: 'PlansConnection';
  /** A list of edges which contains the `Plan` and cursor to aid in pagination. */
  edges: Array<PlansEdge>;
  /** A list of `Plan` objects. */
  nodes: Array<Plan>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Plan` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Plan` edge in the connection. */
export type PlansEdge = {
  __typename?: 'PlansEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Plan` at the end of the edge. */
  node: Plan;
};

/** Methods to use when ordering `Plan`. */
export enum PlansOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MarketingTypeAsc = 'MARKETING_TYPE_ASC',
  MarketingTypeDesc = 'MARKETING_TYPE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type PtcAsset = Node & {
  __typename?: 'PtcAsset';
  chainingStationValue: Scalars['String']['output'];
  crc: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  distanceFromReferencePoint: Scalars['String']['output'];
  drawingReference: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  installationReportPdfUrl?: Maybe<Scalars['String']['output']>;
  line: Scalars['String']['output'];
  lineShort: Scalars['String']['output'];
  location: Scalars['String']['output'];
  mpValueOfFirstTransponder: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `PtcAsset`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `PtcInstallationReport`. */
  ptcInstallationReports: PtcInstallationReportsConnection;
  /** Reads and enables pagination through a set of `PtcVerificationReport`. */
  ptcVerificationReports: PtcVerificationReportsConnection;
  ramsId: Scalars['String']['output'];
  referencePoint: Scalars['String']['output'];
  referencePointStationChaining: Scalars['String']['output'];
  softwareReleaseTimestamp: Scalars['String']['output'];
  softwareVersion: Scalars['String']['output'];
  status: PtcAssetStatus;
  telegramHex: Scalars['String']['output'];
  trackNumber: Scalars['String']['output'];
  transponderNumber: Scalars['String']['output'];
  transponderSet: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  verificationReportPdfUrl?: Maybe<Scalars['String']['output']>;
};


export type PtcAssetPtcInstallationReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcInstallationReportCondition>;
  filter?: InputMaybe<PtcInstallationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcInstallationReportsOrderBy>>;
};


export type PtcAssetPtcVerificationReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcVerificationReportCondition>;
  filter?: InputMaybe<PtcVerificationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcVerificationReportsOrderBy>>;
};

/**
 * A condition to be used against `PtcAsset` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PtcAssetCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ramsId` field. */
  ramsId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `PtcAsset` object types. All fields are combined with a logical ‘and.’ */
export type PtcAssetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PtcAssetFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PtcAssetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PtcAssetFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ptcInstallationReports` relation. */
  ptcInstallationReports?: InputMaybe<PtcAssetToManyPtcInstallationReportFilter>;
  /** Some related `ptcInstallationReports` exist. */
  ptcInstallationReportsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ptcVerificationReports` relation. */
  ptcVerificationReports?: InputMaybe<PtcAssetToManyPtcVerificationReportFilter>;
  /** Some related `ptcVerificationReports` exist. */
  ptcVerificationReportsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ramsId` field. */
  ramsId?: InputMaybe<StringFilter>;
};

export enum PtcAssetStatus {
  Installed = 'INSTALLED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

/** A filter to be used against many `PtcInstallationReport` object types. All fields are combined with a logical ‘and.’ */
export type PtcAssetToManyPtcInstallationReportFilter = {
  /** Every related `PtcInstallationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PtcInstallationReportFilter>;
  /** No related `PtcInstallationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PtcInstallationReportFilter>;
  /** Some related `PtcInstallationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PtcInstallationReportFilter>;
};

/** A filter to be used against many `PtcVerificationReport` object types. All fields are combined with a logical ‘and.’ */
export type PtcAssetToManyPtcVerificationReportFilter = {
  /** Every related `PtcVerificationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PtcVerificationReportFilter>;
  /** No related `PtcVerificationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PtcVerificationReportFilter>;
  /** Some related `PtcVerificationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PtcVerificationReportFilter>;
};

/** A connection to a list of `PtcAsset` values. */
export type PtcAssetsConnection = {
  __typename?: 'PtcAssetsConnection';
  /** A list of edges which contains the `PtcAsset` and cursor to aid in pagination. */
  edges: Array<PtcAssetsEdge>;
  /** A list of `PtcAsset` objects. */
  nodes: Array<PtcAsset>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PtcAsset` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PtcAsset` edge in the connection. */
export type PtcAssetsEdge = {
  __typename?: 'PtcAssetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PtcAsset` at the end of the edge. */
  node: PtcAsset;
};

/** Methods to use when ordering `PtcAsset`. */
export enum PtcAssetsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RamsIdAsc = 'RAMS_ID_ASC',
  RamsIdDesc = 'RAMS_ID_DESC'
}

export type PtcInstallationReport = Node & {
  __typename?: 'PtcInstallationReport';
  actualDistanceFromReferencePoint: Scalars['Float']['output'];
  actualDistanceFromReferencePointComment: Scalars['String']['output'];
  chainingStationValueComment: Scalars['String']['output'];
  crcComment: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Member` that is related to this `PtcInstallationReport`. */
  createdByMember?: Maybe<Member>;
  createdByMemberId: Scalars['String']['output'];
  distanceFromReferencePointComment: Scalars['String']['output'];
  drawingReferenceComment: Scalars['String']['output'];
  equipmentFileUrl?: Maybe<Scalars['String']['output']>;
  gpsCoordindates: GeographyPoint;
  gpsCoordindatesComment: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  installedAt: Scalars['Datetime']['output'];
  installedAtComment: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `PtcInstallationReport`. */
  installedByMember?: Maybe<Member>;
  installedByMemberComment: Scalars['String']['output'];
  installedByMemberId: Scalars['String']['output'];
  lineComment: Scalars['String']['output'];
  locationComment: Scalars['String']['output'];
  mpValueOfFirstTransponderComment: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `PtcInstallationReport`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `PtcInstallationReport`. */
  programPlugLabelIdVerifiedByMember?: Maybe<Member>;
  programPlugLabelIdVerifiedByMemberComment: Scalars['String']['output'];
  programPlugLabelIdVerifiedByMemberId: Scalars['String']['output'];
  /** Reads a single `PtcAsset` that is related to this `PtcInstallationReport`. */
  ptcAsset?: Maybe<PtcAsset>;
  ptcAssetId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `PtcVerificationReport`. */
  ptcVerificationReports: PtcVerificationReportsConnection;
  ramsIdComment: Scalars['String']['output'];
  referencePointComment: Scalars['String']['output'];
  referencePointStationChainingComment: Scalars['String']['output'];
  softwareReleaseTimestampComment: Scalars['String']['output'];
  softwareVersionComment: Scalars['String']['output'];
  telegramHexComment: Scalars['String']['output'];
  trackNumberComment: Scalars['String']['output'];
  transponderNumberComment: Scalars['String']['output'];
  transponderSerialNumber: Scalars['String']['output'];
  transponderSerialNumberComment: Scalars['String']['output'];
  transponderSetComment: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `PtcInstallationReport`. */
  transponderTelegramReadByMember?: Maybe<Member>;
  transponderTelegramReadByMemberComment: Scalars['String']['output'];
  transponderTelegramReadByMemberId: Scalars['String']['output'];
  verifiedAt: Scalars['Datetime']['output'];
  verifiedAtComment: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `PtcInstallationReport`. */
  verifiedByMember?: Maybe<Member>;
  verifiedByMemberComment: Scalars['String']['output'];
  verifiedByMemberId: Scalars['String']['output'];
  waysideComponentUrl?: Maybe<Scalars['String']['output']>;
};


export type PtcInstallationReportPtcVerificationReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcVerificationReportCondition>;
  filter?: InputMaybe<PtcVerificationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcVerificationReportsOrderBy>>;
};

/**
 * A condition to be used against `PtcInstallationReport` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PtcInstallationReportCondition = {
  /** Checks for equality with the object’s `createdByMemberId` field. */
  createdByMemberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `installedByMemberId` field. */
  installedByMemberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `programPlugLabelIdVerifiedByMemberId` field. */
  programPlugLabelIdVerifiedByMemberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ptcAssetId` field. */
  ptcAssetId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `transponderTelegramReadByMemberId` field. */
  transponderTelegramReadByMemberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `verifiedByMemberId` field. */
  verifiedByMemberId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `PtcInstallationReport` object types. All fields are combined with a logical ‘and.’ */
export type PtcInstallationReportFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PtcInstallationReportFilter>>;
  /** Filter by the object’s `createdByMember` relation. */
  createdByMember?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `createdByMemberId` field. */
  createdByMemberId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `installedByMember` relation. */
  installedByMember?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `installedByMemberId` field. */
  installedByMemberId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PtcInstallationReportFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PtcInstallationReportFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `programPlugLabelIdVerifiedByMember` relation. */
  programPlugLabelIdVerifiedByMember?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `programPlugLabelIdVerifiedByMemberId` field. */
  programPlugLabelIdVerifiedByMemberId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ptcAsset` relation. */
  ptcAsset?: InputMaybe<PtcAssetFilter>;
  /** Filter by the object’s `ptcAssetId` field. */
  ptcAssetId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `ptcVerificationReports` relation. */
  ptcVerificationReports?: InputMaybe<PtcInstallationReportToManyPtcVerificationReportFilter>;
  /** Some related `ptcVerificationReports` exist. */
  ptcVerificationReportsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `transponderTelegramReadByMember` relation. */
  transponderTelegramReadByMember?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `transponderTelegramReadByMemberId` field. */
  transponderTelegramReadByMemberId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `verifiedByMember` relation. */
  verifiedByMember?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `verifiedByMemberId` field. */
  verifiedByMemberId?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `PtcVerificationReport` object types. All fields are combined with a logical ‘and.’ */
export type PtcInstallationReportToManyPtcVerificationReportFilter = {
  /** Every related `PtcVerificationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PtcVerificationReportFilter>;
  /** No related `PtcVerificationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PtcVerificationReportFilter>;
  /** Some related `PtcVerificationReport` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PtcVerificationReportFilter>;
};

/** A connection to a list of `PtcInstallationReport` values. */
export type PtcInstallationReportsConnection = {
  __typename?: 'PtcInstallationReportsConnection';
  /** A list of edges which contains the `PtcInstallationReport` and cursor to aid in pagination. */
  edges: Array<PtcInstallationReportsEdge>;
  /** A list of `PtcInstallationReport` objects. */
  nodes: Array<PtcInstallationReport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PtcInstallationReport` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PtcInstallationReport` edge in the connection. */
export type PtcInstallationReportsEdge = {
  __typename?: 'PtcInstallationReportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PtcInstallationReport` at the end of the edge. */
  node: PtcInstallationReport;
};

/** Methods to use when ordering `PtcInstallationReport`. */
export enum PtcInstallationReportsOrderBy {
  CreatedByMemberIdAsc = 'CREATED_BY_MEMBER_ID_ASC',
  CreatedByMemberIdDesc = 'CREATED_BY_MEMBER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InstalledByMemberIdAsc = 'INSTALLED_BY_MEMBER_ID_ASC',
  InstalledByMemberIdDesc = 'INSTALLED_BY_MEMBER_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgramPlugLabelIdVerifiedByMemberIdAsc = 'PROGRAM_PLUG_LABEL_ID_VERIFIED_BY_MEMBER_ID_ASC',
  ProgramPlugLabelIdVerifiedByMemberIdDesc = 'PROGRAM_PLUG_LABEL_ID_VERIFIED_BY_MEMBER_ID_DESC',
  PtcAssetIdAsc = 'PTC_ASSET_ID_ASC',
  PtcAssetIdDesc = 'PTC_ASSET_ID_DESC',
  TransponderTelegramReadByMemberIdAsc = 'TRANSPONDER_TELEGRAM_READ_BY_MEMBER_ID_ASC',
  TransponderTelegramReadByMemberIdDesc = 'TRANSPONDER_TELEGRAM_READ_BY_MEMBER_ID_DESC',
  VerifiedByMemberIdAsc = 'VERIFIED_BY_MEMBER_ID_ASC',
  VerifiedByMemberIdDesc = 'VERIFIED_BY_MEMBER_ID_DESC'
}

export type PtcVerificationReport = Node & {
  __typename?: 'PtcVerificationReport';
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `Member` that is related to this `PtcVerificationReport`. */
  createdByMember?: Maybe<Member>;
  createdByMemberId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `PtcVerificationReport`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PtcAsset` that is related to this `PtcVerificationReport`. */
  ptcAsset?: Maybe<PtcAsset>;
  ptcAssetId: Scalars['UUID']['output'];
  /** Reads a single `PtcInstallationReport` that is related to this `PtcVerificationReport`. */
  ptcInstallationReport?: Maybe<PtcInstallationReport>;
  ptcInstallationReportId: Scalars['UUID']['output'];
  question01Comment: Scalars['String']['output'];
  question01Response: Scalars['Boolean']['output'];
  question02Comment: Scalars['String']['output'];
  question02Response: Scalars['Boolean']['output'];
  question03Comment: Scalars['String']['output'];
  question03Response: Scalars['Boolean']['output'];
  question04Comment: Scalars['String']['output'];
  question04Response: Scalars['Boolean']['output'];
  question05Comment: Scalars['String']['output'];
  question05Response: Scalars['Boolean']['output'];
  question06Comment: Scalars['String']['output'];
  question06Response: Scalars['Boolean']['output'];
  question07Comment: Scalars['String']['output'];
  question07Response: Scalars['Boolean']['output'];
  question08Comment: Scalars['String']['output'];
  question08Response: Scalars['Boolean']['output'];
  question09Comment: Scalars['String']['output'];
  question09Response: Scalars['Boolean']['output'];
  question10Comment: Scalars['String']['output'];
  question10Response: Scalars['Boolean']['output'];
  question11Comment: Scalars['String']['output'];
  question11Response: Scalars['Boolean']['output'];
  question12Comment: Scalars['String']['output'];
  question12Response: Scalars['Boolean']['output'];
  question13Comment: Scalars['String']['output'];
  question13Response: Scalars['Boolean']['output'];
  waysideVerificationUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `PtcVerificationReport` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PtcVerificationReportCondition = {
  /** Checks for equality with the object’s `createdByMemberId` field. */
  createdByMemberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ptcAssetId` field. */
  ptcAssetId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `ptcInstallationReportId` field. */
  ptcInstallationReportId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `PtcVerificationReport` object types. All fields are combined with a logical ‘and.’ */
export type PtcVerificationReportFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PtcVerificationReportFilter>>;
  /** Filter by the object’s `createdByMember` relation. */
  createdByMember?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `createdByMemberId` field. */
  createdByMemberId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PtcVerificationReportFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PtcVerificationReportFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ptcAsset` relation. */
  ptcAsset?: InputMaybe<PtcAssetFilter>;
  /** Filter by the object’s `ptcAssetId` field. */
  ptcAssetId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `ptcInstallationReport` relation. */
  ptcInstallationReport?: InputMaybe<PtcInstallationReportFilter>;
  /** Filter by the object’s `ptcInstallationReportId` field. */
  ptcInstallationReportId?: InputMaybe<UuidFilter>;
};

/** A connection to a list of `PtcVerificationReport` values. */
export type PtcVerificationReportsConnection = {
  __typename?: 'PtcVerificationReportsConnection';
  /** A list of edges which contains the `PtcVerificationReport` and cursor to aid in pagination. */
  edges: Array<PtcVerificationReportsEdge>;
  /** A list of `PtcVerificationReport` objects. */
  nodes: Array<PtcVerificationReport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PtcVerificationReport` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PtcVerificationReport` edge in the connection. */
export type PtcVerificationReportsEdge = {
  __typename?: 'PtcVerificationReportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PtcVerificationReport` at the end of the edge. */
  node: PtcVerificationReport;
};

/** Methods to use when ordering `PtcVerificationReport`. */
export enum PtcVerificationReportsOrderBy {
  CreatedByMemberIdAsc = 'CREATED_BY_MEMBER_ID_ASC',
  CreatedByMemberIdDesc = 'CREATED_BY_MEMBER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PtcAssetIdAsc = 'PTC_ASSET_ID_ASC',
  PtcAssetIdDesc = 'PTC_ASSET_ID_DESC',
  PtcInstallationReportIdAsc = 'PTC_INSTALLATION_REPORT_ID_ASC',
  PtcInstallationReportIdDesc = 'PTC_INSTALLATION_REPORT_ID_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads and enables pagination through a set of `Guardme`. */
  activeGuardmes?: Maybe<GuardmesConnection>;
  /** Reads and enables pagination through a set of `Guardme`. */
  activeGuardmesByOrganization?: Maybe<GuardmesConnection>;
  /** Reads and enables pagination through a set of `Member`. */
  activeMembers?: Maybe<MembersConnection>;
  adminApplicationStatistics?: Maybe<ApplicationStatistic>;
  adminOrganization?: Maybe<Organization>;
  /** Reads and enables pagination through a set of `Member`. */
  adminOrganizationMembers?: Maybe<MembersConnection>;
  /** Reads and enables pagination through a set of `Organization`. */
  adminOrganizations?: Maybe<OrganizationsConnection>;
  adminRapidsosWorkflow?: Maybe<RapidsosWorkflow>;
  adminRapidsosWorkflowByGuardmeId?: Maybe<RapidsosWorkflow>;
  /** Reads and enables pagination through a set of `RapidsosWorkflow`. */
  adminRapidsosWorkflows?: Maybe<RapidsosWorkflowsConnection>;
  adminUser?: Maybe<User>;
  /** Reads and enables pagination through a set of `Member`. */
  adminUserMemberships?: Maybe<MembersConnection>;
  /** Reads and enables pagination through a set of `MobileDevice`. */
  adminUserMobileDevices?: Maybe<MobileDevicesConnection>;
  /** Reads and enables pagination through a set of `User`. */
  adminUsers?: Maybe<UsersConnection>;
  /** Get a single `Attachment`. */
  attachment?: Maybe<Attachment>;
  /** Reads a single `Attachment` using its globally unique `ID`. */
  attachmentByNodeId?: Maybe<Attachment>;
  /** Get a single `BivyStick`. */
  bivyStick?: Maybe<BivyStick>;
  /** Get a single `BivyStick`. */
  bivyStickByImei?: Maybe<BivyStick>;
  /** Reads a single `BivyStick` using its globally unique `ID`. */
  bivyStickByNodeId?: Maybe<BivyStick>;
  /** Reads and enables pagination through a set of `BivyStick`. */
  bivySticks?: Maybe<BivySticksConnection>;
  /** Get a single `CheckIn`. */
  checkIn?: Maybe<CheckIn>;
  /** Reads a single `CheckIn` using its globally unique `ID`. */
  checkInByNodeId?: Maybe<CheckIn>;
  /** Get a single `CheckInReport`. */
  checkInReport?: Maybe<CheckInReport>;
  /** Reads a single `CheckInReport` using its globally unique `ID`. */
  checkInReportByNodeId?: Maybe<CheckInReport>;
  /** Reads and enables pagination through a set of `CheckInReport`. */
  checkInReports?: Maybe<CheckInReportsConnection>;
  /** Get a single `CheckInRequest`. */
  checkInRequest?: Maybe<CheckInRequest>;
  checkInRequestById?: Maybe<CheckInRequest>;
  /** Reads a single `CheckInRequest` using its globally unique `ID`. */
  checkInRequestByNodeId?: Maybe<CheckInRequest>;
  /** Reads and enables pagination through a set of `CheckInRequest`. */
  checkInRequests?: Maybe<CheckInRequestsConnection>;
  /** Reads and enables pagination through a set of `CheckIn`. */
  checkIns?: Maybe<CheckInsConnection>;
  currentUser?: Maybe<User>;
  /** Get a single `EmergencyContact`. */
  emergencyContact?: Maybe<EmergencyContact>;
  /** Reads a single `EmergencyContact` using its globally unique `ID`. */
  emergencyContactByNodeId?: Maybe<EmergencyContact>;
  /** Get a single `EnabledIncidentType`. */
  enabledIncidentType?: Maybe<EnabledIncidentType>;
  /** Reads a single `EnabledIncidentType` using its globally unique `ID`. */
  enabledIncidentTypeByNodeId?: Maybe<EnabledIncidentType>;
  /** Reads and enables pagination through a set of `EnabledIncidentType`. */
  enabledIncidentTypes?: Maybe<EnabledIncidentTypesConnection>;
  generateAvatarUrlFromString?: Maybe<Scalars['String']['output']>;
  /** Get a single `Group`. */
  group?: Maybe<Group>;
  /** Reads a single `Group` using its globally unique `ID`. */
  groupByNodeId?: Maybe<Group>;
  /** Get a single `Group`. */
  groupByOrganizationIdAndName?: Maybe<Group>;
  /** Reads and enables pagination through a set of `Group`. */
  groups?: Maybe<GroupsConnection>;
  /** Get a single `Guardme`. */
  guardme?: Maybe<Guardme>;
  /** Get a single `GuardmeAttachment`. */
  guardmeAttachment?: Maybe<GuardmeAttachment>;
  /** Reads a single `GuardmeAttachment` using its globally unique `ID`. */
  guardmeAttachmentByNodeId?: Maybe<GuardmeAttachment>;
  /** Reads and enables pagination through a set of `GuardmeAttachment`. */
  guardmeAttachments?: Maybe<GuardmeAttachmentsConnection>;
  /** Get a single `GuardmeAuditLog`. */
  guardmeAuditLog?: Maybe<GuardmeAuditLog>;
  /** Reads a single `GuardmeAuditLog` using its globally unique `ID`. */
  guardmeAuditLogByNodeId?: Maybe<GuardmeAuditLog>;
  /** Reads and enables pagination through a set of `GuardmeAuditLog`. */
  guardmeAuditLogs?: Maybe<GuardmeAuditLogsConnection>;
  /** Reads a single `Guardme` using its globally unique `ID`. */
  guardmeByNodeId?: Maybe<Guardme>;
  /** Get a single `GuardmeLivestream`. */
  guardmeLivestream?: Maybe<GuardmeLivestream>;
  /** Reads a single `GuardmeLivestream` using its globally unique `ID`. */
  guardmeLivestreamByNodeId?: Maybe<GuardmeLivestream>;
  /** Reads and enables pagination through a set of `GuardmeLivestream`. */
  guardmeLivestreams?: Maybe<GuardmeLivestreamsConnection>;
  /** Get a single `GuardmeLocation`. */
  guardmeLocation?: Maybe<GuardmeLocation>;
  /** Reads a single `GuardmeLocation` using its globally unique `ID`. */
  guardmeLocationByNodeId?: Maybe<GuardmeLocation>;
  /** Reads and enables pagination through a set of `GuardmeLocation`. */
  guardmeLocations?: Maybe<GuardmeLocationsConnection>;
  /** Reads and enables pagination through a set of `Guardme`. */
  guardmes?: Maybe<GuardmesConnection>;
  /** Get a single `Incident`. */
  incident?: Maybe<Incident>;
  /** Reads a single `Incident` using its globally unique `ID`. */
  incidentByNodeId?: Maybe<Incident>;
  /** Get a single `IncidentType`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `IncidentType` using its globally unique `ID`. */
  incidentTypeByNodeId?: Maybe<IncidentType>;
  /** Reads and enables pagination through a set of `IncidentType`. */
  incidentTypes?: Maybe<IncidentTypesConnection>;
  /** Get a single `IncidentUpdate`. */
  incidentUpdate?: Maybe<IncidentUpdate>;
  /** Reads a single `IncidentUpdate` using its globally unique `ID`. */
  incidentUpdateByNodeId?: Maybe<IncidentUpdate>;
  /** Reads and enables pagination through a set of `IncidentUpdate`. */
  incidentUpdates?: Maybe<IncidentUpdatesConnection>;
  /** Reads and enables pagination through a set of `Incident`. */
  incidents?: Maybe<IncidentsConnection>;
  /** Get a single `Invitation`. */
  invitation?: Maybe<Invitation>;
  /** Reads a single `Invitation` using its globally unique `ID`. */
  invitationByNodeId?: Maybe<Invitation>;
  /** Reads and enables pagination through a set of `Invitation`. */
  invitations?: Maybe<InvitationsConnection>;
  /** Provides key settings required for IoT use (e.g. Livestream Devices). */
  iotSettings: IotSettingsPayload;
  /** Get a single `Livestream`. */
  livestream?: Maybe<Livestream>;
  /** Reads a single `Livestream` using its globally unique `ID`. */
  livestreamByNodeId?: Maybe<Livestream>;
  /** Generates a HLS url to view livestream device video */
  livestreamDeviceStreamingUrl: LivestreamDeviceStreamingUrlPayload;
  /** Reads and enables pagination through a set of `Livestream`. */
  livestreams?: Maybe<LivestreamsConnection>;
  /** Get a single `Member`. */
  member?: Maybe<Member>;
  /** Reads a single `Member` using its globally unique `ID`. */
  memberByNodeId?: Maybe<Member>;
  /** Get a single `Member`. */
  memberByOrganizationIdAndUserId?: Maybe<Member>;
  /** Reads and enables pagination through a set of `MemberStatistic`. */
  memberStatistics?: Maybe<MemberStatisticsConnection>;
  /** Reads and enables pagination through a set of `Member`. */
  members?: Maybe<MembersConnection>;
  /** Get a single `MembershipCode`. */
  membershipCode?: Maybe<MembershipCode>;
  /** Reads a single `MembershipCode` using its globally unique `ID`. */
  membershipCodeByNodeId?: Maybe<MembershipCode>;
  /** Reads and enables pagination through a set of `MembershipCode`. */
  membershipCodes?: Maybe<MembershipCodesConnection>;
  /** Get a single `MembershipRequest`. */
  membershipRequest?: Maybe<MembershipRequest>;
  /** Reads a single `MembershipRequest` using its globally unique `ID`. */
  membershipRequestByNodeId?: Maybe<MembershipRequest>;
  /** Get a single `MembershipRequest`. */
  membershipRequestByOrganizationIdAndUserId?: Maybe<MembershipRequest>;
  /** Reads and enables pagination through a set of `MembershipRequest`. */
  membershipRequests?: Maybe<MembershipRequestsConnection>;
  /** Get a single `MobileDevice`. */
  mobileDevice?: Maybe<MobileDevice>;
  /** Get a single `MobileDevice`. */
  mobileDeviceByDeviceToken?: Maybe<MobileDevice>;
  /** Reads a single `MobileDevice` using its globally unique `ID`. */
  mobileDeviceByNodeId?: Maybe<MobileDevice>;
  /** Reads and enables pagination through a set of `MobileDevice`. */
  mobileDevices?: Maybe<MobileDevicesConnection>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  /** Get a single `Organization`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Organization` using its globally unique `ID`. */
  organizationByNodeId?: Maybe<Organization>;
  /** Get a single `OrganizationMetric`. */
  organizationMetric?: Maybe<OrganizationMetric>;
  /** Reads a single `OrganizationMetric` using its globally unique `ID`. */
  organizationMetricByNodeId?: Maybe<OrganizationMetric>;
  /** Reads and enables pagination through a set of `OrganizationMetric`. */
  organizationMetrics?: Maybe<OrganizationMetricsConnection>;
  /** Get a single `OrganizationSetting`. */
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `OrganizationSetting` using its globally unique `ID`. */
  organizationSettingByNodeId?: Maybe<OrganizationSetting>;
  /** Reads and enables pagination through a set of `OrganizationStatistic`. */
  organizationStatistics?: Maybe<OrganizationStatisticsConnection>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizations?: Maybe<OrganizationsConnection>;
  /** Get a single `Place`. */
  place?: Maybe<Place>;
  /** Reads a single `Place` using its globally unique `ID`. */
  placeByNodeId?: Maybe<Place>;
  /** Reads and enables pagination through a set of `Place`. */
  places?: Maybe<PlacesConnection>;
  /** Get a single `Plan`. */
  plan?: Maybe<Plan>;
  /** Reads a single `Plan` using its globally unique `ID`. */
  planByNodeId?: Maybe<Plan>;
  /** Reads and enables pagination through a set of `Plan`. */
  plans?: Maybe<PlansConnection>;
  /** Get a single `PtcAsset`. */
  ptcAsset?: Maybe<PtcAsset>;
  /** Reads a single `PtcAsset` using its globally unique `ID`. */
  ptcAssetByNodeId?: Maybe<PtcAsset>;
  /** Get a single `PtcAsset`. */
  ptcAssetByOrganizationIdAndRamsId?: Maybe<PtcAsset>;
  /** Reads and enables pagination through a set of `PtcAsset`. */
  ptcAssets?: Maybe<PtcAssetsConnection>;
  /** Get a single `PtcInstallationReport`. */
  ptcInstallationReport?: Maybe<PtcInstallationReport>;
  /** Reads a single `PtcInstallationReport` using its globally unique `ID`. */
  ptcInstallationReportByNodeId?: Maybe<PtcInstallationReport>;
  /** Reads and enables pagination through a set of `PtcInstallationReport`. */
  ptcInstallationReports?: Maybe<PtcInstallationReportsConnection>;
  /** Get a single `PtcVerificationReport`. */
  ptcVerificationReport?: Maybe<PtcVerificationReport>;
  /** Reads a single `PtcVerificationReport` using its globally unique `ID`. */
  ptcVerificationReportByNodeId?: Maybe<PtcVerificationReport>;
  /** Reads and enables pagination through a set of `PtcVerificationReport`. */
  ptcVerificationReports?: Maybe<PtcVerificationReportsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads and enables pagination through a set of `Guardme`. */
  recentGuardmes?: Maybe<GuardmesConnection>;
  /** Get a single `ScheduledGuardme`. */
  scheduledGuardme?: Maybe<ScheduledGuardme>;
  /** Reads a single `ScheduledGuardme` using its globally unique `ID`. */
  scheduledGuardmeByNodeId?: Maybe<ScheduledGuardme>;
  /** Reads and enables pagination through a set of `ScheduledGuardme`. */
  scheduledGuardmes?: Maybe<ScheduledGuardmesConnection>;
  /** Reads and enables pagination through a set of `Member`. */
  searchMembers?: Maybe<MembersConnection>;
  /** Retrieve available products from stripe */
  stripeProducts?: Maybe<StripeProductsPayload>;
  /** Provides system setting information. */
  system: SystemPayload;
  /** Get a single `User`. */
  user?: Maybe<User>;
  /** Reads a single `User` using its globally unique `ID`. */
  userByNodeId?: Maybe<User>;
  /** Get a single `UserNotification`. */
  userNotification?: Maybe<UserNotification>;
  /** Reads a single `UserNotification` using its globally unique `ID`. */
  userNotificationByNodeId?: Maybe<UserNotification>;
  /** Reads and enables pagination through a set of `UserNotification`. */
  userNotifications?: Maybe<UserNotificationsConnection>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActiveGuardmesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GuardmeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActiveGuardmesByOrganizationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GuardmeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActiveMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  sinceInHours: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminOrganizationArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminOrganizationMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  filter?: InputMaybe<OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDeleted: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminRapidsosWorkflowArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminRapidsosWorkflowByGuardmeIdArgs = {
  guardmeId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminRapidsosWorkflowsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<RapidsosWorkflowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminUserArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminUserMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminUserMobileDevicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MobileDeviceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAdminUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAttachmentArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAttachmentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBivyStickArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBivyStickByImeiArgs = {
  imei: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBivyStickByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBivySticksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BivyStickCondition>;
  filter?: InputMaybe<BivyStickFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BivySticksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInReportArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInReportByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInReportCondition>;
  filter?: InputMaybe<CheckInReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInReportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInRequestArgs = {
  checkInReportId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInRequestByIdArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInRequestByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInRequestCondition>;
  filter?: InputMaybe<CheckInRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInRequestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckInsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CheckInCondition>;
  filter?: InputMaybe<CheckInFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmergencyContactArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmergencyContactByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnabledIncidentTypeArgs = {
  incidentTypeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnabledIncidentTypeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnabledIncidentTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnabledIncidentTypeCondition>;
  filter?: InputMaybe<EnabledIncidentTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnabledIncidentTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGenerateAvatarUrlFromStringArgs = {
  initialLength?: InputMaybe<Scalars['Int']['input']>;
  string: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupByOrganizationIdAndNameArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeAttachmentArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeAttachmentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeAttachmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeAttachmentCondition>;
  filter?: InputMaybe<GuardmeAttachmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeAuditLogArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeAuditLogByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeAuditLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeAuditLogCondition>;
  filter?: InputMaybe<GuardmeAuditLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeAuditLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeLivestreamArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeLivestreamByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeLivestreamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeLivestreamCondition>;
  filter?: InputMaybe<GuardmeLivestreamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeLivestreamsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeLocationArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeLocationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmeLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeLocationCondition>;
  filter?: InputMaybe<GuardmeLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmeLocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGuardmesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeCondition>;
  filter?: InputMaybe<GuardmeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIncidentArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIncidentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIncidentTypeArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIncidentTypeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIncidentTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentTypeCondition>;
  filter?: InputMaybe<IncidentTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIncidentUpdateArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIncidentUpdateByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIncidentUpdatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentUpdateCondition>;
  filter?: InputMaybe<IncidentUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentUpdatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIncidentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentCondition>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInvitationArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvitationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvitationCondition>;
  filter?: InputMaybe<InvitationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvitationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLivestreamArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLivestreamByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLivestreamDeviceStreamingUrlArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLivestreamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LivestreamCondition>;
  filter?: InputMaybe<LivestreamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LivestreamsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberByOrganizationIdAndUserIdArgs = {
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MemberStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromTimestamp: Scalars['Datetime']['input'];
  intervalType: StatisticIntervalType;
  last?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  timezone: Scalars['String']['input'];
  toTimestamp: Scalars['Datetime']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCondition>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipCodeArgs = {
  code: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipCodeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipCodeCondition>;
  filter?: InputMaybe<MembershipCodeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipCodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipRequestArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipRequestByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipRequestByOrganizationIdAndUserIdArgs = {
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipRequestCondition>;
  filter?: InputMaybe<MembershipRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipRequestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMobileDeviceArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMobileDeviceByDeviceTokenArgs = {
  deviceToken: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMobileDeviceByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMobileDevicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MobileDeviceCondition>;
  filter?: InputMaybe<MobileDeviceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MobileDevicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationMetricArgs = {
  organizationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationMetricByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationMetricsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationMetricCondition>;
  filter?: InputMaybe<OrganizationMetricFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationMetricsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationSettingArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationSettingByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<OrganizationStatisticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromTimestamp: Scalars['Datetime']['input'];
  intervalType: StatisticIntervalType;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  toTimestamp: Scalars['Datetime']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  filter?: InputMaybe<OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlaceArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlaceByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PlaceCondition>;
  filter?: InputMaybe<PlaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PlacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPlanArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlanByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPlansArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PlanCondition>;
  filter?: InputMaybe<PlanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PlansOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPtcAssetArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPtcAssetByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPtcAssetByOrganizationIdAndRamsIdArgs = {
  organizationId: Scalars['String']['input'];
  ramsId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPtcAssetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcAssetCondition>;
  filter?: InputMaybe<PtcAssetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcAssetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPtcInstallationReportArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPtcInstallationReportByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPtcInstallationReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcInstallationReportCondition>;
  filter?: InputMaybe<PtcInstallationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcInstallationReportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPtcVerificationReportArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPtcVerificationReportByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPtcVerificationReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PtcVerificationReportCondition>;
  filter?: InputMaybe<PtcVerificationReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PtcVerificationReportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRecentGuardmesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GuardmeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  sinceInHours: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledGuardmeArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledGuardmeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledGuardmesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledGuardmeCondition>;
  filter?: InputMaybe<ScheduledGuardmeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledGuardmesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  search: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserNotificationArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserNotificationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserNotificationCondition>;
  filter?: InputMaybe<UserNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type RapidsosWorkflow = {
  __typename?: 'RapidsosWorkflow';
  createdAt: Scalars['Datetime']['output'];
  data: Scalars['JSON']['output'];
  guardmeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  memberId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/** A filter to be used against `RapidsosWorkflow` object types. All fields are combined with a logical ‘and.’ */
export type RapidsosWorkflowFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RapidsosWorkflowFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RapidsosWorkflowFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RapidsosWorkflowFilter>>;
};

/** A connection to a list of `RapidsosWorkflow` values. */
export type RapidsosWorkflowsConnection = {
  __typename?: 'RapidsosWorkflowsConnection';
  /** A list of edges which contains the `RapidsosWorkflow` and cursor to aid in pagination. */
  edges: Array<RapidsosWorkflowsEdge>;
  /** A list of `RapidsosWorkflow` objects. */
  nodes: Array<RapidsosWorkflow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RapidsosWorkflow` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RapidsosWorkflow` edge in the connection. */
export type RapidsosWorkflowsEdge = {
  __typename?: 'RapidsosWorkflowsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RapidsosWorkflow` at the end of the edge. */
  node: RapidsosWorkflow;
};

/** All input for the `registerLiveActivityTokens` mutation. */
export type RegisterLiveActivityTokensInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  guardmeId?: InputMaybe<Scalars['String']['input']>;
  pushToStartToken: Scalars['String']['input'];
  uniqueId: Scalars['String']['input'];
  updateToken?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `registerLiveActivityTokens` mutation. */
export type RegisterLiveActivityTokensPayload = {
  __typename?: 'RegisterLiveActivityTokensPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `registerMobileDevice` mutation. */
export type RegisterMobileDeviceInput = {
  applicationVersion?: InputMaybe<Scalars['String']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deviceToken: Scalars['String']['input'];
  isPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSandbox?: InputMaybe<Scalars['Boolean']['input']>;
  model: Scalars['String']['input'];
  systemName: Scalars['String']['input'];
  systemVersion: Scalars['String']['input'];
  uniqueId: Scalars['String']['input'];
};

/** The output of our `registerMobileDevice` mutation. */
export type RegisterMobileDevicePayload = {
  __typename?: 'RegisterMobileDevicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  mobileDevice?: Maybe<MobileDevice>;
  /** An edge for our `MobileDevice`. May be used by Relay 1. */
  mobileDeviceEdge?: Maybe<MobileDevicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `MobileDevice`. */
  user?: Maybe<User>;
};


/** The output of our `registerMobileDevice` mutation. */
export type RegisterMobileDevicePayloadMobileDeviceEdgeArgs = {
  orderBy?: Array<MobileDevicesOrderBy>;
};

export type RemoveEmailAddressInput = {
  id: Scalars['String']['input'];
  isValid: Scalars['Boolean']['input'];
};

export type RemoveEmailAddressPayload = {
  __typename?: 'RemoveEmailAddressPayload';
  pendingEmailAddress: PendingEmailAddress;
  query?: Maybe<Query>;
  /** @deprecated Use AddEmailAddressPayload.pendingEmailAddress */
  userEmailAddress: UserEmailAddress;
};

/** All input for the `removeMemberFromGroup` mutation. */
export type RemoveMemberFromGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

/** The output of our `removeMemberFromGroup` mutation. */
export type RemoveMemberFromGroupPayload = {
  __typename?: 'RemoveMemberFromGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  mapGroupsMember?: Maybe<MapGroupsMember>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type RemovePhoneNumberInput = {
  id: Scalars['String']['input'];
  isValid: Scalars['Boolean']['input'];
};

export type RemovePhoneNumberPayload = {
  __typename?: 'RemovePhoneNumberPayload';
  pendingPhoneNumber: PendingPhoneNumber;
  query?: Maybe<Query>;
  /** @deprecated Use RemovePhoneNumberPayload.pendingPhoneNumber */
  userPhoneNumber: UserPhoneNumber;
};

export type ReverifyEmailAddressInput = {
  emailAddress: Scalars['String']['input'];
};

export type ReverifyEmailAddressPayload = {
  __typename?: 'ReverifyEmailAddressPayload';
  pendingEmailAddress: PendingEmailAddress;
  query?: Maybe<Query>;
};

export type ReverifyPhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
};

export type ReverifyPhoneNumberPayload = {
  __typename?: 'ReverifyPhoneNumberPayload';
  pendingPhoneNumber: PendingPhoneNumber;
  query?: Maybe<Query>;
  /** @deprecated Use ReverifyPhoneNumberPayload.pendingPhoneNumber */
  userPhoneNumber: UserPhoneNumber;
};

export type ScheduledGuardme = Node & {
  __typename?: 'ScheduledGuardme';
  createdAt: Scalars['Datetime']['output'];
  description: Scalars['String']['output'];
  durationMinutes: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isOneshot: Scalars['Boolean']['output'];
  /** Reads a single `Member` that is related to this `ScheduledGuardme`. */
  member?: Maybe<Member>;
  memberId: Scalars['String']['output'];
  nextRunAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  oneshotSchedule: Scalars['Datetime']['output'];
  /** Reads a single `Organization` that is related to this `ScheduledGuardme`. */
  organization?: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  recurringSchedule: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `ScheduledGuardme` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ScheduledGuardmeCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ScheduledGuardme` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledGuardmeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScheduledGuardmeFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScheduledGuardmeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScheduledGuardmeFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `ScheduledGuardme` values. */
export type ScheduledGuardmesConnection = {
  __typename?: 'ScheduledGuardmesConnection';
  /** A list of edges which contains the `ScheduledGuardme` and cursor to aid in pagination. */
  edges: Array<ScheduledGuardmesEdge>;
  /** A list of `ScheduledGuardme` objects. */
  nodes: Array<ScheduledGuardme>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScheduledGuardme` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ScheduledGuardme` edge in the connection. */
export type ScheduledGuardmesEdge = {
  __typename?: 'ScheduledGuardmesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ScheduledGuardme` at the end of the edge. */
  node: ScheduledGuardme;
};

/** Methods to use when ordering `ScheduledGuardme`. */
export enum ScheduledGuardmesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `setCurrentUserDefaultOrganizationId` mutation. */
export type SetCurrentUserDefaultOrganizationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};

/** The output of our `setCurrentUserDefaultOrganizationId` mutation. */
export type SetCurrentUserDefaultOrganizationIdPayload = {
  __typename?: 'SetCurrentUserDefaultOrganizationIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  string?: Maybe<Scalars['String']['output']>;
};

/** All input for the `startGuardme` mutation. */
export type StartGuardmeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  guardme: GuardmeInput;
};

/** All input for the `startGuardmeLivestream` mutation. */
export type StartGuardmeLivestreamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  guardmeId: Scalars['String']['input'];
};

/** The output of our `startGuardmeLivestream` mutation. */
export type StartGuardmeLivestreamPayload = {
  __typename?: 'StartGuardmeLivestreamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Guardme` that is related to this `Livestream`. */
  guardme?: Maybe<Guardme>;
  /** Reads a single `Incident` that is related to this `Livestream`. */
  incident?: Maybe<Incident>;
  livestream?: Maybe<Livestream>;
  /** An edge for our `Livestream`. May be used by Relay 1. */
  livestreamEdge?: Maybe<LivestreamsEdge>;
  /** Reads a single `Member` that is related to this `Livestream`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Livestream`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `startGuardmeLivestream` mutation. */
export type StartGuardmeLivestreamPayloadLivestreamEdgeArgs = {
  orderBy?: Array<LivestreamsOrderBy>;
};

/** The output of our `startGuardme` mutation. */
export type StartGuardmePayload = {
  __typename?: 'StartGuardmePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  guardme?: Maybe<Guardme>;
  /** An edge for our `Guardme`. May be used by Relay 1. */
  guardmeEdge?: Maybe<GuardmesEdge>;
  /** Reads a single `Member` that is related to this `Guardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Guardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `startGuardme` mutation. */
export type StartGuardmePayloadGuardmeEdgeArgs = {
  orderBy?: Array<GuardmesOrderBy>;
};

/** All input for the `startIncidentLivestream` mutation. */
export type StartIncidentLivestreamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  incidentId: Scalars['String']['input'];
};

/** The output of our `startIncidentLivestream` mutation. */
export type StartIncidentLivestreamPayload = {
  __typename?: 'StartIncidentLivestreamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Guardme` that is related to this `Livestream`. */
  guardme?: Maybe<Guardme>;
  /** Reads a single `Incident` that is related to this `Livestream`. */
  incident?: Maybe<Incident>;
  livestream?: Maybe<Livestream>;
  /** An edge for our `Livestream`. May be used by Relay 1. */
  livestreamEdge?: Maybe<LivestreamsEdge>;
  /** Reads a single `Member` that is related to this `Livestream`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Livestream`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `startIncidentLivestream` mutation. */
export type StartIncidentLivestreamPayloadLivestreamEdgeArgs = {
  orderBy?: Array<LivestreamsOrderBy>;
};

/** All input for the `startMembershipRequest` mutation. */
export type StartMembershipRequestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

/** The output of our `startMembershipRequest` mutation. */
export type StartMembershipRequestPayload = {
  __typename?: 'StartMembershipRequestPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `startMembershipRequest` mutation. */
export type StartMembershipRequestPayloadOrganizationEdgeArgs = {
  orderBy?: Array<OrganizationsOrderBy>;
};

/** All input for the `startTimedGuardme` mutation. */
export type StartTimedGuardmeInput = {
  attachmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  batteryLevel: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentLocation: LocationInput;
  endsAt: Scalars['Datetime']['input'];
  memberId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `startTimedGuardme` mutation. */
export type StartTimedGuardmePayload = {
  __typename?: 'StartTimedGuardmePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  guardme?: Maybe<Guardme>;
  /** An edge for our `Guardme`. May be used by Relay 1. */
  guardmeEdge?: Maybe<GuardmesEdge>;
  /** Reads a single `Member` that is related to this `Guardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Guardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `startTimedGuardme` mutation. */
export type StartTimedGuardmePayloadGuardmeEdgeArgs = {
  orderBy?: Array<GuardmesOrderBy>;
};

export enum StatisticIntervalType {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

/** A filter to be used against StatisticIntervalType fields. All fields are combined with a logical ‘and.’ */
export type StatisticIntervalTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<StatisticIntervalType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<StatisticIntervalType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<StatisticIntervalType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<StatisticIntervalType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<StatisticIntervalType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<StatisticIntervalType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<StatisticIntervalType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<StatisticIntervalType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<StatisticIntervalType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<StatisticIntervalType>>;
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

export type StripeAutomaticTax = {
  __typename?: 'StripeAutomaticTax';
  enabled: Scalars['Boolean']['output'];
};

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  amountDue: Scalars['Int']['output'];
  amountPaid: Scalars['Int']['output'];
  amountRemaining: Scalars['Int']['output'];
  automaticTax: StripeAutomaticTax;
  created: Scalars['Datetime']['output'];
  currency: Scalars['String']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  discounts: Array<Scalars['String']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoicePdf?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paid: Scalars['Boolean']['output'];
  paidOutOfBand: Scalars['Boolean']['output'];
  paymentIntent: Scalars['String']['output'];
  periodEnd: Scalars['Datetime']['output'];
  periodStart: Scalars['Datetime']['output'];
  status?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  subtotal: Scalars['Int']['output'];
  subtotalExcludingTax?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
  totalDiscountAmounts: Array<StripeTotalDiscountAmounts>;
  totalExcludingTax?: Maybe<Scalars['Int']['output']>;
  totalTaxAmounts: Array<StripeTotalTaxAmounts>;
};

export enum StripePlanInterval {
  Month = 'MONTH',
  Year = 'YEAR'
}

export type StripePrice = {
  __typename?: 'StripePrice';
  /** Describes how to compute the price per period. Either 'per_unit' or 'tiered'. 'per_unit' indicates that the fixed amount (specified in 'unit_amount' or 'unit_amount_decimal') will be charged per unit in 'quantity' (for prices with 'usage_type=licensed'), or per unit of total usage (for prices with 'usage_type=metered'). 'tiered' indicates that the unit pricing will be computed using a tiering strategy as defined using the 'tiers' and 'tiers_mode' attributes. */
  billingScheme?: Maybe<Scalars['String']['output']>;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  createdAt: Scalars['Datetime']['output'];
  /** Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase. Must be a [supported currency](https://stripe.com/docs/currencies). */
  currency?: Maybe<Scalars['String']['output']>;
  /** When set, provides configuration for the amount to be adjusted by the customer during Checkout Sessions and Payment Links. */
  customUnitAmount?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the object. */
  id: Scalars['String']['output'];
  /** Whether the price can be used for new purchases. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Has the value 'true' if the object exists in live mode or the value 'false' if the object exists in test mode. */
  isLivemode?: Maybe<Scalars['Boolean']['output']>;
  /** A lookup key used to retrieve prices dynamically from a static string. This may be up to 200 characters. */
  lookupKey?: Maybe<Scalars['String']['output']>;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** A brief description of the price, hidden from customers. */
  nickname?: Maybe<Scalars['String']['output']>;
  /** The ID of the product this price is associated with. */
  product?: Maybe<Scalars['String']['output']>;
  /** The recurring components of a price such as 'interval' and 'usage_type'. */
  recurring?: Maybe<StripeRecurring>;
  /** Specifies whether the price is considered inclusive of taxes or exclusive of taxes. One of 'inclusive', 'exclusive', or 'unspecified'. Once specified as either 'inclusive' or 'exclusive', it cannot be changed. */
  taxBehavior?: Maybe<Scalars['String']['output']>;
  /** One of 'one_time' or 'recurring' depending on whether the price is for a one-time purchase or a recurring (subscription) purchase. */
  type?: Maybe<Scalars['String']['output']>;
  /** The unit amount in %s to be charged, represented as a whole integer if possible. Only set if 'billing_scheme=per_unit'. */
  unitAmount?: Maybe<Scalars['Int']['output']>;
  /** The unit amount in %s to be charged, represented as a decimal string with at most 12 decimal places. Only set if 'billing_scheme=per_unit'. */
  unitAmountDecimal?: Maybe<Scalars['String']['output']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  /** A short one-line description of the product, meant to be displayable to the customer. Only applicable to products of'type=good'. */
  caption?: Maybe<Scalars['String']['output']>;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  createdAt: Scalars['Datetime']['output'];
  defaultPrice?: Maybe<StripePrice>;
  /** The ID of the [Price](https://stripe.com/docs/api/prices) object that is the default price for this product. */
  defaultPriceId?: Maybe<Scalars['String']['output']>;
  /** The product's description, meant to be displayable to the customer. Use this field to optionally store a long form explanation of the product being sold for your own rendering purposes. */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the object. */
  id: Scalars['String']['output'];
  /** A list of up to 8 URLs of images for this product, meant to be displayable to the customer. */
  images?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the product is currently available for purchase. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Has the value'true' if the object exists in live mode or the value'false' if the object exists in test mode. */
  isLivemode?: Maybe<Scalars['Boolean']['output']>;
  /** Set of [key-value pairs](https://stripe.com/docs/api/metadata) that you can attach to an object. This can be useful for storing additional information about the object in a structured format. */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** The product's name, meant to be displayable to the customer. */
  name: Scalars['String']['output'];
  /** Extra information about a product which will appear on your customer's credit card statement. In the case that multiple products are billed at once, the first statement descriptor will be used. */
  statementDescriptor?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<StripeTaxCode>;
  /** A [tax code](https://stripe.com/docs/tax/tax-categories) ID. */
  taxCodeId?: Maybe<Scalars['String']['output']>;
  /** The type of the product. The product is either of type'good', which is eligible for use with Orders and SKUs, or'service', which is eligible for use with Subscriptions and Plans. */
  type?: Maybe<Scalars['String']['output']>;
  /** A label that represents units of this product in Stripe and on customers' receipts and invoices. When set, this will be included in associated invoice line item descriptions. */
  unitLabel?: Maybe<Scalars['String']['output']>;
  /** Time at which the object was last updated. Measured in seconds since the Unix epoch. */
  updatedAt: Scalars['Datetime']['output'];
  /** A URL of a publicly-accessible webpage for this product. */
  url?: Maybe<Scalars['String']['output']>;
};

export type StripeProductsPayload = {
  __typename?: 'StripeProductsPayload';
  products: Array<StripeProduct>;
};

export type StripeRecurring = {
  __typename?: 'StripeRecurring';
  aggregateUsage?: Maybe<Scalars['Int']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  intervalCount?: Maybe<Scalars['Int']['output']>;
  trialPeriodDays?: Maybe<Scalars['Int']['output']>;
  usageType?: Maybe<Scalars['String']['output']>;
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  billingCycleAnchor: Scalars['Datetime']['output'];
  createdAt: Scalars['Datetime']['output'];
  currentPeriodEnd: Scalars['Datetime']['output'];
  currentPeriodStart: Scalars['Datetime']['output'];
  hasMore: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  items: Array<StripeSubscriptionItem>;
};

export type StripeSubscriptionItem = {
  __typename?: 'StripeSubscriptionItem';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  planAmount: Scalars['Int']['output'];
  planInterval: StripePlanInterval;
  priceUnitAmount: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type StripeTaxCode = {
  __typename?: 'StripeTaxCode';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type StripeTotalDiscountAmounts = {
  __typename?: 'StripeTotalDiscountAmounts';
  amount: Scalars['Int']['output'];
  discount: Scalars['String']['output'];
};

export type StripeTotalTaxAmounts = {
  __typename?: 'StripeTotalTaxAmounts';
  amount: Scalars['Int']['output'];
  inclusive: Scalars['Boolean']['output'];
  tax_rate: Scalars['String']['output'];
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  /** Triggered when a CheckInReport's data changes. */
  checkInReportUpdates?: Maybe<CheckInReportUpdatesPayload>;
  /** Triggered when a guardme's data changes. */
  checkInUpdates?: Maybe<CheckInUpdatesPayload>;
  currentUserNotificationUpdates?: Maybe<CurrentUserNotificationUpdatesPayload>;
  currentUserUpdates?: Maybe<CurrentUserUpdatesPayload>;
  /** Triggered when a guardme's location data changes. */
  guardmeLocationUpdates?: Maybe<GuardmeLocationUpdatesPayload>;
  /** Triggered when a guardme's data changes. */
  guardmeUpdates?: Maybe<GuardmeUpdatesPayload>;
  /** Triggered when a incident's data changes. */
  incidentUpdates?: Maybe<IncidentUpdatesPayload>;
  /** Triggered when a incident's data changes. */
  incidentsUpdates?: Maybe<IncidentsUpdatesPayload>;
  /** Triggered when a organization's data changes. */
  organizationUpdates?: Maybe<OrganizationUpdatesPayload>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionCheckInReportUpdatesArgs = {
  input: CheckInReportUpdatesInput;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionCheckInUpdatesArgs = {
  input: CheckInUpdatesInput;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionGuardmeLocationUpdatesArgs = {
  input: GuardmeLocationUpdatesInput;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionGuardmeUpdatesArgs = {
  input: GuardmeUpdatesInput;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionIncidentUpdatesArgs = {
  input: IncidentUpdatesInput;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionIncidentsUpdatesArgs = {
  input: IncidentsUpdatesInput;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionOrganizationUpdatesArgs = {
  input: OrganizationUpdatesInput;
};

export type SystemPayload = {
  __typename?: 'SystemPayload';
  /** The deployed api service version. */
  apiService: Scalars['String']['output'];
  assets: Scalars['String']['output'];
  databaseService: Scalars['String']['output'];
  incidentTypes: Scalars['String']['output'];
  infrastructure: Scalars['String']['output'];
  jobQueueService: Scalars['String']['output'];
  lambdaService: Scalars['String']['output'];
};

export type TimeSeries = {
  __typename?: 'TimeSeries';
  count?: Maybe<Scalars['BigInt']['output']>;
  date?: Maybe<Scalars['Datetime']['output']>;
};

/** All input for the `transferOrganizationOwnership` mutation. */
export type TransferOrganizationOwnershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `transferOrganizationOwnership` mutation. */
export type TransferOrganizationOwnershipPayload = {
  __typename?: 'TransferOrganizationOwnershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `transferOrganizationOwnership` mutation. */
export type TransferOrganizationOwnershipPayloadOrganizationEdgeArgs = {
  orderBy?: Array<OrganizationsOrderBy>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UnverifiedAuth0Account = {
  __typename?: 'UnverifiedAuth0Account';
  createdAt: Scalars['Datetime']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  userId: Scalars['String']['output'];
};

/** All input for the `updateAllowMembershipRequests` mutation. */
export type UpdateAllowMembershipRequestsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

/** The output of our `updateAllowMembershipRequests` mutation. */
export type UpdateAllowMembershipRequestsPayload = {
  __typename?: 'UpdateAllowMembershipRequestsPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export enum UpdateAvatarType {
  Custom = 'CUSTOM',
  Gravatar = 'GRAVATAR',
  Initials = 'INITIALS',
  Unchanged = 'UNCHANGED'
}

/** All input for the `updateCurrentLocation` mutation. */
export type UpdateCurrentLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentLocation: CurrentLocationInputRecordInput;
};

/** The output of our `updateCurrentLocation` mutation. */
export type UpdateCurrentLocationPayload = {
  __typename?: 'UpdateCurrentLocationPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateEmergencyContact` mutation. */
export type UpdateEmergencyContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  patch: EmergencyContactPatchRecordInput;
};

/** The output of our `updateEmergencyContact` mutation. */
export type UpdateEmergencyContactPayload = {
  __typename?: 'UpdateEmergencyContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emergencyContact?: Maybe<EmergencyContact>;
  /** An edge for our `EmergencyContact`. May be used by Relay 1. */
  emergencyContactEdge?: Maybe<EmergencyContactsEdge>;
  /** Reads a single `Member` that is related to this `EmergencyContact`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `EmergencyContact`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmergencyContact`. */
  user?: Maybe<User>;
};


/** The output of our `updateEmergencyContact` mutation. */
export type UpdateEmergencyContactPayloadEmergencyContactEdgeArgs = {
  orderBy?: Array<EmergencyContactsOrderBy>;
};

/** All input for the `updateEnabledIncidentTypeAssignedGroup` mutation. */
export type UpdateEnabledIncidentTypeAssignedGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our `updateEnabledIncidentTypeAssignedGroup` mutation. */
export type UpdateEnabledIncidentTypeAssignedGroupPayload = {
  __typename?: 'UpdateEnabledIncidentTypeAssignedGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `EnabledIncidentType`. */
  defaultAssignedGroup?: Maybe<Group>;
  enabledIncidentType?: Maybe<EnabledIncidentType>;
  /** An edge for our `EnabledIncidentType`. May be used by Relay 1. */
  enabledIncidentTypeEdge?: Maybe<EnabledIncidentTypesEdge>;
  /** Reads a single `IncidentType` that is related to this `EnabledIncidentType`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `Organization` that is related to this `EnabledIncidentType`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateEnabledIncidentTypeAssignedGroup` mutation. */
export type UpdateEnabledIncidentTypeAssignedGroupPayloadEnabledIncidentTypeEdgeArgs = {
  orderBy?: Array<EnabledIncidentTypesOrderBy>;
};

/** All input for the `updateGroup` mutation. */
export type UpdateGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** All input for the `updateGroupMembers` mutation. */
export type UpdateGroupMembersInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  memberIds: Array<InputMaybe<Scalars['String']['input']>>;
};

/** The output of our `updateGroupMembers` mutation. */
export type UpdateGroupMembersPayload = {
  __typename?: 'UpdateGroupMembersPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Organization` that is related to this `Group`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateGroupMembers` mutation. */
export type UpdateGroupMembersPayloadGroupEdgeArgs = {
  orderBy?: Array<GroupsOrderBy>;
};

/** The output of our `updateGroup` mutation. */
export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Organization` that is related to this `Group`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateGroup` mutation. */
export type UpdateGroupPayloadGroupEdgeArgs = {
  orderBy?: Array<GroupsOrderBy>;
};

/** All input for the `updateGuardmeBatteryLevel` mutation. */
export type UpdateGuardmeBatteryLevelInput = {
  batteryLevel: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our `updateGuardmeBatteryLevel` mutation. */
export type UpdateGuardmeBatteryLevelPayload = {
  __typename?: 'UpdateGuardmeBatteryLevelPayload';
  boolean: Scalars['Boolean']['output'];
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateGuardme` mutation. */
export type UpdateGuardmeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  patch: GuardmePatchRecordInput;
};

/** All input for the `updateGuardmeNotes` mutation. */
export type UpdateGuardmeNotesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['String']['input'];
  notes: Scalars['String']['input'];
};

/** The output of our `updateGuardmeNotes` mutation. */
export type UpdateGuardmeNotesPayload = {
  __typename?: 'UpdateGuardmeNotesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  guardme?: Maybe<Guardme>;
  /** An edge for our `Guardme`. May be used by Relay 1. */
  guardmeEdge?: Maybe<GuardmesEdge>;
  /** Reads a single `Member` that is related to this `Guardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Guardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateGuardmeNotes` mutation. */
export type UpdateGuardmeNotesPayloadGuardmeEdgeArgs = {
  orderBy?: Array<GuardmesOrderBy>;
};

/** All input for the `updateGuardmePanicAsAdmin` mutation. */
export type UpdateGuardmePanicAsAdminInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  guardmeId: Scalars['String']['input'];
  operatorPhoneNumber: Scalars['String']['input'];
  useOperatorFlow: Scalars['Boolean']['input'];
};

/** The output of our `updateGuardmePanicAsAdmin` mutation. */
export type UpdateGuardmePanicAsAdminPayload = {
  __typename?: 'UpdateGuardmePanicAsAdminPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  guardme?: Maybe<Guardme>;
  /** An edge for our `Guardme`. May be used by Relay 1. */
  guardmeEdge?: Maybe<GuardmesEdge>;
  /** Reads a single `Member` that is related to this `Guardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Guardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateGuardmePanicAsAdmin` mutation. */
export type UpdateGuardmePanicAsAdminPayloadGuardmeEdgeArgs = {
  orderBy?: Array<GuardmesOrderBy>;
};

/** The output of our `updateGuardme` mutation. */
export type UpdateGuardmePayload = {
  __typename?: 'UpdateGuardmePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  guardme?: Maybe<Guardme>;
  /** An edge for our `Guardme`. May be used by Relay 1. */
  guardmeEdge?: Maybe<GuardmesEdge>;
  /** Reads a single `Member` that is related to this `Guardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Guardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateGuardme` mutation. */
export type UpdateGuardmePayloadGuardmeEdgeArgs = {
  orderBy?: Array<GuardmesOrderBy>;
};

/** All input for the `updateIncidentContact` mutation. */
export type UpdateIncidentContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  incidentId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

/** The output of our `updateIncidentContact` mutation. */
export type UpdateIncidentContactPayload = {
  __typename?: 'UpdateIncidentContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `Incident`. */
  contactMember?: Maybe<Member>;
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `IncidentType` that is related to this `Incident`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `Organization` that is related to this `Incident`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Group` that is related to this `Incident`. */
  ownedByGroup?: Maybe<Group>;
  /** Reads a single `Member` that is related to this `Incident`. */
  ownedByMember?: Maybe<Member>;
  /** Reads a single `Incident` that is related to this `Incident`. */
  parent?: Maybe<Incident>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Member` that is related to this `Incident`. */
  submittedByMember?: Maybe<Member>;
};


/** The output of our `updateIncidentContact` mutation. */
export type UpdateIncidentContactPayloadIncidentEdgeArgs = {
  orderBy?: Array<IncidentsOrderBy>;
};

/** All input for the `updateIncidentDetails` mutation. */
export type UpdateIncidentDetailsInput = {
  additionalData: Scalars['JSON']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  incidentId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

/** The output of our `updateIncidentDetails` mutation. */
export type UpdateIncidentDetailsPayload = {
  __typename?: 'UpdateIncidentDetailsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `Incident`. */
  contactMember?: Maybe<Member>;
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `IncidentType` that is related to this `Incident`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `Organization` that is related to this `Incident`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Group` that is related to this `Incident`. */
  ownedByGroup?: Maybe<Group>;
  /** Reads a single `Member` that is related to this `Incident`. */
  ownedByMember?: Maybe<Member>;
  /** Reads a single `Incident` that is related to this `Incident`. */
  parent?: Maybe<Incident>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Member` that is related to this `Incident`. */
  submittedByMember?: Maybe<Member>;
};


/** The output of our `updateIncidentDetails` mutation. */
export type UpdateIncidentDetailsPayloadIncidentEdgeArgs = {
  orderBy?: Array<IncidentsOrderBy>;
};

/** All input for the `updateIncidentGroup` mutation. */
export type UpdateIncidentGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  incidentId: Scalars['String']['input'];
};

/** The output of our `updateIncidentGroup` mutation. */
export type UpdateIncidentGroupPayload = {
  __typename?: 'UpdateIncidentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `Incident`. */
  contactMember?: Maybe<Member>;
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `IncidentType` that is related to this `Incident`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `Organization` that is related to this `Incident`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Group` that is related to this `Incident`. */
  ownedByGroup?: Maybe<Group>;
  /** Reads a single `Member` that is related to this `Incident`. */
  ownedByMember?: Maybe<Member>;
  /** Reads a single `Incident` that is related to this `Incident`. */
  parent?: Maybe<Incident>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Member` that is related to this `Incident`. */
  submittedByMember?: Maybe<Member>;
};


/** The output of our `updateIncidentGroup` mutation. */
export type UpdateIncidentGroupPayloadIncidentEdgeArgs = {
  orderBy?: Array<IncidentsOrderBy>;
};

/** All input for the `updateIncidentOwner` mutation. */
export type UpdateIncidentOwnerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  incidentId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

/** The output of our `updateIncidentOwner` mutation. */
export type UpdateIncidentOwnerPayload = {
  __typename?: 'UpdateIncidentOwnerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `Incident`. */
  contactMember?: Maybe<Member>;
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `IncidentType` that is related to this `Incident`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `Organization` that is related to this `Incident`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Group` that is related to this `Incident`. */
  ownedByGroup?: Maybe<Group>;
  /** Reads a single `Member` that is related to this `Incident`. */
  ownedByMember?: Maybe<Member>;
  /** Reads a single `Incident` that is related to this `Incident`. */
  parent?: Maybe<Incident>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Member` that is related to this `Incident`. */
  submittedByMember?: Maybe<Member>;
};


/** The output of our `updateIncidentOwner` mutation. */
export type UpdateIncidentOwnerPayloadIncidentEdgeArgs = {
  orderBy?: Array<IncidentsOrderBy>;
};

/** All input for the `updateIncidentPriority` mutation. */
export type UpdateIncidentPriorityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  incidentId: Scalars['String']['input'];
  priority: IncidentPriorityType;
};

/** The output of our `updateIncidentPriority` mutation. */
export type UpdateIncidentPriorityPayload = {
  __typename?: 'UpdateIncidentPriorityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `Incident`. */
  contactMember?: Maybe<Member>;
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `IncidentType` that is related to this `Incident`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `Organization` that is related to this `Incident`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Group` that is related to this `Incident`. */
  ownedByGroup?: Maybe<Group>;
  /** Reads a single `Member` that is related to this `Incident`. */
  ownedByMember?: Maybe<Member>;
  /** Reads a single `Incident` that is related to this `Incident`. */
  parent?: Maybe<Incident>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Member` that is related to this `Incident`. */
  submittedByMember?: Maybe<Member>;
};


/** The output of our `updateIncidentPriority` mutation. */
export type UpdateIncidentPriorityPayloadIncidentEdgeArgs = {
  orderBy?: Array<IncidentsOrderBy>;
};

/** All input for the `updateIncidentStatus` mutation. */
export type UpdateIncidentStatusInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  incidentId: Scalars['String']['input'];
  status: IncidentStatusType;
};

/** The output of our `updateIncidentStatus` mutation. */
export type UpdateIncidentStatusPayload = {
  __typename?: 'UpdateIncidentStatusPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `Incident`. */
  contactMember?: Maybe<Member>;
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `IncidentType` that is related to this `Incident`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `Organization` that is related to this `Incident`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Group` that is related to this `Incident`. */
  ownedByGroup?: Maybe<Group>;
  /** Reads a single `Member` that is related to this `Incident`. */
  ownedByMember?: Maybe<Member>;
  /** Reads a single `Incident` that is related to this `Incident`. */
  parent?: Maybe<Incident>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Member` that is related to this `Incident`. */
  submittedByMember?: Maybe<Member>;
};


/** The output of our `updateIncidentStatus` mutation. */
export type UpdateIncidentStatusPayloadIncidentEdgeArgs = {
  orderBy?: Array<IncidentsOrderBy>;
};

/** All input for the `updateIncidentTypeAllowlist` mutation. */
export type UpdateIncidentTypeAllowlistInput = {
  allowlist: Array<InputMaybe<Scalars['String']['input']>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  useAllowlist: Scalars['Boolean']['input'];
};

/** The output of our `updateIncidentTypeAllowlist` mutation. */
export type UpdateIncidentTypeAllowlistPayload = {
  __typename?: 'UpdateIncidentTypeAllowlistPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  incidentType?: Maybe<IncidentType>;
  /** An edge for our `IncidentType`. May be used by Relay 1. */
  incidentTypeEdge?: Maybe<IncidentTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateIncidentTypeAllowlist` mutation. */
export type UpdateIncidentTypeAllowlistPayloadIncidentTypeEdgeArgs = {
  orderBy?: Array<IncidentTypesOrderBy>;
};

/** All input for the `updateIncidentType` mutation. */
export type UpdateIncidentTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  incidentId: Scalars['String']['input'];
  incidentTypeId: Scalars['String']['input'];
};

/** The output of our `updateIncidentType` mutation. */
export type UpdateIncidentTypePayload = {
  __typename?: 'UpdateIncidentTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `Incident`. */
  contactMember?: Maybe<Member>;
  incident?: Maybe<Incident>;
  /** An edge for our `Incident`. May be used by Relay 1. */
  incidentEdge?: Maybe<IncidentsEdge>;
  /** Reads a single `IncidentType` that is related to this `Incident`. */
  incidentType?: Maybe<IncidentType>;
  /** Reads a single `Organization` that is related to this `Incident`. */
  organization?: Maybe<Organization>;
  /** Reads a single `Group` that is related to this `Incident`. */
  ownedByGroup?: Maybe<Group>;
  /** Reads a single `Member` that is related to this `Incident`. */
  ownedByMember?: Maybe<Member>;
  /** Reads a single `Incident` that is related to this `Incident`. */
  parent?: Maybe<Incident>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Member` that is related to this `Incident`. */
  submittedByMember?: Maybe<Member>;
};


/** The output of our `updateIncidentType` mutation. */
export type UpdateIncidentTypePayloadIncidentEdgeArgs = {
  orderBy?: Array<IncidentsOrderBy>;
};

/** All input for the `updateInvitation` mutation. */
export type UpdateInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupIds: Array<InputMaybe<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
  organizationRole: MemberRole;
};

/** The output of our `updateInvitation` mutation. */
export type UpdateInvitationPayload = {
  __typename?: 'UpdateInvitationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  invitation?: Maybe<Invitation>;
  /** An edge for our `Invitation`. May be used by Relay 1. */
  invitationEdge?: Maybe<InvitationsEdge>;
  /** Reads a single `Organization` that is related to this `Invitation`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateInvitation` mutation. */
export type UpdateInvitationPayloadInvitationEdgeArgs = {
  orderBy?: Array<InvitationsOrderBy>;
};

export enum UpdateLogoType {
  Custom = 'CUSTOM',
  Initials = 'INITIALS',
  Unchanged = 'UNCHANGED'
}

/** All input for the `updateMemberDisplayName` mutation. */
export type UpdateMemberDisplayNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};

/** The output of our `updateMemberDisplayName` mutation. */
export type UpdateMemberDisplayNamePayload = {
  __typename?: 'UpdateMemberDisplayNamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge?: Maybe<MembersEdge>;
  /** Reads a single `Organization` that is related to this `Member`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Member`. */
  user?: Maybe<User>;
};


/** The output of our `updateMemberDisplayName` mutation. */
export type UpdateMemberDisplayNamePayloadMemberEdgeArgs = {
  orderBy?: Array<MembersOrderBy>;
};

/** All input for the `updateMemberGroups` mutation. */
export type UpdateMemberGroupsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupIds: Array<InputMaybe<Scalars['String']['input']>>;
  memberId: Scalars['String']['input'];
};

/** The output of our `updateMemberGroups` mutation. */
export type UpdateMemberGroupsPayload = {
  __typename?: 'UpdateMemberGroupsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge?: Maybe<MembersEdge>;
  /** Reads a single `Organization` that is related to this `Member`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Member`. */
  user?: Maybe<User>;
};


/** The output of our `updateMemberGroups` mutation. */
export type UpdateMemberGroupsPayloadMemberEdgeArgs = {
  orderBy?: Array<MembersOrderBy>;
};

/** All input for the `updateMemberMetadata` mutation. */
export type UpdateMemberMetadataInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
};

/** The output of our `updateMemberMetadata` mutation. */
export type UpdateMemberMetadataPayload = {
  __typename?: 'UpdateMemberMetadataPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge?: Maybe<MembersEdge>;
  /** Reads a single `Organization` that is related to this `Member`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Member`. */
  user?: Maybe<User>;
};


/** The output of our `updateMemberMetadata` mutation. */
export type UpdateMemberMetadataPayloadMemberEdgeArgs = {
  orderBy?: Array<MembersOrderBy>;
};

/** All input for the `updateMemberRole` mutation. */
export type UpdateMemberRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['String']['input'];
  roleId: MemberRole;
};

/** The output of our `updateMemberRole` mutation. */
export type UpdateMemberRolePayload = {
  __typename?: 'UpdateMemberRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  member?: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge?: Maybe<MembersEdge>;
  /** Reads a single `Organization` that is related to this `Member`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Member`. */
  user?: Maybe<User>;
};


/** The output of our `updateMemberRole` mutation. */
export type UpdateMemberRolePayloadMemberEdgeArgs = {
  orderBy?: Array<MembersOrderBy>;
};

/** All input for the `updateOrganizationCheckInSettings` mutation. */
export type UpdateOrganizationCheckInSettingsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  shouldNotifyAdministrator: Scalars['Boolean']['input'];
  shouldNotifyOwner: Scalars['Boolean']['input'];
  shouldNotifySupervisor: Scalars['Boolean']['input'];
  supervisorGroupId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationCheckInSettings` mutation. */
export type UpdateOrganizationCheckInSettingsPayload = {
  __typename?: 'UpdateOrganizationCheckInSettingsPayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationCheckInSupervisorGroup` mutation. */
export type UpdateOrganizationCheckInSupervisorGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationCheckInSupervisorGroup` mutation. */
export type UpdateOrganizationCheckInSupervisorGroupPayload = {
  __typename?: 'UpdateOrganizationCheckInSupervisorGroupPayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationDetails` mutation. */
export type UpdateOrganizationDetailsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customLogoKey?: InputMaybe<Scalars['String']['input']>;
  logoType: UpdateLogoType;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  ownerMemberId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

/** The output of our `updateOrganizationDetails` mutation. */
export type UpdateOrganizationDetailsPayload = {
  __typename?: 'UpdateOrganizationDetailsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateOrganizationDetails` mutation. */
export type UpdateOrganizationDetailsPayloadOrganizationEdgeArgs = {
  orderBy?: Array<OrganizationsOrderBy>;
};

/** All input for the `updateOrganizationGuardmeNotificationSettings` mutation. */
export type UpdateOrganizationGuardmeNotificationSettingsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  concludedGroupIds: Array<InputMaybe<Scalars['String']['input']>>;
  concludedMetadataKeys: Array<InputMaybe<Scalars['String']['input']>>;
  concludedRoles: Array<InputMaybe<MemberRole>>;
  expiredGroupIds: Array<InputMaybe<Scalars['String']['input']>>;
  expiredMetadataKeys: Array<InputMaybe<Scalars['String']['input']>>;
  expiredRoles: Array<InputMaybe<MemberRole>>;
  organizationId: Scalars['String']['input'];
  panicGroupIds: Array<InputMaybe<Scalars['String']['input']>>;
  panicMetadataKeys: Array<InputMaybe<Scalars['String']['input']>>;
  panicRoles: Array<InputMaybe<MemberRole>>;
  startedGroupIds: Array<InputMaybe<Scalars['String']['input']>>;
  startedMetadataKeys: Array<InputMaybe<Scalars['String']['input']>>;
  startedRoles: Array<InputMaybe<MemberRole>>;
};

/** The output of our `updateOrganizationGuardmeNotificationSettings` mutation. */
export type UpdateOrganizationGuardmeNotificationSettingsPayload = {
  __typename?: 'UpdateOrganizationGuardmeNotificationSettingsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateOrganizationGuardmeNotificationSettings` mutation. */
export type UpdateOrganizationGuardmeNotificationSettingsPayloadOrganizationEdgeArgs = {
  orderBy?: Array<OrganizationsOrderBy>;
};

/** All input for the `updateOrganizationGuardmeSettings` mutation. */
export type UpdateOrganizationGuardmeSettingsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  includeMemberMetadata: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
  sendConcludedNotification: Scalars['Boolean']['input'];
  sendExpiredNotification: Scalars['Boolean']['input'];
  sendPanicNotification: Scalars['Boolean']['input'];
  sendStartedNotification: Scalars['Boolean']['input'];
  shouldNotifyAdministrator: Scalars['Boolean']['input'];
  shouldNotifyOwner: Scalars['Boolean']['input'];
  shouldNotifySupervisor: Scalars['Boolean']['input'];
  supervisorGroupId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationGuardmeSettings` mutation. */
export type UpdateOrganizationGuardmeSettingsPayload = {
  __typename?: 'UpdateOrganizationGuardmeSettingsPayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationGuardmeSupervisorGroup` mutation. */
export type UpdateOrganizationGuardmeSupervisorGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationGuardmeSupervisorGroup` mutation. */
export type UpdateOrganizationGuardmeSupervisorGroupPayload = {
  __typename?: 'UpdateOrganizationGuardmeSupervisorGroupPayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationIncidentSettings` mutation. */
export type UpdateOrganizationIncidentSettingsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  shouldNotifyAdministrator: Scalars['Boolean']['input'];
  shouldNotifyOwner: Scalars['Boolean']['input'];
  shouldNotifySupervisor: Scalars['Boolean']['input'];
  supervisorGroupId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationIncidentSettings` mutation. */
export type UpdateOrganizationIncidentSettingsPayload = {
  __typename?: 'UpdateOrganizationIncidentSettingsPayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationIncidentSupervisorGroup` mutation. */
export type UpdateOrganizationIncidentSupervisorGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationIncidentSupervisorGroup` mutation. */
export type UpdateOrganizationIncidentSupervisorGroupPayload = {
  __typename?: 'UpdateOrganizationIncidentSupervisorGroupPayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationLogoUrl` mutation. */
export type UpdateOrganizationLogoUrlInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  logoUrl: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationLogoUrl` mutation. */
export type UpdateOrganizationLogoUrlPayload = {
  __typename?: 'UpdateOrganizationLogoUrlPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateOrganizationLogoUrl` mutation. */
export type UpdateOrganizationLogoUrlPayloadOrganizationEdgeArgs = {
  orderBy?: Array<OrganizationsOrderBy>;
};

/** All input for the `updateOrganizationMapSettings` mutation. */
export type UpdateOrganizationMapSettingsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  organizationId: Scalars['String']['input'];
  zoom: Scalars['Int']['input'];
};

/** The output of our `updateOrganizationMapSettings` mutation. */
export type UpdateOrganizationMapSettingsPayload = {
  __typename?: 'UpdateOrganizationMapSettingsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateOrganizationMapSettings` mutation. */
export type UpdateOrganizationMapSettingsPayloadOrganizationEdgeArgs = {
  orderBy?: Array<OrganizationsOrderBy>;
};

/** All input for the `updateOrganizationMemberMetadataFields` mutation. */
export type UpdateOrganizationMemberMetadataFieldsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fields: Scalars['JSON']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationMemberMetadataFields` mutation. */
export type UpdateOrganizationMemberMetadataFieldsPayload = {
  __typename?: 'UpdateOrganizationMemberMetadataFieldsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateOrganizationMemberMetadataFields` mutation. */
export type UpdateOrganizationMemberMetadataFieldsPayloadOrganizationEdgeArgs = {
  orderBy?: Array<OrganizationsOrderBy>;
};

/** All input for the `updateOrganizationName` mutation. */
export type UpdateOrganizationNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationName` mutation. */
export type UpdateOrganizationNamePayload = {
  __typename?: 'UpdateOrganizationNamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateOrganizationName` mutation. */
export type UpdateOrganizationNamePayloadOrganizationEdgeArgs = {
  orderBy?: Array<OrganizationsOrderBy>;
};

/** All input for the `updateOrganizationRapidsosSettings` mutation. */
export type UpdateOrganizationRapidsosSettingsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isOperatorFlowEnabled: Scalars['Boolean']['input'];
  isPanicButtonFlowEnabled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
  socPhoneNumber: Scalars['String']['input'];
};

/** The output of our `updateOrganizationRapidsosSettings` mutation. */
export type UpdateOrganizationRapidsosSettingsPayload = {
  __typename?: 'UpdateOrganizationRapidsosSettingsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateOrganizationRapidsosSettings` mutation. */
export type UpdateOrganizationRapidsosSettingsPayloadOrganizationEdgeArgs = {
  orderBy?: Array<OrganizationsOrderBy>;
};

/** All input for the `updateOrganizationSettingsAdministratorNotifiedOnCheckIn` mutation. */
export type UpdateOrganizationSettingsAdministratorNotifiedOnCheckInInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationSettingsAdministratorNotifiedOnCheckIn` mutation. */
export type UpdateOrganizationSettingsAdministratorNotifiedOnCheckInPayload = {
  __typename?: 'UpdateOrganizationSettingsAdministratorNotifiedOnCheckInPayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationSettingsAdministratorNotifiedOnGuardme` mutation. */
export type UpdateOrganizationSettingsAdministratorNotifiedOnGuardmeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationSettingsAdministratorNotifiedOnGuardme` mutation. */
export type UpdateOrganizationSettingsAdministratorNotifiedOnGuardmePayload = {
  __typename?: 'UpdateOrganizationSettingsAdministratorNotifiedOnGuardmePayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationSettingsAdministratorNotifiedOnIncident` mutation. */
export type UpdateOrganizationSettingsAdministratorNotifiedOnIncidentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationSettingsAdministratorNotifiedOnIncident` mutation. */
export type UpdateOrganizationSettingsAdministratorNotifiedOnIncidentPayload = {
  __typename?: 'UpdateOrganizationSettingsAdministratorNotifiedOnIncidentPayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationSettingsOwnerNotifiedOnCheckIn` mutation. */
export type UpdateOrganizationSettingsOwnerNotifiedOnCheckInInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationSettingsOwnerNotifiedOnCheckIn` mutation. */
export type UpdateOrganizationSettingsOwnerNotifiedOnCheckInPayload = {
  __typename?: 'UpdateOrganizationSettingsOwnerNotifiedOnCheckInPayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationSettingsOwnerNotifiedOnGuardme` mutation. */
export type UpdateOrganizationSettingsOwnerNotifiedOnGuardmeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationSettingsOwnerNotifiedOnGuardme` mutation. */
export type UpdateOrganizationSettingsOwnerNotifiedOnGuardmePayload = {
  __typename?: 'UpdateOrganizationSettingsOwnerNotifiedOnGuardmePayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationSettingsOwnerNotifiedOnIncident` mutation. */
export type UpdateOrganizationSettingsOwnerNotifiedOnIncidentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updateOrganizationSettingsOwnerNotifiedOnIncident` mutation. */
export type UpdateOrganizationSettingsOwnerNotifiedOnIncidentPayload = {
  __typename?: 'UpdateOrganizationSettingsOwnerNotifiedOnIncidentPayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationTimezone` mutation. */
export type UpdateOrganizationTimezoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

/** The output of our `updateOrganizationTimezone` mutation. */
export type UpdateOrganizationTimezonePayload = {
  __typename?: 'UpdateOrganizationTimezonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Reads a single `Member` that is related to this `Organization`. */
  ownerMember?: Maybe<Member>;
  /** Reads a single `Plan` that is related to this `Organization`. */
  plan?: Maybe<Plan>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateOrganizationTimezone` mutation. */
export type UpdateOrganizationTimezonePayloadOrganizationEdgeArgs = {
  orderBy?: Array<OrganizationsOrderBy>;
};

/** All input for the `updatePlace` mutation. */
export type UpdatePlaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  geojson: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  radius: Scalars['Int']['input'];
};

/** The output of our `updatePlace` mutation. */
export type UpdatePlacePayload = {
  __typename?: 'UpdatePlacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Place`. */
  organization?: Maybe<Organization>;
  place?: Maybe<Place>;
  /** An edge for our `Place`. May be used by Relay 1. */
  placeEdge?: Maybe<PlacesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updatePlace` mutation. */
export type UpdatePlacePayloadPlaceEdgeArgs = {
  orderBy?: Array<PlacesOrderBy>;
};

/** All input for the `updatePlan` mutation. */
export type UpdatePlanInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  featureList: Array<InputMaybe<Scalars['String']['input']>>;
  featureRapidsos: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  planId: Scalars['String']['input'];
};

/** The output of our `updatePlan` mutation. */
export type UpdatePlanPayload = {
  __typename?: 'UpdatePlanPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  /** An edge for our `Plan`. May be used by Relay 1. */
  planEdge?: Maybe<PlansEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updatePlan` mutation. */
export type UpdatePlanPayloadPlanEdgeArgs = {
  orderBy?: Array<PlansOrderBy>;
};

/** All input for the `updatePtcAccess` mutation. */
export type UpdatePtcAccessInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  readOnlyGroupId: Scalars['String']['input'];
  readWriteGroupId: Scalars['String']['input'];
};

/** The output of our `updatePtcAccess` mutation. */
export type UpdatePtcAccessPayload = {
  __typename?: 'UpdatePtcAccessPayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updatePtcNotifications` mutation. */
export type UpdatePtcNotificationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notifyAdministrator: Scalars['Boolean']['input'];
  notifyReadOnlyGroup: Scalars['Boolean']['input'];
  notifyReadWriteGroup: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};

/** The output of our `updatePtcNotifications` mutation. */
export type UpdatePtcNotificationsPayload = {
  __typename?: 'UpdatePtcNotificationsPayload';
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  checkInSupervisorGroup?: Maybe<Group>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  guardmeSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  incidentSupervisorGroup?: Maybe<Group>;
  /** Reads a single `Organization` that is related to this `OrganizationSetting`. */
  organization?: Maybe<Organization>;
  organizationSetting?: Maybe<OrganizationSetting>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadOnlyGroup?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `OrganizationSetting`. */
  ptcReadWriteGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateScheduledGuardme` mutation. */
export type UpdateScheduledGuardmeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  durationMinutes: Scalars['Int']['input'];
  id: Scalars['UUID']['input'];
  isEnabled: Scalars['Boolean']['input'];
  isOneshot: Scalars['Boolean']['input'];
  oneshotSchedule?: InputMaybe<Scalars['Datetime']['input']>;
  recurringSchedule?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** The output of our `updateScheduledGuardme` mutation. */
export type UpdateScheduledGuardmePayload = {
  __typename?: 'UpdateScheduledGuardmePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `ScheduledGuardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `ScheduledGuardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  scheduledGuardme?: Maybe<ScheduledGuardme>;
  /** An edge for our `ScheduledGuardme`. May be used by Relay 1. */
  scheduledGuardmeEdge?: Maybe<ScheduledGuardmesEdge>;
};


/** The output of our `updateScheduledGuardme` mutation. */
export type UpdateScheduledGuardmePayloadScheduledGuardmeEdgeArgs = {
  orderBy?: Array<ScheduledGuardmesOrderBy>;
};

/** All input for the `updateTimedGuardmeEndsAt` mutation. */
export type UpdateTimedGuardmeEndsAtInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['Datetime']['input'];
  memberId: Scalars['String']['input'];
};

/** The output of our `updateTimedGuardmeEndsAt` mutation. */
export type UpdateTimedGuardmeEndsAtPayload = {
  __typename?: 'UpdateTimedGuardmeEndsAtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  guardme?: Maybe<Guardme>;
  /** An edge for our `Guardme`. May be used by Relay 1. */
  guardmeEdge?: Maybe<GuardmesEdge>;
  /** Reads a single `Member` that is related to this `Guardme`. */
  member?: Maybe<Member>;
  /** Reads a single `Organization` that is related to this `Guardme`. */
  organization?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateTimedGuardmeEndsAt` mutation. */
export type UpdateTimedGuardmeEndsAtPayloadGuardmeEdgeArgs = {
  orderBy?: Array<GuardmesOrderBy>;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  patch: UserPatchRecordInput;
};

/** The output of our `updateUser` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `updateUser` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: Array<UsersOrderBy>;
};

/** A user who can log in to the application. */
export type User = Node & {
  __typename?: 'User';
  /** Reads and enables pagination through a set of `Guardme`. */
  activeGuardmes: GuardmesConnection;
  applicationRole: ApplicationRole;
  avatarType: AvatarType;
  avatarUrl: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  emailAddressAuth0Id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced. Use User.emailAddress */
  emailAddresses?: Maybe<EmailAddresses>;
  /** Reads and enables pagination through a set of `EmergencyContact`. */
  emergencyContacts: EmergencyContactsConnection;
  fullName: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Guardme`. */
  guardmes: GuardmesConnection;
  id: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Incident`. */
  incidents: IncidentsConnection;
  /** Reads and enables pagination through a set of `Invitation`. */
  invitations: InvitationsConnection;
  isEnabled: Scalars['Boolean']['output'];
  lastActiveAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `Member`. */
  members: MembersConnection;
  /** Reads and enables pagination through a set of `MembershipRequest`. */
  membershipRequests: MembershipRequestsConnection;
  /** Reads and enables pagination through a set of `Member`. */
  memberships: MembersConnection;
  metadata: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `MobileDevice`. */
  mobileDevices: MobileDevicesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Organization`. */
  organizations: OrganizationsConnection;
  pendingEmailAddress?: Maybe<Scalars['String']['output']>;
  pendingPhoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberAuth0Id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced. Use User.phoneNumbers */
  phoneNumbers?: Maybe<PhoneNumbers>;
  /** @deprecated Dropped. Use User.metadata */
  preferences: UserPreferences;
  primaryAuth0Id: Scalars['String']['output'];
  /** @deprecated Dropped. Use User.application_role */
  role: UserRoleObject;
  /** @deprecated Dropped. Use User.fullName */
  shortName: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `UserNotification`. */
  userNotifications: UserNotificationsConnection;
};


/** A user who can log in to the application. */
export type UserActiveGuardmesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GuardmeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A user who can log in to the application. */
export type UserEmergencyContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmergencyContactCondition>;
  filter?: InputMaybe<EmergencyContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmergencyContactsOrderBy>>;
};


/** A user who can log in to the application. */
export type UserGuardmesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GuardmeCondition>;
  filter?: InputMaybe<GuardmeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmesOrderBy>>;
};


/** A user who can log in to the application. */
export type UserIncidentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IncidentCondition>;
  filter?: InputMaybe<IncidentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy>>;
};


/** A user who can log in to the application. */
export type UserInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<InvitationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A user who can log in to the application. */
export type UserMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCondition>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembersOrderBy>>;
};


/** A user who can log in to the application. */
export type UserMembershipRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MembershipRequestCondition>;
  filter?: InputMaybe<MembershipRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MembershipRequestsOrderBy>>;
};


/** A user who can log in to the application. */
export type UserMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A user who can log in to the application. */
export type UserMobileDevicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MobileDeviceCondition>;
  filter?: InputMaybe<MobileDeviceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MobileDevicesOrderBy>>;
};


/** A user who can log in to the application. */
export type UserOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A user who can log in to the application. */
export type UserUserNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserNotificationCondition>;
  filter?: InputMaybe<UserNotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserNotificationsOrderBy>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `emailAddress` field. */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fullName` field. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Filter Users with fullName, phoneNumber, or emailAddress like the provided value. */
  identifierLike?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `primaryAuth0Id` field. */
  primaryAuth0Id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `timezone` field. */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UserEmailAddress = {
  __typename?: 'UserEmailAddress';
  emailAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `emailAddress` field. */
  emailAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emergencyContacts` relation. */
  emergencyContacts?: InputMaybe<UserToManyEmergencyContactFilter>;
  /** Some related `emergencyContacts` exist. */
  emergencyContactsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `members` relation. */
  members?: InputMaybe<UserToManyMemberFilter>;
  /** Some related `members` exist. */
  membersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `membershipRequests` relation. */
  membershipRequests?: InputMaybe<UserToManyMembershipRequestFilter>;
  /** Some related `membershipRequests` exist. */
  membershipRequestsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `mobileDevices` relation. */
  mobileDevices?: InputMaybe<UserToManyMobileDeviceFilter>;
  /** Some related `mobileDevices` exist. */
  mobileDevicesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `pendingEmailAddress` field. */
  pendingEmailAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `pendingPhoneNumber` field. */
  pendingPhoneNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `primaryAuth0Id` field. */
  primaryAuth0Id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `timezone` field. */
  timezone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userNotifications` relation. */
  userNotifications?: InputMaybe<UserToManyUserNotificationFilter>;
  /** Some related `userNotifications` exist. */
  userNotificationsExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** All input for the `userMemberIds` mutation. */
export type UserMemberIdsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** The output of our `userMemberIds` mutation. */
export type UserMemberIdsPayload = {
  __typename?: 'UserMemberIdsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  strings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserNotification = Node & {
  __typename?: 'UserNotification';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `UserNotification`. */
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  type: UserNotificationType;
  /** Reads a single `User` that is related to this `UserNotification`. */
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

/**
 * A condition to be used against `UserNotification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserNotificationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isRead` field. */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `UserNotification` object types. All fields are combined with a logical ‘and.’ */
export type UserNotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserNotificationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isRead` field. */
  isRead?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserNotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserNotificationFilter>>;
  /** Filter by the object’s `organization` relation. */
  organization?: InputMaybe<OrganizationFilter>;
  /** A related `organization` exists. */
  organizationExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
};

export enum UserNotificationReadFilter {
  All = 'ALL',
  ReadOnly = 'READ_ONLY',
  UnreadOnly = 'UNREAD_ONLY'
}

export enum UserNotificationType {
  Account = 'ACCOUNT',
  Group = 'GROUP',
  Guardme = 'GUARDME',
  GuardmeConcluded = 'GUARDME_CONCLUDED',
  GuardmeExpired = 'GUARDME_EXPIRED',
  GuardmePanic = 'GUARDME_PANIC',
  GuardmeStarted = 'GUARDME_STARTED',
  Invitation = 'INVITATION',
  MassNotification = 'MASS_NOTIFICATION',
  MembershipRequest = 'MEMBERSHIP_REQUEST',
  MemberAddedToGroup = 'MEMBER_ADDED_TO_GROUP',
  MemberAssignedRole = 'MEMBER_ASSIGNED_ROLE',
  MemberRemovedFromGroup = 'MEMBER_REMOVED_FROM_GROUP',
  Organization = 'ORGANIZATION',
  Task = 'TASK',
  UserAddedEmailAddress = 'USER_ADDED_EMAIL_ADDRESS',
  UserAddedPhoneNumber = 'USER_ADDED_PHONE_NUMBER',
  UserOrganizationInvitation = 'USER_ORGANIZATION_INVITATION',
  UserRemovedEmailAddress = 'USER_REMOVED_EMAIL_ADDRESS',
  UserRemovedPhoneNumber = 'USER_REMOVED_PHONE_NUMBER',
  UserWelcome = 'USER_WELCOME'
}

/** A connection to a list of `UserNotification` values. */
export type UserNotificationsConnection = {
  __typename?: 'UserNotificationsConnection';
  /** A list of edges which contains the `UserNotification` and cursor to aid in pagination. */
  edges: Array<UserNotificationsEdge>;
  /** A list of `UserNotification` objects. */
  nodes: Array<UserNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserNotification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserNotification` edge in the connection. */
export type UserNotificationsEdge = {
  __typename?: 'UserNotificationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserNotification` at the end of the edge. */
  node: UserNotification;
};

/** Methods to use when ordering `UserNotification`. */
export enum UserNotificationsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsReadAsc = 'IS_READ_ASC',
  IsReadDesc = 'IS_READ_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** An input for mutations affecting `UserPatchRecord` */
export type UserPatchRecordInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
};

export type UserPhoneNumber = {
  __typename?: 'UserPhoneNumber';
  id: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  defaultOrganizationId?: Maybe<Scalars['String']['output']>;
  isDarkmodeEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type UserRoleObject = {
  __typename?: 'UserRoleObject';
  name: Scalars['String']['output'];
  scopes: Array<Scalars['String']['output']>;
};

/** A filter to be used against many `EmergencyContact` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyEmergencyContactFilter = {
  /** Every related `EmergencyContact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmergencyContactFilter>;
  /** No related `EmergencyContact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmergencyContactFilter>;
  /** Some related `EmergencyContact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmergencyContactFilter>;
};

/** A filter to be used against many `Member` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyMemberFilter = {
  /** Every related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberFilter>;
  /** No related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberFilter>;
  /** Some related `Member` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberFilter>;
};

/** A filter to be used against many `MembershipRequest` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyMembershipRequestFilter = {
  /** Every related `MembershipRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembershipRequestFilter>;
  /** No related `MembershipRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembershipRequestFilter>;
  /** Some related `MembershipRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembershipRequestFilter>;
};

/** A filter to be used against many `MobileDevice` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyMobileDeviceFilter = {
  /** Every related `MobileDevice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MobileDeviceFilter>;
  /** No related `MobileDevice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MobileDeviceFilter>;
  /** Some related `MobileDevice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MobileDeviceFilter>;
};

/** A filter to be used against many `UserNotification` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserNotificationFilter = {
  /** Every related `UserNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserNotificationFilter>;
  /** No related `UserNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserNotificationFilter>;
  /** Some related `UserNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserNotificationFilter>;
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  EmailAddressAsc = 'EMAIL_ADDRESS_ASC',
  EmailAddressDesc = 'EMAIL_ADDRESS_DESC',
  FullNameAsc = 'FULL_NAME_ASC',
  FullNameDesc = 'FULL_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PhoneNumberAsc = 'PHONE_NUMBER_ASC',
  PhoneNumberDesc = 'PHONE_NUMBER_DESC',
  PrimaryAuth0IdAsc = 'PRIMARY_AUTH0_ID_ASC',
  PrimaryAuth0IdDesc = 'PRIMARY_AUTH0_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TimezoneAsc = 'TIMEZONE_ASC',
  TimezoneDesc = 'TIMEZONE_DESC'
}

export type VerifyEmailAddressInput = {
  emailAddress: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type VerifyEmailAddressPayload = {
  __typename?: 'VerifyEmailAddressPayload';
  currentUser?: Maybe<User>;
  pendingEmailAddress?: Maybe<PendingEmailAddress>;
  query?: Maybe<Query>;
};

export type VerifyPhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type VerifyPhoneNumberPayload = {
  __typename?: 'VerifyPhoneNumberPayload';
  currentUser?: Maybe<User>;
  pendingPhoneNumber?: Maybe<PendingPhoneNumber>;
  query?: Maybe<Query>;
};

export type UploadAttachmentInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  mimetype: Scalars['String']['input'];
};

export type UploadAttachmentPayload = {
  __typename?: 'uploadAttachmentPayload';
  fields: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  query?: Maybe<Query>;
  url: Scalars['String']['output'];
};

export type UploadAvatarInput = {
  mimetype: Scalars['String']['input'];
  /** Default is true, this will update User.avatarUrl silently once the file is uplaoded. */
  useWorkerTask?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UploadAvatarPayload = {
  __typename?: 'uploadAvatarPayload';
  fields: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  query?: Maybe<Query>;
  url: Scalars['String']['output'];
};

export type UploadGuardmeAttachmentInput = {
  guardmeId: Scalars['String']['input'];
  mimetype: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type UploadGuardmeAttachmentPayload = {
  __typename?: 'uploadGuardmeAttachmentPayload';
  fields: Scalars['JSON']['output'];
  key: Scalars['String']['output'];
  query?: Maybe<Query>;
  url: Scalars['String']['output'];
};

export type UploadIncidentAttachmentInput = {
  incidentId: Scalars['String']['input'];
  mimetype: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type UploadIncidentAttachmentPayload = {
  __typename?: 'uploadIncidentAttachmentPayload';
  fields: Scalars['JSON']['output'];
  key: Scalars['String']['output'];
  query?: Maybe<Query>;
  url: Scalars['String']['output'];
};

export type UploadOrganizationLogoInput = {
  mimetype: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  /** Default is true, this will update User.avatarUrl silently once the file is uplaoded. */
  useWorkerTask?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UploadOrganizationLogoPayload = {
  __typename?: 'uploadOrganizationLogoPayload';
  fields: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  query?: Maybe<Query>;
  url: Scalars['String']['output'];
};

export type AttachmentUploadGqlMutationVariables = Exact<{
  input: UploadAttachmentInput;
}>;


export type AttachmentUploadGqlMutation = { __typename?: 'Mutation', uploadAttachment?: { __typename?: 'uploadAttachmentPayload', id: string, fields: Record<string, MetadataField>, key: string, url: string } | null };

export type DeleteSubscriptionIntentQueryMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type DeleteSubscriptionIntentQueryMutation = { __typename?: 'Mutation', deleteOrganizationSubscriptionIntent?: { __typename?: 'DeleteOrganizationSubscriptionIntentPayload', status: boolean } | null };

export type CreateSubscriptionIntentQueryMutationVariables = Exact<{
  annual: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
  timezone: Scalars['String']['input'];
  subscriptionCount: Scalars['Int']['input'];
}>;


export type CreateSubscriptionIntentQueryMutation = { __typename?: 'Mutation', createOrganizationSubscriptionIntent?: { __typename?: 'CreateOrganizationSubscriptionIntentPayload', clientSecret: string, organizationId: string, subscriptionId: string, invoice: { __typename?: 'StripeInvoice', total: number } } | null };

export type PaymentStatusUserUpdateQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentStatusUserUpdateQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, memberships: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, organizationRole: MemberRole, organizationId: string, isGuardmeSupervisor?: boolean | null, isIncidentSupervisor?: boolean | null, isCheckInSupervisor?: boolean | null, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string }> }, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string } | null }> } } | null };

export type SelectPlansGqlQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectPlansGqlQuery = { __typename?: 'Query', basicPlan?: { __typename?: 'PlansConnection', nodes: Array<{ __typename?: 'Plan', id: string, marketingType?: PlanMarketingType | null, name: string, description: string, isExternalBilling: boolean, featureList: Array<string | null>, stripeMonthPriceId: string, stripeYearPriceId: string, stripeProductId: string, stripeMonthPrice?: { __typename?: 'StripePrice', id: string, unitAmount?: number | null } | null, stripeYearPrice?: { __typename?: 'StripePrice', id: string, unitAmount?: number | null } | null, stripeProduct?: { __typename?: 'StripeProduct', id: string } | null }> } | null, premiumPlan?: { __typename?: 'PlansConnection', nodes: Array<{ __typename?: 'Plan', id: string, marketingType?: PlanMarketingType | null, name: string, description: string, isExternalBilling: boolean, featureList: Array<string | null>, stripeMonthPriceId: string, stripeYearPriceId: string, stripeProductId: string, stripeMonthPrice?: { __typename?: 'StripePrice', id: string, unitAmount?: number | null } | null, stripeYearPrice?: { __typename?: 'StripePrice', id: string, unitAmount?: number | null } | null, stripeProduct?: { __typename?: 'StripeProduct', id: string } | null }> } | null };

export type ResendPendingEmailAddressCodeGqlMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
}>;


export type ResendPendingEmailAddressCodeGqlMutation = { __typename?: 'Mutation', currentUserUpdateEmailAddress?: { __typename?: 'CurrentUserUpdateEmailAddressPayload', query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, pendingEmailAddress?: string | null } | null } | null } | null };

export type DeletePendingEmailAddressGqlMutationVariables = Exact<{ [key: string]: never; }>;


export type DeletePendingEmailAddressGqlMutation = { __typename?: 'Mutation', currentUserDeletePendingEmailAddress?: { __typename?: 'CurrentUserDeletePendingEmailAddressPayload', query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, pendingEmailAddress?: string | null } | null } | null } | null };

export type ResendPendingPhoneNumberCodeGqlMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type ResendPendingPhoneNumberCodeGqlMutation = { __typename?: 'Mutation', currentUserUpdatePhoneNumber?: { __typename?: 'CurrentUserUpdatePhoneNumberPayload', query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, pendingPhoneNumber?: string | null } | null } | null } | null };

export type DeletePendingPhoneNumberGqlMutationVariables = Exact<{ [key: string]: never; }>;


export type DeletePendingPhoneNumberGqlMutation = { __typename?: 'Mutation', currentUserDeletePendingPhoneNumber?: { __typename?: 'CurrentUserDeletePendingPhoneNumberPayload', query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, pendingPhoneNumber?: string | null } | null } | null } | null };

export type AccountNotificationsPageGqlQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type AccountNotificationsPageGqlQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, userNotifications: { __typename?: 'UserNotificationsConnection', totalCount: number, nodes: Array<{ __typename?: 'UserNotification', id: string, type: UserNotificationType, isRead: boolean, metadata: Record<string, MetadataField>, createdAt: string, organizationId?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | null } } } | null };

export type VerifyCurrentUserEmailAddressMutationVariables = Exact<{
  input: VerifyEmailAddressInput;
}>;


export type VerifyCurrentUserEmailAddressMutation = { __typename?: 'Mutation', verifyEmailAddress?: { __typename?: 'VerifyEmailAddressPayload', query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, emailAddress?: string | null, pendingEmailAddress?: string | null } | null } | null } | null };

export type VerifyPendingPhonenumberMutationVariables = Exact<{
  input: VerifyPhoneNumberInput;
}>;


export type VerifyPendingPhonenumberMutation = { __typename?: 'Mutation', verifyPhoneNumber?: { __typename?: 'VerifyPhoneNumberPayload', query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, phoneNumber?: string | null, pendingPhoneNumber?: string | null } | null } | null } | null };

export type Accept_Invitation_MutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Accept_Invitation_MutationMutation = { __typename?: 'Mutation', acceptInvitation?: { __typename?: 'AcceptInvitationPayload', query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, memberships: { __typename?: 'MembersConnection', totalCount: number, nodes: Array<{ __typename?: 'Member', id: string, organizationRole: MemberRole, createdAt: string, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string } | null }> }, invitations: { __typename?: 'InvitationsConnection', totalCount: number, nodes: Array<{ __typename?: 'Invitation', id: string, key: string, organizationRole: MemberRole, organizationName?: string | null, organization?: { __typename?: 'Organization', id: string, logoUrl: string } | null }> } } | null } | null } | null };

export type Acknowledge_Notification_MutationMutationVariables = Exact<{
  notificationIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type Acknowledge_Notification_MutationMutation = { __typename?: 'Mutation', acknowledgeUserNotifications?: { __typename?: 'AcknowledgeUserNotificationsPayload', userNotifications?: Array<{ __typename?: 'UserNotification', id: string, isRead: boolean }> | null, query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, userNotifications: { __typename?: 'UserNotificationsConnection', totalCount: number } } | null } | null } | null };

export type Cancel_Membership_Request_MutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Cancel_Membership_Request_MutationMutation = { __typename?: 'Mutation', cancelMembershipRequest?: { __typename?: 'CancelMembershipRequestPayload', query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, membershipRequests: { __typename?: 'MembershipRequestsConnection', totalCount: number, nodes: Array<{ __typename?: 'MembershipRequest', id: string, organizationName?: string | null, organizationId: string }> } } | null } | null } | null };

export type Current_User_Close_Account_MutationMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type Current_User_Close_Account_MutationMutation = { __typename?: 'Mutation', currentUserCloseAccount?: { __typename?: 'CurrentUserCloseAccountPayload', user?: { __typename?: 'User', id: string } | null } | null };

export type Current_User_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Current_User_QueryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, fullName: string, avatarUrl: string, applicationRole: ApplicationRole, metadata: Record<string, MetadataField>, emailAddress?: string | null, phoneNumber?: string | null, timezone: string, userNotifications: { __typename?: 'UserNotificationsConnection', totalCount: number }, memberships: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, organizationRole: MemberRole, organizationId: string, isGuardmeSupervisor?: boolean | null, isIncidentSupervisor?: boolean | null, isCheckInSupervisor?: boolean | null, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string }> }, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string, timezone: string, defaultMapZoom: number, plan?: { __typename?: 'Plan', id: string, name: string } | null, defaultMapCenter: { __typename?: 'GeographyPoint', latitude: number, longitude: number } } | null }> } } | null };

export type Current_User_Updates_SubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type Current_User_Updates_SubscriptionSubscription = { __typename?: 'Subscription', currentUserUpdates?: { __typename?: 'CurrentUserUpdatesPayload', event?: string | null, relatedIds?: Array<string> | null, user?: { __typename?: 'User', id: string, fullName: string, emailAddress?: string | null, pendingEmailAddress?: string | null, phoneNumber?: string | null, pendingPhoneNumber?: string | null, applicationRole: ApplicationRole, avatarUrl: string, metadata: Record<string, MetadataField>, memberships: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, organizationId: string, organizationRole: MemberRole, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string } | null }> } } | null } | null };

export type Delete_Notification_MutationMutationVariables = Exact<{
  notificationIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type Delete_Notification_MutationMutation = { __typename?: 'Mutation', deleteUserNotifications?: { __typename?: 'DeleteUserNotificationsPayload', query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, userNotifications: { __typename?: 'UserNotificationsConnection', totalCount: number } } | null } | null } | null };

export type Membership_Request_Discover_MutationMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type Membership_Request_Discover_MutationMutation = { __typename?: 'Mutation', membershipRequestDiscover?: { __typename?: 'MembershipRequestDiscoverPayload', membershipRequestDiscoverResult?: { __typename?: 'MembershipRequestDiscoverResult', code?: string | null, organizationId?: string | null, organizationLogoUrl?: string | null, organizationName?: string | null, publicMetadataFields?: Record<string, MetadataField> | null } | null } | null };

export type Membership_Request_Submit_MutationMutationVariables = Exact<{
  code: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
}>;


export type Membership_Request_Submit_MutationMutation = { __typename?: 'Mutation', membershipRequestSubmit?: { __typename?: 'MembershipRequestSubmitPayload', membershipRequest?: { __typename?: 'MembershipRequest', id: string, organizationName?: string | null, createdAt: string, updatedAt: string } | null, query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', membershipRequests: { __typename?: 'MembershipRequestsConnection', totalCount: number, nodes: Array<{ __typename?: 'MembershipRequest', id: string, organizationName?: string | null, createdAt: string, updatedAt: string }> } } | null } | null } | null };

export type Update_Current_User_MutationMutationVariables = Exact<{
  input: CurrentUserUpdateDetailsInput;
}>;


export type Update_Current_User_MutationMutation = { __typename?: 'Mutation', currentUserUpdateDetails?: { __typename?: 'CurrentUserUpdateDetailsPayload', user?: { __typename?: 'User', id: string, fullName: string, timezone: string, avatarType: AvatarType, avatarUrl: string } | null } | null };

export type Update_Email_Address_MutationMutationVariables = Exact<{
  input: CurrentUserUpdateEmailAddressInput;
}>;


export type Update_Email_Address_MutationMutation = { __typename?: 'Mutation', currentUserUpdateEmailAddress?: { __typename?: 'CurrentUserUpdateEmailAddressPayload', pendingEmailAddress?: { __typename?: 'PendingEmailAddress', id?: string | null, userId?: string | null, emailAddress?: string | null } | null, query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, pendingEmailAddress?: string | null } | null } | null } | null };

export type Update_Phone_Number_MutationMutationVariables = Exact<{
  input: CurrentUserUpdatePhoneNumberInput;
}>;


export type Update_Phone_Number_MutationMutation = { __typename?: 'Mutation', currentUserUpdatePhoneNumber?: { __typename?: 'CurrentUserUpdatePhoneNumberPayload', pendingPhoneNumber?: { __typename?: 'PendingPhoneNumber', id?: string | null, userId?: string | null, phoneNumber?: string | null } | null, query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, pendingPhoneNumber?: string | null } | null } | null } | null };

export type Upload_Avatar_MutationMutationVariables = Exact<{
  input: UploadAvatarInput;
}>;


export type Upload_Avatar_MutationMutation = { __typename?: 'Mutation', uploadAvatar?: { __typename?: 'uploadAvatarPayload', id: string, fields: Record<string, MetadataField>, key: string, url: string } | null };

export type User_Debug_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type User_Debug_QueryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, mobileDevices: { __typename?: 'MobileDevicesConnection', nodes: Array<{ __typename?: 'MobileDevice', id: string, deviceToken: string, deviceModel: string, deviceType: MobileDeviceType, deviceOsVersion: string, operationalStatus?: string | null }> } } | null };

export type User_Membership_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type User_Membership_QueryQuery = { __typename?: 'Query', currentUser?: (
    { __typename?: 'User', id: string, memberships: { __typename?: 'MembersConnection', totalCount: number, nodes: Array<{ __typename?: 'Member', createdAt: string, id: string, organizationRole: MemberRole, organization?: { __typename?: 'Organization', id: string, logoUrl: string, name: string } | null }> }, invitations: { __typename?: 'InvitationsConnection', totalCount: number, nodes: Array<{ __typename?: 'Invitation', id: string, key: string, organizationRole: MemberRole, organizationName?: string | null, organization?: { __typename?: 'Organization', id: string, logoUrl: string } | null }> }, membershipRequests: { __typename?: 'MembershipRequestsConnection', totalCount: number, nodes: Array<{ __typename?: 'MembershipRequest', id: string, organizationName?: string | null, organizationId: string, createdAt: string }> } }
    & { ' $fragmentRefs'?: { 'User_Memberships_FragmentFragment': User_Memberships_FragmentFragment } }
  ) | null };

export type User_Memberships_FragmentFragment = { __typename?: 'User', memberships: { __typename?: 'MembersConnection', totalCount: number, nodes: Array<{ __typename?: 'Member', createdAt: string, id: string, organizationRole: MemberRole, organization?: { __typename?: 'Organization', id: string, logoUrl: string, name: string } | null }> }, invitations: { __typename?: 'InvitationsConnection', totalCount: number, nodes: Array<{ __typename?: 'Invitation', id: string, key: string, organizationRole: MemberRole, organizationName?: string | null, organization?: { __typename?: 'Organization', id: string, logoUrl: string } | null }> }, membershipRequests: { __typename?: 'MembershipRequestsConnection', totalCount: number, nodes: Array<{ __typename?: 'MembershipRequest', id: string, organizationName?: string | null, organizationId: string, createdAt: string }> } } & { ' $fragmentName'?: 'User_Memberships_FragmentFragment' };

export type User_Notifications_QueryQueryVariables = Exact<{
  first: Scalars['Int']['input'];
}>;


export type User_Notifications_QueryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, invitations: { __typename?: 'InvitationsConnection', totalCount: number }, userNotifications: { __typename?: 'UserNotificationsConnection', totalCount: number, nodes: Array<{ __typename?: 'UserNotification', id: string, type: UserNotificationType, isRead: boolean, metadata: Record<string, MetadataField>, createdAt: string, organizationId?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | null } } } | null };

export type User_Profile_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type User_Profile_QueryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, applicationRole: ApplicationRole, timezone: string, fullName: string, avatarUrl: string, avatarType: AvatarType, metadata: Record<string, MetadataField>, createdAt: string, emailAddress?: string | null, pendingEmailAddress?: string | null, phoneNumber?: string | null, pendingPhoneNumber?: string | null } | null };

export type Check_In_Report_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Check_In_Report_QueryQuery = { __typename?: 'Query', checkInReport?: (
    { __typename?: 'CheckInReport', id: string, organizationId: string, shortId: string, createdAt: string }
    & { ' $fragmentRefs'?: { 'Check_In_Report_Requestor_FragmentFragment': Check_In_Report_Requestor_FragmentFragment;'Check_In_Report_Map_FragmentFragment': Check_In_Report_Map_FragmentFragment;'Check_In_Report_Restrictions_FragmentFragment': Check_In_Report_Restrictions_FragmentFragment;'Check_In_Report_Requests_FragmentFragment': Check_In_Report_Requests_FragmentFragment } }
  ) | null };

export type Check_In_Report_Requestor_FragmentFragment = { __typename?: 'CheckInReport', id: string, organizationId: string, requestorMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null } & { ' $fragmentName'?: 'Check_In_Report_Requestor_FragmentFragment' };

export type Check_In_Report_Map_FragmentFragment = { __typename?: 'CheckInReport', id: string, organizationId: string, shortId: string, cutoffAt?: string | null, placeId?: string | null, place?: { __typename?: 'Place', id: string, name: string, description: string, radius: number, spatialData:
      | { __typename?: 'GeographyLineString', geojson?: any | null }
      | { __typename?: 'GeographyPoint', geojson?: any | null }
      | { __typename?: 'GeographyPolygon', geojson?: any | null }
     } | null, organization?: { __typename?: 'Organization', defaultMapZoom: number, defaultMapCenter: { __typename?: 'GeographyPoint', latitude: number, longitude: number } } | null, checkInRequests: { __typename?: 'CheckInRequestsConnection', totalCount: number, nodes: Array<{ __typename?: 'CheckInRequest', id: string, checkInId?: string | null, checkIn?: { __typename?: 'CheckIn', id: string, shortId: string, createdAt: string, coordinates: { __typename?: 'GeometryPoint', x: number, y: number } } | null, member?: { __typename?: 'Member', id: string, displayName?: string | null, fullName: string, avatarUrl?: string | null } | null }> } } & { ' $fragmentName'?: 'Check_In_Report_Map_FragmentFragment' };

export type Check_In_Report_Restrictions_FragmentFragment = { __typename?: 'CheckInReport', id: string, organizationId: string, cutoffAt?: string | null, placeId?: string | null, place?: { __typename?: 'Place', id: string, name: string, center: { __typename?: 'GeographyPoint', latitude: number, longitude: number } } | null } & { ' $fragmentName'?: 'Check_In_Report_Restrictions_FragmentFragment' };

export type Check_In_Report_Requests_FragmentFragment = { __typename?: 'CheckInReport', id: string, organizationId: string, cutoffAt?: string | null, checkInRequests: { __typename?: 'CheckInRequestsConnection', totalCount: number, nodes: Array<{ __typename?: 'CheckInRequest', id: string, checkInId?: string | null, checkIn?: { __typename?: 'CheckIn', id: string, shortId: string, createdAt: string, coordinates: { __typename?: 'GeometryPoint', x: number, y: number } } | null, member?: { __typename?: 'Member', id: string, displayName?: string | null, fullName: string, avatarUrl?: string | null } | null }> } } & { ' $fragmentName'?: 'Check_In_Report_Requests_FragmentFragment' };

export type Check_In_Report_Updates_SubscriptionSubscriptionVariables = Exact<{
  input: CheckInReportUpdatesInput;
}>;


export type Check_In_Report_Updates_SubscriptionSubscription = { __typename?: 'Subscription', checkInReportUpdates?: { __typename?: 'CheckInReportUpdatesPayload', event?: GraphqlCheckInReportUpdateEvent | null, relatedIds?: Array<string> | null, checkInReport?: { __typename?: 'CheckInReport', id: string, shortId: string, createdAt: string, cutoffAt?: string | null, organization?: { __typename?: 'Organization', id: string, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string, radius: number, spatialData:
              | { __typename?: 'GeographyLineString', geojson?: any | null }
              | { __typename?: 'GeographyPoint', geojson?: any | null }
              | { __typename?: 'GeographyPolygon', geojson?: any | null }
             }> } } | null, place?: { __typename?: 'Place', id: string, name: string, description: string } | null, requestorMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, checkInRequests: { __typename?: 'CheckInRequestsConnection', totalCount: number, nodes: Array<{ __typename?: 'CheckInRequest', id: string, checkInId?: string | null, checkIn?: { __typename?: 'CheckIn', id: string, shortId: string, createdAt: string, coordinates: { __typename?: 'GeometryPoint', x: number, y: number } } | null, member?: { __typename?: 'Member', id: string, displayName?: string | null, fullName: string, avatarUrl?: string | null } | null }> } } | null } | null };

export type Check_In_Reports_QueryQueryVariables = Exact<{
  createdAt?: InputMaybe<CheckInReportsCreatedAtConditionInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInReportsOrderBy> | CheckInReportsOrderBy>;
  organizationId: Scalars['String']['input'];
  requestorMemberId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type Check_In_Reports_QueryQuery = { __typename?: 'Query', checkInReports?: { __typename?: 'CheckInReportsConnection', totalCount: number, edges: Array<{ __typename?: 'CheckInReportsEdge', node: { __typename?: 'CheckInReport', id: string, organizationId: string, shortId: string, createdAt: string, cutoffAt?: string | null, requestorMemberId: string, placeId?: string | null, requestorMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null, lastActiveAt?: string | null } | null, checkInRequests: { __typename?: 'CheckInRequestsConnection', totalCount: number }, place?: { __typename?: 'Place', id: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean } } | null };

export type Create_Check_In_Report_MutationMutationVariables = Exact<{
  input: CreateCheckInReportInput;
}>;


export type Create_Check_In_Report_MutationMutation = { __typename?: 'Mutation', createCheckInReport?: { __typename?: 'CreateCheckInReportPayload', checkInReport?: { __typename?: 'CheckInReport', id: string, createdAt: string, cutoffAt?: string | null, placeId?: string | null, requestorMember?: { __typename?: 'Member', id: string, displayName?: string | null, fullName: string, avatarUrl?: string | null } | null, place?: { __typename?: 'Place', id: string, name: string, description: string } | null } | null } | null };

export type Check_In_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Check_In_QueryQuery = { __typename?: 'Query', checkIn?: (
    { __typename?: 'CheckIn', id: string, organizationId: string, shortId: string, createdAt: string, memberId: string, member?: (
      { __typename?: 'Member', id: string }
      & { ' $fragmentRefs'?: { 'Check_In_Member_Details_FragmentFragment': Check_In_Member_Details_FragmentFragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'Check_In_Location_Details_FragmentFragment': Check_In_Location_Details_FragmentFragment;'Check_In_Map_FragmentFragment': Check_In_Map_FragmentFragment } }
  ) | null };

export type Check_In_Member_Details_FragmentFragment = { __typename?: 'Member', id: string, organizationId: string, fullName: string, displayName?: string | null, timezone: string, avatarUrl?: string | null, phoneNumber?: string | null, emailAddress?: string | null, metadata?: Record<string, MetadataField> | null, lastActiveAt?: string | null, organization?: { __typename?: 'Organization', id: string, memberMetadataFields: Record<string, MetadataField> } | null } & { ' $fragmentName'?: 'Check_In_Member_Details_FragmentFragment' };

export type Check_In_Location_Details_FragmentFragment = { __typename?: 'CheckIn', id: string, organizationId: string, coordinates: { __typename?: 'GeometryPoint', x: number, y: number }, geocode?: { __typename?: 'CheckInGeocode', id: string, address: string, plusCode: string } | null, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string, radius: number, spatialData:
        | { __typename?: 'GeographyLineString', geojson?: any | null }
        | { __typename?: 'GeographyPoint', geojson?: any | null }
        | { __typename?: 'GeographyPolygon', geojson?: any | null }
      , center: { __typename?: 'GeographyPoint', longitude: number, latitude: number } }> }, organization?: { __typename?: 'Organization', id: string, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string, radius: number, spatialData:
          | { __typename?: 'GeographyLineString', geojson?: any | null }
          | { __typename?: 'GeographyPoint', geojson?: any | null }
          | { __typename?: 'GeographyPolygon', geojson?: any | null }
        , center: { __typename?: 'GeographyPoint', longitude: number, latitude: number } }> } } | null } & { ' $fragmentName'?: 'Check_In_Location_Details_FragmentFragment' };

export type Check_In_Map_FragmentFragment = { __typename?: 'CheckIn', id: string, organizationId: string, coordinates: { __typename?: 'GeometryPoint', x: number, y: number }, member?: { __typename?: 'Member', id: string, avatarUrl?: string | null, displayName?: string | null, fullName: string } | null, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string, radius: number, center: { __typename?: 'GeographyPoint', latitude: number, longitude: number }, spatialData:
        | { __typename?: 'GeographyLineString', geojson?: any | null }
        | { __typename?: 'GeographyPoint', geojson?: any | null }
        | { __typename?: 'GeographyPolygon', geojson?: any | null }
       }> } } & { ' $fragmentName'?: 'Check_In_Map_FragmentFragment' };

export type Check_In_Updates_SubscriptionSubscriptionVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Check_In_Updates_SubscriptionSubscription = { __typename?: 'Subscription', checkInUpdates?: { __typename?: 'CheckInUpdatesPayload', event?: GraphqlCheckInEvent | null, relatedIds?: Array<string> | null, checkIn?: { __typename?: 'CheckIn', id: string, shortId: string, createdAt: string, organizationId: string, coordinates: { __typename?: 'GeometryPoint', x: number, y: number }, member?: { __typename?: 'Member', id: string, displayName?: string | null, fullName: string, avatarUrl?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string } | null } | null } | null };

export type Check_Ins_QueryQueryVariables = Exact<{
  createdAt?: InputMaybe<CheckInsCreatedAtConditionInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CheckInsOrderBy> | CheckInsOrderBy>;
  organizationId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type Check_Ins_QueryQuery = { __typename?: 'Query', checkIns?: { __typename?: 'CheckInsConnection', totalCount: number, edges: Array<{ __typename?: 'CheckInsEdge', node: { __typename?: 'CheckIn', id: string, organizationId: string, shortId: string, createdAt: string, memberId: string, member?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string, radius: number, spatialData:
              | { __typename?: 'GeographyLineString', geojson?: any | null }
              | { __typename?: 'GeographyPoint', geojson?: any | null }
              | { __typename?: 'GeographyPolygon', geojson?: any | null }
            , center: { __typename?: 'GeographyPoint', longitude: number, latitude: number } }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type NavOrganizationGqlQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type NavOrganizationGqlQuery = { __typename?: 'Query', activeGuardmes?: { __typename?: 'GuardmesConnection', nodes: Array<{ __typename?: 'Guardme', id: string, status: GuardmeStatus }> } | null };

export type NotificationsMenuItemGqlQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsMenuItemGqlQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, userNotifications: { __typename?: 'UserNotificationsConnection', totalCount: number }, invitations: { __typename?: 'InvitationsConnection', totalCount: number } } | null };

export type PendingInvitationsCalloutGqlQueryVariables = Exact<{ [key: string]: never; }>;


export type PendingInvitationsCalloutGqlQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, invitations: { __typename?: 'InvitationsConnection', totalCount: number } } | null };

export type Dashboard_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Dashboard_QueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, organizationMetric?: { __typename?: 'OrganizationMetric', guardmesActive: number, incidentsActive: number } | null } | null };

export type Guardme_Dashboard_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Guardme_Dashboard_QueryQuery = { __typename?: 'Query', activeGuardmes?: { __typename?: 'GuardmesConnection', nodes: Array<{ __typename?: 'Guardme', id: string, organizationId: string, shortId: string, memberId: string, status: GuardmeStatus, createdAt: string, endsAt: string, updatedAt: string, batteryLevel?: number | null, totalAttachments?: number | null, member?: { __typename?: 'Member', id: string, organizationId: string, avatarUrl?: string | null, displayName?: string | null, fullName: string, phoneNumber?: string | null, emailAddress?: string | null, organizationRole: MemberRole } | null }> } | null };

export type Incidents_Dashboard_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Incidents_Dashboard_QueryQuery = { __typename?: 'Query', incidents?: { __typename?: 'IncidentsConnection', nodes: Array<{ __typename?: 'Incident', id: string, organizationId: string, shortId: string, subject: string, priority: IncidentPriorityType, contactMemberId: string, incidentTypeId: string, status: IncidentStatusType, updatedAt: string, ownedByGroupId?: string | null, ownedByMemberId?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string } | null, contactMember?: { __typename?: 'Member', id: string, organizationId: string, fullName: string, displayName?: string | null, avatarUrl?: string | null, lastActiveAt?: string | null, organizationRole: MemberRole, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, organizationId: string, name: string }> } } | null, incidentType?: { __typename?: 'IncidentType', id: string, name: string, iconSvg: string } | null, ownedByGroup?: { __typename?: 'Group', id: string, organizationId: string, name: string, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, organizationId: string, fullName: string, displayName?: string | null, avatarUrl?: string | null, lastActiveAt?: string | null }> } } | null, ownedByMember?: { __typename?: 'Member', id: string, organizationId: string, fullName: string, displayName?: string | null, avatarUrl?: string | null, lastActiveAt?: string | null, organizationRole: MemberRole, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, organizationId: string, name: string }> } } | null }> } | null };

export type Overview_Dashboard_QueryQueryVariables = Exact<{
  organizationId?: Scalars['String']['input'];
  days: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
}>;


export type Overview_Dashboard_QueryQuery = { __typename?: 'Query', organization?: (
    { __typename?: 'Organization', id: string, organizationMetric?: { __typename?: 'OrganizationMetric', checkInsGraph?: Array<{ __typename?: 'TimeSeries', date?: string | null, count?: any | null } | null> | null, guardmesGraph?: Array<{ __typename?: 'TimeSeries', date?: string | null, count?: any | null } | null> | null, incidentsGraph?: Array<{ __typename?: 'TimeSeries', date?: string | null, count?: any | null } | null> | null } | null }
    & { ' $fragmentRefs'?: { 'Incidents_Breakdown_FragmentFragment': Incidents_Breakdown_FragmentFragment;'Members_Breakdown_FrragmentFragment': Members_Breakdown_FrragmentFragment } }
  ) | null };

export type Incidents_Breakdown_FragmentFragment = { __typename?: 'Organization', id: string, organizationMetric?: { __typename?: 'OrganizationMetric', incidentsActive: number, incidentsOpen: number, incidentsInProgress: number, incidentsActiveHigh: number, incidentsActiveLow: number, incidentsActiveMedium: number, incidentsActiveUrgent: number } | null } & { ' $fragmentName'?: 'Incidents_Breakdown_FragmentFragment' };

export type Members_Breakdown_FrragmentFragment = { __typename?: 'Organization', id: string, organizationMetric?: { __typename?: 'OrganizationMetric', invitations: number, members: number, membershipRequests: number } | null } & { ' $fragmentName'?: 'Members_Breakdown_FrragmentFragment' };

export type Recent_Activity_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  createdAt_gte: Scalars['Datetime']['input'];
}>;


export type Recent_Activity_QueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, organizationMetric?: { __typename?: 'OrganizationMetric', incidentsActiveUrgent: number, guardmesInPanic: number, guardmesExpired: number } | null } | null, incidents?: { __typename?: 'IncidentsConnection', nodes: Array<{ __typename?: 'Incident', id: string, shortId: string, status: IncidentStatusType, priority: IncidentPriorityType, createdAt: string, incidentType?: { __typename?: 'IncidentType', id: string, iconSvg: string } | null, contactMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, incidentCoordinates: { __typename?: 'GeometryPoint', x: number, y: number } }> } | null, guardmes?: { __typename?: 'GuardmesConnection', nodes: Array<{ __typename?: 'Guardme', id: string, shortId: string, status: GuardmeStatus, createdAt: string, member?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, lastLocation?: { __typename?: 'GuardmeLocation', coordinates: { __typename?: 'GeometryPoint', x: number, y: number } } | null }> } | null, checkIns?: { __typename?: 'CheckInsConnection', nodes: Array<{ __typename?: 'CheckIn', id: string, shortId: string, createdAt: string, member?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, coordinates: { __typename?: 'GeometryPoint', x: number, y: number } }> } | null };

export type Reports_Dashboard_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  createdAtGte: Scalars['Datetime']['input'];
  createdAtLte: Scalars['Datetime']['input'];
}>;


export type Reports_Dashboard_QueryQuery = { __typename?: 'Query', organization?: (
    { __typename?: 'Organization', id: string, name: string, logoUrl: string }
    & { ' $fragmentRefs'?: { 'Check_In_Report_FragementFragment': Check_In_Report_FragementFragment;'Guard_Me_Report_FragmentFragment': Guard_Me_Report_FragmentFragment;'Incident_Report_FragmentFragment': Incident_Report_FragmentFragment } }
  ) | null };

export type Check_In_Report_FragementFragment = { __typename?: 'Organization', checkIns: { __typename?: 'CheckInsConnection', nodes: Array<{ __typename?: 'CheckIn', id: string, organizationId: string, shortId: string, createdAt: string, member?: { __typename?: 'Member', id: string, avatarUrl?: string | null, displayName?: string | null, fullName: string, lastActiveAt?: string | null, organizationRole: MemberRole, organizationId: string } | null }> } } & { ' $fragmentName'?: 'Check_In_Report_FragementFragment' };

export type Guard_Me_Report_FragmentFragment = { __typename?: 'Organization', guardmes: { __typename?: 'GuardmesConnection', nodes: Array<{ __typename?: 'Guardme', id: string, organizationId: string, shortId: string, createdAt: string, endsAt: string, status: GuardmeStatus, member?: { __typename?: 'Member', id: string, avatarUrl?: string | null, displayName?: string | null, fullName: string, lastActiveAt?: string | null, organizationRole: MemberRole, organizationId: string } | null }> } } & { ' $fragmentName'?: 'Guard_Me_Report_FragmentFragment' };

export type Incident_Report_FragmentFragment = { __typename?: 'Organization', incidents: { __typename?: 'IncidentsConnection', nodes: Array<{ __typename?: 'Incident', id: string, organizationId: string, shortId: string, subject: string, description: string, createdAt: string, resolutionAt?: string | null, firstResponseAt?: string | null, contactMember?: { __typename?: 'Member', id: string, organizationId: string, avatarUrl?: string | null, displayName?: string | null, fullName: string, lastActiveAt?: string | null, organizationRole: MemberRole } | null, incidentUpdates: { __typename?: 'IncidentUpdatesConnection', nodes: Array<{ __typename?: 'IncidentUpdate', id: string, organizationId: string, type: IncidentUpdateTypeType, updatedValue?: Record<string, MetadataField> | null, performedByMember?: { __typename?: 'Member', id: string, organizationId: string, avatarUrl?: string | null, displayName?: string | null, fullName: string, lastActiveAt?: string | null, organizationRole: MemberRole } | null }> } }> } } & { ' $fragmentName'?: 'Incident_Report_FragmentFragment' };

export type GuardmeAttachmenGqlQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GuardmeAttachmenGqlQuery = { __typename?: 'Query', guardmeAttachment?: { __typename?: 'GuardmeAttachment', id: string, comment: string, createdAt: string, attachments: { __typename?: 'AttachmentsConnection', nodes: Array<{ __typename?: 'Attachment', id: string, url?: string | null, mimetype: string, createdAt: string }> } } | null };

export type GuardMeAttachmentsGqlQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GuardMeAttachmentsGqlQuery = { __typename?: 'Query', guardme?: { __typename?: 'Guardme', id: string, guardmeAttachments: { __typename?: 'GuardmeAttachmentsConnection', nodes: Array<{ __typename?: 'GuardmeAttachment', id: string, createdAt: string, attachments: { __typename?: 'AttachmentsConnection', totalCount: number } }> }, livestreams: { __typename?: 'LivestreamsConnection', nodes: Array<{ __typename?: 'Livestream', id: string, createdAt: string }> } } | null };

export type GuardMeAuditLogQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GuardMeAuditLogQuery = { __typename?: 'Query', guardme?: { __typename?: 'Guardme', id: string, memberId: string, member?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null } | null, guardmeAuditLogs: { __typename?: 'GuardmeAuditLogsConnection', nodes: Array<{ __typename?: 'GuardmeAuditLog', id: string, type: string, details: Record<string, MetadataField>, performedById?: string | null, createdAt: string, performedBy?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null } | null }> } } | null };

export type GuardMeConcludeMutationVariables = Exact<{
  guardmeId: Scalars['String']['input'];
}>;


export type GuardMeConcludeMutation = { __typename?: 'Mutation', endGuardme?: { __typename?: 'EndGuardmePayload', guardme?: { __typename?: 'Guardme', id: string, completedAt?: string | null, endsAt: string, isActive?: boolean | null, isExpired?: boolean | null, isSafe: boolean, updatedAt: string } | null } | null };

export type GuardMeExtendDialogGqlMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
  endsAt: Scalars['Datetime']['input'];
}>;


export type GuardMeExtendDialogGqlMutation = { __typename?: 'Mutation', updateTimedGuardmeEndsAt?: { __typename?: 'UpdateTimedGuardmeEndsAtPayload', guardme?: { __typename?: 'Guardme', id: string, endsAt: string, updatedAt: string } | null } | null };

export type GuardMePanicAsAdminMutationVariables = Exact<{
  guardmeId: Scalars['String']['input'];
  useOperatorFlow: Scalars['Boolean']['input'];
  operatorPhoneNumber: Scalars['String']['input'];
}>;


export type GuardMePanicAsAdminMutation = { __typename?: 'Mutation', updateGuardmePanicAsAdmin?: { __typename?: 'UpdateGuardmePanicAsAdminPayload', guardme?: { __typename?: 'Guardme', id: string, endsAt: string, isExpired?: boolean | null, isSafe: boolean, updatedAt: string } | null } | null };

export type GuardMeActionsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GuardMeActionsQuery = { __typename?: 'Query', guardme?: { __typename?: 'Guardme', id: string, endsAt: string, isActive?: boolean | null, isSafe: boolean, isExpired?: boolean | null, memberId: string, organization?: { __typename?: 'Organization', id: string, settingIsRapidsosPanicButtonFlowEnabled: boolean, settingIsRapidsosOperatorFlowEnabled: boolean, settingRapidsosSocPhoneNumber: string } | null } | null };

export type Guardme_Livestream_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Guardme_Livestream_QueryQuery = { __typename?: 'Query', livestream?: { __typename?: 'Livestream', id: string, status: LivestreamStatus, streamingUrl?: string | null, url?: string | null, createdAt: string } | null };

export type Guardme_Audit_Log_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Guardme_Audit_Log_QueryQuery = { __typename?: 'Query', guardme?: { __typename?: 'Guardme', id: string, organizationId: string, memberId: string, member?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null } | null, guardmeAuditLogs: { __typename?: 'GuardmeAuditLogsConnection', nodes: Array<{ __typename?: 'GuardmeAuditLog', id: string, type: string, details: Record<string, MetadataField>, performedById?: string | null, createdAt: string, performedBy?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null } | null }> }, guardmeAttachments: { __typename?: 'GuardmeAttachmentsConnection', nodes: Array<{ __typename?: 'GuardmeAttachment', id: string, comment: string, createdAt: string, attachments: { __typename?: 'AttachmentsConnection', nodes: Array<{ __typename?: 'Attachment', id: string, mimetype: string, filename: string, url?: string | null }> } }> }, livestreams: { __typename?: 'LivestreamsConnection', nodes: Array<{ __typename?: 'Livestream', id: string, status: LivestreamStatus, streamingUrl?: string | null, url?: string | null, createdAt: string }> } } | null };

export type Guardme_Emergency_Contacts_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Guardme_Emergency_Contacts_QueryQuery = { __typename?: 'Query', guardme?: { __typename?: 'Guardme', id: string, member?: { __typename?: 'Member', id: string, emergencyContacts: { __typename?: 'EmergencyContactsConnection', nodes: Array<{ __typename?: 'EmergencyContact', id: string, phoneNumber: string, description: string }> } } | null } | null };

export type Guardme_Map_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Guardme_Map_QueryQuery = { __typename?: 'Query', guardme?: { __typename?: 'Guardme', id: string, locationTimelineAsEncodedPolyline?: string | null, member?: { __typename?: 'Member', id: string, organizationId: string, displayName?: string | null, fullName: string, avatarUrl?: string | null } | null, lastLocation?: { __typename?: 'GuardmeLocation', id: string, createdAt: string, coordinates: { __typename?: 'GeometryPoint', x: number, y: number }, geocode?: { __typename?: 'GuardmeLocationGeocode', id: string, address: string, plusCode: string } | null } | null } | null };

export type Guardme_Member_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Guardme_Member_QueryQuery = { __typename?: 'Query', guardme?: { __typename?: 'Guardme', id: string, member?: { __typename?: 'Member', id: string, organizationId: string, fullName: string, displayName?: string | null, timezone: string, avatarUrl?: string | null, phoneNumber?: string | null, emailAddress?: string | null, metadata?: Record<string, MetadataField> | null, organization?: { __typename?: 'Organization', id: string, memberMetadataFields: Record<string, MetadataField> } | null } | null } | null };

export type Guard_Me_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Guard_Me_QueryQuery = { __typename?: 'Query', guardme?: (
    { __typename?: 'Guardme', id: string, shortId: string, notes: string, status: GuardmeStatus, completedAt?: string | null, createdAt: string, endsAt: string, updatedAt: string, memberId: string, organizationId: string, member?: (
      { __typename?: 'Member', id: string }
      & { ' $fragmentRefs'?: { 'Guardme_Member_Details_FragmentFragment': Guardme_Member_Details_FragmentFragment } }
    ) | null, organization?: { __typename?: 'Organization', id: string, memberMetadataFields: Record<string, MetadataField>, settingIsRapidsosPanicButtonFlowEnabled: boolean, settingIsRapidsosOperatorFlowEnabled: boolean, settingRapidsosSocPhoneNumber: string } | null }
    & { ' $fragmentRefs'?: { 'Guardme_Session_Details_FragmentFragment': Guardme_Session_Details_FragmentFragment } }
  ) | null };

export type Guardme_Session_Details_FragmentFragment = { __typename?: 'Guardme', id: string, completedAt?: string | null, createdAt: string, endsAt: string, totalAttachments?: number | null, batteryLevel?: number | null } & { ' $fragmentName'?: 'Guardme_Session_Details_FragmentFragment' };

export type Guardme_Member_Details_FragmentFragment = { __typename?: 'Member', id: string, organizationId: string, fullName: string, displayName?: string | null, timezone: string, avatarUrl?: string | null, phoneNumber?: string | null, emailAddress?: string | null, metadata?: Record<string, MetadataField> | null, organization?: { __typename?: 'Organization', id: string, memberMetadataFields: Record<string, MetadataField> } | null } & { ' $fragmentName'?: 'Guardme_Member_Details_FragmentFragment' };

export type Guard_Mes_QueryQueryVariables = Exact<{
  createdAt?: InputMaybe<GuardMesCreatedAtConditionInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GuardmesOrderBy> | GuardmesOrderBy>;
  organizationId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GuardMesStatusConditionInput>;
}>;


export type Guard_Mes_QueryQuery = { __typename?: 'Query', guardmes?: { __typename?: 'GuardmesConnection', totalCount: number, edges: Array<{ __typename?: 'GuardmesEdge', node: { __typename?: 'Guardme', id: string, organizationId: string, shortId: string, status: GuardmeStatus, createdAt: string, completedAt?: string | null, endsAt: string, memberId: string, member?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type Guardme_Updates_SubscriptionSubscriptionVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Guardme_Updates_SubscriptionSubscription = { __typename?: 'Subscription', guardmeUpdates?: { __typename?: 'GuardmeUpdatesPayload', event?: GraphqlGuardmeEvent | null, relatedIds?: Array<string> | null, guardme?: { __typename: 'Guardme', id: string, shortId: string, status: GuardmeStatus, endsAt: string, completedAt?: string | null, createdAt: string, updatedAt: string, isSafe: boolean, isActive?: boolean | null, isExpired?: boolean | null, batteryLevel?: number | null, notes: string, organizationId: string, locationTimelineAsEncodedPolyline?: string | null, memberId: string, totalAttachments?: number | null, lastLocation?: { __typename?: 'GuardmeLocation', id: string, createdAt: string, coordinates: { __typename?: 'GeometryPoint', x: number, y: number }, geocode?: { __typename?: 'GuardmeLocationGeocode', id: string, address: string, plusCode: string } | null } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, member?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null, phoneNumber?: string | null } | null, guardmeAttachments: { __typename?: 'GuardmeAttachmentsConnection', nodes: Array<{ __typename?: 'GuardmeAttachment', id: string }> }, livestreams: { __typename?: 'LivestreamsConnection', nodes: Array<{ __typename?: 'Livestream', id: string }> }, guardmeAuditLogs: { __typename?: 'GuardmeAuditLogsConnection', nodes: Array<{ __typename?: 'GuardmeAuditLog', id: string }> } } | null } | null };

export type MembershipRequestCalloutGqlQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type MembershipRequestCalloutGqlQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, membershipRequests: { __typename?: 'MembershipRequestsConnection', totalCount: number } } | null };

export type Current_User_Recent_Activity_QueryQueryVariables = Exact<{
  gte: Scalars['Datetime']['input'];
}>;


export type Current_User_Recent_Activity_QueryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, memberships: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, organizationId: string, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string } | null, checkIns: { __typename?: 'CheckInsConnection', nodes: Array<{ __typename?: 'CheckIn', id: string, shortId: string, createdAt: string, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string }> } }> }, guardmes: { __typename?: 'GuardmesConnection', nodes: Array<{ __typename?: 'Guardme', id: string, shortId: string, createdAt: string, status: GuardmeStatus, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string }> } }> }, incidentsByContactMemberId: { __typename?: 'IncidentsConnection', nodes: Array<{ __typename?: 'Incident', id: string, shortId: string, createdAt: string, status: IncidentStatusType, priority: IncidentPriorityType, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string }> }, incidentType?: { __typename?: 'IncidentType', id: string, name: string, iconSvg: string } | null }> } }> } } | null };

export type Home_QueryQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type Home_QueryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, memberships: { __typename?: 'MembersConnection', totalCount: number, nodes: Array<{ __typename?: 'Member', id: string, guardmes: { __typename?: 'GuardmesConnection', totalCount: number }, incidentsByContactMemberId: { __typename?: 'IncidentsConnection', totalCount: number }, incidentsByOwnedByMemberId: { __typename?: 'IncidentsConnection', totalCount: number }, checkIns: { __typename?: 'CheckInsConnection', totalCount: number }, checkInRequests: { __typename?: 'CheckInRequestsConnection', totalCount: number } }> }, userNotifications: { __typename?: 'UserNotificationsConnection', totalCount: number } } | null };

export type My_Inicdents_QueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<IncidentsCreatedAtConditionInput>;
  status?: InputMaybe<IncidentsStatusConditionInput>;
  priority?: InputMaybe<IncidentsPriorityConditionInput>;
  types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy> | IncidentsOrderBy>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  assignedToMe?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type My_Inicdents_QueryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, memberships: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, incidentsByContactMemberId: { __typename?: 'IncidentsConnection', totalCount: number, nodes: Array<{ __typename?: 'Incident', id: string, organizationId: string, shortId: string, subject: string, description: string, status: IncidentStatusType, priority: IncidentPriorityType, createdAt: string, updatedAt: string, contactMemberId: string, ownedByMemberId?: string | null, ownedByGroupId?: string | null, incidentTypeId: string, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string } | null, contactMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, ownedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, ownedByGroup?: { __typename?: 'Group', id: string, name: string } | null, incidentType?: { __typename?: 'IncidentType', id: string, name: string, iconSvg: string } | null }> } }> } } | null };

export type EditIncidentContactDropdownDropdownGqlMutationVariables = Exact<{
  input: UpdateIncidentContactInput;
}>;


export type EditIncidentContactDropdownDropdownGqlMutation = { __typename?: 'Mutation', updateIncidentContact?: { __typename?: 'UpdateIncidentContactPayload', incident?: { __typename?: 'Incident', id: string, contactMemberId: string, contactMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null } | null } | null };

export type AllMemberDropdownGqlQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type AllMemberDropdownGqlQuery = { __typename?: 'Query', members?: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, isEnabled: boolean, fullName: string, displayName?: string | null, avatarUrl?: string | null }> } | null };

export type EditIncidentGroupDropdownGqlMutationVariables = Exact<{
  input: UpdateIncidentGroupInput;
}>;


export type EditIncidentGroupDropdownGqlMutation = { __typename?: 'Mutation', updateIncidentGroup?: { __typename?: 'UpdateIncidentGroupPayload', incident?: { __typename?: 'Incident', id: string, ownedByGroupId?: string | null, ownedByGroup?: { __typename?: 'Group', id: string, name: string } | null } | null } | null };

export type AllGroupDropdownGqlQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type AllGroupDropdownGqlQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, name: string }> } | null };

export type EditIncidentOwnerDropdownGqlMutationVariables = Exact<{
  input: UpdateIncidentOwnerInput;
}>;


export type EditIncidentOwnerDropdownGqlMutation = { __typename?: 'Mutation', updateIncidentOwner?: { __typename?: 'UpdateIncidentOwnerPayload', incident?: { __typename?: 'Incident', id: string, ownedByMemberId?: string | null, ownedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null } | null } | null };

export type EditIncidentPriorityDropdownGqlMutationVariables = Exact<{
  input: UpdateIncidentPriorityInput;
}>;


export type EditIncidentPriorityDropdownGqlMutation = { __typename?: 'Mutation', updateIncidentPriority?: { __typename?: 'UpdateIncidentPriorityPayload', incident?: { __typename?: 'Incident', id: string, priority: IncidentPriorityType } | null } | null };

export type EditIncidentStatusDropdownGqlMutationVariables = Exact<{
  input: UpdateIncidentStatusInput;
}>;


export type EditIncidentStatusDropdownGqlMutation = { __typename?: 'Mutation', updateIncidentStatus?: { __typename?: 'UpdateIncidentStatusPayload', incident?: { __typename?: 'Incident', id: string, status: IncidentStatusType } | null } | null };

export type IncidentGroupControlGqlMutationVariables = Exact<{
  incidentId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
}>;


export type IncidentGroupControlGqlMutation = { __typename?: 'Mutation', updateIncidentGroup?: { __typename?: 'UpdateIncidentGroupPayload', incident?: { __typename?: 'Incident', id: string, updatedAt: string, ownedByGroup?: { __typename?: 'Group', id: string, name: string } | null, incidentUpdates: { __typename?: 'IncidentUpdatesConnection', nodes: Array<{ __typename?: 'IncidentUpdate', id: string, type: IncidentUpdateTypeType, message?: string | null, createdAt: string, isSystemMessage: boolean, performedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, incidentAttachment?: { __typename?: 'Attachment', id: string, url?: string | null } | null }> } } | null } | null };

export type IncidentLivestreamDroneGqlQueryVariables = Exact<{
  livestreamId: Scalars['String']['input'];
}>;


export type IncidentLivestreamDroneGqlQuery = { __typename?: 'Query', livestream?: { __typename?: 'Livestream', id: string, status: LivestreamStatus, droneEndpoint?: string | null } | null };

export type StartLivestreamDroneGqlMutationVariables = Exact<{
  input: StartIncidentLivestreamInput;
}>;


export type StartLivestreamDroneGqlMutation = { __typename?: 'Mutation', startIncidentLivestream?: { __typename?: 'StartIncidentLivestreamPayload', livestream?: { __typename?: 'Livestream', id: string, droneEndpoint?: string | null, createdAt: string, status: LivestreamStatus } | null } | null };

export type EndLivestreamDroneGqlMutationVariables = Exact<{
  input: EndIncidentLivestreamInput;
}>;


export type EndLivestreamDroneGqlMutation = { __typename?: 'Mutation', endIncidentLivestream?: { __typename?: 'EndIncidentLivestreamPayload', livestream?: { __typename?: 'Livestream', id: string, endedAt?: string | null, createdAt: string, status: LivestreamStatus } | null } | null };

export type IncidentUpdatesGqlSubscriptionVariables = Exact<{
  incidentId: Scalars['String']['input'];
}>;


export type IncidentUpdatesGqlSubscription = { __typename?: 'Subscription', incidentUpdates?: { __typename?: 'IncidentUpdatesPayload', event?: GraphqlIncidentUpdateEvent | null, relatedIds?: Array<string> | null, incident?: { __typename?: 'Incident', id: string, shortId: string, organizationId: string, updatedAt: string, createdAt: string, resolutionAt?: string | null, firstResponseAt?: string | null, priority: IncidentPriorityType, status: IncidentStatusType, subject: string, description: string, additionalData: Record<string, MetadataField>, contactMemberId: string, incidentCoordinates: { __typename?: 'GeometryPoint', x: number, y: number }, incidentCoordinatesGeocode?: { __typename?: 'IncidentCoordinatesGeocode', id: string, address: string, plusCode: string } | null, submittedByMemberCoordinates: { __typename?: 'GeometryPoint', x: number, y: number }, submittedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, contactMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null, emailAddress?: string | null, phoneNumber?: string | null } | null, ownedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, ownedByGroup?: { __typename?: 'Group', id: string, name: string } | null, incidentUpdates: { __typename?: 'IncidentUpdatesConnection', nodes: Array<{ __typename?: 'IncidentUpdate', id: string, type: IncidentUpdateTypeType, message?: string | null, createdAt: string, previousValue?: Record<string, MetadataField> | null, updatedValue?: Record<string, MetadataField> | null, isSystemMessage: boolean, performedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, attachments: { __typename?: 'AttachmentsConnection', nodes: Array<{ __typename?: 'Attachment', id: string, mimetype: string, url?: string | null }> } }> }, incidentType?: { __typename?: 'IncidentType', id: string, name: string, dataSchema: Record<string, MetadataField>, uiSchema: Record<string, MetadataField> } | null } | null } | null };

export type MemberComponentGqlQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MemberComponentGqlQuery = { __typename?: 'Query', member?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null };

export type CreateIncidentNoteFormGqlMutationVariables = Exact<{
  message: Scalars['String']['input'];
  incidentId: Scalars['String']['input'];
  isPrivate: Scalars['Boolean']['input'];
  attachmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateIncidentNoteFormGqlMutation = { __typename?: 'Mutation', createIncidentNote?: { __typename?: 'CreateIncidentNotePayload', incident?: { __typename?: 'Incident', id: string, incidentUpdates: { __typename?: 'IncidentUpdatesConnection', nodes: Array<{ __typename?: 'IncidentUpdate', id: string, type: IncidentUpdateTypeType, message?: string | null, createdAt: string, isSystemMessage: boolean, performedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, attachments: { __typename?: 'AttachmentsConnection', nodes: Array<{ __typename?: 'Attachment', id: string, url?: string | null }> } }> } } | null } | null };

export type IncidentNoteControlCloseGqlMutationVariables = Exact<{
  incidentId: Scalars['String']['input'];
}>;


export type IncidentNoteControlCloseGqlMutation = { __typename?: 'Mutation', updateIncidentStatus?: { __typename?: 'UpdateIncidentStatusPayload', incident?: { __typename?: 'Incident', id: string, status: IncidentStatusType, incidentUpdates: { __typename?: 'IncidentUpdatesConnection', nodes: Array<{ __typename?: 'IncidentUpdate', id: string, type: IncidentUpdateTypeType, message?: string | null, createdAt: string, isSystemMessage: boolean, performedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, attachments: { __typename?: 'AttachmentsConnection', nodes: Array<{ __typename?: 'Attachment', id: string, url?: string | null }> } }> } } | null } | null };

export type Incident_Livestream_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Incident_Livestream_QueryQuery = { __typename?: 'Query', livestream?: { __typename?: 'Livestream', id: string, status: LivestreamStatus, streamingUrl?: string | null, url?: string | null, createdAt: string } | null };

export type IncidentPriorityMenuRadioGroupGqlMutationVariables = Exact<{
  incidentId: Scalars['String']['input'];
  priority: IncidentPriorityType;
}>;


export type IncidentPriorityMenuRadioGroupGqlMutation = { __typename?: 'Mutation', updateIncidentPriority?: { __typename?: 'UpdateIncidentPriorityPayload', incident?: { __typename?: 'Incident', id: string, priority: IncidentPriorityType, incidentUpdates: { __typename?: 'IncidentUpdatesConnection', nodes: Array<{ __typename?: 'IncidentUpdate', id: string, type: IncidentUpdateTypeType, message?: string | null, createdAt: string, isSystemMessage: boolean, performedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, attachments: { __typename?: 'AttachmentsConnection', nodes: Array<{ __typename?: 'Attachment', id: string, url?: string | null }> } }> } } | null } | null };

export type IncidentStatusMenuRadioGroupGqlMutationVariables = Exact<{
  incidentId: Scalars['String']['input'];
  status: IncidentStatusType;
}>;


export type IncidentStatusMenuRadioGroupGqlMutation = { __typename?: 'Mutation', updateIncidentStatus?: { __typename?: 'UpdateIncidentStatusPayload', incident?: { __typename?: 'Incident', id: string, status: IncidentStatusType, incidentUpdates: { __typename?: 'IncidentUpdatesConnection', nodes: Array<{ __typename?: 'IncidentUpdate', id: string, type: IncidentUpdateTypeType, message?: string | null, createdAt: string, isSystemMessage: boolean, performedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, attachments: { __typename?: 'AttachmentsConnection', nodes: Array<{ __typename?: 'Attachment', id: string, url?: string | null }> } }> } } | null } | null };

export type Assign_Incident_MutationMutationVariables = Exact<{
  owner: UpdateIncidentOwnerInput;
  group: UpdateIncidentGroupInput;
}>;


export type Assign_Incident_MutationMutation = { __typename?: 'Mutation', updateIncidentOwner?: { __typename?: 'UpdateIncidentOwnerPayload', incident?: { __typename?: 'Incident', id: string, ownedByMemberId?: string | null, ownedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null, lastActiveAt?: string | null } | null } | null } | null, updateIncidentGroup?: { __typename?: 'UpdateIncidentGroupPayload', incident?: { __typename?: 'Incident', id: string, ownedByGroupId?: string | null, ownedByGroup?: { __typename?: 'Group', id: string, name: string } | null } | null } | null };

export type Create_Incident_MutationMutationVariables = Exact<{
  input: CreateIncidentInput;
}>;


export type Create_Incident_MutationMutation = { __typename?: 'Mutation', createIncident?: { __typename?: 'CreateIncidentPayload', incident?: { __typename?: 'Incident', id: string, organizationId: string, shortId: string, incidentUpdates: { __typename?: 'IncidentUpdatesConnection', nodes: Array<{ __typename?: 'IncidentUpdate', id: string, type: IncidentUpdateTypeType, message?: string | null, createdAt: string, isSystemMessage: boolean, performedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, attachments: { __typename?: 'AttachmentsConnection', nodes: Array<{ __typename?: 'Attachment', id: string, url?: string | null }> } }> } } | null } | null };

export type Enabled_Incident_Types_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Enabled_Incident_Types_QueryQuery = { __typename?: 'Query', enabledIncidentTypes?: { __typename?: 'EnabledIncidentTypesConnection', totalCount: number, nodes: Array<{ __typename?: 'EnabledIncidentType', id: string, defaultAssignedGroup?: { __typename?: 'Group', id: string, name: string } | null, incidentType?: { __typename?: 'IncidentType', id: string, category: string, name: string, description: string, iconSvg: string, uiSchema: Record<string, MetadataField>, dataSchema: Record<string, MetadataField> } | null }> } | null, organization?: { __typename?: 'Organization', id: string, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, fullName: string, displayName?: string | null, isEnabled: boolean }> } } | null };

export type Group_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Group_QueryQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, organizationId: string, name: string } | null };

export type Incident_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Incident_QueryQuery = { __typename?: 'Query', incident?: (
    { __typename?: 'Incident', id: string, shortId: string, organizationId: string, updatedAt: string, createdAt: string, firstResponseAt?: string | null, resolutionAt?: string | null, priority: IncidentPriorityType, status: IncidentStatusType, subject: string, description: string, additionalData: Record<string, MetadataField>, submittedByMemberId: string, contactMemberId: string, ownedByMemberId?: string | null, ownedByGroupId?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, name: string }> }, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, displayName?: string | null, fullName: string }> } } | null, submittedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, contactMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null, emailAddress?: string | null, phoneNumber?: string | null, lastActiveAt?: string | null } | null, ownedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, ownedByGroup?: { __typename?: 'Group', id: string, name: string } | null, livestreams: { __typename?: 'LivestreamsConnection', nodes: Array<{ __typename?: 'Livestream', id: string, status: LivestreamStatus, memberId: string }> }, incidentType?: { __typename?: 'IncidentType', id: string, name: string, dataSchema: Record<string, MetadataField>, uiSchema: Record<string, MetadataField>, iconSvg: string, allowDroneEndpoint: boolean, category: string } | null }
    & { ' $fragmentRefs'?: { 'Inicdent_Updates_FragmentFragment': Inicdent_Updates_FragmentFragment;'Incident_Details_FragmentFragment': Incident_Details_FragmentFragment;'Inicdent_Information_FragmentFragment': Inicdent_Information_FragmentFragment;'Inicdent_Contact_FragmentFragment': Inicdent_Contact_FragmentFragment;'Incident_Location_FragmentFragment': Incident_Location_FragmentFragment } }
  ) | null };

export type Inicdent_Information_FragmentFragment = { __typename?: 'Incident', id: string, priority: IncidentPriorityType, status: IncidentStatusType, resolutionAt?: string | null, firstResponseAt?: string | null, createdAt: string, updatedAt: string, ownedByMemberId?: string | null, ownedByGroupId?: string | null, contactMember?: { __typename?: 'Member', id: string, organizationId: string, displayName?: string | null, fullName: string, avatarUrl?: string | null, lastActiveAt?: string | null } | null, ownedByMember?: { __typename?: 'Member', id: string, organizationId: string, displayName?: string | null, fullName: string, avatarUrl?: string | null, lastActiveAt?: string | null } | null, ownedByGroup?: { __typename?: 'Group', id: string, organizationId: string, name: string } | null, incidentType?: { __typename?: 'IncidentType', id: string, name: string, iconSvg: string, category: string } | null } & { ' $fragmentName'?: 'Inicdent_Information_FragmentFragment' };

export type Inicdent_Updates_FragmentFragment = { __typename?: 'Incident', id: string, shortId: string, organizationId: string, incidentType?: { __typename?: 'IncidentType', id: string, uiSchema: Record<string, MetadataField>, dataSchema: Record<string, MetadataField> } | null, incidentUpdates: { __typename?: 'IncidentUpdatesConnection', nodes: Array<{ __typename?: 'IncidentUpdate', id: string, type: IncidentUpdateTypeType, message?: string | null, createdAt: string, previousValue?: Record<string, MetadataField> | null, updatedValue?: Record<string, MetadataField> | null, isSystemMessage: boolean, performedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, attachments: { __typename?: 'AttachmentsConnection', nodes: Array<{ __typename?: 'Attachment', id: string, mimetype: string, url?: string | null, filename: string, createdAt: string }> } }> } } & { ' $fragmentName'?: 'Inicdent_Updates_FragmentFragment' };

export type Incident_Details_FragmentFragment = { __typename?: 'Incident', id: string, shortId: string, organizationId: string, subject: string, description: string, additionalData: Record<string, MetadataField>, contactMember?: { __typename?: 'Member', id: string, organizationId: string, displayName?: string | null, fullName: string, avatarUrl?: string | null, lastActiveAt?: string | null } | null, incidentType?: { __typename?: 'IncidentType', id: string, name: string, dataSchema: Record<string, MetadataField>, uiSchema: Record<string, MetadataField> } | null } & { ' $fragmentName'?: 'Incident_Details_FragmentFragment' };

export type Inicdent_Contact_FragmentFragment = { __typename?: 'Incident', id: string, shortId: string, organizationId: string, contactMemberId: string, contactMember?: { __typename?: 'Member', id: string, organizationId: string, displayName?: string | null, fullName: string, avatarUrl?: string | null, lastActiveAt?: string | null, emailAddress?: string | null, phoneNumber?: string | null, metadata?: Record<string, MetadataField> | null, timezone: string, emergencyContacts: { __typename?: 'EmergencyContactsConnection', nodes: Array<{ __typename?: 'EmergencyContact', id: string, description: string, phoneNumber: string, priority: number }> } } | null, organization?: { __typename?: 'Organization', id: string, memberMetadataFields: Record<string, MetadataField> } | null } & { ' $fragmentName'?: 'Inicdent_Contact_FragmentFragment' };

export type Incident_Location_FragmentFragment = { __typename?: 'Incident', id: string, shortId: string, organizationId: string, incidentCoordinates: { __typename?: 'GeometryPoint', x: number, y: number }, incidentCoordinatesGeocode?: { __typename?: 'IncidentCoordinatesGeocode', id: string, address: string, plusCode: string } | null, submittedByMemberCoordinates: { __typename?: 'GeometryPoint', x: number, y: number }, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string, radius: number, spatialData:
        | { __typename?: 'GeographyLineString', geojson?: any | null }
        | { __typename?: 'GeographyPoint', geojson?: any | null }
        | { __typename?: 'GeographyPolygon', geojson?: any | null }
       }> }, organization?: { __typename?: 'Organization', id: string, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string, radius: number, spatialData:
          | { __typename?: 'GeographyLineString', geojson?: any | null }
          | { __typename?: 'GeographyPoint', geojson?: any | null }
          | { __typename?: 'GeographyPolygon', geojson?: any | null }
         }> } } | null } & { ' $fragmentName'?: 'Incident_Location_FragmentFragment' };

export type Incident_Types_List_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Incident_Types_List_QueryQuery = { __typename?: 'Query', enabledIncidentTypes?: { __typename?: 'EnabledIncidentTypesConnection', totalCount: number, edges: Array<{ __typename?: 'EnabledIncidentTypesEdge', node: { __typename?: 'EnabledIncidentType', id: string, organizationId: string, incidentTypeId: string, incidentType?: { __typename?: 'IncidentType', id: string, name: string, iconSvg: string } | null } }> } | null };

export type Incidents_QueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<IncidentsCreatedAtConditionInput>;
  status?: InputMaybe<IncidentsStatusConditionInput>;
  priority?: InputMaybe<IncidentsPriorityConditionInput>;
  types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<IncidentsOrderBy> | IncidentsOrderBy>;
}>;


export type Incidents_QueryQuery = { __typename?: 'Query', incidents?: { __typename?: 'IncidentsConnection', totalCount: number, edges: Array<{ __typename?: 'IncidentsEdge', node: { __typename?: 'Incident', id: string, organizationId: string, shortId: string, subject: string, description: string, status: IncidentStatusType, priority: IncidentPriorityType, createdAt: string, updatedAt: string, contactMemberId: string, ownedByMemberId?: string | null, ownedByGroupId?: string | null, incidentTypeId: string, contactMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, ownedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, ownedByGroup?: { __typename?: 'Group', id: string, name: string } | null, incidentType?: { __typename?: 'IncidentType', id: string, name: string, iconSvg: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean } } | null };

export type Incidents_Updates_SubscriptionSubscriptionVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Incidents_Updates_SubscriptionSubscription = { __typename?: 'Subscription', incidentsUpdates?: { __typename?: 'IncidentsUpdatesPayload', event?: GraphqlIncidentsUpdatesEvent | null, relatedIds?: Array<string> | null, incident?: { __typename?: 'Incident', id: string, shortId: string, subject: string, status: IncidentStatusType, priority: IncidentPriorityType, createdAt: string, updatedAt: string, organizationId: string, organization?: { __typename?: 'Organization', id: string, name: string } | null } | null } | null };

export type Update_Incident_Agent_MutationMutationVariables = Exact<{
  input: UpdateIncidentOwnerInput;
}>;


export type Update_Incident_Agent_MutationMutation = { __typename?: 'Mutation', updateIncidentOwner?: { __typename?: 'UpdateIncidentOwnerPayload', incident?: { __typename?: 'Incident', id: string, ownedByMemberId?: string | null, ownedByMember?: { __typename?: 'Member', id: string, organizationId: string, avatarUrl?: string | null, lastActiveAt?: string | null, displayName?: string | null, fullName: string } | null } | null } | null };

export type Update_Incident_Contact_MutationMutationVariables = Exact<{
  input: UpdateIncidentContactInput;
}>;


export type Update_Incident_Contact_MutationMutation = { __typename?: 'Mutation', updateIncidentContact?: { __typename?: 'UpdateIncidentContactPayload', incident?: (
      { __typename?: 'Incident', id: string }
      & { ' $fragmentRefs'?: { 'Inicdent_Contact_FragmentFragment': Inicdent_Contact_FragmentFragment } }
    ) | null } | null };

export type Update_Incident_Details_MutationMutationVariables = Exact<{
  incidentId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  description: Scalars['String']['input'];
  additionalData: Scalars['JSON']['input'];
}>;


export type Update_Incident_Details_MutationMutation = { __typename?: 'Mutation', updateIncidentDetails?: { __typename?: 'UpdateIncidentDetailsPayload', incident?: { __typename?: 'Incident', id: string, subject: string, description: string, additionalData: Record<string, MetadataField>, incidentUpdates: { __typename?: 'IncidentUpdatesConnection', nodes: Array<{ __typename?: 'IncidentUpdate', id: string, type: IncidentUpdateTypeType, message?: string | null, createdAt: string, isSystemMessage: boolean, performedByMember?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null, attachments: { __typename?: 'AttachmentsConnection', nodes: Array<{ __typename?: 'Attachment', id: string, url?: string | null }> } }> } } | null } | null };

export type Update_Incident_Group_MutationMutationVariables = Exact<{
  input: UpdateIncidentGroupInput;
}>;


export type Update_Incident_Group_MutationMutation = { __typename?: 'Mutation', updateIncidentGroup?: { __typename?: 'UpdateIncidentGroupPayload', incident?: { __typename?: 'Incident', id: string, ownedByGroupId?: string | null, ownedByGroup?: { __typename?: 'Group', id: string, organizationId: string, name: string } | null } | null } | null };

export type Update_Incident_Priority_MutationMutationVariables = Exact<{
  input: UpdateIncidentPriorityInput;
}>;


export type Update_Incident_Priority_MutationMutation = { __typename?: 'Mutation', updateIncidentPriority?: { __typename?: 'UpdateIncidentPriorityPayload', incident?: { __typename?: 'Incident', id: string, priority: IncidentPriorityType } | null } | null };

export type Update_Incident_Status_MutationMutationVariables = Exact<{
  input: UpdateIncidentStatusInput;
}>;


export type Update_Incident_Status_MutationMutation = { __typename?: 'Mutation', updateIncidentStatus?: { __typename?: 'UpdateIncidentStatusPayload', incident?: { __typename?: 'Incident', id: string, status: IncidentStatusType } | null } | null };

export type AddMemberToGroupQueryMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
}>;


export type AddMemberToGroupQueryMutation = { __typename?: 'Mutation', addMemberToGroup?: { __typename?: 'AddMemberToGroupPayload', mapGroupsMember?: { __typename?: 'MapGroupsMember', organizationId: string, groupId: string, memberId: string } | null } | null };

export type GroupDeleteGqlMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GroupDeleteGqlMutation = { __typename?: 'Mutation', deleteGroup?: { __typename?: 'DeleteGroupPayload', group?: { __typename?: 'Group', id: string, name: string, organizationId: string } | null } | null };

export type GroupSelectQueryQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GroupSelectQueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, groups: { __typename?: 'GroupsConnection', totalCount: number, nodes: Array<{ __typename?: 'Group', id: string, name: string }> } } | null };

export type Approve_Membership_UpdaaterQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Approve_Membership_UpdaaterQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, membershipRequests: { __typename?: 'MembershipRequestsConnection', nodes: Array<{ __typename?: 'MembershipRequest', id: string }> } } | null };

export type OrganizationInvitationsGqlQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type OrganizationInvitationsGqlQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, invitations: { __typename?: 'InvitationsConnection', nodes: Array<{ __typename?: 'Invitation', id: string }> } } | null };

export type DeleteInvitationUpdateQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type DeleteInvitationUpdateQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, invitations: { __typename?: 'InvitationsConnection', nodes: Array<{ __typename?: 'Invitation', id: string }> } } | null };

export type DeleteMemberUpdateQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type DeleteMemberUpdateQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string }> } } | null };

export type Deny_Memership_Request_UpdaterQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Deny_Memership_Request_UpdaterQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, membershipRequests: { __typename?: 'MembershipRequestsConnection', nodes: Array<{ __typename?: 'MembershipRequest', id: string }> } } | null };

export type EditDisplayNameDialogGqlMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
}>;


export type EditDisplayNameDialogGqlMutation = { __typename?: 'Mutation', updateMemberDisplayName?: { __typename?: 'UpdateMemberDisplayNamePayload', member?: { __typename?: 'Member', id: string, displayName?: string | null, fullName: string } | null } | null };

export type EditGroupsDialogGqlMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
  groupIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type EditGroupsDialogGqlMutation = { __typename?: 'Mutation', updateMemberGroups?: { __typename?: 'UpdateMemberGroupsPayload', member?: { __typename?: 'Member', id: string, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, name: string }> } } | null } | null };

export type EditMetadataDialogGqlMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
}>;


export type EditMetadataDialogGqlMutation = { __typename?: 'Mutation', updateMemberMetadata?: { __typename?: 'UpdateMemberMetadataPayload', member?: { __typename?: 'Member', id: string, metadata?: Record<string, MetadataField> | null } | null } | null };

export type EditRoleDropdownGqlMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
  roleId: MemberRole;
}>;


export type EditRoleDropdownGqlMutation = { __typename?: 'Mutation', updateMemberRole?: { __typename?: 'UpdateMemberRolePayload', member?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, organizationRole: MemberRole } | null } | null };

export type Member_Check_Ins_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Member_Check_Ins_QueryQuery = { __typename?: 'Query', member?: { __typename?: 'Member', id: string, checkIns: { __typename?: 'CheckInsConnection', totalCount: number, nodes: Array<{ __typename?: 'CheckIn', id: string, organizationId: string, shortId: string, createdAt: string, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string }> } }> } } | null };

export type EnableeMemberDetailStatusMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type EnableeMemberDetailStatusMutation = { __typename?: 'Mutation', enableMember?: { __typename?: 'EnableMemberPayload', member?: { __typename?: 'Member', id: string, isEnabled: boolean } | null } | null };

export type DisableMemberDetailStatusMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type DisableMemberDetailStatusMutation = { __typename?: 'Mutation', disableMember?: { __typename?: 'DisableMemberPayload', member?: { __typename?: 'Member', id: string, isEnabled: boolean } | null } | null };

export type Member_Gaurdmes_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Member_Gaurdmes_QueryQuery = { __typename?: 'Query', member?: { __typename?: 'Member', id: string, guardmes: { __typename?: 'GuardmesConnection', totalCount: number, nodes: Array<{ __typename?: 'Guardme', id: string, organizationId: string, shortId: string, status: GuardmeStatus, createdAt: string, endsAt: string }> } } | null };

export type Member_Incidentss_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Member_Incidentss_QueryQuery = { __typename?: 'Query', member?: { __typename?: 'Member', id: string, incidentsByContactMemberId: { __typename?: 'IncidentsConnection', totalCount: number, nodes: Array<{ __typename?: 'Incident', id: string, organizationId: string, shortId: string, subject: string, description: string, status: IncidentStatusType, priority: IncidentPriorityType, createdAt: string, incidentType?: { __typename?: 'IncidentType', id: string, name: string, iconSvg: string } | null }> } } | null };

export type MemberOverviewGqlQueryVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type MemberOverviewGqlQuery = { __typename?: 'Query', member?: { __typename?: 'Member', id: string, guardmesTotal: { __typename?: 'GuardmesConnection', totalCount: number }, incidentsTotal: { __typename?: 'IncidentsConnection', totalCount: number }, checkInsTotal: { __typename?: 'CheckInsConnection', totalCount: number } } | null };

export type Approve_Membership_Request_MutationMutationVariables = Exact<{
  input: ApproveMembershipRequestInput;
}>;


export type Approve_Membership_Request_MutationMutation = { __typename?: 'Mutation', approveMembershipRequest?: { __typename?: 'ApproveMembershipRequestPayload', member?: { __typename?: 'Member', id: string, organizationId: string } | null } | null };

export type Create_Invitation_MutationMutationVariables = Exact<{
  input: CreateInvitationInput;
}>;


export type Create_Invitation_MutationMutation = { __typename?: 'Mutation', createInvitation?: { __typename?: 'CreateInvitationPayload', invitation?: { __typename?: 'Invitation', id: string, key: string, metadata: Record<string, MetadataField>, groupIds: Array<string | null>, organizationId: string, organizationRole: MemberRole } | null } | null };

export type Delete_Member_MutationMutationVariables = Exact<{
  input: DeleteMemberInput;
}>;


export type Delete_Member_MutationMutation = { __typename?: 'Mutation', deleteMember?: { __typename?: 'DeleteMemberPayload', member?: { __typename?: 'Member', id: string, organizationId: string } | null } | null };

export type Deny_Membership_Request_MutationMutationVariables = Exact<{
  input: DenyMembershipRequestInput;
}>;


export type Deny_Membership_Request_MutationMutation = { __typename?: 'Mutation', denyMembershipRequest?: { __typename?: 'DenyMembershipRequestPayload', membershipRequest?: { __typename?: 'MembershipRequest', id: string, organizationId: string } | null } | null };

export type Disable_Member_MutationMutationVariables = Exact<{
  input: DisableMemberInput;
}>;


export type Disable_Member_MutationMutation = { __typename?: 'Mutation', disableMember?: { __typename?: 'DisableMemberPayload', member?: { __typename?: 'Member', id: string, isEnabled: boolean } | null } | null };

export type Enable_Member_MutationMutationVariables = Exact<{
  input: EnableMemberInput;
}>;


export type Enable_Member_MutationMutation = { __typename?: 'Mutation', enableMember?: { __typename?: 'EnableMemberPayload', member?: { __typename?: 'Member', id: string, isEnabled: boolean } | null } | null };

export type Group_Add_Members_MutationMutationVariables = Exact<{
  input: AddGroupMembersInput;
}>;


export type Group_Add_Members_MutationMutation = { __typename?: 'Mutation', addGroupMembers?: { __typename?: 'AddGroupMembersPayload', group?: { __typename?: 'Group', id: string, name: string, organizationId: string, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, avatarUrl?: string | null, fullName: string, displayName?: string | null, lastActiveAt?: string | null, isEnabled: boolean }> }, organization?: { __typename?: 'Organization', id: string, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, name: string }> } } | null } | null } | null };

export type Group_Create_MutationMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type Group_Create_MutationMutation = { __typename?: 'Mutation', createGroup?: { __typename?: 'CreateGroupPayload', group?: { __typename?: 'Group', id: string, name: string, description: string, organizationId: string, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, avatarUrl?: string | null, fullName: string, displayName?: string | null, lastActiveAt?: string | null, isEnabled: boolean }> }, organization?: { __typename?: 'Organization', id: string, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string }> } } | null } | null } | null };

export type Group_Delete_MutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Group_Delete_MutationMutation = { __typename?: 'Mutation', deleteGroup?: { __typename?: 'DeleteGroupPayload', group?: { __typename?: 'Group', id: string, name: string, organizationId: string, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, avatarUrl?: string | null, fullName: string, displayName?: string | null, lastActiveAt?: string | null, isEnabled: boolean }> }, organization?: { __typename?: 'Organization', id: string, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string }> } } | null } | null } | null };

export type Group_Link_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Group_Link_QueryQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, organizationId: string, name: string } | null };

export type Group_Select_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Group_Select_QueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, organizationId: string, name: string, description: string }> } } | null };

export type Group_Update_Members_MutationMutationVariables = Exact<{
  input: UpdateGroupMembersInput;
}>;


export type Group_Update_Members_MutationMutation = { __typename?: 'Mutation', updateGroupMembers?: { __typename?: 'UpdateGroupMembersPayload', group?: { __typename?: 'Group', id: string, organizationId: string, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, avatarUrl?: string | null, fullName: string, displayName?: string | null, lastActiveAt?: string | null, isEnabled: boolean }> }, organization?: { __typename?: 'Organization', id: string, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string }> } } | null } | null } | null };

export type Group_Update_MutationMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type Group_Update_MutationMutation = { __typename?: 'Mutation', updateGroup?: { __typename?: 'UpdateGroupPayload', group?: { __typename?: 'Group', id: string, name: string, description: string, organizationId: string, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, avatarUrl?: string | null, fullName: string, displayName?: string | null, lastActiveAt?: string | null, isEnabled: boolean }> }, organization?: { __typename?: 'Organization', id: string, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string }> } } | null } | null } | null };

export type Groups_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Groups_QueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, organizationId: string, name: string, description: string, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, avatarUrl?: string | null, fullName: string, displayName?: string | null, lastActiveAt?: string | null, isEnabled: boolean }> } }> } } | null };

export type Invitation_Delete_MutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Invitation_Delete_MutationMutation = { __typename?: 'Mutation', deleteInvitation?: { __typename?: 'DeleteInvitationPayload', invitation?: { __typename?: 'Invitation', id: string, organizationId: string, organization?: { __typename?: 'Organization', invitations: { __typename?: 'InvitationsConnection', nodes: Array<{ __typename?: 'Invitation', id: string }> } } | null } | null } | null };

export type Member_Activity_QueryQueryVariables = Exact<{
  memberId: Scalars['String']['input'];
  timestamp: Scalars['Datetime']['input'];
}>;


export type Member_Activity_QueryQuery = { __typename?: 'Query', member?: { __typename?: 'Member', id: string, guardmes: { __typename?: 'GuardmesConnection', nodes: Array<{ __typename?: 'Guardme', id: string, shortId: string, createdAt: string }> }, incidents: { __typename?: 'IncidentsConnection', nodes: Array<{ __typename?: 'Incident', id: string, shortId: string, createdAt: string, subject: string, incidentType?: { __typename?: 'IncidentType', id: string, name: string } | null }> }, checkIns: { __typename?: 'CheckInsConnection', nodes: Array<{ __typename?: 'CheckIn', id: string, shortId: string, createdAt: string }> } } | null };

export type Member_Link_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Member_Link_QueryQuery = { __typename?: 'Query', member?: { __typename?: 'Member', id: string, organizationId: string, displayName?: string | null, fullName: string, avatarUrl?: string | null, lastActiveAt?: string | null } | null };

export type Member_Or_Group_Select_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Member_Or_Group_Select_QueryQuery = { __typename?: 'Query', members?: { __typename?: 'MembersConnection', edges: Array<{ __typename?: 'MembersEdge', node: { __typename?: 'Member', id: string, organizationId: string, displayName?: string | null, fullName: string, avatarUrl?: string | null, isEnabled: boolean } }> } | null, groups?: { __typename?: 'GroupsConnection', edges: Array<{ __typename?: 'GroupsEdge', node: { __typename?: 'Group', id: string, organizationId: string, name: string, description: string } }> } | null };

export type Member_QueryQueryVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type Member_QueryQuery = { __typename?: 'Query', member?: (
    { __typename?: 'Member', id: string, organizationId: string }
    & { ' $fragmentRefs'?: { 'Member_Header_FragmentFragment': Member_Header_FragmentFragment;'Member_Detail_FragmentFragment': Member_Detail_FragmentFragment;'Member_Detail_Metadata_FragmentFragment': Member_Detail_Metadata_FragmentFragment;'Member_Detail_Groups_FragmentFragment': Member_Detail_Groups_FragmentFragment;'Member_Detail_Emergency_Contacts_FragmentFragment': Member_Detail_Emergency_Contacts_FragmentFragment } }
  ) | null };

export type Member_Header_FragmentFragment = { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, organizationRole: MemberRole, avatarUrl?: string | null, createdAt: string, lastActiveAt?: string | null, emailAddress?: string | null, phoneNumber?: string | null, isEnabled: boolean, organization?: { __typename?: 'Organization', id: string, memberMetadataFields: Record<string, MetadataField> } | null } & { ' $fragmentName'?: 'Member_Header_FragmentFragment' };

export type Member_Detail_FragmentFragment = { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, organizationRole: MemberRole, avatarUrl?: string | null, createdAt: string, lastActiveAt?: string | null, emailAddress?: string | null, phoneNumber?: string | null, isEnabled: boolean, timezone: string, metadata?: Record<string, MetadataField> | null } & { ' $fragmentName'?: 'Member_Detail_FragmentFragment' };

export type Member_Detail_Metadata_FragmentFragment = { __typename?: 'Member', id: string, metadata?: Record<string, MetadataField> | null, organization?: { __typename?: 'Organization', id: string, memberMetadataFields: Record<string, MetadataField> } | null } & { ' $fragmentName'?: 'Member_Detail_Metadata_FragmentFragment' };

export type Member_Detail_Groups_FragmentFragment = { __typename?: 'Member', id: string, organizationId: string, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, name: string }> }, organization?: { __typename?: 'Organization', groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, name: string }> } } | null } & { ' $fragmentName'?: 'Member_Detail_Groups_FragmentFragment' };

export type Member_Detail_Emergency_Contacts_FragmentFragment = { __typename?: 'Member', id: string, emergencyContacts: { __typename?: 'EmergencyContactsConnection', nodes: Array<{ __typename?: 'EmergencyContact', id: string, description: string, phoneNumber: string, priority: number }> } } & { ' $fragmentName'?: 'Member_Detail_Emergency_Contacts_FragmentFragment' };

export type Member_Select_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Member_Select_QueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, organizationId: string, displayName?: string | null, fullName: string, avatarUrl?: string | null, isEnabled: boolean }> } } | null };

export type Members_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Members_QueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, memberMetadataFields: Record<string, MetadataField>, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, organizationId: string, name: string, description: string, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null, isEnabled: boolean }> } }> }, invitations: { __typename?: 'InvitationsConnection', nodes: Array<{ __typename?: 'Invitation', id: string, organizationId: string, key: string, organizationRole: MemberRole, groupIds: Array<string | null>, metadata: Record<string, MetadataField> }> }, membershipRequests: { __typename?: 'MembershipRequestsConnection', nodes: Array<{ __typename?: 'MembershipRequest', id: string, organizationId: string, createdAt: string, fullName?: string | null, avatarUrl?: string | null, phoneNumber?: string | null, emailAddress?: string | null, membershipCode?: { __typename?: 'MembershipCode', id: string, organizationRole: MemberRole } | null }> }, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, organizationId: string, createdAt: string, fullName: string, displayName?: string | null, avatarUrl?: string | null, organizationRole: MemberRole, lastActiveAt?: string | null, isEnabled: boolean, emailAddress?: string | null, phoneNumber?: string | null, updatedAt: string }> } } | null };

export type Membership_Request_QueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type Membership_Request_QueryQuery = { __typename?: 'Query', membershipRequest?: { __typename?: 'MembershipRequest', id: string, createdAt: string, updatedAt: string, fullName?: string | null, phoneNumber?: string | null, emailAddress?: string | null, publicMetadata: Record<string, MetadataField>, organizationId: string, membershipCode?: { __typename?: 'MembershipCode', id: string, code: string, groupIds: Array<string | null>, organizationRole: MemberRole } | null, organization?: { __typename?: 'Organization', id: string, name: string, memberMetadataFields: Record<string, MetadataField>, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, name: string }> } } | null } | null };

export type Update_Group_MutationMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type Update_Group_MutationMutation = { __typename?: 'Mutation', updateGroup?: { __typename?: 'UpdateGroupPayload', group?: { __typename?: 'Group', id: string, name: string, description: string, updatedAt: string } | null } | null };

export type Update_Member_Role_MutationMutationVariables = Exact<{
  input: UpdateMemberRoleInput;
}>;


export type Update_Member_Role_MutationMutation = { __typename?: 'Mutation', updateMemberRole?: { __typename?: 'UpdateMemberRolePayload', member?: { __typename?: 'Member', id: string, organizationRole: MemberRole } | null } | null };

export type DisableMemberGqlMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type DisableMemberGqlMutation = { __typename?: 'Mutation', disableMember?: { __typename?: 'DisableMemberPayload', member?: { __typename?: 'Member', id: string, isEnabled: boolean } | null } | null };

export type EnableMemberGqlMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type EnableMemberGqlMutation = { __typename?: 'Mutation', enableMember?: { __typename?: 'EnableMemberPayload', member?: { __typename?: 'Member', id: string, isEnabled: boolean } | null } | null };

export type Delete_Membership_Code_MutationMutationVariables = Exact<{
  input: DeleteMembershipCodeInput;
}>;


export type Delete_Membership_Code_MutationMutation = { __typename?: 'Mutation', deleteMembershipCode?: { __typename?: 'DeleteMembershipCodePayload', organization?: { __typename?: 'Organization', id: string, membershipCodes: { __typename?: 'MembershipCodesConnection', totalCount: number, nodes: Array<{ __typename?: 'MembershipCode', id: string, organizationRole: MemberRole, groupIds: Array<string | null>, code: string, createdAt: string, updatedAt: string }> } } | null } | null };

export type Assign_Bivy_Stick_MutationMutationVariables = Exact<{
  input: AssignBivyStickToMemberInput;
}>;


export type Assign_Bivy_Stick_MutationMutation = { __typename?: 'Mutation', assignBivyStickToMember?: { __typename?: 'AssignBivyStickToMemberPayload', bivyStick?: { __typename?: 'BivyStick', id: string, isActive: boolean, organizationId: string, memberId?: string | null, member?: { __typename?: 'Member', id: string, displayName?: string | null, fullName: string, avatarUrl?: string | null, isEnabled: boolean } | null } | null } | null };

export type Create_Membership_Code_MutationMutationVariables = Exact<{
  input: CreateMembershipCodeInput;
}>;


export type Create_Membership_Code_MutationMutation = { __typename?: 'Mutation', createMembershipCode?: { __typename?: 'CreateMembershipCodePayload', organization?: { __typename?: 'Organization', id: string, membershipCodes: { __typename?: 'MembershipCodesConnection', totalCount: number, nodes: Array<{ __typename?: 'MembershipCode', id: string, organizationRole: MemberRole, groupIds: Array<string | null>, code: string, createdAt: string, updatedAt: string }> } } | null } | null };

export type Create_Place_MutationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  geojson: Scalars['JSON']['input'];
  radius: Scalars['Int']['input'];
}>;


export type Create_Place_MutationMutation = { __typename?: 'Mutation', createPlace?: { __typename?: 'CreatePlacePayload', organization?: { __typename?: 'Organization', id: string, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string, description: string, updatedAt: string, createdAt: string, radius: number, encodedPolyline?: string | null, center: { __typename?: 'GeographyPoint', longitude: number, latitude: number, srid: number }, spatialData:
            | { __typename?: 'GeographyLineString', geojson?: any | null, srid: number }
            | { __typename?: 'GeographyPoint', geojson?: any | null, srid: number }
            | { __typename?: 'GeographyPolygon', geojson?: any | null, srid: number }
           }> } } | null } | null };

export type Delete_Place_MutationMutationVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;


export type Delete_Place_MutationMutation = { __typename?: 'Mutation', deletePlace?: { __typename?: 'DeletePlacePayload', organization?: { __typename?: 'Organization', id: string, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string }> } } | null, place?: { __typename?: 'Place', id: string, name: string } | null } | null };

export type Disable_Incident_Type_MutationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  incidentTypeId: Scalars['String']['input'];
}>;


export type Disable_Incident_Type_MutationMutation = { __typename?: 'Mutation', disableIncidentForOrganization?: { __typename?: 'DisableIncidentForOrganizationPayload', query?: { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, enabledIncidentTypes: { __typename?: 'EnabledIncidentTypesConnection', totalCount: number, nodes: Array<{ __typename?: 'EnabledIncidentType', id: string, organizationId: string, incidentTypeId: string, defaultAssignedGroup?: { __typename?: 'Group', id: string, name: string, members: { __typename?: 'MembersConnection', totalCount: number } } | null }> } } | null } | null } | null };

export type Enable_Incident_Type_MutationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  incidentTypeId: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type Enable_Incident_Type_MutationMutation = { __typename?: 'Mutation', enableIncidentForOrganization?: { __typename?: 'EnableIncidentForOrganizationPayload', query?: { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, enabledIncidentTypes: { __typename?: 'EnabledIncidentTypesConnection', totalCount: number, nodes: Array<{ __typename?: 'EnabledIncidentType', id: string, organizationId: string, incidentTypeId: string, defaultAssignedGroupId?: string | null, defaultAssignedGroup?: { __typename?: 'Group', id: string, name: string, members: { __typename?: 'MembersConnection', totalCount: number } } | null }> } } | null } | null } | null };

export type Place_Select_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Place_Select_QueryQuery = { __typename?: 'Query', places?: { __typename?: 'PlacesConnection', edges: Array<{ __typename?: 'PlacesEdge', node: { __typename?: 'Place', id: string, organizationId: string, name: string, description: string } }> } | null };

export type Settings_Billing_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type Settings_Billing_QueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, createdAt: string, plan?: { __typename?: 'Plan', id: string, name: string, description: string, featureList: Array<string | null>, featureRapidsos: boolean, isExternalBilling: boolean } | null, subscription?: { __typename?: 'StripeSubscription', id: string, billingCycleAnchor: string, createdAt: string, currentPeriodEnd: string, currentPeriodStart: string, hasMore: boolean, items: Array<{ __typename?: 'StripeSubscriptionItem', createdAt: string, id: string, planAmount: number, planInterval: StripePlanInterval, priceUnitAmount: number, quantity: number }> } | null } | null };

export type Settings_General_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Settings_General_QueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, timezone: string, logoUrl: string, logoType: LogoType, memberMetadataFields: Record<string, MetadataField>, defaultMapZoom: number, ownerMemberId?: string | null, defaultMapCenter: { __typename?: 'GeographyPoint', longitude: number, latitude: number }, groups: { __typename?: 'GroupsConnection', totalCount: number, nodes: Array<{ __typename?: 'Group', id: string, name: string }> }, ownerMember?: { __typename?: 'Member', id: string, avatarUrl?: string | null, fullName: string, displayName?: string | null } | null, membershipCodes: { __typename?: 'MembershipCodesConnection', nodes: Array<{ __typename?: 'MembershipCode', id: string, code: string, groupIds: Array<string | null>, organizationRole: MemberRole, requiresApproval: boolean, createdAt: string }> }, members: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, fullName: string, displayName?: string | null, isEnabled: boolean }> } } | null };

export type Settings_Incident_Types_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Settings_Incident_Types_QueryQuery = { __typename?: 'Query', incidentTypes?: { __typename?: 'IncidentTypesConnection', totalCount: number, nodes: Array<{ __typename?: 'IncidentType', id: string, name: string, description: string, category: string, allowlist: Array<string | null>, useAllowlist: boolean, iconSvg: string }> } | null, organization?: { __typename?: 'Organization', id: string, enabledIncidentTypes: { __typename?: 'EnabledIncidentTypesConnection', totalCount: number, nodes: Array<{ __typename?: 'EnabledIncidentType', id: string, incidentTypeId: string, defaultAssignedGroupId?: string | null, defaultAssignedGroup?: { __typename?: 'Group', id: string, name: string } | null }> } } | null };

export type Settings_Integrations_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Settings_Integrations_QueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, settingIsRapidsosOperatorFlowEnabled: boolean, settingIsRapidsosPanicButtonFlowEnabled: boolean, settingRapidsosSocPhoneNumber: string, plan?: { __typename?: 'Plan', id: string, name: string, featureRapidsos: boolean } | null, bivySticks: { __typename?: 'BivySticksConnection', nodes: Array<{ __typename?: 'BivyStick', id: string, imei: string, isRegistered: boolean, createdAt: string, updatedAt: string, member?: { __typename?: 'Member', id: string, fullName: string, displayName?: string | null, avatarUrl?: string | null } | null }> } } | null };

export type Settings_Notifications_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Settings_Notifications_QueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, enabledIncidentTypes: { __typename?: 'EnabledIncidentTypesConnection', totalCount: number }, settings?: (
      { __typename?: 'OrganizationSetting', id: string }
      & { ' $fragmentRefs'?: { 'Check_In_Notification_Settings_FragmentFragment': Check_In_Notification_Settings_FragmentFragment;'Guardme_Notification_Settings_FragmentFragment': Guardme_Notification_Settings_FragmentFragment;'Incident_Notification_Settings_FragmentFragment': Incident_Notification_Settings_FragmentFragment } }
    ) | null } | null };

export type Check_In_Notification_Settings_FragmentFragment = { __typename?: 'OrganizationSetting', id: string, checkInSupervisorGroupId?: string | null, isAdministratorNotifiedOnCheckIn: boolean, isOwnerNotifiedOnCheckIn: boolean, isSupervisorNotifiedOnCheckIn: boolean } & { ' $fragmentName'?: 'Check_In_Notification_Settings_FragmentFragment' };

export type Guardme_Notification_Settings_FragmentFragment = { __typename?: 'OrganizationSetting', id: string, guardmeIsConcludedNotificationEnabled: boolean, guardmeIsExpiredNotificationEnabled: boolean, guardmeIsMetadataIncludedInNotification: boolean, guardmeIsPanicNotificationEnabled: boolean, guardmeIsStartedNotificationEnabled: boolean, guardmeSupervisorGroupId?: string | null, isAdministratorNotifiedOnGuardme: boolean, isOwnerNotifiedOnGuardme: boolean, isSupervisorNotifiedOnGuardme: boolean } & { ' $fragmentName'?: 'Guardme_Notification_Settings_FragmentFragment' };

export type Incident_Notification_Settings_FragmentFragment = { __typename?: 'OrganizationSetting', id: string, incidentSupervisorGroupId?: string | null, isAdministratorNotifiedOnIncident: boolean, isOwnerNotifiedOnIncident: boolean, isSupervisorNotifiedOnIncident: boolean } & { ' $fragmentName'?: 'Incident_Notification_Settings_FragmentFragment' };

export type Settings_Places_QueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type Settings_Places_QueryQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, defaultMapZoom: number, defaultMapCenter: { __typename?: 'GeographyPoint', longitude: number, latitude: number }, places: { __typename?: 'PlacesConnection', nodes: Array<{ __typename?: 'Place', id: string, name: string, description: string, updatedAt: string, createdAt: string, radius: number, encodedPolyline?: string | null, center: { __typename?: 'GeographyPoint', longitude: number, latitude: number, srid: number }, spatialData:
          | { __typename?: 'GeographyLineString', geojson?: any | null, srid: number }
          | { __typename?: 'GeographyPoint', geojson?: any | null, srid: number }
          | { __typename?: 'GeographyPolygon', geojson?: any | null, srid: number }
         }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } } | null };

export type Update_Organization_Member_Metadata_Fields_MutationMutationVariables = Exact<{
  input: UpdateOrganizationMemberMetadataFieldsInput;
}>;


export type Update_Organization_Member_Metadata_Fields_MutationMutation = { __typename?: 'Mutation', updateOrganizationMemberMetadataFields?: { __typename?: 'UpdateOrganizationMemberMetadataFieldsPayload', organization?: { __typename?: 'Organization', id: string, memberMetadataFields: Record<string, MetadataField> } | null } | null };

export type Update_Enabled_Incident_Type_MutationMutationVariables = Exact<{
  input: UpdateEnabledIncidentTypeAssignedGroupInput;
}>;


export type Update_Enabled_Incident_Type_MutationMutation = { __typename?: 'Mutation', updateEnabledIncidentTypeAssignedGroup?: { __typename?: 'UpdateEnabledIncidentTypeAssignedGroupPayload', enabledIncidentType?: { __typename?: 'EnabledIncidentType', id: string, defaultAssignedGroup?: { __typename?: 'Group', id: string, name: string } | null } | null } | null };

export type Update_Organization_Check_In_Settings_MutationMutationVariables = Exact<{
  input: UpdateOrganizationCheckInSettingsInput;
}>;


export type Update_Organization_Check_In_Settings_MutationMutation = { __typename?: 'Mutation', updateOrganizationCheckInSettings?: { __typename?: 'UpdateOrganizationCheckInSettingsPayload', organizationSetting?: { __typename?: 'OrganizationSetting', id: string, isAdministratorNotifiedOnCheckIn: boolean, isOwnerNotifiedOnCheckIn: boolean, isSupervisorNotifiedOnCheckIn: boolean, checkInSupervisorGroupId?: string | null, checkInSupervisorGroup?: { __typename?: 'Group', id: string, name: string } | null } | null } | null };

export type Update_Organization_Details_MutationMutationVariables = Exact<{
  input: UpdateOrganizationDetailsInput;
}>;


export type Update_Organization_Details_MutationMutation = { __typename?: 'Mutation', updateOrganizationDetails?: { __typename?: 'UpdateOrganizationDetailsPayload', organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string, logoType: LogoType, ownerMemberId?: string | null, timezone: string } | null } | null };

export type Update_Organization_Guardme_Settings_MutationMutationVariables = Exact<{
  input: UpdateOrganizationGuardmeSettingsInput;
}>;


export type Update_Organization_Guardme_Settings_MutationMutation = { __typename?: 'Mutation', updateOrganizationGuardmeSettings?: { __typename?: 'UpdateOrganizationGuardmeSettingsPayload', organizationSetting?: { __typename?: 'OrganizationSetting', id: string, isOwnerNotifiedOnGuardme: boolean, isAdministratorNotifiedOnGuardme: boolean, isSupervisorNotifiedOnGuardme: boolean, guardmeIsStartedNotificationEnabled: boolean, guardmeIsConcludedNotificationEnabled: boolean, guardmeIsExpiredNotificationEnabled: boolean, guardmeIsPanicNotificationEnabled: boolean, guardmeIsMetadataIncludedInNotification: boolean, guardmeSupervisorGroupId?: string | null, guardmeSupervisorGroup?: { __typename?: 'Group', id: string, name: string } | null } | null } | null };

export type Update_Organization_Incident_Settings_MutationMutationVariables = Exact<{
  input: UpdateOrganizationIncidentSettingsInput;
}>;


export type Update_Organization_Incident_Settings_MutationMutation = { __typename?: 'Mutation', updateOrganizationIncidentSettings?: { __typename?: 'UpdateOrganizationIncidentSettingsPayload', organizationSetting?: { __typename?: 'OrganizationSetting', id: string, isOwnerNotifiedOnIncident: boolean, isAdministratorNotifiedOnIncident: boolean, isSupervisorNotifiedOnIncident: boolean, incidentSupervisorGroupId?: string | null, incidentSupervisorGroup?: { __typename?: 'Group', id: string, name: string } | null } | null } | null };

export type Update_Organization_Map_Settings_MutationMutationVariables = Exact<{
  input: UpdateOrganizationMapSettingsInput;
}>;


export type Update_Organization_Map_Settings_MutationMutation = { __typename?: 'Mutation', updateOrganizationMapSettings?: { __typename?: 'UpdateOrganizationMapSettingsPayload', organization?: { __typename?: 'Organization', id: string, defaultMapZoom: number, defaultMapCenter: { __typename?: 'GeographyPoint', latitude: number, longitude: number } } | null, query?: { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, memberships: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, organization?: { __typename?: 'Organization', id: string, defaultMapZoom: number, defaultMapCenter: { __typename?: 'GeographyPoint', latitude: number, longitude: number } } | null }> } } | null } | null } | null };

export type Update_Organization_Rapidsos_Settings_MutationMutationVariables = Exact<{
  input: UpdateOrganizationRapidsosSettingsInput;
}>;


export type Update_Organization_Rapidsos_Settings_MutationMutation = { __typename?: 'Mutation', updateOrganizationRapidsosSettings?: { __typename?: 'UpdateOrganizationRapidsosSettingsPayload', organization?: { __typename?: 'Organization', id: string, settingIsRapidsosOperatorFlowEnabled: boolean, settingIsRapidsosPanicButtonFlowEnabled: boolean, settingRapidsosSocPhoneNumber: string } | null } | null };

export type Update_Place_MutationMutationVariables = Exact<{
  input: UpdatePlaceInput;
}>;


export type Update_Place_MutationMutation = { __typename?: 'Mutation', updatePlace?: { __typename?: 'UpdatePlacePayload', place?: { __typename?: 'Place', id: string, name: string, description: string, radius: number, encodedPolyline?: string | null, spatialData:
        | { __typename?: 'GeographyLineString', geojson?: any | null }
        | { __typename?: 'GeographyPoint', geojson?: any | null }
        | { __typename?: 'GeographyPolygon', geojson?: any | null }
      , center: { __typename?: 'GeographyPoint', longitude: number, latitude: number } } | null } | null };

export type Upload_Organization_Logo_MutationMutationVariables = Exact<{
  input: UploadOrganizationLogoInput;
}>;


export type Upload_Organization_Logo_MutationMutation = { __typename?: 'Mutation', uploadOrganizationLogo?: { __typename?: 'uploadOrganizationLogoPayload', id: string, fields: Record<string, MetadataField>, key: string, url: string } | null };

export type OrganizationUpdatesGqlSubscriptionVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type OrganizationUpdatesGqlSubscription = { __typename?: 'Subscription', organizationUpdates?: { __typename?: 'OrganizationUpdatesPayload', event?: GraphqlOrganizationUpdateEvent | null, relatedIds?: Array<string> | null, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl: string, organizationMetric?: { __typename?: 'OrganizationMetric', incidentsActive: number, incidentsOpen: number, incidentsInProgress: number, incidentsActiveHigh: number, incidentsActiveLow: number, incidentsActiveMedium: number, incidentsActiveUrgent: number, checkInsTotal: number, incidentsTotal: number, guardmesTotal: number, guardmesActive: number, guardmesInPanic: number, guardmesExpired: number } | null } | null } | null };

export type UseCurrentUserQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UseCurrentUserQueryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, fullName: string, avatarUrl: string, applicationRole: ApplicationRole, organizations: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: string, name: string, logoUrl: string }> }, memberships: { __typename?: 'MembersConnection', nodes: Array<{ __typename?: 'Member', id: string, organizationRole: MemberRole, groups: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, name: string }> } }> } } | null };

export const User_Memberships_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"USER_MEMBERSHIPS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<User_Memberships_FragmentFragment, unknown>;
export const Check_In_Report_Requestor_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_REPORT_REQUESTOR_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"requestorMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]} as unknown as DocumentNode<Check_In_Report_Requestor_FragmentFragment, unknown>;
export const Check_In_Report_Map_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_REPORT_MAP_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffAt"}},{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}},{"kind":"Field","name":{"kind":"Name","value":"radius"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultMapCenter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultMapZoom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkInRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkInId"}},{"kind":"Field","name":{"kind":"Name","value":"checkIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Check_In_Report_Map_FragmentFragment, unknown>;
export const Check_In_Report_Restrictions_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_REPORT_RESTRICTIONS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffAt"}},{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]} as unknown as DocumentNode<Check_In_Report_Restrictions_FragmentFragment, unknown>;
export const Check_In_Report_Requests_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_REPORT_REQUESTS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffAt"}},{"kind":"Field","name":{"kind":"Name","value":"checkInRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkInId"}},{"kind":"Field","name":{"kind":"Name","value":"checkIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Check_In_Report_Requests_FragmentFragment, unknown>;
export const Check_In_Member_Details_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_MEMBER_DETAILS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}}]} as unknown as DocumentNode<Check_In_Member_Details_FragmentFragment, unknown>;
export const Check_In_Location_Details_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_LOCATION_DETAILS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckIn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"plusCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Check_In_Location_Details_FragmentFragment, unknown>;
export const Check_In_Map_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_MAP_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckIn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Check_In_Map_FragmentFragment, unknown>;
export const Incidents_Breakdown_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INCIDENTS_BREAKDOWN_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidentsActive"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsOpen"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveHigh"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveLow"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveMedium"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveUrgent"}}]}}]}}]} as unknown as DocumentNode<Incidents_Breakdown_FragmentFragment, unknown>;
export const Members_Breakdown_FrragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MEMBERS_BREAKDOWN_FRRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitations"}},{"kind":"Field","name":{"kind":"Name","value":"members"}},{"kind":"Field","name":{"kind":"Name","value":"membershipRequests"}}]}}]}}]} as unknown as DocumentNode<Members_Breakdown_FrragmentFragment, unknown>;
export const Check_In_Report_FragementFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_REPORT_FRAGEMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkIns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtGte"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtLte"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Check_In_Report_FragementFragment, unknown>;
export const Guard_Me_Report_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GUARD_ME_REPORT_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtGte"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtLte"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Guard_Me_Report_FragmentFragment, unknown>;
export const Incident_Report_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INCIDENT_REPORT_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtGte"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtLte"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolutionAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstResponseAt"}},{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedValue"}},{"kind":"Field","name":{"kind":"Name","value":"performedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Incident_Report_FragmentFragment, unknown>;
export const Guardme_Session_Details_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GUARDME_SESSION_DETAILS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Guardme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalAttachments"}},{"kind":"Field","name":{"kind":"Name","value":"batteryLevel"}}]}}]} as unknown as DocumentNode<Guardme_Session_Details_FragmentFragment, unknown>;
export const Guardme_Member_Details_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GUARDME_MEMBER_DETAILS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}}]} as unknown as DocumentNode<Guardme_Member_Details_FragmentFragment, unknown>;
export const Inicdent_Information_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INICDENT_INFORMATION_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstResponseAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconSvg"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]} as unknown as DocumentNode<Inicdent_Information_FragmentFragment, unknown>;
export const Inicdent_Updates_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INICDENT_UPDATES_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uiSchema"}},{"kind":"Field","name":{"kind":"Name","value":"dataSchema"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"previousValue"}},{"kind":"Field","name":{"kind":"Name","value":"updatedValue"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemMessage"}},{"kind":"Field","name":{"kind":"Name","value":"performedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Inicdent_Updates_FragmentFragment, unknown>;
export const Incident_Details_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INCIDENT_DETAILS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataSchema"}},{"kind":"Field","name":{"kind":"Name","value":"uiSchema"}}]}}]}}]} as unknown as DocumentNode<Incident_Details_FragmentFragment, unknown>;
export const Inicdent_Contact_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INICDENT_CONTACT_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"emergencyContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}}]} as unknown as DocumentNode<Inicdent_Contact_FragmentFragment, unknown>;
export const Incident_Location_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INCIDENT_LOCATION_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentCoordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentCoordinatesGeocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"plusCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submittedByMemberCoordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Incident_Location_FragmentFragment, unknown>;
export const Member_Header_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MEMBER_HEADER_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}}]} as unknown as DocumentNode<Member_Header_FragmentFragment, unknown>;
export const Member_Detail_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MEMBER_DETAIL_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]} as unknown as DocumentNode<Member_Detail_FragmentFragment, unknown>;
export const Member_Detail_Metadata_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MEMBER_DETAIL_METADATA_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}}]} as unknown as DocumentNode<Member_Detail_Metadata_FragmentFragment, unknown>;
export const Member_Detail_Groups_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MEMBER_DETAIL_GROUPS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Member_Detail_Groups_FragmentFragment, unknown>;
export const Member_Detail_Emergency_Contacts_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MEMBER_DETAIL_EMERGENCY_CONTACTS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emergencyContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]}}]}}]} as unknown as DocumentNode<Member_Detail_Emergency_Contacts_FragmentFragment, unknown>;
export const Check_In_Notification_Settings_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_NOTIFICATION_SETTINGS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationSetting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkInSupervisorGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"isAdministratorNotifiedOnCheckIn"}},{"kind":"Field","name":{"kind":"Name","value":"isOwnerNotifiedOnCheckIn"}},{"kind":"Field","name":{"kind":"Name","value":"isSupervisorNotifiedOnCheckIn"}}]}}]} as unknown as DocumentNode<Check_In_Notification_Settings_FragmentFragment, unknown>;
export const Guardme_Notification_Settings_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GUARDME_NOTIFICATION_SETTINGS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationSetting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsConcludedNotificationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsExpiredNotificationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsMetadataIncludedInNotification"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsPanicNotificationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsStartedNotificationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeSupervisorGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"isAdministratorNotifiedOnGuardme"}},{"kind":"Field","name":{"kind":"Name","value":"isOwnerNotifiedOnGuardme"}},{"kind":"Field","name":{"kind":"Name","value":"isSupervisorNotifiedOnGuardme"}}]}}]} as unknown as DocumentNode<Guardme_Notification_Settings_FragmentFragment, unknown>;
export const Incident_Notification_Settings_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INCIDENT_NOTIFICATION_SETTINGS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationSetting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"incidentSupervisorGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"isAdministratorNotifiedOnIncident"}},{"kind":"Field","name":{"kind":"Name","value":"isOwnerNotifiedOnIncident"}},{"kind":"Field","name":{"kind":"Name","value":"isSupervisorNotifiedOnIncident"}}]}}]} as unknown as DocumentNode<Incident_Notification_Settings_FragmentFragment, unknown>;
export const AttachmentUploadGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AttachmentUploadGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uploadAttachmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadAttachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<AttachmentUploadGqlMutation, AttachmentUploadGqlMutationVariables>;
export const DeleteSubscriptionIntentQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSubscriptionIntentQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrganizationSubscriptionIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<DeleteSubscriptionIntentQueryMutation, DeleteSubscriptionIntentQueryMutationVariables>;
export const CreateSubscriptionIntentQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSubscriptionIntentQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"annual"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganizationSubscriptionIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"annual"},"value":{"kind":"Variable","name":{"kind":"Name","value":"annual"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subscriptionCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionCount"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSubscriptionIntentQueryMutation, CreateSubscriptionIntentQueryMutationVariables>;
export const PaymentStatusUserUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentStatusUserUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"isGuardmeSupervisor"}},{"kind":"Field","name":{"kind":"Name","value":"isIncidentSupervisor"}},{"kind":"Field","name":{"kind":"Name","value":"isCheckInSupervisor"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PaymentStatusUserUpdateQuery, PaymentStatusUserUpdateQueryVariables>;
export const SelectPlansGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectPlansGql"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"basicPlan"},"name":{"kind":"Name","value":"plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"marketingType"},"value":{"kind":"EnumValue","value":"BASIC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"marketingType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isExternalBilling"}},{"kind":"Field","name":{"kind":"Name","value":"featureList"}},{"kind":"Field","name":{"kind":"Name","value":"stripeMonthPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeMonthPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripeYearPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeYearPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripeProductId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"premiumPlan"},"name":{"kind":"Name","value":"plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"marketingType"},"value":{"kind":"EnumValue","value":"PREMIUM"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"marketingType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isExternalBilling"}},{"kind":"Field","name":{"kind":"Name","value":"featureList"}},{"kind":"Field","name":{"kind":"Name","value":"stripeMonthPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeMonthPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripeYearPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeYearPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripeProductId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SelectPlansGqlQuery, SelectPlansGqlQueryVariables>;
export const ResendPendingEmailAddressCodeGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendPendingEmailAddressCodeGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserUpdateEmailAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"emailAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailAddress"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pendingEmailAddress"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ResendPendingEmailAddressCodeGqlMutation, ResendPendingEmailAddressCodeGqlMutationVariables>;
export const DeletePendingEmailAddressGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePendingEmailAddressGql"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserDeletePendingEmailAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pendingEmailAddress"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeletePendingEmailAddressGqlMutation, DeletePendingEmailAddressGqlMutationVariables>;
export const ResendPendingPhoneNumberCodeGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendPendingPhoneNumberCodeGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserUpdatePhoneNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pendingPhoneNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ResendPendingPhoneNumberCodeGqlMutation, ResendPendingPhoneNumberCodeGqlMutationVariables>;
export const DeletePendingPhoneNumberGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePendingPhoneNumberGql"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserDeletePendingPhoneNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pendingPhoneNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeletePendingPhoneNumberGqlMutation, DeletePendingPhoneNumberGqlMutationVariables>;
export const AccountNotificationsPageGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountNotificationsPageGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountNotificationsPageGqlQuery, AccountNotificationsPageGqlQueryVariables>;
export const VerifyCurrentUserEmailAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyCurrentUserEmailAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyEmailAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyEmailAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"pendingEmailAddress"}}]}}]}}]}}]}}]} as unknown as DocumentNode<VerifyCurrentUserEmailAddressMutation, VerifyCurrentUserEmailAddressMutationVariables>;
export const VerifyPendingPhonenumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyPendingPhonenumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyPhoneNumberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyPhoneNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pendingPhoneNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<VerifyPendingPhonenumberMutation, VerifyPendingPhonenumberMutationVariables>;
export const Accept_Invitation_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ACCEPT_INVITATION_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Accept_Invitation_MutationMutation, Accept_Invitation_MutationMutationVariables>;
export const Acknowledge_Notification_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ACKNOWLEDGE_NOTIFICATION_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acknowledgeUserNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notificationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRead"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Acknowledge_Notification_MutationMutation, Acknowledge_Notification_MutationMutationVariables>;
export const Cancel_Membership_Request_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CANCEL_MEMBERSHIP_REQUEST_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelMembershipRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membershipRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Cancel_Membership_Request_MutationMutation, Cancel_Membership_Request_MutationMutationVariables>;
export const Current_User_Close_Account_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CURRENT_USER_CLOSE_ACCOUNT_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserCloseAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clientMutationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Current_User_Close_Account_MutationMutation, Current_User_Close_Account_MutationMutationVariables>;
export const Current_User_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CURRENT_USER_QUERY"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRole"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"userNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"isGuardmeSupervisor"}},{"kind":"Field","name":{"kind":"Name","value":"isIncidentSupervisor"}},{"kind":"Field","name":{"kind":"Name","value":"isCheckInSupervisor"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultMapCenter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultMapZoom"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Current_User_QueryQuery, Current_User_QueryQueryVariables>;
export const Current_User_Updates_SubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CURRENT_USER_UPDATES_SUBSCRIPTION"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"pendingEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pendingPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRole"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"relatedIds"}}]}}]}}]} as unknown as DocumentNode<Current_User_Updates_SubscriptionSubscription, Current_User_Updates_SubscriptionSubscriptionVariables>;
export const Delete_Notification_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DELETE_NOTIFICATION_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notificationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRead"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Delete_Notification_MutationMutation, Delete_Notification_MutationMutationVariables>;
export const Membership_Request_Discover_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MEMBERSHIP_REQUEST_DISCOVER_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipRequestDiscover"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipRequestDiscoverResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationLogoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"publicMetadataFields"}}]}}]}}]}}]} as unknown as DocumentNode<Membership_Request_Discover_MutationMutation, Membership_Request_Discover_MutationMutationVariables>;
export const Membership_Request_Submit_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MEMBERSHIP_REQUEST_SUBMIT_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipRequestSubmit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"publicMetadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Membership_Request_Submit_MutationMutation, Membership_Request_Submit_MutationMutationVariables>;
export const Update_Current_User_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_CURRENT_USER_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CurrentUserUpdateDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserUpdateDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"avatarType"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]} as unknown as DocumentNode<Update_Current_User_MutationMutation, Update_Current_User_MutationMutationVariables>;
export const Update_Email_Address_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_EMAIL_ADDRESS_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CurrentUserUpdateEmailAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserUpdateEmailAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pendingEmailAddress"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Update_Email_Address_MutationMutation, Update_Email_Address_MutationMutationVariables>;
export const Update_Phone_Number_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_PHONE_NUMBER_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CurrentUserUpdatePhoneNumberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserUpdatePhoneNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pendingPhoneNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Update_Phone_Number_MutationMutation, Update_Phone_Number_MutationMutationVariables>;
export const Upload_Avatar_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPLOAD_AVATAR_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uploadAvatarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadAvatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<Upload_Avatar_MutationMutation, Upload_Avatar_MutationMutationVariables>;
export const User_Debug_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"USER_DEBUG_QUERY"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mobileDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deviceToken"}},{"kind":"Field","name":{"kind":"Name","value":"deviceModel"}},{"kind":"Field","name":{"kind":"Name","value":"deviceType"}},{"kind":"Field","name":{"kind":"Name","value":"deviceOsVersion"}},{"kind":"Field","name":{"kind":"Name","value":"operationalStatus"}}]}}]}}]}}]}}]} as unknown as DocumentNode<User_Debug_QueryQuery, User_Debug_QueryQueryVariables>;
export const User_Membership_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"USER_MEMBERSHIP_QUERY"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"USER_MEMBERSHIPS_FRAGMENT"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"USER_MEMBERSHIPS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<User_Membership_QueryQuery, User_Membership_QueryQueryVariables>;
export const User_Notifications_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"USER_NOTIFICATIONS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<User_Notifications_QueryQuery, User_Notifications_QueryQueryVariables>;
export const User_Profile_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"USER_PROFILE_QUERY"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRole"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"avatarType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"pendingEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pendingPhoneNumber"}}]}}]}}]} as unknown as DocumentNode<User_Profile_QueryQuery, User_Profile_QueryQueryVariables>;
export const Check_In_Report_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CHECK_IN_REPORT_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkInReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CHECK_IN_REPORT_REQUESTOR_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CHECK_IN_REPORT_MAP_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CHECK_IN_REPORT_RESTRICTIONS_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CHECK_IN_REPORT_REQUESTS_FRAGMENT"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_REPORT_REQUESTOR_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"requestorMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_REPORT_MAP_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffAt"}},{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}},{"kind":"Field","name":{"kind":"Name","value":"radius"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultMapCenter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultMapZoom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkInRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkInId"}},{"kind":"Field","name":{"kind":"Name","value":"checkIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_REPORT_RESTRICTIONS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffAt"}},{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_REPORT_REQUESTS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffAt"}},{"kind":"Field","name":{"kind":"Name","value":"checkInRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkInId"}},{"kind":"Field","name":{"kind":"Name","value":"checkIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Check_In_Report_QueryQuery, Check_In_Report_QueryQueryVariables>;
export const Check_In_Report_Updates_SubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CHECK_IN_REPORT_UPDATES_SUBSCRIPTION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInReportUpdatesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkInReportUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkInReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffAt"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}},{"kind":"Field","name":{"kind":"Name","value":"radius"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestorMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkInRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkInId"}},{"kind":"Field","name":{"kind":"Name","value":"checkIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"relatedIds"}}]}}]}}]} as unknown as DocumentNode<Check_In_Report_Updates_SubscriptionSubscription, Check_In_Report_Updates_SubscriptionSubscriptionVariables>;
export const Check_In_Reports_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CHECK_IN_REPORTS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInReportsCreatedAtConditionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInReportsOrderBy"}}}},"defaultValue":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestorMemberId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkInReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"requestorMemberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestorMemberId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"shortId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffAt"}},{"kind":"Field","name":{"kind":"Name","value":"requestorMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"requestorMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkInRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<Check_In_Reports_QueryQuery, Check_In_Reports_QueryQueryVariables>;
export const Create_Check_In_Report_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_CHECK_IN_REPORT_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCheckInReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCheckInReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkInReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"requestorMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cutoffAt"}},{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Create_Check_In_Report_MutationMutation, Create_Check_In_Report_MutationMutationVariables>;
export const Check_In_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CHECK_IN_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CHECK_IN_MEMBER_DETAILS_FRAGMENT"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CHECK_IN_LOCATION_DETAILS_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CHECK_IN_MAP_FRAGMENT"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_MEMBER_DETAILS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_LOCATION_DETAILS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckIn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"plusCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_MAP_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CheckIn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Check_In_QueryQuery, Check_In_QueryQueryVariables>;
export const Check_In_Updates_SubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CHECK_IN_UPDATES_SUBSCRIPTION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkInUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"relatedIds"}}]}}]}}]} as unknown as DocumentNode<Check_In_Updates_SubscriptionSubscription, Check_In_Updates_SubscriptionSubscriptionVariables>;
export const Check_Ins_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CHECK_INS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInsCreatedAtConditionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckInsOrderBy"}}}},"defaultValue":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkIns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"shortId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<Check_Ins_QueryQuery, Check_Ins_QueryQueryVariables>;
export const NavOrganizationGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NavOrganizationGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeGuardmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<NavOrganizationGqlQuery, NavOrganizationGqlQueryVariables>;
export const NotificationsMenuItemGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotificationsMenuItemGql"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRead"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<NotificationsMenuItemGqlQuery, NotificationsMenuItemGqlQueryVariables>;
export const PendingInvitationsCalloutGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PendingInvitationsCalloutGql"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<PendingInvitationsCalloutGqlQuery, PendingInvitationsCalloutGqlQueryVariables>;
export const Dashboard_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DASHBOARD_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardmesActive"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActive"}}]}}]}}]}}]} as unknown as DocumentNode<Dashboard_QueryQuery, Dashboard_QueryQueryVariables>;
export const Guardme_Dashboard_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GUARDME_DASHBOARD_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeGuardmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"batteryLevel"}},{"kind":"Field","name":{"kind":"Name","value":"totalAttachments"}}]}}]}}]}}]} as unknown as DocumentNode<Guardme_Dashboard_QueryQuery, Guardme_Dashboard_QueryQueryVariables>;
export const Incidents_Dashboard_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"INCIDENTS_DASHBOARD_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"closed"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"inProgress"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"contactMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconSvg"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Incidents_Dashboard_QueryQuery, Incidents_Dashboard_QueryQueryVariables>;
export const Overview_Dashboard_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OVERVIEW_DASHBOARD_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"INCIDENTS_BREAKDOWN_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MEMBERS_BREAKDOWN_FRRAGMENT"}},{"kind":"Field","name":{"kind":"Name","value":"organizationMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkInsGraph"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}},{"kind":"Argument","name":{"kind":"Name","value":"timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guardmesGraph"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}},{"kind":"Argument","name":{"kind":"Name","value":"timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentsGraph"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}},{"kind":"Argument","name":{"kind":"Name","value":"timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INCIDENTS_BREAKDOWN_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidentsActive"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsOpen"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveHigh"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveLow"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveMedium"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveUrgent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MEMBERS_BREAKDOWN_FRRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitations"}},{"kind":"Field","name":{"kind":"Name","value":"members"}},{"kind":"Field","name":{"kind":"Name","value":"membershipRequests"}}]}}]}}]} as unknown as DocumentNode<Overview_Dashboard_QueryQuery, Overview_Dashboard_QueryQueryVariables>;
export const Recent_Activity_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RECENT_ACTIVITY_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt_gte"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveUrgent"}},{"kind":"Field","name":{"kind":"Name","value":"guardmesInPanic"}},{"kind":"Field","name":{"kind":"Name","value":"guardmesExpired"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt_gte"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"iconSvg"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentCoordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"guardmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt_gte"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkIns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt_gte"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Recent_Activity_QueryQuery, Recent_Activity_QueryQueryVariables>;
export const Reports_Dashboard_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"REPORTS_DASHBOARD_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAtGte"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAtLte"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CHECK_IN_REPORT_FRAGEMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GUARD_ME_REPORT_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"INCIDENT_REPORT_FRAGMENT"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_REPORT_FRAGEMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkIns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtGte"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtLte"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GUARD_ME_REPORT_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtGte"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtLte"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INCIDENT_REPORT_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtGte"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAtLte"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolutionAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstResponseAt"}},{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedValue"}},{"kind":"Field","name":{"kind":"Name","value":"performedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Reports_Dashboard_QueryQuery, Reports_Dashboard_QueryQueryVariables>;
export const GuardmeAttachmenGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GuardmeAttachmenGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardmeAttachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GuardmeAttachmenGqlQuery, GuardmeAttachmenGqlQueryVariables>;
export const GuardMeAttachmentsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GuardMeAttachmentsGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeAttachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"livestreams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GuardMeAttachmentsGqlQuery, GuardMeAttachmentsGqlQueryVariables>;
export const GuardMeAuditLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GuardMeAuditLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guardmeAuditLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"performedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"performedById"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GuardMeAuditLogQuery, GuardMeAuditLogQueryVariables>;
export const GuardMeConcludeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GuardMeConclude"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guardmeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endGuardme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"guardmeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guardmeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"isSafe"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GuardMeConcludeMutation, GuardMeConcludeMutationVariables>;
export const GuardMeExtendDialogGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GuardMeExtendDialogGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endsAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimedGuardmeEndsAt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endsAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endsAt"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GuardMeExtendDialogGqlMutation, GuardMeExtendDialogGqlMutationVariables>;
export const GuardMePanicAsAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GuardMePanicAsAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guardmeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useOperatorFlow"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorPhoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGuardmePanicAsAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"guardmeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guardmeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useOperatorFlow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useOperatorFlow"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operatorPhoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorPhoneNumber"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"isSafe"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GuardMePanicAsAdminMutation, GuardMePanicAsAdminMutationVariables>;
export const GuardMeActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GuardMeActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isSafe"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"settingIsRapidsosPanicButtonFlowEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"settingIsRapidsosOperatorFlowEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"settingRapidsosSocPhoneNumber"}}]}}]}}]}}]} as unknown as DocumentNode<GuardMeActionsQuery, GuardMeActionsQueryVariables>;
export const Guardme_Livestream_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GUARDME_LIVESTREAM_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"livestream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"streamingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<Guardme_Livestream_QueryQuery, Guardme_Livestream_QueryQueryVariables>;
export const Guardme_Audit_Log_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GUARDME_AUDIT_LOG_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guardmeAuditLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"performedById"}},{"kind":"Field","name":{"kind":"Name","value":"performedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"guardmeAttachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"livestreams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"streamingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Guardme_Audit_Log_QueryQuery, Guardme_Audit_Log_QueryQueryVariables>;
export const Guardme_Emergency_Contacts_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GUARDME_EMERGENCY_CONTACTS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emergencyContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Guardme_Emergency_Contacts_QueryQuery, Guardme_Emergency_Contacts_QueryQueryVariables>;
export const Guardme_Map_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GUARDME_MAP_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationTimelineAsEncodedPolyline"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"plusCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Guardme_Map_QueryQuery, Guardme_Map_QueryQueryVariables>;
export const Guardme_Member_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GUARDME_MEMBER_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Guardme_Member_QueryQuery, Guardme_Member_QueryQueryVariables>;
export const Guard_Me_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GUARD_ME_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GUARDME_MEMBER_DETAILS_FRAGMENT"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}},{"kind":"Field","name":{"kind":"Name","value":"settingIsRapidsosPanicButtonFlowEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"settingIsRapidsosOperatorFlowEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"settingRapidsosSocPhoneNumber"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GUARDME_SESSION_DETAILS_FRAGMENT"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GUARDME_MEMBER_DETAILS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GUARDME_SESSION_DETAILS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Guardme"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalAttachments"}},{"kind":"Field","name":{"kind":"Name","value":"batteryLevel"}}]}}]} as unknown as DocumentNode<Guard_Me_QueryQuery, Guard_Me_QueryQueryVariables>;
export const Guard_Mes_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GUARD_MES_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GuardMesCreatedAtConditionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GuardmesOrderBy"}}}},"defaultValue":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GuardMesStatusConditionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<Guard_Mes_QueryQuery, Guard_Mes_QueryQueryVariables>;
export const Guardme_Updates_SubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GUARDME_UPDATES_SUBSCRIPTION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardmeUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guardme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSafe"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"batteryLevel"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"locationTimelineAsEncodedPolyline"}},{"kind":"Field","name":{"kind":"Name","value":"lastLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"plusCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAttachments"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeAttachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"livestreams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"guardmeAuditLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"relatedIds"}}]}}]}}]} as unknown as DocumentNode<Guardme_Updates_SubscriptionSubscription, Guardme_Updates_SubscriptionSubscriptionVariables>;
export const MembershipRequestCalloutGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MembershipRequestCalloutGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membershipRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<MembershipRequestCalloutGqlQuery, MembershipRequestCalloutGqlQueryVariables>;
export const Current_User_Recent_Activity_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CURRENT_USER_RECENT_ACTIVITY_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gte"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkIns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ID_DESC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gte"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"guardmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ID_DESC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gte"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentsByContactMemberId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ID_DESC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gte"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconSvg"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Current_User_Recent_Activity_QueryQuery, Current_User_Recent_Activity_QueryQueryVariables>;
export const Home_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HOME_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"guardmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentsByContactMemberId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"closed"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"inProgress"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentsByOwnedByMemberId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"closed"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"inProgress"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"open"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkIns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkInRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"checkInReportId"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRead"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<Home_QueryQuery, Home_QueryQueryVariables>;
export const My_Inicdents_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MY_INICDENTS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentsCreatedAtConditionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentsStatusConditionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priority"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentsPriorityConditionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentsOrderBy"}}}},"defaultValue":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignedToMe"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsByContactMemberId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignedToMeOrMyGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignedToMe"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priority"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"types"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contactMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconSvg"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<My_Inicdents_QueryQuery, My_Inicdents_QueryQueryVariables>;
export const EditIncidentContactDropdownDropdownGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditIncidentContactDropdownDropdownGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIncidentContactInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contactMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditIncidentContactDropdownDropdownGqlMutation, EditIncidentContactDropdownDropdownGqlMutationVariables>;
export const AllMemberDropdownGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllMemberDropdownGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]} as unknown as DocumentNode<AllMemberDropdownGqlQuery, AllMemberDropdownGqlQueryVariables>;
export const EditIncidentGroupDropdownGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditIncidentGroupDropdownGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIncidentGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditIncidentGroupDropdownGqlMutation, EditIncidentGroupDropdownGqlMutationVariables>;
export const AllGroupDropdownGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllGroupDropdownGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AllGroupDropdownGqlQuery, AllGroupDropdownGqlQueryVariables>;
export const EditIncidentOwnerDropdownGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditIncidentOwnerDropdownGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIncidentOwnerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentOwner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditIncidentOwnerDropdownGqlMutation, EditIncidentOwnerDropdownGqlMutationVariables>;
export const EditIncidentPriorityDropdownGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditIncidentPriorityDropdownGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIncidentPriorityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentPriority"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]}}]}}]} as unknown as DocumentNode<EditIncidentPriorityDropdownGqlMutation, EditIncidentPriorityDropdownGqlMutationVariables>;
export const EditIncidentStatusDropdownGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditIncidentStatusDropdownGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIncidentStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<EditIncidentStatusDropdownGqlMutation, EditIncidentStatusDropdownGqlMutationVariables>;
export const IncidentGroupControlGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IncidentGroupControlGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"incidentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemMessage"}},{"kind":"Field","name":{"kind":"Name","value":"performedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IncidentGroupControlGqlMutation, IncidentGroupControlGqlMutationVariables>;
export const IncidentLivestreamDroneGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IncidentLivestreamDroneGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"livestreamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"livestream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"livestreamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"droneEndpoint"}}]}}]}}]} as unknown as DocumentNode<IncidentLivestreamDroneGqlQuery, IncidentLivestreamDroneGqlQueryVariables>;
export const StartLivestreamDroneGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartLivestreamDroneGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartIncidentLivestreamInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startIncidentLivestream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"livestream"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"droneEndpoint"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<StartLivestreamDroneGqlMutation, StartLivestreamDroneGqlMutationVariables>;
export const EndLivestreamDroneGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EndLivestreamDroneGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EndIncidentLivestreamInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endIncidentLivestream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"livestream"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<EndLivestreamDroneGqlMutation, EndLivestreamDroneGqlMutationVariables>;
export const IncidentUpdatesGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"IncidentUpdatesGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"incidentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstResponseAt"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}},{"kind":"Field","name":{"kind":"Name","value":"incidentCoordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentCoordinatesGeocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"plusCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submittedByMemberCoordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submittedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"previousValue"}},{"kind":"Field","name":{"kind":"Name","value":"updatedValue"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemMessage"}},{"kind":"Field","name":{"kind":"Name","value":"performedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataSchema"}},{"kind":"Field","name":{"kind":"Name","value":"uiSchema"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"relatedIds"}}]}}]}}]} as unknown as DocumentNode<IncidentUpdatesGqlSubscription, IncidentUpdatesGqlSubscriptionVariables>;
export const MemberComponentGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberComponentGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]} as unknown as DocumentNode<MemberComponentGqlQuery, MemberComponentGqlQueryVariables>;
export const CreateIncidentNoteFormGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIncidentNoteFormGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPrivate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attachmentIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIncidentNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"incidentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isPrivate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPrivate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"attachmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attachmentIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemMessage"}},{"kind":"Field","name":{"kind":"Name","value":"performedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateIncidentNoteFormGqlMutation, CreateIncidentNoteFormGqlMutationVariables>;
export const IncidentNoteControlCloseGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IncidentNoteControlCloseGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"incidentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"CLOSED"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemMessage"}},{"kind":"Field","name":{"kind":"Name","value":"performedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IncidentNoteControlCloseGqlMutation, IncidentNoteControlCloseGqlMutationVariables>;
export const Incident_Livestream_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"INCIDENT_LIVESTREAM_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"livestream"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"streamingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<Incident_Livestream_QueryQuery, Incident_Livestream_QueryQueryVariables>;
export const IncidentPriorityMenuRadioGroupGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IncidentPriorityMenuRadioGroupGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priority"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentPriorityType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentPriority"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"incidentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priority"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemMessage"}},{"kind":"Field","name":{"kind":"Name","value":"performedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IncidentPriorityMenuRadioGroupGqlMutation, IncidentPriorityMenuRadioGroupGqlMutationVariables>;
export const IncidentStatusMenuRadioGroupGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IncidentStatusMenuRadioGroupGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentStatusType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"incidentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemMessage"}},{"kind":"Field","name":{"kind":"Name","value":"performedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<IncidentStatusMenuRadioGroupGqlMutation, IncidentStatusMenuRadioGroupGqlMutationVariables>;
export const Assign_Incident_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ASSIGN_INCIDENT_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIncidentOwnerInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"group"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIncidentGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentOwner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owner"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateIncidentGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"group"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Assign_Incident_MutationMutation, Assign_Incident_MutationMutationVariables>;
export const Create_Incident_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_INCIDENT_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIncidentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIncident"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemMessage"}},{"kind":"Field","name":{"kind":"Name","value":"performedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Create_Incident_MutationMutation, Create_Incident_MutationMutationVariables>;
export const Enabled_Incident_Types_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ENABLED_INCIDENT_TYPES_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabledIncidentTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssignedGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"iconSvg"}},{"kind":"Field","name":{"kind":"Name","value":"uiSchema"}},{"kind":"Field","name":{"kind":"Name","value":"dataSchema"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Enabled_Incident_Types_QueryQuery, Enabled_Incident_Types_QueryQueryVariables>;
export const Group_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GROUP_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Group_QueryQuery, Group_QueryQueryVariables>;
export const Incident_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"INCIDENT_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstResponseAt"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionAt"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}},{"kind":"Field","name":{"kind":"Name","value":"submittedByMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"submittedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"livestreams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataSchema"}},{"kind":"Field","name":{"kind":"Name","value":"uiSchema"}},{"kind":"Field","name":{"kind":"Name","value":"iconSvg"}},{"kind":"Field","name":{"kind":"Name","value":"allowDroneEndpoint"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"INICDENT_UPDATES_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"INCIDENT_DETAILS_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"INICDENT_INFORMATION_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"INICDENT_CONTACT_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"INCIDENT_LOCATION_FRAGMENT"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INICDENT_UPDATES_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uiSchema"}},{"kind":"Field","name":{"kind":"Name","value":"dataSchema"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"previousValue"}},{"kind":"Field","name":{"kind":"Name","value":"updatedValue"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemMessage"}},{"kind":"Field","name":{"kind":"Name","value":"performedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INCIDENT_DETAILS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataSchema"}},{"kind":"Field","name":{"kind":"Name","value":"uiSchema"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INICDENT_INFORMATION_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstResponseAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconSvg"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INICDENT_CONTACT_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"emergencyContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INCIDENT_LOCATION_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentCoordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentCoordinatesGeocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"plusCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submittedByMemberCoordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Incident_QueryQuery, Incident_QueryQueryVariables>;
export const Incident_Types_List_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"INCIDENT_TYPES_LIST_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabledIncidentTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconSvg"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Incident_Types_List_QueryQuery, Incident_Types_List_QueryQueryVariables>;
export const Incidents_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"INCIDENTS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentsCreatedAtConditionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentsStatusConditionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priority"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentsPriorityConditionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IncidentsOrderBy"}}}},"defaultValue":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priority"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"types"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contactMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incidentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconSvg"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<Incidents_QueryQuery, Incidents_QueryQueryVariables>;
export const Incidents_Updates_SubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"INCIDENTS_UPDATES_SUBSCRIPTION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidentsUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"relatedIds"}}]}}]}}]} as unknown as DocumentNode<Incidents_Updates_SubscriptionSubscription, Incidents_Updates_SubscriptionSubscriptionVariables>;
export const Update_Incident_Agent_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_INCIDENT_AGENT_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIncidentOwnerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentOwner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Update_Incident_Agent_MutationMutation, Update_Incident_Agent_MutationMutationVariables>;
export const Update_Incident_Contact_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_INCIDENT_CONTACT_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIncidentContactInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"INICDENT_CONTACT_FRAGMENT"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INICDENT_CONTACT_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Incident"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"contactMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"emergencyContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}}]} as unknown as DocumentNode<Update_Incident_Contact_MutationMutation, Update_Incident_Contact_MutationMutationVariables>;
export const Update_Incident_Details_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_INCIDENT_DETAILS_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additionalData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"incidentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incidentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"additionalData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additionalData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}},{"kind":"Field","name":{"kind":"Name","value":"incidentUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemMessage"}},{"kind":"Field","name":{"kind":"Name","value":"performedByMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Update_Incident_Details_MutationMutation, Update_Incident_Details_MutationMutationVariables>;
export const Update_Incident_Group_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_INCIDENT_GROUP_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIncidentGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ownedByGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Update_Incident_Group_MutationMutation, Update_Incident_Group_MutationMutationVariables>;
export const Update_Incident_Priority_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_INCIDENT_PRIORITY_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIncidentPriorityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentPriority"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]}}]}}]} as unknown as DocumentNode<Update_Incident_Priority_MutationMutation, Update_Incident_Priority_MutationMutationVariables>;
export const Update_Incident_Status_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_INCIDENT_STATUS_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIncidentStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIncidentStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<Update_Incident_Status_MutationMutation, Update_Incident_Status_MutationMutationVariables>;
export const AddMemberToGroupQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddMemberToGroupQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addMemberToGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mapGroupsMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}}]}}]}}]}}]} as unknown as DocumentNode<AddMemberToGroupQueryMutation, AddMemberToGroupQueryMutationVariables>;
export const GroupDeleteGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GroupDeleteGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]} as unknown as DocumentNode<GroupDeleteGqlMutation, GroupDeleteGqlMutationVariables>;
export const GroupSelectQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GroupSelectQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GroupSelectQueryQuery, GroupSelectQueryQueryVariables>;
export const Approve_Membership_UpdaaterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"APPROVE_MEMBERSHIP_UPDAATER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membershipRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Approve_Membership_UpdaaterQuery, Approve_Membership_UpdaaterQueryVariables>;
export const OrganizationInvitationsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationInvitationsGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationInvitationsGqlQuery, OrganizationInvitationsGqlQueryVariables>;
export const DeleteInvitationUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeleteInvitationUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteInvitationUpdateQuery, DeleteInvitationUpdateQueryVariables>;
export const DeleteMemberUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeleteMemberUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteMemberUpdateQuery, DeleteMemberUpdateQueryVariables>;
export const Deny_Memership_Request_UpdaterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DENY_MEMERSHIP_REQUEST_UPDATER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membershipRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Deny_Memership_Request_UpdaterQuery, Deny_Memership_Request_UpdaterQueryVariables>;
export const EditDisplayNameDialogGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditDisplayNameDialogGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMemberDisplayName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<EditDisplayNameDialogGqlMutation, EditDisplayNameDialogGqlMutationVariables>;
export const EditGroupsDialogGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditGroupsDialogGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMemberGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditGroupsDialogGqlMutation, EditGroupsDialogGqlMutationVariables>;
export const EditMetadataDialogGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditMetadataDialogGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMemberMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<EditMetadataDialogGqlMutation, EditMetadataDialogGqlMutationVariables>;
export const EditRoleDropdownGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditRoleDropdownGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberRole"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMemberRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}}]}}]}}]}}]} as unknown as DocumentNode<EditRoleDropdownGqlMutation, EditRoleDropdownGqlMutationVariables>;
export const Member_Check_Ins_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MEMBER_CHECK_INS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkIns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ID_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Member_Check_Ins_QueryQuery, Member_Check_Ins_QueryQueryVariables>;
export const EnableeMemberDetailStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnableeMemberDetailStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<EnableeMemberDetailStatusMutation, EnableeMemberDetailStatusMutationVariables>;
export const DisableMemberDetailStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableMemberDetailStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disableMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<DisableMemberDetailStatusMutation, DisableMemberDetailStatusMutationVariables>;
export const Member_Gaurdmes_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MEMBER_GAURDMES_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"guardmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ID_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Member_Gaurdmes_QueryQuery, Member_Gaurdmes_QueryQueryVariables>;
export const Member_Incidentss_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MEMBER_INCIDENTSS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsByContactMemberId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ID_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iconSvg"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Member_Incidentss_QueryQuery, Member_Incidentss_QueryQueryVariables>;
export const MemberOverviewGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberOverviewGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"guardmesTotal"},"name":{"kind":"Name","value":"guardmes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"incidentsTotal"},"name":{"kind":"Name","value":"incidentsByContactMemberId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"checkInsTotal"},"name":{"kind":"Name","value":"checkIns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<MemberOverviewGqlQuery, MemberOverviewGqlQueryVariables>;
export const Approve_Membership_Request_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"APPROVE_MEMBERSHIP_REQUEST_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApproveMembershipRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approveMembershipRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]} as unknown as DocumentNode<Approve_Membership_Request_MutationMutation, Approve_Membership_Request_MutationMutationVariables>;
export const Create_Invitation_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_INVITATION_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateInvitationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"groupIds"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}}]}}]}}]}}]} as unknown as DocumentNode<Create_Invitation_MutationMutation, Create_Invitation_MutationMutationVariables>;
export const Delete_Member_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DELETE_MEMBER_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]} as unknown as DocumentNode<Delete_Member_MutationMutation, Delete_Member_MutationMutationVariables>;
export const Deny_Membership_Request_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DENY_MEMBERSHIP_REQUEST_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DenyMembershipRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"denyMembershipRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]} as unknown as DocumentNode<Deny_Membership_Request_MutationMutation, Deny_Membership_Request_MutationMutationVariables>;
export const Disable_Member_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DISABLE_MEMBER_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DisableMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disableMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<Disable_Member_MutationMutation, Disable_Member_MutationMutationVariables>;
export const Enable_Member_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ENABLE_MEMBER_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EnableMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<Enable_Member_MutationMutation, Enable_Member_MutationMutationVariables>;
export const Group_Add_Members_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GROUP_ADD_MEMBERS_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddGroupMembersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addGroupMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Group_Add_Members_MutationMutation, Group_Add_Members_MutationMutationVariables>;
export const Group_Create_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GROUP_CREATE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Group_Create_MutationMutation, Group_Create_MutationMutationVariables>;
export const Group_Delete_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GROUP_DELETE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Group_Delete_MutationMutation, Group_Delete_MutationMutationVariables>;
export const Group_Link_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GROUP_LINK_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Group_Link_QueryQuery, Group_Link_QueryQueryVariables>;
export const Group_Select_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GROUP_SELECT_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Group_Select_QueryQuery, Group_Select_QueryQueryVariables>;
export const Group_Update_Members_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GROUP_UPDATE_MEMBERS_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGroupMembersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroupMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Group_Update_Members_MutationMutation, Group_Update_Members_MutationMutationVariables>;
export const Group_Update_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GROUP_UPDATE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Group_Update_MutationMutation, Group_Update_MutationMutationVariables>;
export const Groups_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GROUPS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Groups_QueryQuery, Groups_QueryQueryVariables>;
export const Invitation_Delete_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"INVITATION_DELETE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Invitation_Delete_MutationMutation, Invitation_Delete_MutationMutationVariables>;
export const Member_Activity_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MEMBER_ACTIVITY_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"guardmes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"incidents"},"name":{"kind":"Name","value":"incidentsByContactMemberId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"incidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkIns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Member_Activity_QueryQuery, Member_Activity_QueryQueryVariables>;
export const Member_Link_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MEMBER_LINK_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}}]}}]}}]} as unknown as DocumentNode<Member_Link_QueryQuery, Member_Link_QueryQueryVariables>;
export const Member_Or_Group_Select_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MEMBER_OR_GROUP_SELECT_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Member_Or_Group_Select_QueryQuery, Member_Or_Group_Select_QueryQueryVariables>;
export const Member_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MEMBER_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MEMBER_HEADER_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MEMBER_DETAIL_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MEMBER_DETAIL_METADATA_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MEMBER_DETAIL_GROUPS_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MEMBER_DETAIL_EMERGENCY_CONTACTS_FRAGMENT"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MEMBER_HEADER_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MEMBER_DETAIL_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MEMBER_DETAIL_METADATA_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MEMBER_DETAIL_GROUPS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MEMBER_DETAIL_EMERGENCY_CONTACTS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emergencyContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]}}]}}]} as unknown as DocumentNode<Member_QueryQuery, Member_QueryQueryVariables>;
export const Member_Select_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MEMBER_SELECT_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Member_Select_QueryQuery, Member_Select_QueryQueryVariables>;
export const Members_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MEMBERS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"groupIds"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"membershipCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Members_QueryQuery, Members_QueryQueryVariables>;
export const Membership_Request_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MEMBERSHIP_REQUEST_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"publicMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"membershipCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupIds"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Membership_Request_QueryQuery, Membership_Request_QueryQueryVariables>;
export const Update_Group_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_GROUP_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<Update_Group_MutationMutation, Update_Group_MutationMutationVariables>;
export const Update_Member_Role_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_MEMBER_ROLE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMemberRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMemberRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}}]}}]}}]}}]} as unknown as DocumentNode<Update_Member_Role_MutationMutation, Update_Member_Role_MutationMutationVariables>;
export const DisableMemberGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableMemberGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disableMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<DisableMemberGqlMutation, DisableMemberGqlMutationVariables>;
export const EnableMemberGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnableMemberGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<EnableMemberGqlMutation, EnableMemberGqlMutationVariables>;
export const Delete_Membership_Code_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DELETE_MEMBERSHIP_CODE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteMembershipCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMembershipCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membershipCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"groupIds"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Delete_Membership_Code_MutationMutation, Delete_Membership_Code_MutationMutationVariables>;
export const Assign_Bivy_Stick_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ASSIGN_BIVY_STICK_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignBivyStickToMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignBivyStickToMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bivyStick"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Assign_Bivy_Stick_MutationMutation, Assign_Bivy_Stick_MutationMutationVariables>;
export const Create_Membership_Code_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_MEMBERSHIP_CODE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMembershipCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMembershipCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membershipCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"groupIds"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Create_Membership_Code_MutationMutation, Create_Membership_Code_MutationMutationVariables>;
export const Create_Place_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_PLACE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"geojson"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"radius"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPlace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"geojson"},"value":{"kind":"Variable","name":{"kind":"Name","value":"geojson"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"radius"},"value":{"kind":"Variable","name":{"kind":"Name","value":"radius"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"srid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}},{"kind":"Field","name":{"kind":"Name","value":"srid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"encodedPolyline"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Create_Place_MutationMutation, Create_Place_MutationMutationVariables>;
export const Delete_Place_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DELETE_PLACE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePlace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<Delete_Place_MutationMutation, Delete_Place_MutationMutationVariables>;
export const Disable_Incident_Type_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DISABLE_INCIDENT_TYPE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"incidentTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disableIncidentForOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"incidentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incidentTypeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enabledIncidentTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssignedGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Disable_Incident_Type_MutationMutation, Disable_Incident_Type_MutationMutationVariables>;
export const Enable_Incident_Type_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ENABLE_INCIDENT_TYPE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"incidentTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableIncidentForOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"incidentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"incidentTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"defaultAssignedGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enabledIncidentTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssignedGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssignedGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Enable_Incident_Type_MutationMutation, Enable_Incident_Type_MutationMutationVariables>;
export const Place_Select_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PLACE_SELECT_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Place_Select_QueryQuery, Place_Select_QueryQueryVariables>;
export const Settings_Billing_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SETTINGS_BILLING_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"featureList"}},{"kind":"Field","name":{"kind":"Name","value":"featureRapidsos"}},{"kind":"Field","name":{"kind":"Name","value":"isExternalBilling"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycleAnchor"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodStart"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planAmount"}},{"kind":"Field","name":{"kind":"Name","value":"planInterval"}},{"kind":"Field","name":{"kind":"Name","value":"priceUnitAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasMore"}}]}}]}}]}}]} as unknown as DocumentNode<Settings_Billing_QueryQuery, Settings_Billing_QueryQueryVariables>;
export const Settings_General_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SETTINGS_GENERAL_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMapCenter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultMapZoom"}},{"kind":"Field","name":{"kind":"Name","value":"ownerMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupIds"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"requiresApproval"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Settings_General_QueryQuery, Settings_General_QueryQueryVariables>;
export const Settings_Incident_Types_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SETTINGS_INCIDENT_TYPES_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidentTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"allowlist"}},{"kind":"Field","name":{"kind":"Name","value":"useAllowlist"}},{"kind":"Field","name":{"kind":"Name","value":"iconSvg"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enabledIncidentTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"incidentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssignedGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssignedGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Settings_Incident_Types_QueryQuery, Settings_Incident_Types_QueryQueryVariables>;
export const Settings_Integrations_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SETTINGS_INTEGRATIONS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"settingIsRapidsosOperatorFlowEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"settingIsRapidsosPanicButtonFlowEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"settingRapidsosSocPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"featureRapidsos"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bivySticks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imei"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Settings_Integrations_QueryQuery, Settings_Integrations_QueryQueryVariables>;
export const Settings_Notifications_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SETTINGS_NOTIFICATIONS_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enabledIncidentTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CHECK_IN_NOTIFICATION_SETTINGS_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GUARDME_NOTIFICATION_SETTINGS_FRAGMENT"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"INCIDENT_NOTIFICATION_SETTINGS_FRAGMENT"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CHECK_IN_NOTIFICATION_SETTINGS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationSetting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkInSupervisorGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"isAdministratorNotifiedOnCheckIn"}},{"kind":"Field","name":{"kind":"Name","value":"isOwnerNotifiedOnCheckIn"}},{"kind":"Field","name":{"kind":"Name","value":"isSupervisorNotifiedOnCheckIn"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GUARDME_NOTIFICATION_SETTINGS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationSetting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsConcludedNotificationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsExpiredNotificationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsMetadataIncludedInNotification"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsPanicNotificationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsStartedNotificationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeSupervisorGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"isAdministratorNotifiedOnGuardme"}},{"kind":"Field","name":{"kind":"Name","value":"isOwnerNotifiedOnGuardme"}},{"kind":"Field","name":{"kind":"Name","value":"isSupervisorNotifiedOnGuardme"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"INCIDENT_NOTIFICATION_SETTINGS_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationSetting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"incidentSupervisorGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"isAdministratorNotifiedOnIncident"}},{"kind":"Field","name":{"kind":"Name","value":"isOwnerNotifiedOnIncident"}},{"kind":"Field","name":{"kind":"Name","value":"isSupervisorNotifiedOnIncident"}}]}}]} as unknown as DocumentNode<Settings_Notifications_QueryQuery, Settings_Notifications_QueryQueryVariables>;
export const Settings_Places_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SETTINGS_PLACES_QUERY"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMapCenter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultMapZoom"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"srid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}},{"kind":"Field","name":{"kind":"Name","value":"srid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"encodedPolyline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Settings_Places_QueryQuery, Settings_Places_QueryQueryVariables>;
export const Update_Organization_Member_Metadata_Fields_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_ORGANIZATION_MEMBER_METADATA_FIELDS_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationMemberMetadataFieldsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationMemberMetadataFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberMetadataFields"}}]}}]}}]}}]} as unknown as DocumentNode<Update_Organization_Member_Metadata_Fields_MutationMutation, Update_Organization_Member_Metadata_Fields_MutationMutationVariables>;
export const Update_Enabled_Incident_Type_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_ENABLED_INCIDENT_TYPE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEnabledIncidentTypeAssignedGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEnabledIncidentTypeAssignedGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabledIncidentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAssignedGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Update_Enabled_Incident_Type_MutationMutation, Update_Enabled_Incident_Type_MutationMutationVariables>;
export const Update_Organization_Check_In_Settings_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_ORGANIZATION_CHECK_IN_SETTINGS_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationCheckInSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationCheckInSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdministratorNotifiedOnCheckIn"}},{"kind":"Field","name":{"kind":"Name","value":"isOwnerNotifiedOnCheckIn"}},{"kind":"Field","name":{"kind":"Name","value":"isSupervisorNotifiedOnCheckIn"}},{"kind":"Field","name":{"kind":"Name","value":"checkInSupervisorGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"checkInSupervisorGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Update_Organization_Check_In_Settings_MutationMutation, Update_Organization_Check_In_Settings_MutationMutationVariables>;
export const Update_Organization_Details_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_ORGANIZATION_DETAILS_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"ownerMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]}}]} as unknown as DocumentNode<Update_Organization_Details_MutationMutation, Update_Organization_Details_MutationMutationVariables>;
export const Update_Organization_Guardme_Settings_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_ORGANIZATION_GUARDME_SETTINGS_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationGuardmeSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationGuardmeSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOwnerNotifiedOnGuardme"}},{"kind":"Field","name":{"kind":"Name","value":"isAdministratorNotifiedOnGuardme"}},{"kind":"Field","name":{"kind":"Name","value":"isSupervisorNotifiedOnGuardme"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsStartedNotificationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsConcludedNotificationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsExpiredNotificationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsPanicNotificationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeIsMetadataIncludedInNotification"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeSupervisorGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"guardmeSupervisorGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Update_Organization_Guardme_Settings_MutationMutation, Update_Organization_Guardme_Settings_MutationMutationVariables>;
export const Update_Organization_Incident_Settings_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_ORGANIZATION_INCIDENT_SETTINGS_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationIncidentSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationIncidentSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOwnerNotifiedOnIncident"}},{"kind":"Field","name":{"kind":"Name","value":"isAdministratorNotifiedOnIncident"}},{"kind":"Field","name":{"kind":"Name","value":"isSupervisorNotifiedOnIncident"}},{"kind":"Field","name":{"kind":"Name","value":"incidentSupervisorGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"incidentSupervisorGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Update_Organization_Incident_Settings_MutationMutation, Update_Organization_Incident_Settings_MutationMutationVariables>;
export const Update_Organization_Map_Settings_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_ORGANIZATION_MAP_SETTINGS_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationMapSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationMapSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMapCenter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultMapZoom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMapCenter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultMapZoom"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Update_Organization_Map_Settings_MutationMutation, Update_Organization_Map_Settings_MutationMutationVariables>;
export const Update_Organization_Rapidsos_Settings_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_ORGANIZATION_RAPIDSOS_SETTINGS_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationRapidsosSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationRapidsosSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"settingIsRapidsosOperatorFlowEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"settingIsRapidsosPanicButtonFlowEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"settingRapidsosSocPhoneNumber"}}]}}]}}]}}]} as unknown as DocumentNode<Update_Organization_Rapidsos_Settings_MutationMutation, Update_Organization_Rapidsos_Settings_MutationMutationVariables>;
export const Update_Place_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_PLACE_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePlaceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"radius"}},{"kind":"Field","name":{"kind":"Name","value":"encodedPolyline"}},{"kind":"Field","name":{"kind":"Name","value":"spatialData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geojson"}}]}},{"kind":"Field","name":{"kind":"Name","value":"center"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Update_Place_MutationMutation, Update_Place_MutationMutationVariables>;
export const Upload_Organization_Logo_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPLOAD_ORGANIZATION_LOGO_MUTATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uploadOrganizationLogoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadOrganizationLogo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<Upload_Organization_Logo_MutationMutation, Upload_Organization_Logo_MutationMutationVariables>;
export const OrganizationUpdatesGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OrganizationUpdatesGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"organizationMetric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incidentsActive"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsOpen"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveHigh"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveLow"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveMedium"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsActiveUrgent"}},{"kind":"Field","name":{"kind":"Name","value":"checkInsTotal"}},{"kind":"Field","name":{"kind":"Name","value":"incidentsTotal"}},{"kind":"Field","name":{"kind":"Name","value":"guardmesTotal"}},{"kind":"Field","name":{"kind":"Name","value":"guardmesActive"}},{"kind":"Field","name":{"kind":"Name","value":"guardmesInPanic"}},{"kind":"Field","name":{"kind":"Name","value":"guardmesExpired"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"relatedIds"}}]}}]}}]} as unknown as DocumentNode<OrganizationUpdatesGqlSubscription, OrganizationUpdatesGqlSubscriptionVariables>;
export const UseCurrentUserQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UseCurrentUserQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRole"}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UseCurrentUserQueryQuery, UseCurrentUserQueryQueryVariables>;